(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4c53"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4c53"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cnCS2", function(module, exports) {

module.exports = (parcelRequire("4WKyX"))($parcel$resolve("clwvD")).then(()=>parcelRequire('S0nQY'));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1c132cac09cd18d9$var$cachedPreloads;
        case 'prefetch':
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("gnS5A", function(module, exports) {

$parcel$export(module.exports, "rotation", function () { return ye; });

var $3aNd6 = parcelRequire("3aNd6");
var $49decdd7c8e65498$require$Buffer = $3aNd6.Buffer;
function e(e, t, s) {
    return t in e ? Object.defineProperty(e, t, {
        value: s,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = s, e;
}
var t = "undefined" != typeof self ? self : $parcel$global;
const s = "undefined" != typeof navigator, i = s && "undefined" == typeof HTMLImageElement, n = (typeof $parcel$global, false), r = t.Buffer, a = !!r, h = (e)=>void 0 !== e;
function f(e) {
    return void 0 === e || (e instanceof Map ? 0 === e.size : 0 === Object.values(e).filter(h).length);
}
function l(e) {
    let t = new Error(e);
    throw delete t.stack, t;
}
function o(e) {
    let t = function(e) {
        let t = 0;
        return e.ifd0.enabled && (t += 1024), e.exif.enabled && (t += 2048), e.makerNote && (t += 2048), e.userComment && (t += 1024), e.gps.enabled && (t += 512), e.interop.enabled && (t += 100), e.ifd1.enabled && (t += 1024), t + 2048;
    }(e);
    return e.jfif.enabled && (t += 50), e.xmp.enabled && (t += 2e4), e.iptc.enabled && (t += 14e3), e.icc.enabled && (t += 6e3), t;
}
const u = (e)=>String.fromCharCode.apply(null, e), d = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0;
class c {
    static from(e, t) {
        return e instanceof this && e.le === t ? e : new c(e, void 0, void 0, t);
    }
    constructor(e, t = 0, s, i){
        if ("boolean" == typeof i && (this.le = i), Array.isArray(e) && (e = new Uint8Array(e)), 0 === e) this.byteOffset = 0, this.byteLength = 0;
        else if (e instanceof ArrayBuffer) {
            void 0 === s && (s = e.byteLength - t);
            let i = new DataView(e, t, s);
            this._swapDataView(i);
        } else if (e instanceof Uint8Array || e instanceof DataView || e instanceof c) {
            void 0 === s && (s = e.byteLength - t), (t += e.byteOffset) + s > e.byteOffset + e.byteLength && l("Creating view outside of available memory in ArrayBuffer");
            let i = new DataView(e.buffer, t, s);
            this._swapDataView(i);
        } else if ("number" == typeof e) {
            let t = new DataView(new ArrayBuffer(e));
            this._swapDataView(t);
        } else l("Invalid input argument for BufferView: " + e);
    }
    _swapArrayBuffer(e) {
        this._swapDataView(new DataView(e));
    }
    _swapBuffer(e) {
        this._swapDataView(new DataView(e.buffer, e.byteOffset, e.byteLength));
    }
    _swapDataView(e) {
        this.dataView = e, this.buffer = e.buffer, this.byteOffset = e.byteOffset, this.byteLength = e.byteLength;
    }
    _lengthToEnd(e) {
        return this.byteLength - e;
    }
    set(e, t, s = c) {
        return e instanceof DataView || e instanceof c ? e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : e instanceof ArrayBuffer && (e = new Uint8Array(e)), e instanceof Uint8Array || l("BufferView.set(): Invalid data argument."), this.toUint8().set(e, t), new s(this, t, e.byteLength);
    }
    subarray(e, t) {
        return t = t || this._lengthToEnd(e), new c(this, e, t);
    }
    toUint8() {
        return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
    }
    getUint8Array(e, t) {
        return new Uint8Array(this.buffer, this.byteOffset + e, t);
    }
    getString(e = 0, t = this.byteLength) {
        let s = this.getUint8Array(e, t);
        var i;
        return i = s, d ? d.decode(i) : a ? $49decdd7c8e65498$require$Buffer.from(i).toString("utf8") : decodeURIComponent(escape(u(i)));
    }
    getLatin1String(e = 0, t = this.byteLength) {
        let s = this.getUint8Array(e, t);
        return u(s);
    }
    getUnicodeString(e = 0, t = this.byteLength) {
        const s = [];
        for(let i = 0; i < t && e + i < this.byteLength; i += 2)s.push(this.getUint16(e + i));
        return u(s);
    }
    getInt8(e) {
        return this.dataView.getInt8(e);
    }
    getUint8(e) {
        return this.dataView.getUint8(e);
    }
    getInt16(e, t = this.le) {
        return this.dataView.getInt16(e, t);
    }
    getInt32(e, t = this.le) {
        return this.dataView.getInt32(e, t);
    }
    getUint16(e, t = this.le) {
        return this.dataView.getUint16(e, t);
    }
    getUint32(e, t = this.le) {
        return this.dataView.getUint32(e, t);
    }
    getFloat32(e, t = this.le) {
        return this.dataView.getFloat32(e, t);
    }
    getFloat64(e, t = this.le) {
        return this.dataView.getFloat64(e, t);
    }
    getFloat(e, t = this.le) {
        return this.dataView.getFloat32(e, t);
    }
    getDouble(e, t = this.le) {
        return this.dataView.getFloat64(e, t);
    }
    getUintBytes(e, t, s) {
        switch(t){
            case 1:
                return this.getUint8(e, s);
            case 2:
                return this.getUint16(e, s);
            case 4:
                return this.getUint32(e, s);
            case 8:
                return this.getUint64 && this.getUint64(e, s);
        }
    }
    getUint(e, t, s) {
        switch(t){
            case 8:
                return this.getUint8(e, s);
            case 16:
                return this.getUint16(e, s);
            case 32:
                return this.getUint32(e, s);
            case 64:
                return this.getUint64 && this.getUint64(e, s);
        }
    }
    toString(e) {
        return this.dataView.toString(e, this.constructor.name);
    }
    ensureChunk() {}
}
function p(e, t) {
    l(`${e} '${t}' was not loaded, try using full build of exifr.`);
}
class g extends Map {
    constructor(e){
        super(), this.kind = e;
    }
    get(e, t) {
        return this.has(e) || p(this.kind, e), t && (e in t || function(e, t) {
            l(`Unknown ${e} '${t}'.`);
        }(this.kind, e), t[e].enabled || p(this.kind, e)), super.get(e);
    }
    keyList() {
        return Array.from(this.keys());
    }
}
var m = new g("file parser"), y = new g("segment parser"), b = new g("file reader");
let w = t.fetch;
function k(e, t) {
    var i;
    return (i = e).startsWith("data:") || i.length > 1e4 ? v(e, t, "base64") : n && e.includes("://") ? O(e, t, "url", S) : n ? v(e, t, "fs") : s ? O(e, t, "url", S) : void l("Invalid input argument");
}
async function O(e, t, s, i) {
    return b.has(s) ? v(e, t, s) : i ? async function(e, t) {
        let s = await t(e);
        return new c(s);
    }(e, i) : void l(`Parser ${s} is not loaded`);
}
async function v(e, t, s) {
    let i = new (b.get(s))(e, t);
    return await i.read(), i;
}
const S = (e)=>w(e).then((e)=>e.arrayBuffer()), A = (e)=>new Promise((t, s)=>{
        let i = new FileReader;
        i.onloadend = ()=>t(i.result || new ArrayBuffer), i.onerror = s, i.readAsArrayBuffer(e);
    });
class U extends Map {
    get tagKeys() {
        return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
    }
    get tagValues() {
        return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
    }
}
function x(e, t, s) {
    let i = new U;
    for (let [e, t] of s)i.set(e, t);
    if (Array.isArray(t)) for (let s of t)e.set(s, i);
    else e.set(t, i);
    return i;
}
function C(e, t, s) {
    let i, n = e.get(t);
    for (i of s)n.set(i[0], i[1]);
}
const B = new Map, V = new Map, I = new Map, L = [
    "chunked",
    "firstChunkSize",
    "firstChunkSizeNode",
    "firstChunkSizeBrowser",
    "chunkSize",
    "chunkLimit"
], T = [
    "jfif",
    "xmp",
    "icc",
    "iptc",
    "ihdr"
], z = [
    "tiff",
    ...T
], P = [
    "ifd0",
    "ifd1",
    "exif",
    "gps",
    "interop"
], F = [
    ...z,
    ...P
], j = [
    "makerNote",
    "userComment"
], E = [
    "translateKeys",
    "translateValues",
    "reviveValues",
    "multiSegment"
], M = [
    ...E,
    "sanitize",
    "mergeOutput",
    "silentErrors"
];
class _ {
    get translate() {
        return this.translateKeys || this.translateValues || this.reviveValues;
    }
}
class D extends _ {
    get needed() {
        return this.enabled || this.deps.size > 0;
    }
    constructor(t, s, i, n){
        if (super(), e(this, "enabled", !1), e(this, "skip", new Set), e(this, "pick", new Set), e(this, "deps", new Set), e(this, "translateKeys", !1), e(this, "translateValues", !1), e(this, "reviveValues", !1), this.key = t, this.enabled = s, this.parse = this.enabled, this.applyInheritables(n), this.canBeFiltered = P.includes(t), this.canBeFiltered && (this.dict = B.get(t)), void 0 !== i) {
            if (Array.isArray(i)) this.parse = this.enabled = !0, this.canBeFiltered && i.length > 0 && this.translateTagSet(i, this.pick);
            else if ("object" == typeof i) {
                if (this.enabled = !0, this.parse = !1 !== i.parse, this.canBeFiltered) {
                    let { pick: e, skip: t } = i;
                    e && e.length > 0 && this.translateTagSet(e, this.pick), t && t.length > 0 && this.translateTagSet(t, this.skip);
                }
                this.applyInheritables(i);
            } else !0 === i || !1 === i ? this.parse = this.enabled = i : l(`Invalid options argument: ${i}`);
        }
    }
    applyInheritables(e) {
        let t, s;
        for (t of E)s = e[t], void 0 !== s && (this[t] = s);
    }
    translateTagSet(e, t) {
        if (this.dict) {
            let s, i, { tagKeys: n, tagValues: r } = this.dict;
            for (s of e)"string" == typeof s ? (i = r.indexOf(s), -1 === i && (i = n.indexOf(Number(s))), -1 !== i && t.add(Number(n[i]))) : t.add(s);
        } else for (let s of e)t.add(s);
    }
    finalizeFilters() {
        !this.enabled && this.deps.size > 0 ? (this.enabled = !0, X(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && X(this.pick, this.deps);
    }
}
var N = {
    jfif: !1,
    tiff: !0,
    xmp: !1,
    icc: !1,
    iptc: !1,
    ifd0: !0,
    ifd1: !1,
    exif: !0,
    gps: !0,
    interop: !1,
    ihdr: void 0,
    makerNote: !1,
    userComment: !1,
    multiSegment: !1,
    skip: [],
    pick: [],
    translateKeys: !0,
    translateValues: !0,
    reviveValues: !0,
    sanitize: !0,
    mergeOutput: !0,
    silentErrors: !0,
    chunked: !0,
    firstChunkSize: void 0,
    firstChunkSizeNode: 512,
    firstChunkSizeBrowser: 65536,
    chunkSize: 65536,
    chunkLimit: 5
}, $ = new Map;
class R extends _ {
    static useCached(e) {
        let t = $.get(e);
        return void 0 !== t || (t = new this(e), $.set(e, t)), t;
    }
    constructor(e){
        super(), !0 === e ? this.setupFromTrue() : void 0 === e ? this.setupFromUndefined() : Array.isArray(e) ? this.setupFromArray(e) : "object" == typeof e ? this.setupFromObject(e) : l(`Invalid options argument ${e}`), void 0 === this.firstChunkSize && (this.firstChunkSize = s ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = !1), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
    }
    setupFromUndefined() {
        let e;
        for (e of L)this[e] = N[e];
        for (e of M)this[e] = N[e];
        for (e of j)this[e] = N[e];
        for (e of F)this[e] = new D(e, N[e], void 0, this);
    }
    setupFromTrue() {
        let e;
        for (e of L)this[e] = N[e];
        for (e of M)this[e] = N[e];
        for (e of j)this[e] = !0;
        for (e of F)this[e] = new D(e, !0, void 0, this);
    }
    setupFromArray(e) {
        let t;
        for (t of L)this[t] = N[t];
        for (t of M)this[t] = N[t];
        for (t of j)this[t] = N[t];
        for (t of F)this[t] = new D(t, !1, void 0, this);
        this.setupGlobalFilters(e, void 0, P);
    }
    setupFromObject(e) {
        let t;
        for (t of (P.ifd0 = P.ifd0 || P.image, P.ifd1 = P.ifd1 || P.thumbnail, Object.assign(this, e), L))this[t] = W(e[t], N[t]);
        for (t of M)this[t] = W(e[t], N[t]);
        for (t of j)this[t] = W(e[t], N[t]);
        for (t of z)this[t] = new D(t, N[t], e[t], this);
        for (t of P)this[t] = new D(t, N[t], e[t], this.tiff);
        this.setupGlobalFilters(e.pick, e.skip, P, F), !0 === e.tiff ? this.batchEnableWithBool(P, !0) : !1 === e.tiff ? this.batchEnableWithUserValue(P, e) : Array.isArray(e.tiff) ? this.setupGlobalFilters(e.tiff, void 0, P) : "object" == typeof e.tiff && this.setupGlobalFilters(e.tiff.pick, e.tiff.skip, P);
    }
    batchEnableWithBool(e, t) {
        for (let s of e)this[s].enabled = t;
    }
    batchEnableWithUserValue(e, t) {
        for (let s of e){
            let e = t[s];
            this[s].enabled = !1 !== e && void 0 !== e;
        }
    }
    setupGlobalFilters(e, t, s, i = s) {
        if (e && e.length) {
            for (let e of i)this[e].enabled = !1;
            let t = K(e, s);
            for (let [e, s] of t)X(this[e].pick, s), this[e].enabled = !0;
        } else if (t && t.length) {
            let e = K(t, s);
            for (let [t, s] of e)X(this[t].skip, s);
        }
    }
    filterNestedSegmentTags() {
        let { ifd0: e, exif: t, xmp: s, iptc: i, icc: n } = this;
        this.makerNote ? t.deps.add(37500) : t.skip.add(37500), this.userComment ? t.deps.add(37510) : t.skip.add(37510), s.enabled || e.skip.add(700), i.enabled || e.skip.add(33723), n.enabled || e.skip.add(34675);
    }
    traverseTiffDependencyTree() {
        let { ifd0: e, exif: t, gps: s, interop: i } = this;
        i.needed && (t.deps.add(40965), e.deps.add(40965)), t.needed && e.deps.add(34665), s.needed && e.deps.add(34853), this.tiff.enabled = P.some((e)=>!0 === this[e].enabled) || this.makerNote || this.userComment;
        for (let e of P)this[e].finalizeFilters();
    }
    get onlyTiff() {
        return !T.map((e)=>this[e].enabled).some((e)=>!0 === e) && this.tiff.enabled;
    }
    checkLoadedPlugins() {
        for (let e of z)this[e].enabled && !y.has(e) && p("segment parser", e);
    }
}
function K(e, t) {
    let s, i, n, r, a = [];
    for (n of t){
        for (r of (s = B.get(n), i = [], s))(e.includes(r[0]) || e.includes(r[1])) && i.push(r[0]);
        i.length && a.push([
            n,
            i
        ]);
    }
    return a;
}
function W(e, t) {
    return void 0 !== e ? e : void 0 !== t ? t : void 0;
}
function X(e, t) {
    for (let s of t)e.add(s);
}
e(R, "default", N);
class H {
    constructor(t){
        e(this, "parsers", {}), e(this, "output", {}), e(this, "errors", []), e(this, "pushToErrors", (e)=>this.errors.push(e)), this.options = R.useCached(t);
    }
    async read(e) {
        this.file = await function(e, t) {
            return "string" == typeof e ? k(e, t) : s && !i && e instanceof HTMLImageElement ? k(e.src, t) : e instanceof Uint8Array || e instanceof ArrayBuffer || e instanceof DataView ? new c(e) : s && e instanceof Blob ? O(e, t, "blob", A) : void l("Invalid input argument");
        }(e, this.options);
    }
    setup() {
        if (this.fileParser) return;
        let { file: e } = this, t = e.getUint16(0);
        for (let [s, i] of m)if (i.canHandle(e, t)) return this.fileParser = new i(this.options, this.file, this.parsers), e[s] = !0;
        this.file.close && this.file.close(), l("Unknown file format");
    }
    async parse() {
        let { output: e, errors: t } = this;
        var s;
        return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), t.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && t.length > 0 && (e.errors = t), f(s = e) ? void 0 : s;
    }
    async executeParsers() {
        let { output: e } = this;
        await this.fileParser.parse();
        let t = Object.values(this.parsers).map(async (t)=>{
            let s = await t.parse();
            t.assignToOutput(e, s);
        });
        this.options.silentErrors && (t = t.map((e)=>e.catch(this.pushToErrors))), await Promise.all(t);
    }
    async extractThumbnail() {
        this.setup();
        let { options: e, file: t } = this, s = y.get("tiff", e);
        var i;
        if (t.tiff ? i = {
            start: 0,
            type: "tiff"
        } : t.jpeg && (i = await this.fileParser.getOrFindSegment("tiff")), void 0 === i) return;
        let n = await this.fileParser.ensureSegmentChunk(i), r = this.parsers.tiff = new s(n, e, t), a = await r.extractThumbnail();
        return t.close && t.close(), a;
    }
}
async function Y(e, t) {
    let s = new H(t);
    return await s.read(e), s.parse();
}
var G = Object.freeze({
    __proto__: null,
    parse: Y,
    Exifr: H,
    fileParsers: m,
    segmentParsers: y,
    fileReaders: b,
    tagKeys: B,
    tagValues: V,
    tagRevivers: I,
    createDictionary: x,
    extendDictionary: C,
    fetchUrlAsArrayBuffer: S,
    readBlobAsArrayBuffer: A,
    chunkedProps: L,
    otherSegments: T,
    segments: z,
    tiffBlocks: P,
    segmentsAndBlocks: F,
    tiffExtractables: j,
    inheritables: E,
    allFormatters: M,
    Options: R
});
class J {
    static findPosition(e, t) {
        let s = e.getUint16(t + 2) + 2, i = "function" == typeof this.headerLength ? this.headerLength(e, t, s) : this.headerLength, n = t + i, r = s - i;
        return {
            offset: t,
            length: s,
            headerLength: i,
            start: n,
            size: r,
            end: n + r
        };
    }
    static parse(e, t = {}) {
        return new this(e, new R({
            [this.type]: t
        }), e).parse();
    }
    normalizeInput(e) {
        return e instanceof c ? e : new c(e);
    }
    constructor(t, s = {}, i){
        e(this, "errors", []), e(this, "raw", new Map), e(this, "handleError", (e)=>{
            if (!this.options.silentErrors) throw e;
            this.errors.push(e.message);
        }), this.chunk = this.normalizeInput(t), this.file = i, this.type = this.constructor.type, this.globalOptions = this.options = s, this.localOptions = s[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
    }
    translate() {
        this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
    }
    get output() {
        return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
    }
    translateBlock(e, t) {
        let s = I.get(t), i = V.get(t), n = B.get(t), r = this.options[t], a = r.reviveValues && !!s, h = r.translateValues && !!i, f = r.translateKeys && !!n, l = {};
        for (let [t, r] of e)a && s.has(t) ? r = s.get(t)(r) : h && i.has(t) && (r = this.translateValue(r, i.get(t))), f && n.has(t) && (t = n.get(t) || t), l[t] = r;
        return l;
    }
    translateValue(e, t) {
        return t[e] || t.DEFAULT || e;
    }
    assignToOutput(e, t) {
        this.assignObjectToOutput(e, this.constructor.type, t);
    }
    assignObjectToOutput(e, t, s) {
        if (this.globalOptions.mergeOutput) return Object.assign(e, s);
        e[t] ? Object.assign(e[t], s) : e[t] = s;
    }
}
e(J, "headerLength", 4), e(J, "type", void 0), e(J, "multiSegment", !1), e(J, "canHandle", ()=>!1);
function q(e) {
    return 192 === e || 194 === e || 196 === e || 219 === e || 221 === e || 218 === e || 254 === e;
}
function Q(e) {
    return e >= 224 && e <= 239;
}
function Z(e, t, s) {
    for (let [i, n] of y)if (n.canHandle(e, t, s)) return i;
}
class ee extends class {
    constructor(t, s, i){
        e(this, "errors", []), e(this, "ensureSegmentChunk", async (e)=>{
            let t = e.start, s = e.size || 65536;
            if (this.file.chunked) {
                if (this.file.available(t, s)) e.chunk = this.file.subarray(t, s);
                else try {
                    e.chunk = await this.file.readChunk(t, s);
                } catch (t) {
                    l(`Couldn't read segment: ${JSON.stringify(e)}. ${t.message}`);
                }
            } else this.file.byteLength > t + s ? e.chunk = this.file.subarray(t, s) : void 0 === e.size ? e.chunk = this.file.subarray(t) : l("Segment unreachable: " + JSON.stringify(e));
            return e.chunk;
        }), this.extendOptions && this.extendOptions(t), this.options = t, this.file = s, this.parsers = i;
    }
    injectSegment(e, t) {
        this.options[e].enabled && this.createParser(e, t);
    }
    createParser(e, t) {
        let s = new (y.get(e))(t, this.options, this.file);
        return this.parsers[e] = s;
    }
    createParsers(e) {
        for (let t of e){
            let { type: e, chunk: s } = t, i = this.options[e];
            if (i && i.enabled) {
                let t = this.parsers[e];
                t && t.append || t || this.createParser(e, s);
            }
        }
    }
    async readSegments(e) {
        let t = e.map(this.ensureSegmentChunk);
        await Promise.all(t);
    }
} {
    constructor(...t){
        super(...t), e(this, "appSegments", []), e(this, "jpegSegments", []), e(this, "unknownSegments", []);
    }
    static canHandle(e, t) {
        return 65496 === t;
    }
    async parse() {
        await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
    }
    setupSegmentFinderArgs(e) {
        !0 === e ? (this.findAll = !0, this.wanted = new Set(y.keyList())) : (e = void 0 === e ? y.keyList().filter((e)=>this.options[e].enabled) : e.filter((e)=>this.options[e].enabled && y.has(e)), this.findAll = !1, this.remaining = new Set(e), this.wanted = new Set(e)), this.unfinishedMultiSegment = !1;
    }
    async findAppSegments(e = 0, t) {
        this.setupSegmentFinderArgs(t);
        let { file: s, findAll: i, wanted: n, remaining: r } = this;
        if (!i && this.file.chunked && (i = Array.from(n).some((e)=>{
            let t = y.get(e), s = this.options[e];
            return t.multiSegment && s.multiSegment;
        }), i && await this.file.readWhole()), e = this.findAppSegmentsInRange(e, s.byteLength), !this.options.onlyTiff && s.chunked) {
            let t = !1;
            for(; r.size > 0 && !t && (s.canReadNextChunk || this.unfinishedMultiSegment);){
                let { nextChunkOffset: i } = s, n = this.appSegments.some((e)=>!this.file.available(e.offset || e.start, e.length || e.size));
                if (t = e > i && !n ? !await s.readNextChunk(e) : !await s.readNextChunk(i), void 0 === (e = this.findAppSegmentsInRange(e, s.byteLength))) return;
            }
        }
    }
    findAppSegmentsInRange(e, t) {
        t -= 2;
        let s, i, n, r, a, h, { file: f, findAll: l, wanted: o, remaining: u, options: d } = this;
        for(; e < t; e++)if (255 === f.getUint8(e)) {
            if (s = f.getUint8(e + 1), Q(s)) {
                if (i = f.getUint16(e + 2), n = Z(f, e, i), n && o.has(n) && (r = y.get(n), a = r.findPosition(f, e), h = d[n], a.type = n, this.appSegments.push(a), !l && (r.multiSegment && h.multiSegment ? (this.unfinishedMultiSegment = a.chunkNumber < a.chunkCount, this.unfinishedMultiSegment || u.delete(n)) : u.delete(n), 0 === u.size))) break;
                d.recordUnknownSegments && (a = J.findPosition(f, e), a.marker = s, this.unknownSegments.push(a)), e += i + 1;
            } else if (q(s)) {
                if (i = f.getUint16(e + 2), 218 === s && !1 !== d.stopAfterSos) return;
                d.recordJpegSegments && this.jpegSegments.push({
                    offset: e,
                    length: i,
                    marker: s
                }), e += i + 1;
            }
        }
        return e;
    }
    mergeMultiSegments() {
        if (!this.appSegments.some((e)=>e.multiSegment)) return;
        let e = function(e, t) {
            let s, i, n, r = new Map;
            for(let a = 0; a < e.length; a++)s = e[a], i = s[t], r.has(i) ? n = r.get(i) : r.set(i, n = []), n.push(s);
            return Array.from(r);
        }(this.appSegments, "type");
        this.mergedAppSegments = e.map(([e, t])=>{
            let s = y.get(e, this.options);
            if (s.handleMultiSegments) return {
                type: e,
                chunk: s.handleMultiSegments(t)
            };
            return t[0];
        });
    }
    getSegment(e) {
        return this.appSegments.find((t)=>t.type === e);
    }
    async getOrFindSegment(e) {
        let t = this.getSegment(e);
        return void 0 === t && (await this.findAppSegments(0, [
            e
        ]), t = this.getSegment(e)), t;
    }
}
e(ee, "type", "jpeg"), m.set("jpeg", ee);
const te = [
    void 0,
    1,
    1,
    2,
    4,
    8,
    1,
    1,
    2,
    4,
    8,
    4,
    8,
    4
];
class se extends J {
    parseHeader() {
        var e = this.chunk.getUint16();
        18761 === e ? this.le = !0 : 19789 === e && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
    }
    parseTags(e, t, s = new Map) {
        let { pick: i, skip: n } = this.options[t];
        i = new Set(i);
        let r = i.size > 0, a = 0 === n.size, h = this.chunk.getUint16(e);
        e += 2;
        for(let f = 0; f < h; f++){
            let h = this.chunk.getUint16(e);
            if (r) {
                if (i.has(h) && (s.set(h, this.parseTag(e, h, t)), i.delete(h), 0 === i.size)) break;
            } else !a && n.has(h) || s.set(h, this.parseTag(e, h, t));
            e += 12;
        }
        return s;
    }
    parseTag(e, t, s) {
        let { chunk: i } = this, n = i.getUint16(e + 2), r = i.getUint32(e + 4), a = te[n];
        if (a * r <= 4 ? e += 8 : e = i.getUint32(e + 8), (n < 1 || n > 13) && l(`Invalid TIFF value type. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e}`), e > i.byteLength && l(`Invalid TIFF value offset. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e} is outside of chunk size ${i.byteLength}`), 1 === n) return i.getUint8Array(e, r);
        if (2 === n) return "" === (h = (function(e) {
            for(; e.endsWith("\0");)e = e.slice(0, -1);
            return e;
        })(h = i.getString(e, r)).trim()) ? void 0 : h;
        var h;
        if (7 === n) return i.getUint8Array(e, r);
        if (1 === r) return this.parseTagValue(n, e);
        {
            let t = new (function(e) {
                switch(e){
                    case 1:
                        return Uint8Array;
                    case 3:
                        return Uint16Array;
                    case 4:
                        return Uint32Array;
                    case 5:
                        return Array;
                    case 6:
                        return Int8Array;
                    case 8:
                        return Int16Array;
                    case 9:
                        return Int32Array;
                    case 10:
                        return Array;
                    case 11:
                        return Float32Array;
                    case 12:
                        return Float64Array;
                    default:
                        return Array;
                }
            }(n))(r), s = a;
            for(let i = 0; i < r; i++)t[i] = this.parseTagValue(n, e), e += s;
            return t;
        }
    }
    parseTagValue(e, t) {
        let { chunk: s } = this;
        switch(e){
            case 1:
                return s.getUint8(t);
            case 3:
                return s.getUint16(t);
            case 4:
                return s.getUint32(t);
            case 5:
                return s.getUint32(t) / s.getUint32(t + 4);
            case 6:
                return s.getInt8(t);
            case 8:
                return s.getInt16(t);
            case 9:
                return s.getInt32(t);
            case 10:
                return s.getInt32(t) / s.getInt32(t + 4);
            case 11:
                return s.getFloat(t);
            case 12:
                return s.getDouble(t);
            case 13:
                return s.getUint32(t);
            default:
                l(`Invalid tiff type ${e}`);
        }
    }
}
class ie extends se {
    static canHandle(e, t) {
        return 225 === e.getUint8(t + 1) && 1165519206 === e.getUint32(t + 4) && 0 === e.getUint16(t + 8);
    }
    async parse() {
        this.parseHeader();
        let { options: e } = this;
        return e.ifd0.enabled && await this.parseIfd0Block(), e.exif.enabled && await this.safeParse("parseExifBlock"), e.gps.enabled && await this.safeParse("parseGpsBlock"), e.interop.enabled && await this.safeParse("parseInteropBlock"), e.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
    }
    safeParse(e) {
        let t = this[e]();
        return void 0 !== t.catch && (t = t.catch(this.handleError)), t;
    }
    findIfd0Offset() {
        void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
    }
    findIfd1Offset() {
        if (void 0 === this.ifd1Offset) {
            this.findIfd0Offset();
            let e = this.chunk.getUint16(this.ifd0Offset), t = this.ifd0Offset + 2 + 12 * e;
            this.ifd1Offset = this.chunk.getUint32(t);
        }
    }
    parseBlock(e, t) {
        let s = new Map;
        return this[t] = s, this.parseTags(e, t, s), s;
    }
    async parseIfd0Block() {
        if (this.ifd0) return;
        let { file: e } = this;
        this.findIfd0Offset(), this.ifd0Offset < 8 && l("Malformed EXIF data"), !e.chunked && this.ifd0Offset > e.byteLength && l(`IFD0 offset points to outside of file.\nthis.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${e.byteLength}`), e.tiff && await e.ensureChunk(this.ifd0Offset, o(this.options));
        let t = this.parseBlock(this.ifd0Offset, "ifd0");
        return 0 !== t.size ? (this.exifOffset = t.get(34665), this.interopOffset = t.get(40965), this.gpsOffset = t.get(34853), this.xmp = t.get(700), this.iptc = t.get(33723), this.icc = t.get(34675), this.options.sanitize && (t.delete(34665), t.delete(40965), t.delete(34853), t.delete(700), t.delete(33723), t.delete(34675)), t) : void 0;
    }
    async parseExifBlock() {
        if (this.exif) return;
        if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.exifOffset) return;
        this.file.tiff && await this.file.ensureChunk(this.exifOffset, o(this.options));
        let e = this.parseBlock(this.exifOffset, "exif");
        return this.interopOffset || (this.interopOffset = e.get(40965)), this.makerNote = e.get(37500), this.userComment = e.get(37510), this.options.sanitize && (e.delete(40965), e.delete(37500), e.delete(37510)), this.unpack(e, 41728), this.unpack(e, 41729), e;
    }
    unpack(e, t) {
        let s = e.get(t);
        s && 1 === s.length && e.set(t, s[0]);
    }
    async parseGpsBlock() {
        if (this.gps) return;
        if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.gpsOffset) return;
        let e = this.parseBlock(this.gpsOffset, "gps");
        return e && e.has(2) && e.has(4) && (e.set("latitude", ne(...e.get(2), e.get(1))), e.set("longitude", ne(...e.get(4), e.get(3)))), e;
    }
    async parseInteropBlock() {
        if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), void 0 !== this.interopOffset || this.exif || await this.parseExifBlock(), void 0 !== this.interopOffset)) return this.parseBlock(this.interopOffset, "interop");
    }
    async parseThumbnailBlock(e = !1) {
        if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e)) return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1;
    }
    async extractThumbnail() {
        if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(!0), void 0 === this.ifd1) return;
        let e = this.ifd1.get(513), t = this.ifd1.get(514);
        return this.chunk.getUint8Array(e, t);
    }
    get image() {
        return this.ifd0;
    }
    get thumbnail() {
        return this.ifd1;
    }
    createOutput() {
        let e, t, s, i = {};
        for (t of P)if (e = this[t], !f(e)) {
            if (s = this.canTranslate ? this.translateBlock(e, t) : Object.fromEntries(e), this.options.mergeOutput) {
                if ("ifd1" === t) continue;
                Object.assign(i, s);
            } else i[t] = s;
        }
        return this.makerNote && (i.makerNote = this.makerNote), this.userComment && (i.userComment = this.userComment), i;
    }
    assignToOutput(e, t) {
        if (this.globalOptions.mergeOutput) Object.assign(e, t);
        else for (let [s, i] of Object.entries(t))this.assignObjectToOutput(e, s, i);
    }
}
function ne(e, t, s, i) {
    var n = e + t / 60 + s / 3600;
    return "S" !== i && "W" !== i || (n *= -1), n;
}
e(ie, "type", "tiff"), e(ie, "headerLength", 10), y.set("tiff", ie);
var re = Object.freeze({
    __proto__: null,
    default: G,
    Exifr: H,
    fileParsers: m,
    segmentParsers: y,
    fileReaders: b,
    tagKeys: B,
    tagValues: V,
    tagRevivers: I,
    createDictionary: x,
    extendDictionary: C,
    fetchUrlAsArrayBuffer: S,
    readBlobAsArrayBuffer: A,
    chunkedProps: L,
    otherSegments: T,
    segments: z,
    tiffBlocks: P,
    segmentsAndBlocks: F,
    tiffExtractables: j,
    inheritables: E,
    allFormatters: M,
    Options: R,
    parse: Y
});
const ae = {
    ifd0: !1,
    ifd1: !1,
    exif: !1,
    gps: !1,
    interop: !1,
    sanitize: !1,
    reviveValues: !0,
    translateKeys: !1,
    translateValues: !1,
    mergeOutput: !1
}, he = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    gps: [
        1,
        2,
        3,
        4
    ]
});
async function fe(e) {
    let t = new H(he);
    await t.read(e);
    let s = await t.parse();
    if (s && s.gps) {
        let { latitude: e, longitude: t } = s.gps;
        return {
            latitude: e,
            longitude: t
        };
    }
}
const le = Object.assign({}, ae, {
    tiff: !1,
    ifd1: !0,
    mergeOutput: !1
});
async function oe(e) {
    let t = new H(le);
    await t.read(e);
    let s = await t.extractThumbnail();
    return s && a ? r.from(s) : s;
}
async function ue(e) {
    let t = await this.thumbnail(e);
    if (void 0 !== t) {
        let e = new Blob([
            t
        ]);
        return URL.createObjectURL(e);
    }
}
const de = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    ifd0: [
        274
    ]
});
async function ce(e) {
    let t = new H(de);
    await t.read(e);
    let s = await t.parse();
    if (s && s.ifd0) return s.ifd0[274];
}
const pe = Object.freeze({
    1: {
        dimensionSwapped: !1,
        scaleX: 1,
        scaleY: 1,
        deg: 0,
        rad: 0
    },
    2: {
        dimensionSwapped: !1,
        scaleX: -1,
        scaleY: 1,
        deg: 0,
        rad: 0
    },
    3: {
        dimensionSwapped: !1,
        scaleX: 1,
        scaleY: 1,
        deg: 180,
        rad: 180 * Math.PI / 180
    },
    4: {
        dimensionSwapped: !1,
        scaleX: -1,
        scaleY: 1,
        deg: 180,
        rad: 180 * Math.PI / 180
    },
    5: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: -1,
        deg: 90,
        rad: 90 * Math.PI / 180
    },
    6: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: 1,
        deg: 90,
        rad: 90 * Math.PI / 180
    },
    7: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: -1,
        deg: 270,
        rad: 270 * Math.PI / 180
    },
    8: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: 1,
        deg: 270,
        rad: 270 * Math.PI / 180
    }
});
let ge = !0, me = !0;
if ("object" == typeof navigator) {
    let e = navigator.userAgent;
    if (e.includes("iPad") || e.includes("iPhone")) {
        let t = e.match(/OS (\d+)_(\d+)/);
        if (t) {
            let [, e, s] = t, i = Number(e) + .1 * Number(s);
            ge = i < 13.4, me = !1;
        }
    } else if (e.includes("OS X 10")) {
        let [, t] = e.match(/OS X 10[_.](\d+)/);
        ge = me = Number(t) < 15;
    }
    if (e.includes("Chrome/")) {
        let [, t] = e.match(/Chrome\/(\d+)/);
        ge = me = Number(t) < 81;
    } else if (e.includes("Firefox/")) {
        let [, t] = e.match(/Firefox\/(\d+)/);
        ge = me = Number(t) < 77;
    }
}
async function ye(e) {
    let t = await ce(e);
    return Object.assign({
        canvas: ge,
        css: me
    }, pe[t]);
}
class be extends c {
    constructor(...t){
        super(...t), e(this, "ranges", new we), 0 !== this.byteLength && this.ranges.add(0, this.byteLength);
    }
    _tryExtend(e, t, s) {
        if (0 === e && 0 === this.byteLength && s) {
            let e = new DataView(s.buffer || s, s.byteOffset, s.byteLength);
            this._swapDataView(e);
        } else {
            let s = e + t;
            if (s > this.byteLength) {
                let { dataView: e } = this._extend(s);
                this._swapDataView(e);
            }
        }
    }
    _extend(e) {
        let t;
        t = a ? r.allocUnsafe(e) : new Uint8Array(e);
        let s = new DataView(t.buffer, t.byteOffset, t.byteLength);
        return t.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), {
            uintView: t,
            dataView: s
        };
    }
    subarray(e, t, s = !1) {
        return t = t || this._lengthToEnd(e), s && this._tryExtend(e, t), this.ranges.add(e, t), super.subarray(e, t);
    }
    set(e, t, s = !1) {
        s && this._tryExtend(t, e.byteLength, e);
        let i = super.set(e, t);
        return this.ranges.add(t, i.byteLength), i;
    }
    async ensureChunk(e, t) {
        this.chunked && (this.ranges.available(e, t) || await this.readChunk(e, t));
    }
    available(e, t) {
        return this.ranges.available(e, t);
    }
}
class we {
    constructor(){
        e(this, "list", []);
    }
    get length() {
        return this.list.length;
    }
    add(e, t, s = 0) {
        let i = e + t, n = this.list.filter((t)=>ke(e, t.offset, i) || ke(e, t.end, i));
        if (n.length > 0) {
            e = Math.min(e, ...n.map((e)=>e.offset)), i = Math.max(i, ...n.map((e)=>e.end)), t = i - e;
            let s = n.shift();
            s.offset = e, s.length = t, s.end = i, this.list = this.list.filter((e)=>!n.includes(e));
        } else this.list.push({
            offset: e,
            length: t,
            end: i
        });
    }
    available(e, t) {
        let s = e + t;
        return this.list.some((t)=>t.offset <= e && s <= t.end);
    }
}
function ke(e, t, s) {
    return e <= t && t <= s;
}
class Oe extends be {
    constructor(t, s){
        super(0), e(this, "chunksRead", 0), this.input = t, this.options = s;
    }
    async readWhole() {
        this.chunked = !1, await this.readChunk(this.nextChunkOffset);
    }
    async readChunked() {
        this.chunked = !0, await this.readChunk(0, this.options.firstChunkSize);
    }
    async readNextChunk(e = this.nextChunkOffset) {
        if (this.fullyRead) return this.chunksRead++, !1;
        let t = this.options.chunkSize, s = await this.readChunk(e, t);
        return !!s && s.byteLength === t;
    }
    async readChunk(e, t) {
        if (this.chunksRead++, 0 !== (t = this.safeWrapAddress(e, t))) return this._readChunk(e, t);
    }
    safeWrapAddress(e, t) {
        return void 0 !== this.size && e + t > this.size ? Math.max(0, this.size - e) : t;
    }
    get nextChunkOffset() {
        if (0 !== this.ranges.list.length) return this.ranges.list[0].length;
    }
    get canReadNextChunk() {
        return this.chunksRead < this.options.chunkLimit;
    }
    get fullyRead() {
        return void 0 !== this.size && this.nextChunkOffset === this.size;
    }
    read() {
        return this.options.chunked ? this.readChunked() : this.readWhole();
    }
    close() {}
}
b.set("blob", class extends Oe {
    async readWhole() {
        this.chunked = !1;
        let e = await A(this.input);
        this._swapArrayBuffer(e);
    }
    readChunked() {
        return this.chunked = !0, this.size = this.input.size, super.readChunked();
    }
    async _readChunk(e, t) {
        let s = t ? e + t : void 0, i = this.input.slice(e, s), n = await A(i);
        return this.set(n, e, !0);
    }
});
var $49decdd7c8e65498$export$2e2bcd8739ae039 = re;

});
parcelRegister("3aNd6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $24f87a6f86a8996f$export$a143d493d941bafc; }, function (v) { return $24f87a6f86a8996f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $24f87a6f86a8996f$export$f99ded8fe4b79145; }, function (v) { return $24f87a6f86a8996f$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
'use strict';

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case 'base64':
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$24f87a6f86a8996f$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $5d11t.toByteArray($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("5d11t", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3caef5c332c7293f$export$d622b2ad8d90c771; }, function (v) { return $3caef5c332c7293f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3caef5c332c7293f$export$6100ba28696e12de; }, function (v) { return $3caef5c332c7293f$export$6100ba28696e12de = v; });
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
'use strict';
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup['-'.charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup['_'.charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("7rddL", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $56a54f6ebabce67d$export$aafa59e2e03f2942; }, function (v) { return $56a54f6ebabce67d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $56a54f6ebabce67d$export$68d8715fc104d294; }, function (v) { return $56a54f6ebabce67d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



var $6697e6e436eb0e32$exports = {};
$parcel$extendImportMap({
    "clwvD": "tinymce.min.560c202f.js"
});

class $8f658dda969a7982$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.listeners = [];
    }
    connectedCallback() {}
    /**
     * If the custom element is getting removed of the dom, all listeners
     * are getting removed of the element.
     */ disconnectedCallback() {
        this.listeners.forEach((item)=>{
            item.element.removeEventListener(item.event, item.action);
        });
    }
    /**
     * Here you can push a listener object directly to the listener array
     *
     * @param {Listener} {}
     */ pushListener({ event: event, element: element, action: action }) {
        const existing = this.listeners.find((listener)=>listener.element === element && listener.event === event);
        if (existing) {
            existing.element.removeEventListener(existing.event, existing.action);
            this.listeners = this.listeners.filter((listener)=>!(listener.element === element && listener.event === event));
        }
        this.listeners.push({
            event: event,
            element: element,
            action: action
        });
        element.addEventListener(event, action);
    }
    /**
     * Removes the given element from the listener array and removes the
     * EventListener from the element and returns the listener object.
     * If the element was not found, undefined is returned.
     *
     * @param {Element} element
     * @returns {Listener | undefined}
     */ removeListener(element) {
        const foundElement = this.listeners.find((item)=>item.element === element);
        if (!foundElement) return;
        foundElement?.element.removeEventListener(foundElement.event, foundElement.action);
        const newList = this.listeners.filter((item)=>item.element !== element);
        this.listeners = newList;
        return foundElement;
    }
    /**
     * Removes all registered event listeners that were previously added
     * using the `pushListener()` method. This ensures that no dangling
     * or duplicate event handlers remain active on DOM elements.
     *
     * This method should be called before re-rendering or updating the DOM
     * to avoid memory leaks and unintended behavior caused by multiple bindings.
     *
     * @example
     * this.clearListeners();
     * this.render(); // safe to re-bind new listeners after rendering
     */ clearListeners() {
        this.listeners.forEach(({ element: element, event: event, action: action })=>{
            element.removeEventListener(event, action);
        });
        this.listeners = [];
    }
    /**
     * Retrieves a data attribute from the element with the specified name.
     * If the attribute is not present, the provided default value is returned.
     *
     * @protected
     * @param {string} name - The name of the data attribute (without the `data-tk-` prefix).
     * @param {string} defaultValue - The default value to return if the attribute is not found.
     * @returns {string} - The value of the data attribute or the default value.
     */ getDataAttribute(name, defaultValue) {
        return this.getAttribute(`data-tk-${name}`) || defaultValue;
    }
}


var $588d148f2c9ac202$export$4120f82005ec4b2d = /*#__PURE__*/ function(TrackerPushTypes) {
    TrackerPushTypes["BASKET_UPDATE"] = "basket-update";
    TrackerPushTypes["FAVORITE_UPDATE"] = "favorite-update";
    return TrackerPushTypes;
}({});
class $588d148f2c9ac202$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.registry = {};
    }
    constructor(){
        super(), this.trackers = [];
        this.ready = new CustomEvent('tk-tracker-ready');
    }
    static registerTracker(name, factory) {
        this.registry[name] = factory;
    }
    async connectedCallback() {
        this.getTrackingIds();
        if (!this.trackerIds || this.trackerIds.length === 0) throw new Error('Trackier is not defined');
        await this.initTrackers();
        this.registerTrackingListener();
        this.dispatchEvent(this.ready);
    }
    registerTrackingListener() {
        const onTracking = this.handleTracking.bind(this);
        this.pushListener({
            event: 'tk-tracking-push',
            element: this,
            action: onTracking
        });
    }
    getTrackingIds() {
        try {
            this.trackerIds = JSON.parse(this.getAttribute('data-tk-trackers') || '[]');
        } catch (error) {
            console.error('Error parsing json', error);
        }
    }
    async initTrackers() {
        if (!this.trackerIds) return;
        for (const item of this.trackerIds)try {
            const createTracker = $588d148f2c9ac202$export$2e2bcd8739ae039.registry[item.name];
            if (createTracker) {
                const instance = await createTracker(item.key, {
                    endpoint: item.endpoint
                });
                await instance.init();
                this.trackers.push({
                    name: item.name,
                    instance: instance
                });
            } else console.warn(`Tracker "${item.name}" nicht gefunden.`);
        } catch (error) {
            console.error(`This tracker ${item.name} could not be initialized:` + error);
        }
    }
    handleTracking(event) {
        const { trackerType: trackerType, type: type, item: item } = event.detail;
        this.trackers.filter((trackerItem)=>!trackerType || trackerItem.name.toLowerCase() === trackerType.toLowerCase()).forEach((trackerItem)=>{
            if (type === "basket-update") trackerItem.instance.pushBasket(item);
            else if (type === "favorite-update") trackerItem.instance.pushFavorite(item);
            else trackerItem.instance.push(item);
        });
    }
}


class $26efcff9bda53fd7$export$2e2bcd8739ae039 {
    constructor(trackingId, tracker, defaultEndpoint, options){
        this.trackingId = trackingId;
        this.tracker = tracker;
        this.endpoint = options?.endpoint || defaultEndpoint;
        this.url = this.endpoint.replace(/%KEY/g, trackingId);
        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist'
        };
        this.favoriteActionMap = options?.favoriteActionMap || {
            added: 'add',
            deleted: 'delete'
        };
    }
    loadScript() {
        return new Promise((resolve, reject)=>{
            const script = document.createElement('script');
            script.async = true;
            script.src = this.url;
            script.onload = ()=>resolve(script);
            script.onerror = ()=>reject(new Error(`Failed to load script: ${this.url}`));
            document.head.appendChild(script);
        });
    }
}


class $4fa2285174eed561$export$2e2bcd8739ae039 extends (0, $26efcff9bda53fd7$export$2e2bcd8739ae039) {
    constructor(trackingId, options){
        super(trackingId, window.dataLayer || [], `https://www.googletagmanager.com/gtm.js?id=%KEY`, options);
        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist'
        };
    }
    init() {
        return new Promise((resolve, reject)=>{
            try {
                this.initGTM();
                this.loadScript().then(()=>{
                    console.log('Google Tag Manager successfully loaded');
                    resolve();
                }).catch((error)=>{
                    console.error('Error loading Google Tag Manager', error);
                    reject(error);
                });
            } catch (error) {
                console.error('Google Tag Manager initialization failed', error);
                reject(error);
            }
        });
    }
    initGTM() {
        this.tracker.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
    }
    push(item) {
        const { event: event, ...rest } = item;
        this.tracker.push({
            event: event,
            ecommerce: {
                ...rest
            }
        });
    }
    pushBasket(item) {
        this.tracker.push({
            event: this.basketEventMap[item.event],
            ecommerce: {
                currencyCode: item.currency,
                value: item.value,
                items: item.items.map((item)=>({
                        item_id: item.sku,
                        item_name: item.name,
                        price: item.price,
                        quantity: item.quantity
                    }))
            }
        });
    }
    pushFavorite(item) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action],
            ecommerce: {
                category: item.category,
                action: this.favoriteActionMap[item.action],
                name: item.name,
                value: item.value
            }
        });
    }
}



class $30ee64c4b301d5a8$export$2e2bcd8739ae039 extends (0, $26efcff9bda53fd7$export$2e2bcd8739ae039) {
    constructor(trackingId, options){
        super(trackingId, window._mtm || [], `https://matomo01.opacc.net/js/container_%KEY.js`, options);
        this.basketEventMap = options?.basketEventMap || {
            added: 'opc_cart_add',
            deleted: 'opc_cart_remove',
            changed: 'opc_cart_update'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'opc_wishlist_add',
            deleted: 'opc_wishlist_remove'
        };
    }
    async init() {
        await this.loadScript();
        this.initMatomo();
        console.log('Matomo Tag Manager successfully loaded');
    }
    initMatomo() {
        this.tracker.push({
            'mtm.startTime': new Date().getTime(),
            event: 'mtm.Start'
        });
    }
    push(item) {
        this.tracker.push(item);
    }
    pushBasket(item) {
        this.tracker.push({
            event: this.basketEventMap[item.event],
            location: item.location,
            currency: item.currency,
            value: item.value,
            items: item.items
        });
    }
    pushFavorite(item) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action],
            location: window.location.href,
            category: item.category,
            action: this.favoriteActionMap[item.action],
            name: item.name,
            value: item.value
        });
    }
}


// Registry of tracker
(0, $588d148f2c9ac202$export$2e2bcd8739ae039).registerTracker('google', async (trackingId, options)=>new (0, $4fa2285174eed561$export$2e2bcd8739ae039)(trackingId, options));
(0, $588d148f2c9ac202$export$2e2bcd8739ae039).registerTracker('matomo', async (trackingId, options)=>new (0, $30ee64c4b301d5a8$export$2e2bcd8739ae039)(trackingId, options));


class $e31d2de11bbf216d$export$2e2bcd8739ae039 {
    constructor(list){
        this.customElementList = list;
        this.init();
    }
    init() {
        this.customElementList.forEach((item)=>{
            !customElements.get(item.name) && customElements.define(item.name, item.constructor);
        });
    }
}



const $86b3c5b6d66bd808$var$globalFormErrorMessages = {
    badInput: 'Please enter a number.',
    patternMismatch: 'Please match the requested format.',
    rangeOverflow: 'Please select a value that is no more than {max}.',
    rangeUnderflow: 'Please select a value that is no less than {min}.',
    stepMismatch: 'Please select a value that is a multiple from {step}.',
    tooLong: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
    tooShort: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
    typeMismatch: 'The value you have entered for this field is invalid.',
    valueMissing: 'Please fill out this field.',
    // These properties must be empty.
    valid: '',
    customError: ''
};
const $86b3c5b6d66bd808$var$globalFormPasswordValidityMessages = {
    passwordNotMatching: 'The password does not match the one above.'
};
const $86b3c5b6d66bd808$var$globalFormExpandErrorMessages = {
    stepAdjust: 'The value you entered for this field is invalid. The value has been changed from {currentValue} to {newValue}',
    existigName: 'This name {currentValue} already exists.'
};
const $86b3c5b6d66bd808$var$globalBasketMessages = {
    messageEmptyBasket: {
        code: '1-6-6220',
        text: 'Shopping cart is empty'
    },
    messageAddedToBasket: {
        code: '1-6-6221',
        text: 'added to the shopping cart'
    },
    quickOrderMessageTooShort: {
        code: '1-6-6222',
        text: 'At least %1 characters are required for a search.'
    }
};
const $86b3c5b6d66bd808$var$globalDeliveryMessages = {
    messageDeliveryTypeGeneral: {
        code: '1-6-6226',
        text: 'Delivery method changed'
    }
};
const $86b3c5b6d66bd808$var$globalPaymentMessages = {
    messagePaymentTypeCreditCard: {
        code: '1-6-6227',
        text: 'Payment type credit card'
    },
    messagePaymentTypeInvoice: {
        code: '1-6-6227',
        text: 'Payment type invoice'
    },
    messagePaymentTypeInAdvance: {
        code: '1-6-6227',
        text: 'Payment type advance payment'
    },
    messagePaymentTypeOnDelivery: {
        code: '1-6-6227',
        text: 'Payment type cash on delivery'
    },
    messagePaymentTypeGeneral: {
        code: '1-6-6227',
        text: 'Payment type changed'
    }
};
const $86b3c5b6d66bd808$var$globalCompareMessages = {
    messageHint: {
        code: '1-6-6240',
        text: ''
    },
    allRemoved: {
        code: '1-6-6240',
        text: 'All items removed'
    },
    empty: {
        code: '1-6-6240',
        text: 'Your article comparison is empty.'
    },
    importantTitle: {
        code: '1-6-6240',
        text: 'The most important information'
    },
    removed: {
        code: '1-6-6240',
        text: 'The article was successfully removed.'
    },
    added: {
        code: '1-6-6240',
        text: 'The article was successfully added.'
    },
    noAttributesFound: {
        code: '1-6-6240',
        text: 'No comparison attributes were found.'
    }
};
const $86b3c5b6d66bd808$var$globalFavoriteMessages = {
    messageInvalidName: {
        code: '2-6-6270',
        text: 'Unable to create the wish list; the name is invalid.'
    },
    messageMaxLists: {
        code: '2-6-6277',
        text: 'Max. number of wish lists reached!'
    },
    messageMaxPositions: {
        code: '2-6-6278',
        text: 'Max. number of positions reached!'
    },
    messageDeleteConfirmation: {
        code: '2-6-6273',
        text: 'Do you really want to delete the wish list?'
    }
};
const $86b3c5b6d66bd808$var$globalAutocompleteMessages = {
    messageNoValueFound: {
        code: '1-6-6290',
        text: 'No match found!'
    }
};
const $86b3c5b6d66bd808$var$globalAccountMessages = {
    messageDelete: {
        code: '1-6-6200',
        text: 'Do you really want to delete this address?'
    },
    messageChangeSuccess: {
        code: '1-6-6200',
        text: 'Address successfully modified.'
    }
};
const $86b3c5b6d66bd808$var$globalGeneralMessages = {
    messageEmptyText: {
        code: '1-6-6290',
        text: 'The output was suppressed due to an empty text.'
    },
    messageOk: {
        code: '1-6-6290',
        text: 'Yes'
    },
    messageCancel: {
        code: '1-6-6290',
        text: 'No'
    },
    messageChange: {
        code: '1-6-6290',
        text: 'The selection was changed'
    },
    messageDefault: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultInfo: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultWarning: {
        code: '2-6-0000',
        text: ''
    },
    messageDefaultError: {
        code: '3-6-0000',
        text: ''
    },
    messageDefaultDebug: {
        code: '4-6-0000',
        text: ''
    },
    messageClipboard: {
        code: '1-6-6290',
        text: 'The text has been successfully saved to the clipboard.'
    }
};
const $86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages = {
    messageTooShort: {
        code: '1-6-6260',
        text: 'At least 3 characters!'
    },
    messageResultEmpty: {
        code: '1-6-6260',
        text: 'No items found!'
    },
    messageDangerousString: {
        code: '1-6-6260',
        text: 'invalid character <.'
    },
    messageDisallowedCharacter: {
        code: '1-6-6260',
        text: 'Invalid character: %1'
    }
};
const $86b3c5b6d66bd808$var$globalFileuploadAreaMessages = {
    defaultMessage: {
        code: '1-6-2002',
        text: 'Store the files here to upload them'
    },
    fallbackMessage: {
        code: '2-6-2002',
        text: 'Your browser does not support drag&drop file uploads'
    },
    fallbackText: {
        code: '2-6-2002',
        text: 'Use the form to upload your files'
    },
    fileTooBig: {
        code: '2-6-2002',
        text: 'The file is too large. The maximum file size is {{maxFileSize}} MB'
    },
    invalidFileType: {
        code: '2-6-2002',
        text: 'Unable to upload files of this type'
    },
    responseError: {
        code: '3-6-2002',
        text: 'The server rejected your request with status {{statusCode}}'
    },
    cancelUpload: {
        code: '1-6-2002',
        text: 'Cancel upload'
    },
    cancelUploadConfirmation: {
        code: '1-6-2002',
        text: 'Cancel upload?'
    },
    removeFile: {
        code: '1-6-2002',
        text: 'Remove file'
    },
    maxFilesExceeded: {
        code: '2-6-2002',
        text: 'You are not allowed to upload any more files'
    },
    buttonBrowse: {
        code: '1-6-2002',
        text: 'Select files to upload'
    },
    uploadHint: {
        code: '1-6-2002',
        text: 'Drag files and folders here'
    }
};
const $86b3c5b6d66bd808$var$globalFilterMessages = {
    emptyResult: {
        code: '1-1-6280',
        text: 'Keine Ergebnisse gefunden.'
    }
};
const $86b3c5b6d66bd808$var$globalCheckoutMessages = {
    missingTerms: {
        code: '3-6-6230',
        text: 'Please accept the General terms and conditions.'
    },
    loadingCheckoutTitle: {
        code: '1-6-6260',
        text: 'Almost done!'
    },
    loadingCheckoutText: {
        code: '1-6-6261',
        text: 'The order is carried out. This can take a moment!'
    }
};
const $86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages = {
    htmlErrorGeneral: {
        code: '3-6-6000',
        text: 'Something has gone wrong!'
    },
    htmlError401: {
        code: '3-6-6000',
        text: 'A valid authentication is required to process the request.'
    },
    htmlError403: {
        code: '3-6-6000',
        text: 'The request could not be processed due to missing authorization of the client.'
    },
    htmlError404: {
        code: '3-6-6000',
        text: 'The requested site does not exist.'
    },
    htmlError413: {
        code: '3-6-6000',
        text: 'The file is too large.'
    },
    htmlError415: {
        code: '3-6-6000',
        text: 'This media type is not supported.'
    },
    htmlError422: {
        code: '3-6-6000',
        text: 'Unable to display the requested site correctly.'
    },
    htmlError500: {
        code: '3-6-6000',
        text: 'Internal server error'
    },
    htmlError503: {
        code: '3-6-6000',
        text: 'The server is temporarily unavailable.'
    }
};
if (!window.opacc) window.opacc = {};
const $86b3c5b6d66bd808$export$7ea287b8bcd34b91 = {
    ...$86b3c5b6d66bd808$var$globalFormErrorMessages,
    ...$86b3c5b6d66bd808$var$globalFormPasswordValidityMessages,
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormValidityMessages,
    ...window.opacc.tkFormPasswordValidityMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormValidityMessages,
    ...window.opacc.projectFormPasswordValidityMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$35e6ad2b040b8403 = {
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$287bafa924522a4d = {
    ...$86b3c5b6d66bd808$var$globalBasketMessages,
    ...window.opacc.tkBasketMessages,
    ...window.opacc.projectBasketMessages
};
const $86b3c5b6d66bd808$export$ad480231e1cfb49 = {
    ...$86b3c5b6d66bd808$var$globalCompareMessages,
    ...window.opacc.tkCompareMessages,
    ...window.opacc.projectCompareMessages
};
const $86b3c5b6d66bd808$export$329e838a9ba51357 = {
    ...$86b3c5b6d66bd808$var$globalFavoriteMessages,
    ...window.opacc.tkFavoriteMessages,
    ...window.opacc.projectFavoriteMessages
};
const $86b3c5b6d66bd808$export$39227038979f1988 = {
    ...$86b3c5b6d66bd808$var$globalGeneralMessages,
    ...window.opacc.tkGeneralMessages,
    ...window.opacc.projectGeneralMessages
};
const $86b3c5b6d66bd808$export$f625b980042672da = {
    ...$86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages,
    ...window.opacc.tkDirectSearchSuggestMessages,
    ...window.opacc.projectDirectSearchSuggestMessages
};
const $86b3c5b6d66bd808$export$fe24ead06f0313ff = {
    ...$86b3c5b6d66bd808$var$globalFileuploadAreaMessages,
    ...window.opacc.tkFileUploadAreaMessages,
    ...window.opacc.projectFileUploadAreaMessages
};
const $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc = {
    ...$86b3c5b6d66bd808$var$globalFilterMessages,
    ...window.opacc.tkFilterMessages,
    ...window.opacc.projectFilterMessages
};
const $86b3c5b6d66bd808$export$fbedd73e1269236f = {
    ...$86b3c5b6d66bd808$var$globalAutocompleteMessages,
    ...window.opacc.tkAutocompleteMessages,
    ...window.opacc.projectAutocompleteMessages
};
const $86b3c5b6d66bd808$export$389a1ce21906c656 = {
    ...$86b3c5b6d66bd808$var$globalPaymentMessages,
    ...window.opacc.tkPaymentMessages,
    ...window.opacc.projectPaymentMessages
};
const $86b3c5b6d66bd808$export$36d5448025feaaa9 = {
    ...$86b3c5b6d66bd808$var$globalDeliveryMessages,
    ...window.opacc.tkDeliveryMessages,
    ...window.opacc.projectDeliveryMessages
};
const $86b3c5b6d66bd808$export$efd88ea7bc399322 = {
    ...$86b3c5b6d66bd808$var$globalAccountMessages,
    ...window.opacc.tkAccountMessages,
    ...window.opacc.projectAccountMessages
};
const $86b3c5b6d66bd808$export$4705307fe5270e12 = {
    ...$86b3c5b6d66bd808$var$globalCheckoutMessages,
    ...window.opacc.tkCheckoutMessages,
    ...window.opacc.projectCheckoutMessages
};
const $86b3c5b6d66bd808$export$6e7e78d2cde281b0 = {
    ...$86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages,
    ...window.opacc.tkHtmlErrorCodeMessages,
    ...window.opacc.projectHtmlErrorCodeMessages
};
const $86b3c5b6d66bd808$export$97a703132b664051 = {
    ...window.opacc.tkZipCityMessages
};


/**
 * @param {string} html representing any number of sibling elements
 * @return {NodeListOf<ChildNode>}
 */ const $2d540709c75492d4$var$render = (html, isBody = false, shouldDecode = false)=>{
    if (!html) $2d540709c75492d4$var$render('<div></div>');
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    if (shouldDecode) return $2d540709c75492d4$var$render(doc.documentElement.textContent || '');
    return isBody ? doc.body : doc.body.children.item(0);
};
var $2d540709c75492d4$export$2e2bcd8739ae039 = $2d540709c75492d4$var$render;


var $1221feb2184dfefe$export$9130146a86a85749 = /*#__PURE__*/ function(NotificationType) {
    NotificationType["SUCCESS"] = "Success";
    NotificationType["WARNING"] = "Warning";
    NotificationType["ERROR"] = "Error";
    NotificationType["INFO"] = "Info";
    return NotificationType;
}({});
const $1221feb2184dfefe$var$mapMessageCodeToText = (response, messages)=>{
    let textMessage;
    if (!response.pluginId) return '';
    if (response.pluginId === 'paymentType') {
        const paymentMessages = {
            0: messages.messagePaymentTypeGeneral.text,
            1: messages.messagePaymentTypeCreditCard.text,
            2: messages.messagePaymentTypeInvoice.text,
            5: messages.messagePaymentTypeInAdvance.text,
            6: messages.messagePaymentTypeOnDelivery.text
        };
        textMessage = paymentMessages[Number(response.paymentType) || 0];
    } else if (response.pluginId === 'deliveryType') textMessage = messages.messageDeliveryTypeGeneral.text;
    else if (response.pluginId === 'checkoutAdressChange') textMessage = messages.messageChangeSuccess.text;
    return textMessage;
};
const $1221feb2184dfefe$var$getConsoleStyle = (backgroundColor, textColor = 'white')=>[
        `background: ${backgroundColor}`,
        `color: ${textColor}`,
        'display: block'
    ].join(';');
const $1221feb2184dfefe$var$logToConsole = (message, type)=>{
    const consoleHandler = {
        ["Success"] () {
            console.info(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('green'));
        },
        ["Warning"] () {
            console.warn(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('yellow', 'black'));
        },
        ["Error"] () {
            console.log(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('red'));
        },
        ["Info"] () {
            console.debug(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('blue'));
        }
    };
    consoleHandler[type]();
};
const $1221feb2184dfefe$var$renderMessageContainer = (parentElement)=>{
    let messageContainer = parentElement.querySelector('[data-tk-message-container]');
    if (!messageContainer) {
        messageContainer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-message__container" data-tk-message-container></div>');
        parentElement.insertAdjacentElement('beforeend', messageContainer);
    }
    return messageContainer;
};
const $1221feb2184dfefe$export$3a57e165650c636f = (type, message, wait = 2.5, options = {})=>{
    if (!message) return;
    const dialogs = document.querySelectorAll('dialog[open]');
    let messageContainer;
    if (dialogs.length === 0) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
    else {
        const lastDialog = Array.from(dialogs).at(-1);
        if (!lastDialog) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
        else messageContainer = $1221feb2184dfefe$var$renderMessageContainer(lastDialog);
    }
    const toast = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
        <div class="tk-message tk-message--toast tk-message--${type.toLowerCase()}">
            <span class="tk-message__icon"><i class="tk-icon-${type.toLowerCase()}"></i></span>
            <span class="tk-message__label">${message}</span>
        </div>
    `);
    toast.style.animation = `fadein .5s, fadeout .5s ${wait}s`;
    toast.classList.add('tk-message--show');
    messageContainer.appendChild(toast);
    toast.addEventListener('animationend', (event)=>{
        if (event.animationName !== 'fadeout') return;
        messageContainer.removeChild(toast);
    });
    options.consoleMessage ? $1221feb2184dfefe$var$logToConsole(options.consoleMessage, type) : $1221feb2184dfefe$var$logToConsole(message, type);
};
const $1221feb2184dfefe$export$146c7c7e50ed1bd2 = (item, messageOverride)=>{
    const type = item.code.substring(0, 1);
    const message = messageOverride || item.text;
    const typeHandler = {
        1: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Success", message, item.wait),
        2: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Warning", message, item.wait),
        3: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Error", message, item.wait),
        4: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Info", message, item.wait)
    };
    typeHandler[type]();
};
const $1221feb2184dfefe$export$5b256beea4c7e9b5 = (items, response)=>{
    const messages = {
        ...(0, $86b3c5b6d66bd808$export$39227038979f1988),
        ...(0, $86b3c5b6d66bd808$export$efd88ea7bc399322),
        ...(0, $86b3c5b6d66bd808$export$389a1ce21906c656),
        ...(0, $86b3c5b6d66bd808$export$36d5448025feaaa9)
    };
    items.forEach((item)=>{
        $1221feb2184dfefe$export$146c7c7e50ed1bd2(item, $1221feb2184dfefe$var$mapMessageCodeToText(response, messages));
    });
};


class $aa35ef9547ba682e$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.eventName = this.getAttribute('data-tk-event-name') || 'event-purchase';
        this.basketId = this.querySelector('[data-tk-otm-basket-id]') || undefined;
        this.messageContainerSelector = this.getAttribute('data-tk-message-container-selector') || '[id^="wp_messages_container_"]';
        this.sessionTimeoutWrapper = this.querySelector('[data-tk-session-timeout-wrapper]') || undefined;
        this.sessionTime = Number(this.sessionTimeoutWrapper?.getAttribute('data-tk-session-time') || 0);
        this.firstItemToScrollInto = this.querySelector('[data-tk-scroll-into]') || undefined;
    }
    connectedCallback() {
        this.processNotification();
        this.sessionTimeoutWrapper && this.showSessionTimeout();
        this.firstItemToScrollInto && this.scrollToElement();
        if (!this.basketId || !window.dataLayer) return;
        const data = this.getPurchaseData();
        data && window.dataLayer.push(data);
    }
    processNotification() {
        const messageContainer = document.querySelector(this.messageContainerSelector);
        if (!messageContainer || !messageContainer.hasChildNodes()) return;
        const infoMessage = messageContainer.querySelectorAll('.Info');
        const errorMessage = messageContainer.querySelectorAll('.Error');
        const warningMessage = messageContainer.querySelectorAll('.Warning');
        const debugMessage = messageContainer.querySelectorAll('.Debug');
        const messageList = Array.from([
            ...infoMessage,
            ...errorMessage,
            ...warningMessage,
            ...debugMessage
        ]);
        const types = {
            Info: (0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS,
            Error: (0, $1221feb2184dfefe$export$9130146a86a85749).ERROR,
            Warning: (0, $1221feb2184dfefe$export$9130146a86a85749).WARNING,
            Debug: (0, $1221feb2184dfefe$export$9130146a86a85749).INFO
        };
        messageList.forEach((item)=>{
            const type = types[item.className];
            const childList = Array.from(item.firstChild?.childNodes || []);
            const message = childList.find((item)=>item instanceof Text)?.textContent || '';
            const code = item.querySelector('.was-message-code')?.textContent || '';
            const addition = item.querySelector('.was-message-addition')?.textContent || '';
            const wait = Number(item.querySelector('.was-message-wait')?.textContent) || undefined;
            const consoleMessage = `${code}: ${message}} (wait: ${wait} sec.${addition})`;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)(type, message, wait, {
                consoleMessage: consoleMessage
            });
        });
        messageContainer.remove();
    }
    showSessionTimeout() {
        setTimeout(()=>{
            this.sessionTimeoutWrapper.hidden = false;
        }, this.sessionTime);
    }
    getPurchaseData() {
        return {
            event: 'event-purchase',
            ecommerce: {
                purchase: {
                    actionField: this.getActionData(),
                    products: this.getProductData()
                }
            }
        };
    }
    getActionData() {
        const affiliation = this.querySelector('[data-tk-otm-affiliation]');
        const revenue = this.querySelector('[data-tk-otm-revenue]');
        const tax = this.querySelector('[data-tk-otm-tax]');
        const shipping = this.querySelector('[data-tk-otm-shipping]');
        return {
            id: this.basketId.innerText,
            affiliation: affiliation ? affiliation.innerText : '',
            revenue: revenue ? revenue.innerText : '',
            tax: tax ? tax.innerText : '',
            shipping: shipping ? shipping.innerText : ''
        };
    }
    getProductData() {
        const data = [];
        const items = this.querySelectorAll('[data-tk-otm-item]');
        Array.from(items).forEach((item)=>{
            const id = item.querySelector('.otm-id');
            const name = item.querySelector('.otm-name');
            const brand = item.querySelector('.otm-brand');
            const category = item.querySelector('.otm-category');
            const price = item.querySelector('.otm-price');
            const quantity = item.querySelector('.otm-quantity');
            const position = item.querySelector('.otm-position');
            data.push({
                id: id ? id.innerText : '',
                name: name ? name.innerText : '',
                brand: brand ? brand.innerText : '',
                category: category ? category.innerText : '',
                price: price ? price.innerText : '',
                quantity: quantity ? quantity.innerText : '',
                position: position ? position.innerText : ''
            });
        });
        return data;
    }
    scrollToElement() {
        const { top: top } = this.firstItemToScrollInto.getBoundingClientRect();
        const offset = Number(this.firstItemToScrollInto?.getAttribute('data-tk-scroll-into-offset')) || 16;
        const mainContainer = this.querySelector('main');
        const mainRect = mainContainer?.getBoundingClientRect();
        const mainRectTop = mainRect?.top || 0;
        const scrollY = top - mainRectTop - offset;
        setTimeout(()=>{
            window.scrollTo({
                top: scrollY,
                behavior: 'smooth'
            });
        }, 0);
    }
}





const $fbcf93c2a0aa5bcb$export$37cc283d8fbd3462 = (value)=>{
    const bytes = new TextEncoder().encode(value);
    return btoa(String.fromCharCode(...bytes));
};
const $fbcf93c2a0aa5bcb$export$c537b38001c583b7 = (base64)=>{
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (char)=>char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
};
const $fbcf93c2a0aa5bcb$var$isBase64 = (value)=>{
    try {
        return $fbcf93c2a0aa5bcb$export$37cc283d8fbd3462($fbcf93c2a0aa5bcb$export$c537b38001c583b7(value)) === value;
    } catch  {
        return false;
    }
};
var $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039 = $fbcf93c2a0aa5bcb$var$isBase64;


const $1653b55d89a7adce$var$getDefaultErrorFnc = (error)=>{
    throw new Error(`Request failed: ${error}`);
};
const $1653b55d89a7adce$export$a4101276b4831ec4 = (checkForReadOnlyContext = false)=>{
    const asyncUrl = '/WebPortal/async.aspx';
    if (!window.opacc || !window.opacc.systemUrls || !checkForReadOnlyContext || !window.opacc.systemUrls.asyncReadOnly) return asyncUrl;
    return window.opacc.systemUrls.asyncReadOnly;
};
const $1653b55d89a7adce$var$prepareJsonResponse = (response, showMessages)=>{
    const data = (0, $fbcf93c2a0aa5bcb$export$c537b38001c583b7)(response.data);
    const html = document.createElement('div');
    html.innerHTML = data;
    const json = response.contentType === 'application/json' && html.innerText !== '' ? JSON.parse(html.innerText) : {};
    showMessages && (0, $1221feb2184dfefe$export$5b256beea4c7e9b5)(response.messages, json);
    return {
        status: response.status,
        messages: response.messages,
        dataAsBase64: response.data,
        contentType: response,
        success: response.status === 'ok',
        dataAsHtml: response.contentType === 'text/html' ? html.innerText : '',
        dataAsJson: json,
        data: data
    };
};
const $1653b55d89a7adce$var$recordToURLSearchParams = (data)=>{
    const searchParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value])=>{
        searchParams.append(key, value || '');
    });
    return searchParams;
};
const $1653b55d89a7adce$var$formDataToURLSearchParams = (formData)=>{
    const searchParams = new URLSearchParams();
    formData.forEach((value, key)=>{
        searchParams.append(key, value);
    });
    return searchParams;
};
const $1653b55d89a7adce$export$d5a8517da06db2d = async ({ requestURL: requestURL, resolveHandler: resolveHandler, rejectHandler: rejectHandler = $1653b55d89a7adce$var$getDefaultErrorFnc, payload: payload, decodeJSONResponse: decodeJSONResponse = true, cache: cache = 'default', showMessages: showMessages = true, signal: signal })=>{
    const headers = new Headers({
        'x-requested-with': 'XMLHttpRequest',
        'response-type': 'json'
    });
    let body;
    if (payload) {
        headers.set('content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
        if (payload instanceof URLSearchParams) body = payload;
        else if (payload instanceof FormData) body = $1653b55d89a7adce$var$formDataToURLSearchParams(payload);
        else if (payload instanceof Object) body = $1653b55d89a7adce$var$recordToURLSearchParams(payload);
    }
    const init = {
        method: payload ? 'POST' : 'GET',
        headers: headers,
        cache: cache,
        credentials: 'include',
        body: body,
        signal: signal
    };
    try {
        const response = await fetch(requestURL, init);
        const contentType = response.headers.get('content-type');
        const data = contentType?.includes('application/json') ? await response.json() : await response.text();
        const preparedData = decodeJSONResponse ? $1653b55d89a7adce$var$prepareJsonResponse(data, showMessages) : data;
        resolveHandler(preparedData);
    } catch (error) {
        if (error instanceof Error && error.name === 'AbortError') return;
        rejectHandler(error);
    }
};
const $1653b55d89a7adce$export$24835cb787452b46 = async (params)=>{
    const requestManager = document.querySelector('[data-tk-request-manager]');
    if (requestManager) return requestManager.addRequest(params);
    return $1653b55d89a7adce$export$d5a8517da06db2d(params);
};
const $1653b55d89a7adce$export$38e06f4bcf141755 = async (params)=>{
    return new Promise((resolve, reject)=>{
        $1653b55d89a7adce$export$d5a8517da06db2d({
            ...params,
            resolveHandler: (response)=>{
                resolve(response.dataAsJson);
            },
            rejectHandler: reject
        });
    });
};


class $40898dd22403025f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.pages = [];
        this.navigationWrapper = document.querySelector('[data-tk-nav-wrapper]') || undefined;
        this.wrapper = this.querySelector('[data-tk-wrapper]') || undefined;
        this.openButton = document.querySelector(`[data-tk-nav-open="${this.id}"]`) || undefined;
        this.closeButton = document.querySelector(`[data-tk-nav-close="${this.id}"]`) || undefined;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'viewport__navigation--open';
        this.currentMenuId = this.getAttribute('data-tk-current-menu-id') || undefined;
        this.hasChildrenClassName = this.getAttribute('data-tk-has-children-class-name') || 'tk-nav-burger-item--has-children';
        this.asyncTemplateName = this.getAttribute('data-tk-nav-async-template-name') || 'tk-navigation-burgerlist';
        this.desktopMinWidth = Number(this.getAttribute('data-tk-desktop-min-width')) || 1200;
        this.overlayClassName = this.getAttribute('data-tk-overlay-class-name') || 'viewport__overlay';
        this.isMobile = window.viewport.clientWidth < this.desktopMinWidth;
        this.isMobileActive = false;
        this.overlay = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class="${this.overlayClassName}"></div>`);
    }
    connectedCallback() {
        if (!this.currentMenuId) throw new Error('Current menu id is missing!');
        this.registerViewportListener();
        this.registerButtonListener();
        this.registerClickListener();
        this.isMobile && this.switchToMobile();
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        this.isMobile = customEvent.detail.width < this.desktopMinWidth;
        this.isMobile ? this.switchToMobile() : this.switchToDesktop();
    }
    registerButtonListener() {
        this.openButton?.addEventListener('click', this.openNavigation.bind(this));
        this.closeButton?.addEventListener('click', this.closeNavigation.bind(this));
    }
    registerClickListener() {
        this.addEventListener('click', this.handleClickLink.bind(this));
    }
    openNavigation() {
        this.navigationWrapper ? this.navigationWrapper.classList.add(this.openClassName) : this.classList.add(this.openClassName);
        document.body.insertAdjacentElement('beforeend', this.overlay);
    }
    closeNavigation() {
        this.navigationWrapper ? this.navigationWrapper.classList.remove(this.openClassName) : this.classList.remove(this.openClassName);
        const overlay = document.querySelector(`.${this.overlayClassName}`);
        overlay?.remove();
    }
    async handleClickLink(event) {
        if (!this.isMobile) return;
        event.preventDefault();
        const target = event.target;
        let element;
        if (target.hasAttribute('data-tk-nav-id')) element = target;
        else element = target.closest('[data-tk-nav-id]');
        if (!element) return;
        if (!element.parentElement?.classList.contains(this.hasChildrenClassName) && !element.parentElement?.hasAttribute('data-tk-nav-page')) {
            window.location.href = element.href;
            this.closeNavigation();
            return;
        }
        const id = element.getAttribute('data-tk-nav-id');
        if (!id) return;
        if (this.existPage(id)) {
            const page = this.getPage(id);
            if (!page) return;
            this.insertPage(page.element);
            $40898dd22403025f$export$2e2bcd8739ae039.jumpToPage(page.element);
            this.removeLastPageFromDOM();
        } else {
            const response = await this.getTemplate(id);
            this.responseNextLevel(response);
        }
    }
    getTemplate(id) {
        const url = window.opacc.systemUrls?.async || '/WebPortal/async.aspx';
        const data = {
            type: 'navigation',
            navigationid: id,
            template: this.asyncTemplateName
        };
        return new Promise((resolve, reject)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: (response)=>resolve(response),
                rejectHandler: (error)=>reject(error),
                payload: data
            });
        });
    }
    responseNextLevel(response) {
        if (!response.success) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsJson.showItems);
        if (!html) return;
        const navigation = html.querySelector('[data-tk-nav-page]');
        if (!navigation) return;
        this.addPage(navigation);
        this.insertPage(navigation);
        $40898dd22403025f$export$2e2bcd8739ae039.jumpToPage(navigation);
        this.removeLastPageFromDOM();
    }
    insertPage(element) {
        const pages = this.querySelector('[data-tk-nav-pages]');
        if (!pages) return;
        pages.insertAdjacentElement('afterbegin', element);
    }
    addPage(element) {
        const id = element.getAttribute('data-tk-nav-page') || '';
        !this.existPage(id) && this.pages.push({
            id: id,
            element: element
        });
    }
    getPage(id) {
        return this.pages.find((page)=>page.id === id);
    }
    existPage(id) {
        if (id === '') return false;
        const foundPage = this.pages.filter((page)=>page.id === id);
        return foundPage.length > 0;
    }
    removeLastPageFromDOM() {
        const pages = this.querySelector('[data-tk-nav-pages]');
        if (!pages) return;
        const pageList = Array.from(pages.children);
        const oldPages = pageList.filter((element)=>element !== pages.firstElementChild);
        oldPages.forEach((element)=>element.remove());
    }
    async switchToMobile() {
        if (this.isMobileActive) return;
        this.isMobileActive = true;
        this.closeButton && (this.closeButton.hidden = false);
        if (!this.wrapper) return;
        this.desktopView = this.wrapper.innerHTML;
        if (!this.mobileView) {
            const response = await this.getTemplate(this.currentMenuId);
            const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsJson.showItems);
            if (!html) throw new Error('Burgerlist: Root Element is missing!');
            this.wrapper.replaceChildren(html);
            const navigation = html.querySelector('[data-tk-nav-page]');
            navigation && this.addPage(navigation);
        } else {
            this.wrapper.innerHTML = '';
            this.wrapper.insertAdjacentHTML('afterbegin', this.mobileView);
        }
    }
    async switchToDesktop() {
        if (!this.isMobileActive) return;
        this.isMobileActive = false;
        this.closeButton && (this.closeButton.hidden = true);
        if (!this.wrapper) return;
        this.mobileView = this.wrapper.innerHTML;
        if (!this.desktopView) return;
        this.wrapper.innerHTML = '';
        this.wrapper.insertAdjacentHTML('afterbegin', this.desktopView);
    }
    static jumpToPage(element) {
        element.scrollIntoView(false);
    }
}



class $1352bbad447b1dc9$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.lastScrollPosY = 0, this.scrollWay = 0;
        this.header = this.querySelector('header') || undefined;
        if (!this.header) throw new Error('Header: Header is missing!');
        this.disableScrolldownBreakpoint = this.getAttribute('data-tk-disable-scrolldown-breakpoint') || 's';
        this.minWidthBreakpoint = window.viewport.breakpoints.get(this.disableScrolldownBreakpoint) || 0;
        this.elementToScrollWith = this.querySelector('[data-tk-to-scroll-with]') || undefined;
        if (!this.elementToScrollWith) throw new Error('Header: Element to scroll with is missing! Use the [data-tk-to-scroll-with] selector.');
        this.maxHeightScrollWith = this.getMaxHeight();
        this.scrollDeltaY = Number(this.getAttribute('data-tk-scroll-delta-y')) || 1;
    }
    connectedCallback() {
        this.registerViewportListener();
        window.viewport.clientWidth < this.minWidthBreakpoint && this.registerScrollListener();
    }
    registerScrollListener() {
        if (!this.elementToScrollWith) return;
        const onScrolldown = this.handleScrolldown.bind(this);
        this.maxHeightScrollWith = this.getMaxHeight();
        this.pushListener({
            event: 'scroll',
            element: window,
            action: onScrolldown
        });
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.minWidthBreakpoint) this.registerScrollListener();
        else this.removeListener(window);
    }
    handleScrolldown(event) {
        if (!(this.header && this.elementToScrollWith)) return;
        const { scrollY: scrollY } = event.currentTarget;
        if (scrollY > this.lastScrollPosY) {
            if (scrollY <= this.maxHeightScrollWith) this.scrollWay = scrollY;
            else this.scrollWay = this.maxHeightScrollWith;
        } else if (this.scrollWay > this.scrollDeltaY) this.scrollWay = this.lastScrollPosY - scrollY >= this.maxHeightScrollWith ? 0 : this.lastScrollPosY - scrollY;
        else this.scrollWay = 0;
        this.elementToScrollWith.style.transform = `translateY(-${this.scrollWay}px)`;
        this.lastScrollPosY = scrollY;
    }
    getMaxHeight() {
        if (!this.elementToScrollWith) return 0;
        const { paddingBottom: paddingBottom } = window.getComputedStyle(this.elementToScrollWith);
        const { height: height } = this.elementToScrollWith.getBoundingClientRect();
        return height - parseInt(paddingBottom, 10);
    }
}



class $49fab39bf1404505$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.resizeEventName = this.getAttribute('data-tk-resize-event-name') || 'tk-viewport-resize';
        this.resizeObserver = new ResizeObserver(this.checkSize.bind(this));
        // * These breakpoints must match the CSS breakpoints, otherwise conflicts may occur.
        this.breakpoints = new Map([
            [
                'xs',
                576
            ],
            [
                's',
                768
            ],
            [
                'm',
                992
            ],
            [
                'l',
                1200
            ],
            [
                'xl',
                1440
            ]
        ]);
        this.currentBreakpoint = this.getCurrentBreakpoint(this.clientWidth);
    }
    connectedCallback() {
        this.resizeObserver.observe(this);
        window.viewport = this;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
    }
    checkSize(entries) {
        entries.forEach(()=>{
            const currentWidth = window.innerWidth;
            const currentBreakpoint = this.getCurrentBreakpoint(currentWidth);
            if (this.currentBreakpoint !== currentBreakpoint) {
                const event = new CustomEvent(this.resizeEventName, {
                    bubbles: true,
                    detail: {
                        width: currentWidth,
                        breakpoint: currentBreakpoint
                    }
                });
                this.currentBreakpoint = currentBreakpoint;
                this.dispatchEvent(event);
            }
        });
    }
    getCurrentBreakpoint(width) {
        let currentBreakpoint = 'xs';
        this.breakpoints.forEach((value, key)=>{
            if (width >= value) currentBreakpoint = key;
        });
        return currentBreakpoint;
    }
}


class $9ada6dd3e169a5cf$export$2e2bcd8739ae039 extends (0, $49fab39bf1404505$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.breakpoints = new Map([
            [
                'xs',
                576
            ],
            [
                's',
                768
            ],
            [
                'm',
                992
            ],
            [
                'l',
                1200
            ],
            [
                'xl',
                1920
            ]
        ]);
    }
}








var $fd4fdaa8be3050bd$export$eb1b84084436143e = /*#__PURE__*/ function(BasketAction) {
    BasketAction["FETCHING"] = "fetching";
    BasketAction["REFRESHED_LIST"] = "refreshed-list";
    BasketAction["REFRESHED_BASKET"] = "refreshed-basket";
    return BasketAction;
}({});
class $fd4fdaa8be3050bd$export$2e2bcd8739ae039 {
    constructor(component){
        this.listeners = [];
        this.component = component;
        this.componentSelector = `.${this.component.classList.value}`;
        this.basketList = document.querySelector('[data-tk-basket-list]') || undefined;
        this.totalAmount = document.querySelector('[data-tk-basket-total-amount]') || undefined;
        this.miniBasket = document.querySelector('[data-tk-minibasket]') || undefined;
        this.emptyClassName = this.basketList?.getAttribute('data-tk-basket-empty-class-name') || 'module-basket--empty';
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
    emit(data) {
        this.listeners.forEach((listener)=>{
            listener(data);
        });
    }
    fetch(checkForReadonlyContext = false) {
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(checkForReadonlyContext);
        this.emit({
            action: "fetching"
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshResultList.bind(this),
            payload: this.prepareDataSubmission()
        });
    }
    prepareDataSubmission() {
        const { tkAction: tkAction, tkModule: tkModule, tkArtInternalno: tkArtInternalno, tkSalDocItemBoId: tkSalDocItemBoId, tkSalDocBoId: tkSalDocBoId, tkAddAllOptions: tkAddAllOptions, tkVariant: tkVariant, tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3, tkAsyncTemplate: tkAsyncTemplate, tkRequest: tkRequest, tkEncrypted: tkEncrypted } = this.component.dataset;
        const data = {
            type: 'basket',
            action: tkAction,
            module: tkModule,
            originalUrl: window.location.href
        };
        tkArtInternalno && (data.artInternalNo = tkArtInternalno);
        tkSalDocItemBoId && (data.salDocItemBoId = tkSalDocItemBoId);
        tkSalDocBoId && (data.salDocBoId = tkSalDocBoId);
        tkAddAllOptions && (data.addalloptions = tkAddAllOptions);
        tkVariant && (data.artDimVariantNo = tkVariant);
        tkQuantityId1 && (data.catItemQuantityDim1 = this.getButtonDimValue(tkQuantityId1));
        tkQuantityId2 && (data.catItemQuantityDim2 = this.getButtonDimValue(tkQuantityId2));
        tkQuantityId3 && (data.catItemQuantityDim3 = this.getButtonDimValue(tkQuantityId3));
        tkAsyncTemplate && (data.template = tkAsyncTemplate);
        tkRequest && (data.request = tkRequest);
        tkEncrypted && (data.encrypted = tkEncrypted);
        Object.keys(this.component.dataset).filter((key)=>key.startsWith('tkSaldocitem.')).forEach((key)=>{
            data[key.substring(2).toLowerCase()] = this.component.dataset[key];
        });
        if (tkAction === 'addall') {
            const quantities = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.getQuantitiesFromPositions();
            quantities !== '{}' && (data.addall = quantities);
        }
        return data;
    }
    static getQuantitiesFromPositions() {
        const quantities = {};
        const articleList = document.querySelector('[data-tk-basket-add-all-wrapper]');
        const articles = articleList?.querySelectorAll('article');
        articles?.forEach((article)=>{
            const id = article.getAttribute('data-tk-item-number');
            if (!id) return;
            const basketButton = article.querySelector('[data-tk-basket-button]');
            if (!basketButton) return;
            const dimensions = basketButton.querySelectorAll('[data-tk-dimension]:not([hidden])');
            dimensions.forEach((dimension)=>{
                const dimensionNumber = dimension.getAttribute('data-tk-dimension') || '';
                const fieldElement = dimension.querySelector('[data-tk-input-quantity]');
                quantities[`position${id}${dimensionNumber}`] = fieldElement?.value || '0';
            });
        });
        return JSON.stringify(quantities);
    }
    getButtonDimValue(dimNumIdVal) {
        let retVal = '';
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return retVal;
        const input = dim.querySelector('[data-tk-input-quantity]');
        if (!input) return retVal;
        let value = Number(input.value);
        const defaultValue = Number(input.min) || 1;
        if (dim.hidden) return retVal;
        if (Number.isNaN(value) || value <= 0) {
            value = defaultValue;
            retVal = String(defaultValue);
        } else retVal = String(value);
        return retVal;
    }
    getButtonDimUnit(dimNumIdVal) {
        let unit = '';
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return unit;
        if (dim.hidden) return unit;
        const unitElement = dim.querySelector('[data-tk-basket-dim-unit]');
        if (!unitElement) return unit;
        unit = unitElement.innerText;
        return unit;
    }
    refreshResultList(response) {
        this.emit({
            action: "refreshed-list",
            data: response.dataAsJson
        });
        if (!response.success) return;
        this.updateMiniBasket(response.dataAsJson);
        this.updateBasket(response.dataAsJson);
        if (response.dataAsJson.action === 'added') (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(this.getQuantityMessage());
        const { action: action } = response.dataAsJson;
        this.updateCartTracker(action);
    }
    updateMiniBasket(data) {
        this.miniBasket?.dispatchEvent(this.miniBasket.updateEvent);
        this.miniBasket?.setAttribute('data-count', `${data.quantity}`);
    }
    updateBasket(data) {
        if (!this.basketList) return;
        const { tkAction: tkAction } = this.component.dataset;
        if (tkAction === 'delete' || tkAction === 'deleteall') {
            if (data.quantity === 0) window.location.reload();
            else {
                const basketPos = this.basketList.querySelector(`[data-tk-internalno="${this.component.dataset.tkInternalno}"]`) || this.component.closest('[data-tk-basket-item]');
                if (basketPos) basketPos.remove();
            }
        } else if (tkAction === 'change') {
            // update item price and amount
            const price = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-price]');
            if (price) price.innerHTML = `${data.currency} ${data.itemPrice}`;
            const amount = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-amount]');
            if (!amount) return;
            amount.innerHTML = `${data.currency} ${data.itemAmount}`;
        } else if (this.component.closest('tk-quick-order')) {
            // update after quickorder
            const quickorder = this.component.closest('tk-quick-order');
            if (!quickorder) return;
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: quickorder.dataset.tkUrlRefresh || window.location.href,
                resolveHandler: this.refreshBasketList.bind(this)
            });
        }
        // update total amount and VAT
        if (this.totalAmount) this.totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
        const totalVat = this.basketList.querySelector('[data-tk-basket-total-vat]');
        if (totalVat) totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
        this.emit({
            action: "refreshed-basket"
        });
    }
    refreshBasketList(response) {
        if (!response || !response.success || !this.basketList) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        const basketListWrapper = html.querySelector('[data-tk-basket-list]');
        basketListWrapper && (this.basketList.innerHTML = basketListWrapper.innerHTML);
        this.basketList.classList.remove(this.emptyClassName);
        const existDeleteAllButton = document.querySelector('[data-tk-basket-list-actions] > tk-basket-button');
        if (!existDeleteAllButton) {
            const basketHeaderActionWrapper = document.querySelector('[data-tk-basket-list-actions]');
            const deleteAllButton = html.querySelector('[data-tk-basket-list-actions] > tk-basket-button');
            deleteAllButton && basketHeaderActionWrapper?.insertAdjacentElement('beforeend', deleteAllButton);
        }
        const footer = document.querySelector('[data-tk-basket-list-footer]');
        if (!footer) {
            const footerWrapper = html.querySelector('[data-tk-basket-list-footer]');
            footerWrapper && this.basketList.insertAdjacentElement('afterend', footerWrapper);
        }
    }
    static quantityChanger(event) {
        const target = event.target;
        const currentTarget = event.currentTarget;
        if (!target || !target.parentElement) return;
        let wrapper = null;
        wrapper = target.closest('[data-tk-counter]');
        if (!wrapper) wrapper = target.closest('[data-tk-dimension]');
        if (!wrapper) return;
        const decrementButton = wrapper.querySelector('[data-tk-counter-decreaser]');
        const incrementButton = wrapper.querySelector('[data-tk-counter-increaser]');
        const inputField = wrapper.querySelector('[data-tk-input-quantity]');
        if (!inputField) return;
        const step = Number(inputField.getAttribute('step') || 1);
        const min = Number(inputField.getAttribute('min') || step);
        const max = Number(inputField.getAttribute('max') || 0);
        const isMaxSet = max > 0;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = inputField.dataset;
        const artDimCheck = tkArtDimCheckCd ? Number(tkArtDimCheckCd) : 0;
        const oldValue = Number(inputField.value || 0);
        let hasChanged = false;
        let operator = '+';
        if (incrementButton && target === incrementButton) {
            operator = '+';
            if (oldValue < min) operator = '-';
        } else if (decrementButton && target === decrementButton) {
            operator = '-';
            if (oldValue > max && isMaxSet) operator = '+';
        }
        if (event.key === 'ENTER') {
            if (oldValue > max) operator = '+';
            else if (oldValue < min) operator = '-';
        }
        if (artDimCheck > 0) {
            const multiplikator = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.countDecimals(step);
            const currentValPow = oldValue * 10 ** multiplikator;
            const stepPow = step * 10 ** multiplikator;
            if ((currentValPow === 0 || currentValPow % stepPow !== 0) && oldValue >= min) {
                const result = (currentValPow + stepPow - currentValPow % stepPow) / 10 ** multiplikator;
                (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace('{currentValue}', String(oldValue)).replace('{newValue}', String(result)).replace('{step}', String(step)));
                operator = '+';
            }
        }
        if (currentTarget === decrementButton || currentTarget === incrementButton) hasChanged = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.setCalculatedQuantityField(oldValue, inputField, step, min, max, operator);
        return hasChanged;
    }
    getQuantityMessage() {
        const message = {
            ...(0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket
        };
        const { tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3 } = this.component.dataset;
        const dim1Value = this.getButtonDimValue(tkQuantityId1 || '');
        const dim1Unit = this.getButtonDimUnit(tkQuantityId1 || '');
        const dim2Value = this.getButtonDimValue(tkQuantityId2 || '');
        const dim2Unit = this.getButtonDimUnit(tkQuantityId2 || '');
        const dim3Value = this.getButtonDimValue(tkQuantityId3 || '');
        const dim3Unit = this.getButtonDimUnit(tkQuantityId3 || '');
        let quantity = `${dim1Value} ${dim1Unit} `;
        if (dim2Value) quantity = `${quantity}x ${dim2Value} ${dim2Unit} `;
        if (dim3Value) quantity = `${quantity}x ${dim3Value} ${dim3Unit} `;
        message.text = quantity + (0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket.text;
        return message;
    }
    updateCartTracker(action) {
        const urlElement = document.querySelector('[data-tk-basket-tracker]');
        const url = urlElement?.getAttribute('data-tk-url');
        if (!url) return;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleCartTracker.bind(this, action)
        });
    }
    handleCartTracker(action, response) {
        if (!response || !response.dataAsJson) return;
        const { items: items, data: data } = response.dataAsJson;
        const trackerElement = document.querySelector('[data-tk-tracker-wrapper]');
        trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                type: (0, $588d148f2c9ac202$export$4120f82005ec4b2d).BASKET_UPDATE,
                item: {
                    event: action,
                    location: window.location.href,
                    currency: data.currency,
                    value: data.totalAmount,
                    items: items
                }
            }
        }));
    }
    static setCalculatedQuantityField(currentVal, fieldElement, step, min, max = 0, operator = '+') {
        const multiplikator = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.countDecimals(step);
        const currentValPow = Math.round(currentVal * 10 ** multiplikator);
        const stepPow = Math.round(step * 10 ** multiplikator);
        const minPow = Math.round(min * 10 ** multiplikator);
        const maxPow = Math.round(max * 10 ** multiplikator);
        let newValuePow = currentValPow;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = fieldElement.dataset;
        const artDimCheck = Number(tkArtDimCheckCd);
        const operatorHandler = {
            '-': ()=>$fd4fdaa8be3050bd$export$2e2bcd8739ae039.calcMinus(currentValPow, newValuePow, stepPow, minPow, min, Number(artDimCheck)),
            '+': ()=>$fd4fdaa8be3050bd$export$2e2bcd8739ae039.calcPlus(currentValPow, newValuePow, stepPow, maxPow, max, Number(artDimCheck))
        };
        newValuePow = operatorHandler[operator]();
        // Wert veraendert und Step beruecksichtigt?
        if (newValuePow !== currentValPow) {
            if (newValuePow % stepPow === 0 || artDimCheck === 0) {
                fieldElement.value = String(newValuePow / 10 ** multiplikator);
                return true;
            }
            newValuePow = currentValPow;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace('{step}', String(step)));
        }
        return false;
    }
    static calcPlus(currentValPow, newValuePow, stepPow, maxPow, max, artDimCheck) {
        if (maxPow > 0 && newValuePow > maxPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeOverflow.replace('{max}', String(max)));
            return maxPow;
        }
        return currentValPow + stepPow - (artDimCheck > 0 ? currentValPow % stepPow : 0);
    }
    static calcMinus(currentValPow, newValuePow, stepPow, minPow, min, artDimCheck) {
        if (newValuePow <= minPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeUnderflow.replace('{min}', String(min)));
            return minPow;
        }
        const adjustment = artDimCheck === 0 || currentValPow % stepPow === 0 ? stepPow : currentValPow % stepPow;
        return currentValPow - adjustment;
    }
    static countDecimals(value) {
        if (Math.floor(value) === value) return 0;
        return value.toString().split('.')[1].length || 0;
    }
}




var $127c03b03da38c7a$export$416096e8140b15df = /*#__PURE__*/ function(BasketActionTypes) {
    BasketActionTypes["ADD"] = "add";
    BasketActionTypes["CHANGE"] = "change";
    BasketActionTypes["DELETE"] = "delete";
    BasketActionTypes["ADD_ALL"] = "addall";
    BasketActionTypes["DELETE_ALL"] = "deleteall";
    return BasketActionTypes;
}({});
class $127c03b03da38c7a$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.basketAction = new (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039)(this);
        this.action = this.getAttribute('data-tk-action') || "add";
        this.button = this.querySelector('[data-tk-basket-button]') || undefined;
        this.counterWrapper = this.querySelector('[data-tk-counter]') || undefined;
        this.variantWrapper = this.querySelector('[data-tk-basket-variants]') || undefined;
        if (this.counterWrapper) {
            this.decreaser = this.querySelector('[data-tk-counter-decreaser]') || undefined;
            this.increaser = this.querySelector('[data-tk-counter-increaser]') || undefined;
            this.counter = this.querySelector('[data-tk-input-quantity]') || undefined;
            this.counters = this.querySelectorAll('[data-tk-input-quantity]');
        }
    }
    connectedCallback() {
        if (!this.button) throw new Error('Basket: Button is missing!');
        this.registerClickListener();
        this.counterWrapper && this.registerCounter();
        this.registerBasketListener();
        this.variantWrapper && this.registerVariantListener();
    }
    registerClickListener() {
        const onClick = this.handleBasketClick.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerVariantListener() {
        const onInput = this.updateDimensions.bind(this);
        const fieldElement = this.variantWrapper?.querySelector('input[type="hidden"]');
        fieldElement && this.pushListener({
            event: 'change',
            element: fieldElement,
            action: onInput
        });
    }
    registerCounter() {
        if (!this.decreaser || !this.increaser) return;
        if (this.action === "change") {
            const onChange = this.change.bind(this);
            this.pushListener({
                event: 'click',
                element: this.decreaser,
                action: onChange
            });
            this.pushListener({
                event: 'click',
                element: this.increaser,
                action: onChange
            });
            this.counters?.forEach((counter)=>{
                this.pushListener({
                    event: 'change',
                    element: counter,
                    action: onChange
                });
            });
        } else {
            const onDecrease = this.decrease.bind(this);
            this.pushListener({
                event: 'click',
                element: this.decreaser,
                action: onDecrease
            });
            const onIncrease = this.increase.bind(this);
            this.pushListener({
                event: 'click',
                element: this.increaser,
                action: onIncrease
            });
        }
    }
    registerBasketListener() {
        this.basketAction.subscribe((event)=>{
            const basketActionHandler = {
                fetching: ()=>{},
                'refreshed-list': ()=>event.data && this.closeDialog(event.data),
                'refreshed-basket': ()=>{}
            };
            basketActionHandler[event.action]();
        });
    }
    closeDialog(data) {
        this.button.disabled = false;
        if (!data.success) return;
        const dialog = this.closest('dialog');
        if (!dialog) return;
        dialog.close();
    }
    handleBasketClick() {
        this.button.disabled = true;
        this.validateQuantity();
        this.basketAction.fetch(false);
    }
    increase() {
        if (!this.counter || !this.increaser) return;
        const { step: step, max: max, value: value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
    }
    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step: step, min: min, value: value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
    }
    change(event) {
        (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039).quantityChanger(event);
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.button?.click();
        }, 500);
    }
    validateQuantity() {
        const shouldCheckDimension = this.counter?.getAttribute('data-tk-art-dim-check-cd') === '1';
        if (!shouldCheckDimension || !this.counter) return;
        const step = Number(this.counter.step) || 1;
        const currentValue = Number(this.counter.value) || 1;
        const max = Number(this.counter.max);
        const min = Number(this.counter.min);
        if (currentValue % step === 0) return;
        let result = Math.ceil(currentValue / step) * step;
        if (min > 0 && result < min) result += step;
        if (max > 0 && result > max) result -= step;
        this.counter.value = String(result);
        (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepAdjust.replace('{currentValue}', String(currentValue)).replace('{newValue}', String(result)).replace('{step}', String(step)));
    }
    updateDimensions(event) {
        const selectedVariant = event.target;
        const getDimensionValue = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-value`) || '0';
        const getDimensionName = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-name`) || '';
        const getDimensionUnit = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-unit`) || '';
        const getDimensionMin = ()=>Number(selectedVariant.getAttribute('data-tk-min'));
        const getDimensionMax = ()=>Number(selectedVariant.getAttribute('data-tk-max'));
        const getDimensionStep = ()=>Number(selectedVariant.getAttribute('data-tk-step'));
        const getDimensionCheckCd = ()=>selectedVariant.getAttribute('data-tk-art-dim-check-cd') || '';
        const setDimension = (wrapper, dimension)=>{
            const value = getDimensionValue(dimension);
            const fieldElement = wrapper.querySelector('[data-tk-input-quantity]');
            const nameElement = wrapper.querySelector('[data-tk-basket-dim-unit-name]');
            const unitElements = wrapper.querySelectorAll('[data-tk-basket-dim-unit]');
            if (!fieldElement) return;
            fieldElement.value = value !== '0' ? value : '';
            fieldElement.setAttribute('data-tk-art-dim-check-cd', getDimensionCheckCd());
            if (getDimensionMin() > 0) fieldElement.setAttribute('min', String(getDimensionMin()));
            else fieldElement.removeAttribute('min');
            if (getDimensionMax() > 0) fieldElement.setAttribute('max', String(getDimensionMax()));
            else fieldElement.removeAttribute('max');
            if (getDimensionStep() > 0) fieldElement.setAttribute('step', String(getDimensionStep()));
            else fieldElement.removeAttribute('step');
            nameElement && (nameElement.textContent = getDimensionName(dimension));
            unitElements.forEach((element)=>{
                element.textContent = getDimensionUnit(dimension);
            });
        };
        const dimensionWrappers = this.querySelectorAll('[data-tk-dimension]:not([hidden])');
        dimensionWrappers.forEach((wrapper)=>{
            const dimension = wrapper.getAttribute('data-tk-dimension');
            dimension && setDimension(wrapper, dimension);
        });
        this.setAttribute('data-tk-variant', selectedVariant.value);
    }
}



/**
 * Swiper 12.1.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: February 18, 2026
 */ /**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */ /* eslint-disable no-param-reassign */ function $6b317c2177284918$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $6b317c2177284918$var$extend(target = {}, src = {}) {
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($6b317c2177284918$var$isObject(src[key]) && $6b317c2177284918$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $6b317c2177284918$var$extend(target[key], src[key]);
    });
}
const $6b317c2177284918$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $6b317c2177284918$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $6b317c2177284918$var$extend(doc, $6b317c2177284918$var$ssrDocument);
    return doc;
}
const $6b317c2177284918$var$ssrWindow = {
    document: $6b317c2177284918$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $6b317c2177284918$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $6b317c2177284918$var$extend(win, $6b317c2177284918$var$ssrWindow);
    return win;
}



function $36f917fbf2efdd6b$export$342063e11d6c3cad(classes = '') {
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $36f917fbf2efdd6b$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $36f917fbf2efdd6b$export$dda1d9f60106f0e9() {
    return Date.now();
}
function $36f917fbf2efdd6b$var$getComputedStyle(el) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $36f917fbf2efdd6b$export$882b5998b3b9117c(el, axis = 'x') {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $36f917fbf2efdd6b$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $36f917fbf2efdd6b$export$ffb5f4729a158638(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $36f917fbf2efdd6b$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $36f917fbf2efdd6b$export$d141bba7fdc215a3(...args) {
    const to = Object(args[0]);
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$36f917fbf2efdd6b$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>key !== '__proto__' && key !== 'constructor' && key !== 'prototype');
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($36f917fbf2efdd6b$export$ffb5f4729a158638(to[nextKey]) && $36f917fbf2efdd6b$export$ffb5f4729a158638(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $36f917fbf2efdd6b$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$36f917fbf2efdd6b$export$ffb5f4729a158638(to[nextKey]) && $36f917fbf2efdd6b$export$ffb5f4729a158638(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $36f917fbf2efdd6b$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $36f917fbf2efdd6b$export$8b22cf2602fb60ce(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $36f917fbf2efdd6b$export$3b14a55fb2447963({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $36f917fbf2efdd6b$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $36f917fbf2efdd6b$export$f1e1789686576879(element, selector = '') {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $36f917fbf2efdd6b$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $36f917fbf2efdd6b$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $36f917fbf2efdd6b$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $36f917fbf2efdd6b$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $36f917fbf2efdd6b$export$db3b6bfb95261072(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $36f917fbf2efdd6b$export$342063e11d6c3cad(classes));
    return el;
}
function $36f917fbf2efdd6b$export$2d1720544b23b823(el) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $36f917fbf2efdd6b$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $36f917fbf2efdd6b$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $36f917fbf2efdd6b$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $36f917fbf2efdd6b$export$35e795649ee09318(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $36f917fbf2efdd6b$export$4368d992c4eafac0(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $36f917fbf2efdd6b$export$ae1af26003f05816(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $36f917fbf2efdd6b$export$23f2a1d2818174ef(el, size, includeMargins) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $36f917fbf2efdd6b$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $36f917fbf2efdd6b$export$407448d2b89b1813(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $36f917fbf2efdd6b$export$2408f22a0fab9ae5(el, html = '') {
    if (typeof trustedTypes !== 'undefined') el.innerHTML = trustedTypes.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $029bc59d811a92d7$var$support;
function $029bc59d811a92d7$var$calcSupport() {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $029bc59d811a92d7$var$getSupport() {
    if (!$029bc59d811a92d7$var$support) $029bc59d811a92d7$var$support = $029bc59d811a92d7$var$calcSupport();
    return $029bc59d811a92d7$var$support;
}
let $029bc59d811a92d7$var$deviceCached;
function $029bc59d811a92d7$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = $029bc59d811a92d7$var$getSupport();
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $029bc59d811a92d7$var$getDevice(overrides = {}) {
    if (!$029bc59d811a92d7$var$deviceCached) $029bc59d811a92d7$var$deviceCached = $029bc59d811a92d7$var$calcDevice(overrides);
    return $029bc59d811a92d7$var$deviceCached;
}
let $029bc59d811a92d7$var$browser;
function $029bc59d811a92d7$var$calcBrowser() {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const device = $029bc59d811a92d7$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $029bc59d811a92d7$var$getBrowser() {
    if (!$029bc59d811a92d7$var$browser) $029bc59d811a92d7$var$browser = $029bc59d811a92d7$var$calcBrowser();
    return $029bc59d811a92d7$var$browser;
}
function $029bc59d811a92d7$var$Resize({ swiper: swiper, on: on, emit: emit }) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $029bc59d811a92d7$var$Observer({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $029bc59d811a92d7$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $029bc59d811a92d7$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-left') || 0, 10) - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-top') || 0, 10) - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $029bc59d811a92d7$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    // set cssMode offsets
    if (params.cssMode) {
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-slides-offset-before', `${offsetBefore}px`);
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-slides-offset-after', `${offsetAfter}px`);
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
            if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
            if ((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(slide, 'display') === 'none') continue; // eslint-disable-line
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            if (params.virtual.slidesPerViewAutoSlideSize) slideSize = params.virtual.slidesPerViewAutoSlideSize;
            if (slideSize && slide) {
                if (params.roundLengths) slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
            }
        } else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slide.style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(slide, 'width', true) : (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slide) slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slide) slide.swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        // Check if snapToSlideEdge should be applied
        const isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
        const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === 'auto' || isFractionalSlidesPerView);
        // Calculate the last allowed snap index when snapToSlideEdge is enabled
        // This ensures minimum slides are visible at the end
        let lastAllowedSnapIndex = snapGrid.length;
        if (shouldSnapToSlideEdge) {
            let minVisibleSlides;
            if (params.slidesPerView === 'auto') {
                // For 'auto' mode, calculate how many slides fit based on actual sizes
                minVisibleSlides = 1;
                let accumulatedSize = 0;
                for(let i = slidesSizesGrid.length - 1; i >= 0; i -= 1){
                    accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
                    if (accumulatedSize <= swiperSize) minVisibleSlides = slidesSizesGrid.length - i;
                    else break;
                }
            } else minVisibleSlides = Math.floor(params.slidesPerView);
            lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
        }
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (shouldSnapToSlideEdge) // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
            {
                if (i <= lastAllowedSnapIndex) newSlidesGrid.push(slidesGridItem);
            } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
            newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) // Only add edge-aligned snap if snapToSlideEdge is not enabled
        {
            if (!shouldSnapToSlideEdge) snapGrid.push(swiper.virtualSize - swiperSize);
        }
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $029bc59d811a92d7$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $029bc59d811a92d7$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $029bc59d811a92d7$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $029bc59d811a92d7$var$updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $029bc59d811a92d7$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $029bc59d811a92d7$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $029bc59d811a92d7$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $029bc59d811a92d7$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $029bc59d811a92d7$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $36f917fbf2efdd6b$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $36f917fbf2efdd6b$export$625550452a3fa3ec)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $029bc59d811a92d7$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
                }
            });
        }
        // Skip removal if managed by React/Vue component
        if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
    }
};
const $029bc59d811a92d7$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $029bc59d811a92d7$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $029bc59d811a92d7$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $029bc59d811a92d7$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $029bc59d811a92d7$var$unlazy(swiper, i);
    }
};
function $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $029bc59d811a92d7$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled) {
        if (params.loop) realIndex = getVirtualRealIndex(activeIndex);
        else realIndex = activeIndex;
    } else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $029bc59d811a92d7$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $029bc59d811a92d7$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $029bc59d811a92d7$var$update = {
    updateSize: $029bc59d811a92d7$var$updateSize,
    updateSlides: $029bc59d811a92d7$var$updateSlides,
    updateAutoHeight: $029bc59d811a92d7$var$updateAutoHeight,
    updateSlidesOffset: $029bc59d811a92d7$var$updateSlidesOffset,
    updateSlidesProgress: $029bc59d811a92d7$var$updateSlidesProgress,
    updateProgress: $029bc59d811a92d7$var$updateProgress,
    updateSlidesClasses: $029bc59d811a92d7$var$updateSlidesClasses,
    updateActiveIndex: $029bc59d811a92d7$var$updateActiveIndex,
    updateClickedSlide: $029bc59d811a92d7$var$updateClickedSlide
};
function $029bc59d811a92d7$var$getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $029bc59d811a92d7$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $029bc59d811a92d7$var$minTranslate() {
    return -this.snapGrid[0];
}
function $029bc59d811a92d7$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $029bc59d811a92d7$var$translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $029bc59d811a92d7$var$translate = {
    getTranslate: $029bc59d811a92d7$var$getSwiperTranslate,
    setTranslate: $029bc59d811a92d7$var$setTranslate,
    minTranslate: $029bc59d811a92d7$var$minTranslate,
    maxTranslate: $029bc59d811a92d7$var$maxTranslate,
    translateTo: $029bc59d811a92d7$var$translateTo
};
function $029bc59d811a92d7$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $029bc59d811a92d7$var$transitionEmit({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $029bc59d811a92d7$var$transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $029bc59d811a92d7$var$transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $029bc59d811a92d7$var$transition = {
    setTransition: $029bc59d811a92d7$var$setTransition,
    transitionStart: $029bc59d811a92d7$var$transitionStart,
    transitionEnd: $029bc59d811a92d7$var$transitionEnd
};
function $029bc59d811a92d7$var$slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $029bc59d811a92d7$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $029bc59d811a92d7$var$slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter } = swiper.params;
            const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (bothDirections) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $029bc59d811a92d7$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $029bc59d811a92d7$var$slide = {
    slideTo: $029bc59d811a92d7$var$slideTo,
    slideToLoop: $029bc59d811a92d7$var$slideToLoop,
    slideNext: $029bc59d811a92d7$var$slideNext,
    slidePrev: $029bc59d811a92d7$var$slidePrev,
    slideReset: $029bc59d811a92d7$var$slideReset,
    slideToClosest: $029bc59d811a92d7$var$slideToClosest,
    slideToClickedSlide: $029bc59d811a92d7$var$slideToClickedSlide
};
function $029bc59d811a92d7$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial: initial
    });
}
function $029bc59d811a92d7$var$loopFix({ slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = {}) {
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter, initialSlide: initialSlide } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!bothDirections && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $029bc59d811a92d7$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $029bc59d811a92d7$var$loop = {
    loopCreate: $029bc59d811a92d7$var$loopCreate,
    loopFix: $029bc59d811a92d7$var$loopFix,
    loopDestroy: $029bc59d811a92d7$var$loopDestroy
};
function $029bc59d811a92d7$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $029bc59d811a92d7$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $029bc59d811a92d7$var$grabCursor = {
    setGrabCursor: $029bc59d811a92d7$var$setGrabCursor,
    unsetGrabCursor: $029bc59d811a92d7$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $029bc59d811a92d7$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $6b317c2177284918$export$39b482c5e57630a8)() || el === (0, $6b317c2177284918$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $029bc59d811a92d7$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $029bc59d811a92d7$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $029bc59d811a92d7$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $029bc59d811a92d7$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$029bc59d811a92d7$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $029bc59d811a92d7$var$onTouchMove(event) {
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $029bc59d811a92d7$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $029bc59d811a92d7$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $029bc59d811a92d7$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $029bc59d811a92d7$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $029bc59d811a92d7$var$onLoad(e) {
    const swiper = this;
    $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $029bc59d811a92d7$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $029bc59d811a92d7$var$events = (swiper, method)=>{
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $029bc59d811a92d7$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $029bc59d811a92d7$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $029bc59d811a92d7$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $029bc59d811a92d7$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $029bc59d811a92d7$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $029bc59d811a92d7$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $029bc59d811a92d7$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $029bc59d811a92d7$var$onScroll.bind(swiper);
    swiper.onClick = $029bc59d811a92d7$var$onClick.bind(swiper);
    swiper.onLoad = $029bc59d811a92d7$var$onLoad.bind(swiper);
    $029bc59d811a92d7$var$events(swiper, 'on');
}
function $029bc59d811a92d7$var$detachEvents() {
    const swiper = this;
    $029bc59d811a92d7$var$events(swiper, 'off');
}
var $029bc59d811a92d7$var$events$1 = {
    attachEvents: $029bc59d811a92d7$var$attachEvents,
    detachEvents: $029bc59d811a92d7$var$detachEvents
};
const $029bc59d811a92d7$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $029bc59d811a92d7$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, params);
    const isMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $029bc59d811a92d7$var$getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $029bc59d811a92d7$var$breakpoints = {
    setBreakpoint: $029bc59d811a92d7$var$setBreakpoint,
    getBreakpoint: $029bc59d811a92d7$var$getBreakpoint
};
function $029bc59d811a92d7$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $029bc59d811a92d7$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $029bc59d811a92d7$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $029bc59d811a92d7$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $029bc59d811a92d7$var$classes = {
    addClasses: $029bc59d811a92d7$var$addClasses,
    removeClasses: $029bc59d811a92d7$var$removeClasses
};
function $029bc59d811a92d7$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $029bc59d811a92d7$var$checkOverflow$1 = {
    checkOverflow: $029bc59d811a92d7$var$checkOverflow
};
var $029bc59d811a92d7$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    snapToSlideEdge: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $029bc59d811a92d7$var$prototypes = {
    eventsEmitter: $029bc59d811a92d7$var$eventsEmitter,
    update: $029bc59d811a92d7$var$update,
    translate: $029bc59d811a92d7$var$translate,
    transition: $029bc59d811a92d7$var$transition,
    slide: $029bc59d811a92d7$var$slide,
    loop: $029bc59d811a92d7$var$loop,
    grabCursor: $029bc59d811a92d7$var$grabCursor,
    events: $029bc59d811a92d7$var$events$1,
    breakpoints: $029bc59d811a92d7$var$breakpoints,
    checkOverflow: $029bc59d811a92d7$var$checkOverflow$1,
    classes: $029bc59d811a92d7$var$classes
};
const $029bc59d811a92d7$var$extendedDefaults = {};
class $029bc59d811a92d7$export$25ce5a424b770e84 {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, params, {
                    el: containerEl
                });
                swipers.push(new $029bc59d811a92d7$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $029bc59d811a92d7$var$getSupport();
        swiper.device = $029bc59d811a92d7$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $029bc59d811a92d7$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) params.modules.forEach((mod)=>{
            if (typeof mod === 'function' && swiper.modules.indexOf(mod) < 0) swiper.modules.push(mod);
        });
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, $029bc59d811a92d7$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, swiperParams, $029bc59d811a92d7$var$extendedDefaults, params);
        swiper.originalParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, swiper.params);
        swiper.passedParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(slides[0]);
        return (0, $36f917fbf2efdd6b$export$35e795649ee09318)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
            });
        });
        $029bc59d811a92d7$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $029bc59d811a92d7$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $36f917fbf2efdd6b$export$4a5767248b18ef41)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)($029bc59d811a92d7$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $029bc59d811a92d7$var$extendedDefaults;
    }
    static get defaults() {
        return $029bc59d811a92d7$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__) $029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$029bc59d811a92d7$export$25ce5a424b770e84.installModule(m));
            return $029bc59d811a92d7$export$25ce5a424b770e84;
        }
        $029bc59d811a92d7$export$25ce5a424b770e84.installModule(module);
        return $029bc59d811a92d7$export$25ce5a424b770e84;
    }
}
Object.keys($029bc59d811a92d7$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($029bc59d811a92d7$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $029bc59d811a92d7$export$25ce5a424b770e84.prototype[protoMethod] = $029bc59d811a92d7$var$prototypes[prototypeGroup][protoMethod];
    });
});
$029bc59d811a92d7$export$25ce5a424b770e84.use([
    $029bc59d811a92d7$var$Resize,
    $029bc59d811a92d7$var$Observer
]);









function $33834d902fe381ab$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, slidesPerView: slidesPerView, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter, slidesPerViewAutoSlideSize: slidesPerViewAutoSlideSize } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                let swiperSize = swiper.size;
                if (!swiperSize) swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            } else slidesPerViewNumeric = 1;
        } else slidesPerViewNumeric = slidesPerView;
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerViewNumeric + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $52e509fb8653e0d9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true,
            speed: undefined
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && (document.activeElement.isContentEditable || document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        const speed = swiper.params.keyboard.speed;
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext(speed);
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev(speed);
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext(speed);
            if (isPageUp || isArrowUp) swiper.slidePrev(speed);
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $05e7c97b57a34c96$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $756cc3b72a05f628$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



const $9dcb69c205fd1703$var$arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
function $9dcb69c205fd1703$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg: $9dcb69c205fd1703$var$arrowSvg
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) {
                if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
                    const tempEl = document.createElement('div');
                    (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempEl, $9dcb69c205fd1703$var$arrowSvg);
                    el.appendChild(tempEl.querySelector('svg'));
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $781a64a6db1a7446$export$db3b6bfb95261072(classes = '') {
    // Escape all CSS selector special characters
    return `.${classes.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}




function $69d1e0b9767b27dd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $c7252c6c2cf4bba7$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $c36b71b742710ea0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $401de11e8a126d45$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $411c83a941bc1076$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $9649bf9a787c3914$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(notification, message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $36f917fbf2efdd6b$export$35e795649ee09318)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const isActive = (isVirtual ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : swiper.slides.indexOf(slideEl)) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
            else if (isVirtual) swiper.slideTo(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10)), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $38bb61499ef50fab$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $87b0baa371d09db8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $c1783ac9556c9fef$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params }) {
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const getTotalDelay = ()=>{
        let totalDelay = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) totalDelay = currentSlideDelay;
        return totalDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = delayForce;
        if (typeof delay === 'undefined') {
            delay = getTotalDelay();
            autoplayDelayTotal = delay;
            autoplayDelayCurrent = delay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) {
            autoplayTimeLeft = getTotalDelay();
            autoplayDelayTotal = getTotalDelay();
        }
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $21e2f533778c20f0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function isVirtualEnabled() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return false;
        return thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled;
    }
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $36f917fbf2efdd6b$export$ffb5f4729a158638)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        if (isVirtualEnabled()) swiper.thumbs.swiper.on('virtualUpdate', ()=>{
            update(false, {
                autoScroll: false
            });
        });
        return true;
    }
    function update(initial, p) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || isVirtualEnabled()) for(let i = 0; i < thumbsToActivate; i += 1)(0, $36f917fbf2efdd6b$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        if (p?.autoScroll ?? true) autoScroll(initial ? 0 : undefined);
    }
    function autoScroll(slideSpeed) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $49f3fa363ac09256$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $3e2c28ea1ae0e231$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $eb2d45639f1e8538$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $eb2d45639f1e8538$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $eb2d45639f1e8538$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: $eb2d45639f1e8538$var$appendSlide.bind(swiper),
        prependSlide: $eb2d45639f1e8538$var$prependSlide.bind(swiper),
        addSlide: $eb2d45639f1e8538$var$addSlide.bind(swiper),
        removeSlide: $eb2d45639f1e8538$var$removeSlide.bind(swiper),
        removeAllSlides: $eb2d45639f1e8538$var$removeAllSlides.bind(swiper)
    });
}


function $6be88bfc4d238db6$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $b32fc4882a084e0d$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $8cd9c8d5770c3e4b$export$f1e1789686576879({ swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides }) {
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $5d17e4afe2f572c9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $7a34974922f14d54$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $fab3d8cd791e5fc7$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $68ca3c9f22027c47$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $983c76c349961a02$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $ed2173e49aa32019$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $e7abdc2d61949d3e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




const $123791bf45f73bdd$var$isObject = (item)=>{
    return item !== null && typeof item === 'object';
};
/**
 * Merges two objects deeply, combining their properties recursively.
 * If a property in the source object is an object and not an array,
 * it will be merged with the corresponding property in the target object.
 * Otherwise, the property from the source object will overwrite the one in the target object.
 *
 * @template T - The type of the target object.
 * @template U - The type of the source object.
 * @param {T} target - The target object to merge into.
 * @param {U} source - The source object to merge from.
 * @returns {T & U} A new object that is the result of deeply merging the target and source objects.
 */ const $123791bf45f73bdd$var$deepMerge = (target, source)=>{
    const output = {
        ...target
    };
    for(const key in source)if (Object.prototype.hasOwnProperty.call(source, key) && $123791bf45f73bdd$var$isObject(source[key]) && !Array.isArray(source[key])) output[key] = $123791bf45f73bdd$var$deepMerge(target[key] ?? {}, source[key]);
    else output[key] = source[key];
    return output;
};
var $123791bf45f73bdd$export$2e2bcd8739ae039 = $123791bf45f73bdd$var$deepMerge;


class $1e52ca8fdbe257bc$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.customOptions = {};
        this.options = this.getAttribute('data-tk-carousel-options') || undefined;
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-carousel--loaded';
        if (this.options) this.customOptions = JSON.parse(this.options);
    }
    connectedCallback() {
        this.mountCarousel();
    }
    mountCarousel() {
        const root = this.querySelector('[data-tk-carousel-root]');
        const prevButton = this.querySelector('[data-tk-carousel-prev]');
        const nextButton = this.querySelector('[data-tk-carousel-next]');
        const pagination = this.querySelector('[data-tk-carousel-pagination]');
        if (!root || !prevButton || !nextButton || !pagination) {
            console.error('TKCarousel: Required elements are missing in the DOM.');
            return;
        }
        const defaultOptions = {
            modules: [
                (0, $9dcb69c205fd1703$export$2e2bcd8739ae039),
                (0, $69d1e0b9767b27dd$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
                disabledClass: 'tk-carousel__arrow--disabled',
                enabled: false
            },
            pagination: {
                el: pagination,
                bulletClass: 'tk-carousel__pagination-page',
                bulletActiveClass: 'tk-carousel__pagination-page--active',
                clickable: true,
                enabled: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1200: {
                    slidesPerView: 3,
                    navigation: {
                        enabled: true
                    },
                    pagination: {
                        enabled: true
                    }
                }
            },
            on: {
                init: this.onCarouselReady.bind(this)
            }
        };
        const config = (0, $123791bf45f73bdd$export$2e2bcd8739ae039)(defaultOptions, this.customOptions);
        this.slider = new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(root, config);
    }
    onCarouselReady() {
        this.classList.add(this.loadedClassName);
    }
}





class $b0d382fe358ed836$export$2e2bcd8739ae039 extends (0, $1e52ca8fdbe257bc$export$2e2bcd8739ae039) {
    mountCarousel() {
        const root = this.querySelector('[data-tk-carousel-root]');
        const prevButton = this.querySelector('[data-tk-carousel-prev]');
        const nextButton = this.querySelector('[data-tk-carousel-next]');
        const pagination = this.querySelector('[data-tk-carousel-pagination]');
        if (!root || !prevButton || !nextButton || !pagination) {
            console.error('DIWCarousel: Required elements are missing in the DOM.');
            return;
        }
        const defaultOptions = {
            modules: [
                (0, $9dcb69c205fd1703$export$2e2bcd8739ae039),
                (0, $69d1e0b9767b27dd$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 8,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
                disabledClass: 'tk-carousel__arrow--disabled',
                enabled: false
            },
            pagination: {
                el: pagination,
                bulletClass: 'tk-carousel__pagination-page',
                bulletActiveClass: 'tk-carousel__pagination-page--active',
                clickable: true,
                enabled: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 8
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 8,
                    navigation: {
                        enabled: true
                    },
                    pagination: {
                        enabled: true
                    }
                }
            },
            on: {
                init: this.onCarouselReady.bind(this)
            }
        };
        const config = (0, $123791bf45f73bdd$export$2e2bcd8739ae039)(defaultOptions, this.customOptions);
        this.slider = new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(root, config);
    }
}



function $7e8cc8975b3fe464$export$60d21ef256fe91e0(point, rectangle, offset) {
    return point.x < rectangle.left + (offset?.left || 0) || point.x > rectangle.right + (offset?.right || 0) || point.y < rectangle.top + (offset?.top || 0) || point.y > rectangle.bottom + (offset?.bottom || 0);
}
function $7e8cc8975b3fe464$export$dcbd32acb1a13bc6(event, rectangles) {
    const point = {
        x: event.clientX,
        y: event.clientY
    };
    return rectangles.every((item)=>$7e8cc8975b3fe464$export$60d21ef256fe91e0(point, item.rectangle, item.offset));
}


class $d9484b764f1a944d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buttons = this.querySelectorAll('[data-tk-context-button]');
        this.items = this.querySelector('[data-tk-context-items]') || undefined;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-context-menu--open';
        this.responsiveClassName = this.getAttribute('data-tk-responsive-class-name') || 'tk-context-menu--responsive';
        this.dropDownClassName = this.getAttribute('data-tk-dropdown-class-name') || 'tk-context-menu__dropdown';
        this.showAlways = this.hasAttribute('data-tk-show-always');
        this.disableScrolldownBreakpoint = this.getAttribute('data-tk-disable-scrolldown-breakpoint') || 's';
        this.minWidthBreakpoint = window.viewport.breakpoints.get(this.disableScrolldownBreakpoint) || 0;
        this.offset = Number(this.getAttribute('data-tk-context-offset')) || 4;
        this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
        this.eventListeners = new Map();
    }
    subscribe(eventName, callback) {
        if (!this.eventListeners.has(eventName)) this.eventListeners.set(eventName, []);
        this.eventListeners.get(eventName).push(callback);
    }
    unsubscribe(eventName, callback) {
        const listeners = this.eventListeners.get(eventName);
        if (!listeners) return;
        this.eventListeners.set(eventName, listeners.filter((listener)=>listener !== callback));
    }
    emit(eventName, data) {
        const listeners = this.eventListeners.get(eventName);
        if (!listeners) return;
        listeners.forEach((callback)=>callback(data));
    }
    connectedCallback() {
        if (this.buttons.length === 0 || !this.items) throw new Error('Context Menu: Elements are missing!');
        this.registerViewportListener();
        (window.viewport.clientWidth < this.minWidthBreakpoint || this.showAlways) && this.switchToMobile();
        this.registerClickListener();
        this.emit('READY');
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
        this.emit('ENDED');
    }
    registerClickListener() {
        const onClick = this.open.bind(this);
        this.buttons.forEach((button)=>{
            this.pushListener({
                event: 'click',
                element: button,
                action: onClick
            });
        });
    }
    registerCloseListener() {
        const handleClose = this.handleClose.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleResize(entries) {
        entries.forEach(()=>{
            if (!this.copiedItems) return;
            this.setPosition(this.copiedItems);
            const width = this.copiedItems.offsetWidth;
            const height = this.copiedItems.offsetHeight;
            this.emit('RESIZED', {
                width: width,
                height: height
            });
        });
    }
    handleViewportResize(event) {
        event.detail.width < this.minWidthBreakpoint || this.showAlways ? this.switchToMobile() : this.switchToDesktop();
    }
    getVisibleButton(visibility) {
        const buttonList = Array.from(this.buttons);
        return buttonList.find((button)=>visibility === button.checkVisibility());
    }
    switchToDesktop() {
        const button = this.getVisibleButton(true);
        if (!button) return;
        button.hidden = true;
        this.classList.remove(this.responsiveClassName);
    }
    switchToMobile() {
        const button = this.getVisibleButton(false);
        if (!button) return;
        button.hidden = false;
        this.classList.add(this.responsiveClassName);
    }
    copyItemsIfNotExists() {
        const copiedItems = this.items.cloneNode(true);
        copiedItems.classList.add(this.dropDownClassName);
        this.copiedItems = copiedItems;
        document.body.insertAdjacentElement('beforeend', copiedItems);
        this.emit('COPIED');
    }
    open() {
        !this.copiedItems && this.copyItemsIfNotExists();
        if (!this.copiedItems) return;
        this.setPosition(this.copiedItems);
        this.resizeObserver.observe(document.body);
        setTimeout(()=>{
            this.registerCloseListener();
        }, 0);
        this.emit('OPENED', {
            target: this.copiedItems
        });
    }
    setPosition(element) {
        const button = this.getVisibleButton(true);
        if (!button) return;
        element.classList.add(this.openClassName);
        const { top: top, height: height, left: left, right: right } = button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        const rightPosition = right + window.scrollX;
        element.style.top = `${top + height + window.scrollY + this.offset}px`;
        if (window.innerWidth <= element.clientWidth + leftPosition) element.style.left = `${rightPosition - element.clientWidth}px`;
        else element.style.left = `${leftPosition}px`;
    }
    handleClose(event) {
        const button = this.getVisibleButton(true);
        if (!this.copiedItems || !button) return;
        const buttonRect = button.getBoundingClientRect();
        const dropdownRect = this.copiedItems.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: buttonRect
            },
            {
                rectangle: dropdownRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) this.close();
    }
    close() {
        if (!this.copiedItems) return;
        this.copiedItems.classList.remove(this.openClassName);
        this.removeListener(window);
        this.resizeObserver.unobserve(document.body);
        this.emit('CLOSED');
    }
}



class $0d07f57cc5d15afe$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorFlagItem = '[data-tk-flag-item]', this.selectorFlagIcon = '[data-tk-flag-icon]', this.selectorFlagLabel = '[data-tk-flag-label]', this.flagItems = [], this.removedFlagElements = [];
    }
    connectedCallback() {
        this.getAllFlags();
        if (this.flagItems.length < 1) return;
        this.appendSummarizedFlag();
    }
    getAllFlags() {
        const allFlagElements = this.querySelectorAll(this.selectorFlagItem) || undefined;
        // convert NodeList to Array
        const allFlags = Array.from(allFlagElements);
        // remove last Element (not needed for Tooltip-Flag)
        allFlags.pop();
        if (allFlags.length < 1) return;
        allFlags.forEach((item)=>{
            const iconElem = item.querySelector(this.selectorFlagIcon);
            const labelElem = item.querySelector(this.selectorFlagLabel);
            const singleFlagItem = {
                icon: iconElem?.outerHTML,
                label: labelElem?.getAttribute(this.selectorFlagLabel.slice(1, -1)) === 'true' ? labelElem.innerHTML : '',
                showIcon: iconElem?.getAttribute(this.selectorFlagIcon.slice(1, -1)) === 'true',
                showLabel: labelElem?.getAttribute(this.selectorFlagLabel.slice(1, -1)) === 'true'
            };
            this.flagItems.push(singleFlagItem);
            this.removedFlagElements.push(item);
            item.remove();
        });
    }
    getFlagDetails() {
        const returnVal = [];
        this.flagItems.forEach((elem)=>{
            let tooltipString;
            if (elem.showLabel) tooltipString = elem.showIcon ? `${elem.icon} ${elem.label}` : `${elem.label}`;
            else {
                const removedElement = this.removedFlagElements.shift();
                const removedElementLabel = removedElement?.querySelector('[data-tk-flag-label]')?.innerHTML;
                const tmpTooltipString = removedElementLabel || '';
                tooltipString = elem.showIcon ? `${elem.icon}` : tmpTooltipString;
            }
            returnVal.push(tooltipString);
        });
        return returnVal.join(', ').trim();
    }
    appendSummarizedFlag() {
        const tooltipTemplate = this.querySelector('[data-tk-flag-merged]');
        if (!tooltipTemplate) return;
        const clone = tooltipTemplate.content.cloneNode(true);
        const tooltipElement = clone.querySelector('[data-tk-tooltip-content]');
        if (!tooltipElement) return;
        tooltipElement.innerHTML = `+${this.flagItems.length}`;
        tooltipElement.setAttribute('data-tk-tooltip-content', this.getFlagDetails());
        this.prepend(clone);
    }
}




class $21ae20c5af7baedb$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.productVariants = this.querySelector('[data-tk-product-variants]') || undefined;
    }
    connectedCallback() {
        if (!this.url) throw new Error('Product-Tile: No URL defined!');
        this.registerListener();
    }
    registerListener() {
        if (!this.productVariants) return;
        const switchProductVariantHandler = this.changeVariant.bind(this);
        this.pushListener({
            event: 'change',
            element: this.productVariants,
            action: switchProductVariantHandler
        });
    }
    changeVariant() {
        this.getProductVariant(this.productVariants.value);
    }
    getProductVariant(id) {
        const data = {
            article: id
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            resolveHandler: this.switchProductVariant.bind(this),
            payload: data
        });
    }
    switchProductVariant(response) {
        if (!response || !response.success) return;
        this.insertAdjacentHTML('afterend', response.dataAsHtml);
        this.remove();
    }
}




class $21611c672b0d32ce$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorProductVariant = '[data-tk-product-variant]', this.selectorproductVariantFilters = '[data-tk-product-variant-filter]', this.selectorProductVariantList = '[data-tk-product-variant-list]', this.selectorProductVariantAttribute = '[data-tk-product-variant-attribute]', this.selectorProductVariantValue = '[data-tk-product-variant-value]', this.filteredOptions = [], this.selectionHistory = [];
        this.productVariantList = this.querySelector(this.selectorProductVariantList) || undefined;
        this.productVariantFilters = this.querySelectorAll(this.selectorproductVariantFilters) || undefined;
        this.productVariantsCollection = [];
        this.filteredCollection = [];
        this.noVariantFound = this.getAttribute('data-tk-product-variant-none') || 'NONE';
        this.disableSelectingFirst = this.hasAttribute('data-tk-disable-selecting-first');
        this.resetButton = this.querySelector('[data-tk-product-variants-reset]') || undefined;
        this.enableFilterInURL = this.hasAttribute('data-tk-enable-filter-in-url');
    }
    connectedCallback() {
        this.collectProductVariants();
        this.prepareVariantFilters();
        !this.disableSelectingFirst && this.selectFirstVariantInCollection(this.productVariantsCollection);
        this.registerListener();
    }
    registerListener() {
        if (this.productVariantFilters) this.productVariantFilters.forEach((filter)=>{
            const filterListEventHandler = this.filterList.bind(this);
            this.pushListener({
                event: 'change',
                element: filter,
                action: filterListEventHandler
            });
        });
        if (this.productVariantsCollection.length > 0) this.productVariantsCollection.forEach((variant)=>{
            const getSelectedVariantValueHandler = this.getSelectedVariantValue.bind(this, variant.element);
            this.pushListener({
                event: 'change',
                element: variant.element,
                action: getSelectedVariantValueHandler
            });
        });
        const handleReset = this.handleReset.bind(this);
        this.resetButton && this.pushListener({
            event: 'click',
            element: this.resetButton,
            action: handleReset
        });
    }
    getSelectedVariantValue(variant) {
        this.setSelectedVariant(variant.getAttribute('data-tk-product-variant') || '');
    }
    filterList(event) {
        const selectedValues = this.getSelectedFilterValues();
        this.filteredCollection = this.productVariantsCollection.filter((element)=>{
            return Object.keys(selectedValues).every((key)=>{
                return selectedValues[key] === element.spec[key];
            });
        }) || [];
        this.updateProductVariantList();
        this.enableFilterInURL && this.setFilterInURL();
        event && this.filterOptions(event.currentTarget);
    }
    setFilterInURL() {
        const url = new URL(window.location.href);
        const selectedValues = this.getSelectedFilterValues();
        Object.keys(selectedValues).forEach((key)=>{
            url.searchParams.set(key, selectedValues[key]);
        });
        window.history.pushState(null, '', url.href);
    }
    handleReset() {
        this.productVariantsCollection.filter((item)=>item.id !== 'NONE').forEach((item)=>{
            item.element.hidden = false;
        });
        this.filteredOptions.forEach((item)=>{
            const { element: element } = item;
            if (!element) return;
            const optionList = Array.from(element.options);
            optionList.forEach((option)=>{
                option.hidden = false;
                option.selected = false;
            });
            element.disabled = item.options.size < 2;
            const firstOption = element.options.item(0);
            if (!firstOption) return;
            firstOption.selected = true;
        });
        if (!this.enableFilterInURL) return;
        const url = new URL(window.location.href);
        const { searchParams: searchParams } = url;
        this.filteredOptions.forEach((option)=>{
            const { attr: attr } = option;
            searchParams.has(attr) && searchParams.delete(attr);
        });
        window.history.pushState(null, '', url.href);
    }
    filterOptions(target) {
        const filteredList = this.filteredOptions.filter((item)=>item.element !== target);
        const currentValues = filteredList.map((filterOption)=>{
            const values = new Set();
            this.filteredCollection.forEach((item)=>{
                values.add(item.spec[filterOption.attr]);
            });
            return {
                attr: filterOption.attr,
                values: values
            };
        });
        filteredList.forEach((filterOption)=>{
            if (!filterOption.element) return;
            const { options: options } = filterOption.element;
            const optionList = Array.from(options);
            const values = currentValues.find((item)=>item.attr === filterOption.attr)?.values;
            if (!values) return;
            optionList.forEach((option)=>{
                option.hidden = false;
            });
            optionList.filter((option)=>option.value !== '').forEach((option)=>{
                option.hidden = !values.has(option.value);
            });
            filterOption.element.disabled = optionList.filter((item)=>!item.hidden && item.value !== '').length < 2;
        });
        const selectedOption = target.options.item(target.selectedIndex);
        if (!selectedOption) return;
        if (selectedOption.value === '') {
            this.enableLastSelection(target);
            return;
        }
        if (this.selectionHistory.at(-1) !== target) this.selectionHistory.push(target);
    }
    enableLastSelection(target) {
        if (this.selectionHistory.length < 1) return;
        const lastSelection = this.selectionHistory.at(-2);
        if (lastSelection === target) return;
        const index = this.filteredOptions.findIndex((item)=>item.element === lastSelection);
        const lastItem = this.filteredOptions.at(index);
        const lastElement = lastItem?.element;
        if (!lastElement) return;
        Array.from(lastElement.options).forEach((option)=>{
            option.hidden = false;
        });
        lastElement.disabled = false;
        lastElement.dispatchEvent(new Event('change'));
    }
    updateProductVariantList() {
        this.productVariantsCollection.forEach((variant)=>{
            variant.element.hidden = true;
        });
        this.filteredCollection.forEach((variant)=>{
            variant.element.hidden = false;
            if (variant.id === this.noVariantFound) variant.element.hidden = true;
        });
        if (this.filteredCollection.length > 0) !this.disableSelectingFirst && this.selectFirstVariantInCollection(this.filteredCollection);
        else this.showNoVariantsFoundMessage();
    }
    selectFirstVariantInCollection(collection) {
        const hasSelectedElement = collection.some($21611c672b0d32ce$export$2e2bcd8739ae039.findFirstSelectedElement);
        if (hasSelectedElement) return;
        const input = collection.at(0)?.element.querySelector('input[type="radio"]');
        if (!input) return;
        input.checked = true;
        this.setSelectedVariant(input.value);
    }
    static findFirstSelectedElement(variant) {
        const input = variant.element.querySelector('input');
        if (!input) return false;
        return !input.hidden && input.checked;
    }
    setSelectedVariant(selectedValue) {
        this.selectedVariant = selectedValue;
    }
    showNoVariantsFoundMessage() {
        const noVariantFound = this.productVariantsCollection.filter((variant)=>variant.id === this.noVariantFound);
        if (noVariantFound) noVariantFound[0].element.hidden = false;
        this.setSelectedVariant('');
    }
    getSelectedFilterValues() {
        const selectedValues = {};
        this.productVariantFilters.forEach((filter)=>{
            if (filter.value !== '') {
                const selected = {
                    attr: filter.getAttribute('data-tk-product-variant-filter') || '',
                    value: filter.value
                };
                selectedValues[selected.attr] = selected.value;
            }
        });
        return selectedValues;
    }
    collectProductVariants() {
        const variants = this.productVariantList?.querySelectorAll(this.selectorProductVariant);
        variants?.forEach((element)=>{
            const variant = {
                id: element.getAttribute('data-tk-product-variant') || '',
                element: element,
                spec: this.getVariantSpecs(element)
            };
            this.productVariantsCollection.push(variant);
        });
    }
    prepareVariantFilters() {
        const filterAttribute = new Set();
        this.productVariantsCollection.forEach((variant)=>{
            Object.keys(variant.spec).forEach((key)=>filterAttribute.add(key));
        });
        filterAttribute.forEach((attr)=>{
            // filter undefined or null values
            const distinctOptions = new Set(this.productVariantsCollection.map((variant)=>variant.spec[attr]).filter(Boolean));
            const sortedOptions = new Set([
                ...distinctOptions
            ].sort());
            const selectElement = this.querySelector(`[data-tk-product-variant-filter="${attr}"]`) || undefined;
            this.filteredOptions.push({
                element: selectElement,
                attr: attr,
                options: sortedOptions
            });
        });
        this.filteredOptions.forEach((item)=>{
            if (!item.element) return;
            item.element.disabled = item.options.size < 2;
            const optionsHTML = [
                ...item.options
            ].map((option)=>{
                const urlParams = new URLSearchParams(window.location.search);
                const isSelected = urlParams.get(item.attr) === option;
                return `<option value="${option}" ${isSelected ? 'selected' : ''}>${option}</option>`;
            }).join('');
            let resultHTML = '';
            item.options.size > 1 ? resultHTML = `<option value="">${(0, $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc).all.text}</option>${optionsHTML}` : resultHTML = optionsHTML;
            item.element.insertAdjacentHTML('beforeend', resultHTML);
        });
        this.enableFilterInURL && this.filterList();
    }
    getVariantSpecs(variant) {
        const specs = variant.querySelectorAll(this.selectorProductVariantAttribute);
        const specCollection = {};
        specs.forEach((elem)=>{
            const spec = {
                attr: elem.getAttribute('data-tk-product-variant-attribute') || '',
                value: elem.getAttribute('data-tk-product-variant-value') || ''
            };
            specCollection[spec.attr] = spec.value;
        });
        return specCollection;
    }
}


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;



function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
}


function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? (0, $2835f189066da699$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b49248e188a52b8b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $2835f189066da699$export$2e2bcd8739ae039)(node) || !(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node)) return (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(node);
    else return (0, $c829ab0279467772$export$2e2bcd8739ae039)(node);
}






function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)).left + (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $2835f189066da699$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9873d63ab8539814$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b71097fc0b0e5f5c$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e951d80a0194865c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node) && (0, $9873d63ab8539814$export$2e2bcd8739ae039)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(node));
}





function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c48b941fd834c962$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9873d63ab8539814$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(target)));
}







function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    if (isIE && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element);
    if ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $27c48183f07ddbe8$export$2e2bcd8739ae039)(offsetParent) && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}


var $935c50c8659545b7$export$1e95b668f3b82d = 'top';
var $935c50c8659545b7$export$40e543e69a8b3fbb = 'bottom';
var $935c50c8659545b7$export$79ffe56a765070d2 = 'right';
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = 'left';
var $935c50c8659545b7$export$dfb5619354ba860 = 'auto';
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = 'start';
var $935c50c8659545b7$export$bd5df0f255a350f8 = 'end';
var $935c50c8659545b7$export$390fd549c5303b4d = 'clippingParents';
var $935c50c8659545b7$export$d7b7311ec04a3e8f = 'viewport';
var $935c50c8659545b7$export$ae5ab1c730825774 = 'popper';
var $935c50c8659545b7$export$ca50aac9f3ba507f = 'reference';
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = 'beforeRead';
var $935c50c8659545b7$export$aafa59e2e03f2942 = 'read';
var $935c50c8659545b7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = 'beforeMain';
var $935c50c8659545b7$export$f22da7240b7add18 = 'main';
var $935c50c8659545b7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $935c50c8659545b7$export$68d8715fc104d294 = 'write';
var $935c50c8659545b7$export$70a6e5159acce2e6 = 'afterWrite';
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];


function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $935c50c8659545b7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(reference) ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $455dca0e08f2a815$export$2e2bcd8739ae039)((0, $81912adbd60ec5c0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b01cf64433a5b37b$export$2e2bcd8739ae039)(reference, (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $ad01075005a54bff$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6d2b77c34ff005f5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};



function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $935c50c8659545b7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $935c50c8659545b7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $935c50c8659545b7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $935c50c8659545b7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $935c50c8659545b7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $935c50c8659545b7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};










var $063d2297888fea12$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var sideY = (0, $935c50c8659545b7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(popper);
            if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || placement === (0, $935c50c8659545b7$export$79ffe56a765070d2)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideY = (0, $935c50c8659545b7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || placement === (0, $935c50c8659545b7$export$40e543e69a8b3fbb)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideX = (0, $935c50c8659545b7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};





function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $935c50c8659545b7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8d644778f0e020f0$var$offset
};


var $d79ddf39683d3f91$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}



var $5887002dcefa0743$var$hash = {
    start: 'end',
    end: 'start'
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}







function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b49248e188a52b8b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6be351e83d6bf643$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) ? (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $7da9d5689cacb0a6$export$2e2bcd8739ae039)(element, strategy)) : (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $ab4ea6dd03061fae$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) ? (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) && (0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)(), paddingObject);
}


function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $935c50c8659545b7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $935c50c8659545b7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? (0, $935c50c8659545b7$export$ca50aac9f3ba507f) : (0, $935c50c8659545b7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $93ee5964b4e9d426$export$2e2bcd8739ae039)((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $1cd357ee33805adc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $935c50c8659545b7$export$79ffe56a765070d2),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $935c50c8659545b7$export$1e95b668f3b82d),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $935c50c8659545b7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $935c50c8659545b7$export$368f9a87e87fa4e1) : (0, $935c50c8659545b7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $935c50c8659545b7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860) ? (0, $bec6b628c79c2a3d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $935c50c8659545b7$export$79ffe56a765070d2) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(min, (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e82c9e5baaa8e9af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4faf3481d1df2f95$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $935c50c8659545b7$export$1e95b668f3b82d),
        (0, $935c50c8659545b7$export$79ffe56a765070d2),
        (0, $935c50c8659545b7$export$40e543e69a8b3fbb),
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};




var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039),
    (0, $8d644778f0e020f0$export$2e2bcd8739ae039),
    (0, $dabd09962ff7b702$export$2e2bcd8739ae039),
    (0, $4804c92787f86449$export$2e2bcd8739ae039),
    (0, $20e743289f291887$export$2e2bcd8739ae039),
    (0, $7d3d400f3b7c97f3$export$2e2bcd8739ae039)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $c55de979aca75bc6$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $c55de979aca75bc6$var$BOX_CLASS = "tippy-box";
var $c55de979aca75bc6$var$CONTENT_CLASS = "tippy-content";
var $c55de979aca75bc6$var$BACKDROP_CLASS = "tippy-backdrop";
var $c55de979aca75bc6$var$ARROW_CLASS = "tippy-arrow";
var $c55de979aca75bc6$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $c55de979aca75bc6$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $c55de979aca75bc6$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $c55de979aca75bc6$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $c55de979aca75bc6$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $c55de979aca75bc6$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $c55de979aca75bc6$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $c55de979aca75bc6$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $c55de979aca75bc6$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $c55de979aca75bc6$var$normalizeToArray(value) {
    return [].concat(value);
}
function $c55de979aca75bc6$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $c55de979aca75bc6$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $c55de979aca75bc6$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $c55de979aca75bc6$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $c55de979aca75bc6$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $c55de979aca75bc6$var$div() {
    return document.createElement('div');
}
function $c55de979aca75bc6$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $c55de979aca75bc6$var$isType(value, type);
    });
}
function $c55de979aca75bc6$var$isNodeList(value) {
    return $c55de979aca75bc6$var$isType(value, 'NodeList');
}
function $c55de979aca75bc6$var$isMouseEvent(value) {
    return $c55de979aca75bc6$var$isType(value, 'MouseEvent');
}
function $c55de979aca75bc6$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $c55de979aca75bc6$var$getArrayOfElements(value) {
    if ($c55de979aca75bc6$var$isElement(value)) return [
        value
    ];
    if ($c55de979aca75bc6$var$isNodeList(value)) return $c55de979aca75bc6$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $c55de979aca75bc6$var$arrayFrom(document.querySelectorAll(value));
}
function $c55de979aca75bc6$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $c55de979aca75bc6$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $c55de979aca75bc6$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $c55de979aca75bc6$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $c55de979aca75bc6$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $c55de979aca75bc6$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $c55de979aca75bc6$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $c55de979aca75bc6$var$currentInput = {
    isTouch: false
};
var $c55de979aca75bc6$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $c55de979aca75bc6$var$onDocumentTouchStart() {
    if ($c55de979aca75bc6$var$currentInput.isTouch) return;
    $c55de979aca75bc6$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $c55de979aca75bc6$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $c55de979aca75bc6$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $c55de979aca75bc6$var$lastMouseMoveTime < 20) {
        $c55de979aca75bc6$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $c55de979aca75bc6$var$onDocumentMouseMove);
    }
    $c55de979aca75bc6$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $c55de979aca75bc6$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($c55de979aca75bc6$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $c55de979aca75bc6$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $c55de979aca75bc6$var$onDocumentTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $c55de979aca75bc6$var$onWindowBlur);
}
var $c55de979aca75bc6$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $c55de979aca75bc6$var$isIE11 = $c55de979aca75bc6$var$isBrowser ? !!window.msCrypto : false;
function $c55de979aca75bc6$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $c55de979aca75bc6$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $c55de979aca75bc6$var$getDevMessage(message) {
    return $c55de979aca75bc6$var$clean("\n  %ctippy.js\n\n  %c" + $c55de979aca75bc6$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $c55de979aca75bc6$var$getFormattedMessage(message) {
    return [
        $c55de979aca75bc6$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $c55de979aca75bc6$var$visitedMessages;
function $c55de979aca75bc6$var$resetVisitedMessages() {
    $c55de979aca75bc6$var$visitedMessages = new Set();
}
function $c55de979aca75bc6$var$warnWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$errorWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console2;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $c55de979aca75bc6$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $c55de979aca75bc6$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $c55de979aca75bc6$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $c55de979aca75bc6$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $c55de979aca75bc6$var$defaultProps = Object.assign({
    appendTo: $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $c55de979aca75bc6$var$pluginProps, $c55de979aca75bc6$var$renderProps);
var $c55de979aca75bc6$var$defaultKeys = Object.keys($c55de979aca75bc6$var$defaultProps);
var $c55de979aca75bc6$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $c55de979aca75bc6$var$defaultProps[key] = partialProps[key];
    });
};
function $c55de979aca75bc6$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $c55de979aca75bc6$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $c55de979aca75bc6$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($c55de979aca75bc6$var$getExtendedPassedProps(Object.assign({}, $c55de979aca75bc6$var$defaultProps, {
        plugins: plugins
    }))) : $c55de979aca75bc6$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $c55de979aca75bc6$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $c55de979aca75bc6$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $c55de979aca75bc6$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $c55de979aca75bc6$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $c55de979aca75bc6$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $c55de979aca75bc6$var$removeProperties($c55de979aca75bc6$var$defaultProps, Object.keys($c55de979aca75bc6$var$pluginProps));
        var didPassUnknownProp = !$c55de979aca75bc6$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $c55de979aca75bc6$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $c55de979aca75bc6$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $c55de979aca75bc6$var$dangerouslySetInnerHTML(element, html) {
    element[$c55de979aca75bc6$var$innerHTML()] = html;
}
function $c55de979aca75bc6$var$createArrowElement(value) {
    var arrow = $c55de979aca75bc6$var$div();
    if (value === true) arrow.className = $c55de979aca75bc6$var$ARROW_CLASS;
    else {
        arrow.className = $c55de979aca75bc6$var$SVG_ARROW_CLASS;
        if ($c55de979aca75bc6$var$isElement(value)) arrow.appendChild(value);
        else $c55de979aca75bc6$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $c55de979aca75bc6$var$setContent(content, props) {
    if ($c55de979aca75bc6$var$isElement(props.content)) {
        $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $c55de979aca75bc6$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $c55de979aca75bc6$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$ARROW_CLASS) || node.classList.contains($c55de979aca75bc6$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$BACKDROP_CLASS);
        })
    };
}
function $c55de979aca75bc6$var$render(instance) {
    var popper = $c55de979aca75bc6$var$div();
    var box = $c55de979aca75bc6$var$div();
    box.className = $c55de979aca75bc6$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $c55de979aca75bc6$var$div();
    content.className = $c55de979aca75bc6$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $c55de979aca75bc6$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $c55de979aca75bc6$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $c55de979aca75bc6$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$c55de979aca75bc6$var$render.$$tippy = true;
var $c55de979aca75bc6$var$idCounter = 1;
var $c55de979aca75bc6$var$mouseMoveListeners = []; // Used by `hideAll()`
var $c55de979aca75bc6$var$mountedInstances = [];
function $c55de979aca75bc6$var$createTippy(reference, passedProps) {
    var props = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, $c55de979aca75bc6$var$defaultProps, $c55de979aca75bc6$var$getExtendedPassedProps($c55de979aca75bc6$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $c55de979aca75bc6$var$idCounter++;
    var popperInstance = null;
    var plugins = $c55de979aca75bc6$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $c55de979aca75bc6$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $c55de979aca75bc6$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $c55de979aca75bc6$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $c55de979aca75bc6$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $c55de979aca75bc6$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $c55de979aca75bc6$var$mouseMoveListeners = $c55de979aca75bc6$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($c55de979aca75bc6$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $c55de979aca75bc6$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $c55de979aca75bc6$var$actualContains(el, actualTarget);
        })) {
            if ($c55de979aca75bc6$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $c55de979aca75bc6$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $c55de979aca75bc6$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $c55de979aca75bc6$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $c55de979aca75bc6$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($c55de979aca75bc6$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $c55de979aca75bc6$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $c55de979aca75bc6$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $c55de979aca75bc6$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $c55de979aca75bc6$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $98a9ef6d31ff03cd$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $c55de979aca75bc6$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $c55de979aca75bc6$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($c55de979aca75bc6$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, prevProps, $c55de979aca75bc6$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $c55de979aca75bc6$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $c55de979aca75bc6$var$currentInput.isTouch && !instance.props.touch;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 0, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $c55de979aca75bc6$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $c55de979aca75bc6$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 1, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $c55de979aca75bc6$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $c55de979aca75bc6$var$mountedInstances = $c55de979aca75bc6$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $c55de979aca75bc6$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $c55de979aca75bc6$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $c55de979aca75bc6$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $c55de979aca75bc6$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $c55de979aca75bc6$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $c55de979aca75bc6$var$isElement(targets) ? instances[0] : instances;
}
$c55de979aca75bc6$var$tippy.defaultProps = $c55de979aca75bc6$var$defaultProps;
$c55de979aca75bc6$var$tippy.setDefaultProps = $c55de979aca75bc6$var$setDefaultProps;
$c55de979aca75bc6$var$tippy.currentInput = $c55de979aca75bc6$var$currentInput;
var $c55de979aca75bc6$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $c55de979aca75bc6$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $c55de979aca75bc6$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $c55de979aca75bc6$var$applyStylesModifier = Object.assign({}, (0, $312913fa2edc14b2$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $c55de979aca75bc6$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $c55de979aca75bc6$var$tippy($c55de979aca75bc6$var$div(), Object.assign({}, $c55de979aca75bc6$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $c55de979aca75bc6$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $c55de979aca75bc6$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $c55de979aca75bc6$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $c55de979aca75bc6$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $c55de979aca75bc6$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $c55de979aca75bc6$var$tippy(targets, parentProps);
    var normalizedReturnValue = $c55de979aca75bc6$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $c55de979aca75bc6$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($c55de979aca75bc6$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $c55de979aca75bc6$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $c55de979aca75bc6$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $c55de979aca75bc6$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $c55de979aca75bc6$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $c55de979aca75bc6$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $c55de979aca75bc6$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $c55de979aca75bc6$var$createBackdropElement() {
    var backdrop = $c55de979aca75bc6$var$div();
    backdrop.className = $c55de979aca75bc6$var$BACKDROP_CLASS;
    $c55de979aca75bc6$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $c55de979aca75bc6$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $c55de979aca75bc6$var$activeInstances = [];
function $c55de979aca75bc6$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $c55de979aca75bc6$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $c55de979aca75bc6$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $c55de979aca75bc6$var$storeMouseCoords);
}
function $c55de979aca75bc6$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $c55de979aca75bc6$var$storeMouseCoords);
}
var $c55de979aca75bc6$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $c55de979aca75bc6$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $c55de979aca75bc6$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $c55de979aca75bc6$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $c55de979aca75bc6$var$activeInstances = $c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $c55de979aca75bc6$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($c55de979aca75bc6$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) $c55de979aca75bc6$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $c55de979aca75bc6$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $c55de979aca75bc6$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $c55de979aca75bc6$var$getInlineBoundingClientRect($c55de979aca75bc6$var$getBasePlacement(placement), reference.getBoundingClientRect(), $c55de979aca75bc6$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($c55de979aca75bc6$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) {
                    var rects = $c55de979aca75bc6$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $c55de979aca75bc6$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $c55de979aca75bc6$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $c55de979aca75bc6$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $c55de979aca75bc6$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $c55de979aca75bc6$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$c55de979aca75bc6$var$tippy.setDefaultProps({
    render: $c55de979aca75bc6$var$render
});
var $c55de979aca75bc6$export$2e2bcd8739ae039 = $c55de979aca75bc6$var$tippy;



class $b4b8cee06c4cfcc8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorTooltipContent = 'data-tk-tooltip-content', this.selectorTooltipOptions = 'data-tk-tooltip-options';
        this.tooltipContent = this.getAttribute(this.selectorTooltipContent) || undefined;
        this.customOptions = this.getAttribute(this.selectorTooltipOptions) || '{}';
        if (!this.tooltipContent) throw new Error('TK: Missing tooltip content');
    }
    connectedCallback() {
        this.initTooltip();
    }
    initTooltip() {
        this.customOptions = this.customOptions.replace(/'/g, '"');
        const tooltipOptions = {
            content: this.tooltipContent,
            ...this.defaultTooltipOptions(),
            ...JSON.parse(this.customOptions)
        };
        (0, $c55de979aca75bc6$export$2e2bcd8739ae039)(this, tooltipOptions);
    }
    defaultTooltipOptions() {
        return {
            arrow: false,
            theme: 'tk-tooltip',
            allowHTML: true,
            offset: [
                0,
                8
            ]
        };
    }
}





/**
 * data-tk-dialog-jump-forward
 * data-tk-dialog-jump-backward
 * data-tk-dialog-jump-to
 * data-tk-dialog-close
 * data-tk-dialog-close-and-reset
 * data-tk-close-on-backdrop-click
 */ var $2215c02a950e9fbf$var$DialogActions = /*#__PURE__*/ function(DialogActions) {
    DialogActions["JUMP_FORWARD"] = "jump_forward";
    DialogActions["JUMP_BACKWARD"] = "jump_backward";
    DialogActions["JUMP_TO"] = "jump_to";
    DialogActions["RESET_FORM"] = "reset_form";
    return DialogActions;
}($2215c02a950e9fbf$var$DialogActions || {});
class $2215c02a950e9fbf$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.dialogs = [], this.currentDialog = 0, this.shouldOpen = false, this.closeOnBackdropClick = true;
        this.tag = this.getAttribute('data-tk-tag') || 'dialog';
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.button = this.querySelector('button') || undefined;
        this.shouldOpen = this.hasAttribute('data-tk-open');
        this.closeOnBackdropClick = this.hasAttribute('data-tk-close-on-backdrop-click') ? JSON.parse(this.getAttribute('data-tk-close-on-backdrop-click')) : true;
        this.shouldMaxWidth = this.hasAttribute('data-tk-should-max-width');
        this.dialogClassName = this.getAttribute('data-tk-dialog-class-name') || 'tk-dialog';
        this.dialogInnerClassName = this.getAttribute('data-tk-dialog-inner-class-name') || 'tk-dialog__inner';
        this.dialogCloseClassName = this.getAttribute('data-tk-dialog-close-class-name') || 'tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close';
        this.maxWidthClassName = this.getAttribute('data-tk-max-width-class-name') || 'tk-dialog--max-width';
        this.formDataString = this.getAttribute('data-tk-form-data') || undefined;
        this.isPopup = this.hasAttribute('data-tk-is-popup');
        this.isConfirm = this.hasAttribute('data-tk-is-confirm');
        this.confirmTitle = this.getAttribute('data-tk-confirm-title') || undefined;
        this.confirmDescription = this.getAttribute('data-tk-confirm-description') || undefined;
        this.confirmCancelIcon = this.getAttribute('data-tk-confirm-cancel-icon') || 'cross';
        this.confirmCancelLabel = this.getAttribute('data-tk-confirm-cancel-label') || undefined;
        this.confirmSubmitIcon = this.getAttribute('data-tk-confirm-submit-icon') || 'check';
        this.confirmSubmitLabel = this.getAttribute('data-tk-confirm-submit-label') || undefined;
        this.forceReloadContent = this.hasAttribute('data-tk-force-reload-content');
    }
    connectedCallback() {
        if (!this.url) throw new Error('Dialog: URL is missing!');
        this.registerClickListener();
        this.checkAutoOpen();
    }
    registerClickListener() {
        if (!this.button) return;
        const onClick = this.openDialog.bind(this, this.url);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerFormListener(form) {
        const onSubmit = this.handleForm.bind(this, form);
        this.pushListener({
            event: 'submit',
            element: form,
            action: onSubmit
        });
    }
    registerCloseListener() {
        const onClick = this.closeDialog.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: onClick
        });
    }
    createDialog(url) {
        const dialog = $2215c02a950e9fbf$export$2e2bcd8739ae039.renderDialog({
            className: `${this.dialogClassName} ${this.shouldMaxWidth ? this.maxWidthClassName : ''}`,
            closeClassName: this.dialogCloseClassName,
            innerClassName: this.dialogInnerClassName,
            tag: this.tag,
            isConfirm: this.isConfirm,
            confirmURL: url,
            confirmTitle: this.confirmTitle,
            confirmDescription: this.confirmDescription,
            confirmCancelIcon: this.confirmCancelIcon,
            confirmCancelLabel: this.confirmCancelLabel,
            confirmSubmitIcon: this.confirmSubmitIcon,
            confirmSubmitLabel: this.confirmSubmitLabel
        });
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({
            event: 'close',
            element: dialog,
            action: onClosed
        });
        this.currentDialog = this.forceReloadContent ? 0 : this.dialogs.push({
            url: url,
            dialog: dialog
        }) - 1;
        return dialog;
    }
    getContent(url) {
        if (this.isConfirm) {
            this.closeCurrentDialog();
            const dialog = this.createDialog(url);
            $2215c02a950e9fbf$export$2e2bcd8739ae039.open(dialog, this.isPopup);
            this.hookAfterShowModal(dialog);
        } else (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url)
        });
    }
    getContentWithData(url, payload) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: payload
        });
    }
    handleResponseSuccess(url, response) {
        if (!response || !response.success) return;
        this.closeCurrentDialog();
        const dialog = this.createDialog(url);
        const content = dialog.querySelector('[data-tk-dialog-content]');
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(dialog, this.isPopup);
        this.hookAfterShowModal(dialog);
        const form = content.querySelector('form');
        form && this.registerFormListener(form);
    }
    openDialog(url) {
        this.handleUrlAndDialogs(url);
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    closeDialog(event) {
        const dialogItem = this.dialogs.at(this.currentDialog);
        // Used to check if the event isn't triggered by the enter key
        const isRealClickEvent = event.pointerId !== -1;
        if (!dialogItem || !isRealClickEvent) return;
        const { dialog: dialog } = dialogItem;
        if (this.closeOnBackdropClick) $2215c02a950e9fbf$export$2e2bcd8739ae039.closeDialogIfOutside(dialog, event, this.forceReloadContent);
    }
    hookAfterShowModal(dialog) {
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog, this.forceReloadContent));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close-and-reset]', (button)=>this.handleActions("reset_form", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-forward]', (button)=>this.handleActions("jump_forward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-backward]', (button)=>this.handleActions("jump_backward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-to]', (button)=>this.handleActions("jump_to", button));
    }
    static attachButtonClickHandler(dialog, selector, callback) {
        const buttons = dialog.querySelectorAll(selector);
        buttons.forEach((button)=>{
            button.addEventListener('click', ()=>callback(button));
        });
    }
    handleActions(action, button) {
        const handler = {
            jump_forward: ()=>this.forward(button),
            jump_backward: ()=>this.backward(),
            jump_to: ()=>this.jumpTo(button),
            reset_form: ()=>this.resetForm(button)
        };
        handler[action]();
    }
    closeCurrentDialog() {
        const dialogItem = this.dialogs.at(this.currentDialog);
        if (!dialogItem) return;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialogItem.dialog, this.forceReloadContent);
    }
    handleUrlAndDialogs(url) {
        const existsURL = this.dialogs.some((dialogItem)=>dialogItem.url === url);
        if (existsURL) {
            const nextDialog = this.getDialogByURL(url);
            if (!nextDialog) return;
            $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialog);
        } else try {
            const payload = JSON.parse(this.formDataString || '{}');
            Object.keys(payload).length > 0 ? this.getContentWithData(url, payload) : this.getContent(url);
        } catch (error) {
            throw new Error(`Dialog: ${error}`);
        }
    }
    forward(button) {
        // Check if already exists
        const url = button.getAttribute('data-tk-url');
        if (!url) throw new Error('Dialog: URL is missing!');
        this.closeCurrentDialog();
        this.handleUrlAndDialogs(url);
        this.currentDialog += 1;
    }
    backward() {
        const nextDialogItem = this.dialogs.at(this.currentDialog - 1);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialogItem.dialog);
        this.currentDialog -= 1;
    }
    jumpTo(button) {
        const index = Number(button.getAttribute('data-tk-dialog-jump-to'));
        const nextDialogItem = this.dialogs.at(index);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialogItem.dialog);
        this.currentDialog = index;
    }
    resetForm(button) {
        button.form?.reset();
        this.closeCurrentDialog();
    }
    handleForm(form, event) {
        const shouldSwitchToNext = form.hasAttribute('data-tk-switch-to-next');
        if (!shouldSwitchToNext) return;
        event.preventDefault();
        const formData = new FormData(form);
        const url = form.action;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: formData
        });
    }
    getDialogByURL(url) {
        const dialogItem = this.dialogs.find((item)=>item.url === url);
        return dialogItem?.dialog;
    }
    closedDialog() {
        const allDialogClosed = this.dialogs.every((item)=>!item.dialog.open);
        if (!allDialogClosed) return;
        this.currentDialog = 0;
        this.removeListener(window);
    }
    static renderDialog(options) {
        const { tag: tag, className: className = 'tk-dialog', closeClassName: closeClassName = 'tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close', innerClassName: innerClassName = 'tk-dialog__inner', content: content, isConfirm: isConfirm = false, confirmURL: confirmURL, confirmTitle: confirmTitle, confirmDescription: confirmDescription, confirmCancelIcon: confirmCancelIcon, confirmCancelLabel: confirmCancelLabel, confirmSubmitIcon: confirmSubmitIcon, confirmSubmitLabel: confirmSubmitLabel, forceClosing: forceClosing } = options;
        const dialog = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            ${isConfirm ? `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            <form action="${confirmURL}" method="post">
                                <h3>${confirmTitle}</h3>
                                <p>${confirmDescription}</p>
                                <div class="flex flex--gap-x-2 flex--justify-end spacer-mt-9">
                                    <button type="button" class="tk-button tk-button--secondary" data-tk-dialog-close>
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmCancelIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmCancelLabel}</span>
                                    </button>
                                    <button type="submit" class="tk-button tk-button--primary">
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmSubmitIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmSubmitLabel}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </${tag}>
                ` : `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            ${content}
                        </div>
                    </${tag}>
                `}
        `);
        document.body.insertAdjacentElement('beforeend', dialog);
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog, forceClosing));
        return dialog;
    }
    static open(element, isPopup = false) {
        if (element instanceof HTMLDialogElement) isPopup ? element.show() : element.showModal();
        else element.classList.add('tk-dialog--open');
    }
    static close(element, forceClosing = false) {
        forceClosing && $2215c02a950e9fbf$export$2e2bcd8739ae039.destoryInstances(element);
        if (element instanceof HTMLDialogElement) element.close();
        else {
            element.classList.remove('tk-dialog--open');
            element.dispatchEvent(new Event('close'));
        }
        const contextMenus = element.querySelectorAll('[data-tk-context-menu]');
        contextMenus.forEach((menu)=>menu.close());
        forceClosing && element.remove();
    }
    static closeDialogIfOutside(element, event, forceClosing = false) {
        /**
         * Checking the coordinates of the client for the value 0 and the
         * HTMLSelectElement or HTMLOptionElement element ensures that the
         * dialogue does not close in Mozilla. This is a bug in Firefox
         * that has not yet been fixed.
         */ if (event.clientX === 0 && event.clientY === 0 && (event.target instanceof HTMLSelectElement || event.target instanceof HTMLOptionElement)) return;
        const dialogDimensions = element.getBoundingClientRect();
        if (event.clientX < dialogDimensions.left || event.clientX > dialogDimensions.right || event.clientY < dialogDimensions.top || event.clientY > dialogDimensions.bottom) $2215c02a950e9fbf$export$2e2bcd8739ae039.close(element, forceClosing);
    }
    checkAutoOpen() {
        if (!this.shouldOpen) return;
        this.openDialog(this.url);
    }
    renewDialogContent(dialog, url) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.getRenewDialogContent.bind(this, dialog)
        });
    }
    getRenewDialogContent(openDialog, response) {
        const dialogInner = openDialog.querySelector('[data-tk-dialog-content]');
        dialogInner.innerHTML = response.dataAsHtml;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(openDialog);
        this.hookAfterShowModal(openDialog);
    }
    static destoryInstances(element) {
        const richtexts = element.querySelectorAll('[data-cms-richtext]');
        const datepickers = element.querySelectorAll('[data-tk-form-datepicker]');
        richtexts.forEach((richtext)=>{
            const item = richtext;
            item.editors?.forEach((editor)=>{
                editor.destroy();
            });
        });
        datepickers.forEach((datepicker)=>{
            datepicker.flatpickr?.destroy();
        });
    }
}


class $5a26c1218729bf34$export$2e2bcd8739ae039 extends (0, $2215c02a950e9fbf$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.dialogCloseClassName = this.getAttribute('data-tk-dialog-close-class-name') || 'tk-button tk-button--tertiary tk-button--size-l tk-button--only-icon tk-dialog__close';
    }
}






class $edcef81612fbf4b7$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('[data-tk-static-content-edit]') || undefined;
        this.target = this.getAttribute('data-tk-target') || '#tk-static-content-editor';
        this.boId = this.getAttribute('data-tk-bo-id') || undefined;
        this.boNumber = this.getAttribute('data-tk-bo-number') || undefined;
        this.artTextNumber = this.getAttribute('data-tk-art-text-number') || undefined;
        this.bo = this.getAttribute('data-tk-bo') || undefined;
        this.attr = this.getAttribute('data-tk-attr') || undefined;
        this.itemId = this.getAttribute('data-tk-id') || undefined;
        this.langNumber = this.getAttribute('data-tk-lang-number') || undefined;
        this.dataPer = this.getAttribute('data-tk-data-per') || undefined;
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || undefined;
        this.urlTemplate = [];
        this.templateContentPromiseArray = [];
        this.templatesLoaded = false;
        this.fileUploadIFrameURL = this.getAttribute('data-tk-file-upload-iframe-url') || '';
    }
    async connectedCallback() {
        if (!this.button || !this.boId || !this.dataPer || !this.asyncTemplate) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        await (parcelRequire("cnCS2"));
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.sendAjaxRequest.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerModalListener(modal) {
        const saveButton = modal.querySelector('[data-tk-static-content-save]') || undefined;
        const onSave = this.save.bind(this, saveButton);
        saveButton && this.pushListener({
            event: 'click',
            element: saveButton,
            action: onSave
        });
        const cancelButton = modal.querySelector('[data-tk-static-content-cancel]');
        const onCancel = this.cancel.bind(this);
        cancelButton && this.pushListener({
            event: 'click',
            element: cancelButton,
            action: onCancel
        });
    }
    sendAjaxRequest() {
        this.requestData = {
            type: 'staticcontent',
            boid: this.boId,
            bonumber: this.boNumber,
            arttextno: this.artTextNumber,
            per: this.dataPer,
            template: this.asyncTemplate,
            modalid: this.target,
            bo: this.bo,
            id: this.itemId,
            attr: this.attr
        };
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.showContentInEditMode.bind(this),
            payload: this.requestData
        });
    }
    save(button) {
        if (!button) return;
        const htmlEncoded = $edcef81612fbf4b7$export$2e2bcd8739ae039.htmlEncode($edcef81612fbf4b7$export$2e2bcd8739ae039.getContentFromEditMode());
        this.requestData = {
            type: 'staticcontent',
            boid: this.boId,
            bonumber: this.boNumber,
            arttextno: this.artTextNumber,
            bo: this.bo,
            id: this.itemId,
            attr: this.attr,
            html: htmlEncoded
        };
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshContent.bind(this),
            payload: this.requestData
        });
        this.cancel();
    }
    cancel() {
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).close(this.dialog);
    }
    showContentInEditMode(response) {
        if (!response.success || !this.requestData) return;
        this.dialog = (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).renderDialog({
            content: response.dataAsHtml,
            className: 'tk-dialog tk-dialog--fullscreen',
            tag: 'div'
        });
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).open(this.dialog);
        this.pushListener({
            event: 'close',
            element: this.dialog,
            action: ()=>this.dialog?.remove()
        });
        this.initEditor();
        const modal = document.querySelector(this.target);
        if (!modal) return;
        this.registerModalListener(modal);
    }
    static getContentFromEditMode() {
        return window.tinymce.activeEditor?.getContent({
            format: 'raw'
        }) || '';
    }
    refreshContent(response) {
        if (!response.success || !this.requestData) return;
        let contentContainer = document.getElementById(`staticcontent-${this.requestData.boid}-${this.requestData.arttextno}`);
        if (!contentContainer) this.requestData.id !== undefined && (contentContainer = document.getElementById(this.requestData.id));
        else contentContainer.innerHTML = response.dataAsHtml;
    }
    initEditor() {
        if (!this.requestData) return;
        const selector = `${this.requestData.modalid} [data-tk-static-content-textarea]`;
        // Editor must be removed before initialisation
        window.tinymce.remove(selector);
        const options = {
            selector: selector,
            language: $edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage(),
            plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'pagebreak',
                'searchreplace',
                'wordcount',
                'visualblocks',
                'visualchars',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'nonbreaking',
                'save',
                'table',
                'directionality',
                'emoticons',
                'template',
                'quickbars'
            ],
            insertdatetime_formats: [
                '%d.%m.%Y',
                '%H:%M'
            ],
            contextmenu: 'link image table',
            tools: 'inserttable',
            toolbar: "undo redo | styles | bold italic | forecolor backcolor | alignleft aligncenteralignright alignjustify | bullist numlist outdent indent | image media link | preview print | filemanager",
            width: '100%',
            base_url: '/webportal/config/layout/themes/tk/vendor/tinymce/',
            language_url: `/webportal/config/layout/themes/tk/translations/tinymce/${$edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage()}.js`,
            promotion: false,
            content_css: [
                'default',
                `/webportal/config/layout/themes/project/generated/staticcontent.css?${new Date().getTime()}`
            ],
            templates: this.urlTemplate,
            extended_valid_elements: 'tk-tabs-accordion,tk-tabs-accordion[class],i[data-tk-accordion-icon]',
            custom_elements: 'tk-tabs-accordion,tk-tabs-accordion',
            setup: (editor)=>{
                editor.on('SaveContent', (event)=>{
                    event.content = $edcef81612fbf4b7$export$2e2bcd8739ae039.htmlEncode($edcef81612fbf4b7$export$2e2bcd8739ae039.htmlDecode(event.content));
                });
                const openmanager = ()=>{
                    editor.windowManager.openUrl({
                        title: 'File Manager',
                        url: $edcef81612fbf4b7$export$2e2bcd8739ae039.getFileManagerURL(editor),
                        width: 900,
                        height: 440
                    });
                };
                editor.ui.registry.addButton('filemanager', {
                    icon: 'browse',
                    tooltip: 'Insert file',
                    onAction: openmanager
                });
                editor.ui.registry.addMenuItem('filemanager', {
                    icon: 'browse',
                    text: 'Insert file',
                    onAction: openmanager
                });
                const templateURLElement = document.querySelector('[data-tk-staticcontent-templates-url]');
                const templateURL = templateURLElement && templateURLElement.getAttribute('data-op-url');
                if (templateURL) this.getTemplates(templateURL);
            }
        };
        if (this.fileUploadIFrameURL) options.file_picker_callback = this.handleFilePicker.bind(this);
        window.tinymce.init(options);
    }
    handleFilePicker(callback) {
        window.tinymce.activeEditor?.windowManager.openUrl({
            title: 'Fileupload Area',
            url: this.fileUploadIFrameURL,
            width: 800,
            height: 600
        });
        window.addEventListener('message', (event)=>{
            const { data: data } = event;
            if (window.location.origin !== event.origin) return;
            callback(data.content);
        });
    }
    static getFileManagerURL(editor) {
        return `/webportal/filemanager.aspx?editor=${editor.id}&lang=${$edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage()}`;
    }
    static htmlEncode(content) {
        return content.toString().replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    static htmlDecode(content) {
        return content.toString().replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
    }
    static getLanguage() {
        if (window.location.href.indexOf('/en/') !== -1) return 'en_GB';
        if (window.location.href.indexOf('/fr/') !== -1) return 'fr_FR';
        if (window.location.href.indexOf('/it/') !== -1) return 'it';
        return 'de';
    }
    async getTemplates(templateURL) {
        if (this.templatesLoaded) return;
        // get url content
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: templateURL,
                resolveHandler: (response)=>{
                    this.getTemplateContent(response, resolve);
                }
            });
        });
    }
    getTemplateContent(response, resolveFunction) {
        response.dataAsJson.forEach((element)=>{
            this.templateContentPromiseArray = [];
            this.templateContentPromiseArray.push(new Promise((resolve)=>{
                (0, $1653b55d89a7adce$export$24835cb787452b46)({
                    requestURL: element.url,
                    resolveHandler: (response)=>{
                        this.saveTemplateContent(response, element, resolveFunction, resolve);
                    }
                });
            }));
        });
    }
    saveTemplateContent(response, element, resolvedAllFunction, resolveArrayElementFunction) {
        const templateContent = response.dataAsHtml;
        const newTemplateEntry = {
            title: element.title,
            description: element.description,
            content: templateContent
        };
        this.urlTemplate.push(newTemplateEntry);
        resolveArrayElementFunction();
        Promise.allSettled(this.templateContentPromiseArray).then(()=>{
            resolvedAllFunction();
            this.templatesLoaded = true;
        });
    }
}



class $237e800aa488702c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorTabsHead = '[data-tk-tab-head]', this.selectorTabsBody = '[data-tk-tab-body]';
        const tabHead = this.querySelector(this.selectorTabsHead);
        const tabBody = this.querySelector(this.selectorTabsBody);
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-tabs-tab--active';
        this.initialTabIndex = Number(this.getAttribute('data-tk-initial-tab')) || 1;
        this.enableLinks = this.hasAttribute('data-tk-enable-links');
        if (!tabHead) throw new Error('TK: Missing Tab-Header');
        if (!tabBody) throw new Error('TK: Missing Tab-Body');
        this.tabList = tabHead.childElementCount > 0 ? tabHead.children : undefined;
        this.tabContentList = tabBody.childElementCount > 0 ? tabBody.children : undefined;
        if (!this.tabList) throw new Error('TK: Empty Tab-Header');
        if (!this.tabContentList) throw new Error('TK: Empty Tab-Content');
        if (this.tabList.length !== this.tabContentList.length && !this.enableLinks) throw new Error('TK: Tab-Header Elements and Tab-Content Elements must be equal');
    }
    connectedCallback() {
        this.registerListener();
        if (this.tabList && +this.initialTabIndex > 0) {
            const button = this.tabList.item(this.initialTabIndex - 1);
            this.setTabActive(button, this.initialTabIndex - 1);
        }
    }
    registerListener() {
        if (this.tabList) [
            ...this.tabList
        ].forEach((element, index)=>{
            const button = element;
            const eventHandler = this.setTabActive.bind(this, button, index);
            this.pushListener({
                event: 'click',
                element: button,
                action: eventHandler
            });
        });
    }
    setTabActive(button, index) {
        const input = button.querySelector('input');
        if (input && input.disabled || button.disabled) return;
        const item = this.tabContentList?.item(index);
        if (!item) {
            const url = button.getAttribute('data-tk-url');
            const target = button.getAttribute('target') || undefined;
            if (!url) return;
            window.open(url, target);
        } else {
            this.setTabInactive();
            button.classList.add(this.activeClassName);
            item.classList.add(this.activeClassName);
        }
        this.toggleRequiredAttribute(index);
    }
    setTabInactive() {
        if (!this.tabContentList) return;
        [
            ...this.tabContentList
        ].forEach((element, index)=>{
            const button = element;
            button.classList.remove(this.activeClassName);
            const item = this.tabList?.item(index);
            if (!item) return;
            item.classList.remove(this.activeClassName);
        });
    }
    toggleRequiredAttribute(index) {
        if (!this.tabContentList) return;
        const currentElement = this.tabContentList.item(index);
        const contentList = Array.from(this.tabContentList);
        const filteredList = contentList.filter((element)=>element !== currentElement);
        filteredList.forEach((element)=>{
            const fieldElements = element.querySelectorAll('input[required]');
            fieldElements.forEach((fieldElement)=>{
                fieldElement.required = false;
                fieldElement.setAttribute('data-tk-is-required', '');
            });
        });
        const fieldElements = currentElement?.querySelectorAll('input[data-tk-is-required]');
        fieldElements?.forEach((fieldElement)=>{
            fieldElement.required = true;
            fieldElement.removeAttribute('data-tk-is-required');
        });
    }
}







class $1ccb7c18f671f1de$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.hasStartedSync = false;
        this.isAsyncTile = Boolean(this.closest('[data-tk-product-tile][data-tk-url]'));
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.source = this.getAttribute('data-tk-source') || '';
        this.service = this.getAttribute('data-tk-service') || '';
        this.catItemId = this.getAttribute('data-tk-cat-item-id') || '';
        this.articleId = this.getAttribute('data-tk-article-id') || '';
        this.loadingType = this.getAttribute('data-tk-loading-type') || '';
        this.sort = this.getAttribute('data-tk-sort') || '';
        this.key = this.getAttribute('data-tk-key') || '';
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || '';
        this.isServiceClassName = this.getAttribute('data-tk-is-service-class-name') || 'tk-price--has-service';
        this.isPromotionClassName = this.getAttribute('data-tk-is-promotion-class-name') || 'tk-price--has-promotion';
    }
    connectedCallback() {
        this.item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: this
        };
        if (this.articleList && this.loadingType !== '2' && !this.isAsyncTile) this.sendDataToArticleList();
        else this.loadingType === '2' ? this.registerHoverListener() : this.handlePrice();
    }
    registerHoverListener() {
        const onHover = this.handlePrice.bind(this);
        this.pushListener({
            event: 'mouseover',
            element: this,
            action: onHover
        });
    }
    hover() {
        this.hasStartedSync = true;
        this.handlePrice();
    }
    sendDataToArticleList() {
        this.item && this.articleList.addPrice(this.item);
    }
    handlePrice() {
        if (!this.item) return;
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? $1ccb7c18f671f1de$export$2e2bcd8739ae039.getItemsAsJSONString([
            this.item
        ]) : $1ccb7c18f671f1de$export$2e2bcd8739ae039.getItemsAsEntrypoint([
            this.item
        ]);
        const data = {
            type: 'price',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            resolveHandler: this.handleResponse.bind(this),
            payload: data
        });
    }
    static getItemsAsEntrypoint(data) {
        const articles = [];
        data.forEach((item)=>{
            articles.push(item.articleId);
        });
        return {
            articles: articles.join(',')
        };
    }
    static getItemsAsJSONString(data) {
        const items = [];
        data.forEach((item)=>{
            items.push({
                source: item.source,
                service: item.service,
                catitemboid: item.catItemId,
                catitemartinternalno: item.articleId,
                loadingtype: item.loadingType,
                sort: item.sort,
                key: item.key,
                template: item.asyncTemplate
            });
        });
        return {
            catitems: JSON.stringify({
                items: items
            })
        };
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== 1) return;
        const list = response.dataAsJson.items;
        const responseItem = list[0];
        const item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: undefined
        };
        this.refreshPrice(item, responseItem);
    }
    handleError(error) {
        this.hasStartedSync = false;
        throw new Error(error);
    }
    refreshPrice(_item, responseItem) {
        const conditions = [
            {
                condition: responseItem.basispriceisset,
                selector: '[data-tk-price-basic]',
                className: undefined
            },
            {
                condition: responseItem.servicepriceisset,
                selector: '[data-tk-price-service]',
                className: this.isServiceClassName
            },
            {
                condition: responseItem.promopriceisset,
                selector: '[data-tk-price-promotion]',
                className: this.isPromotionClassName
            }
        ];
        const { selector: selector, className: className } = conditions.find(({ condition: condition })=>condition) || {};
        if (!selector) return;
        const element = this.querySelector(selector);
        const { html: html } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? (0, $fbcf93c2a0aa5bcb$export$c537b38001c583b7)(html) : html;
        if (element) element.innerHTML = htmlString;
        else this.innerHTML = htmlString;
        className && this.classList.add(className);
    }
}





class $ad2181492f474118$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.isAsyncTile = Boolean(this.closest('[data-tk-product-tile][data-tk-url]'));
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.source = this.getAttribute('data-tk-source') || '';
        this.catItemId = this.getAttribute('data-tk-cat-item-id') || '';
        this.articleId = this.getAttribute('data-tk-article-id') || '';
        this.stockType = this.getAttribute('data-tk-stock-type') || '';
        this.stockLocation = this.getAttribute('data-tk-stock-location') || '';
        this.dispo = this.getAttribute('data-tk-dispo') || '';
        this.dispoDate = this.getAttribute('data-tk-dispo-date') || '';
        this.loadingType = this.getAttribute('data-tk-loading-type') || '';
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || '';
        this.stockPeriodType = this.getAttribute('data-tk-stock-period-type') || '1';
        this.artUnitType = this.getAttribute('data-tk-art-unit-type') || '3';
    }
    connectedCallback() {
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            stockPeriodType: this.stockPeriodType,
            artUnitType: this.artUnitType,
            element: this
        };
        if (this.articleList && !this.isAsyncTile) this.sendDataToArticleList(item);
        else this.handleStock(item);
    }
    sendDataToArticleList(item) {
        this.articleList.addStock(item);
    }
    handleStock(item) {
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? $ad2181492f474118$export$2e2bcd8739ae039.getItemsAsJSONString([
            item
        ]) : $ad2181492f474118$export$2e2bcd8739ae039.getItemsAsEntrypoint([
            item
        ]);
        const data = {
            type: 'stock',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this)
        });
    }
    static getItemsAsEntrypoint(data) {
        const items = [];
        const articles = [];
        data.forEach((item)=>{
            items.push([
                item.articleId,
                item.stockType,
                item.stockLocation,
                item.stockPeriodType,
                item.dispoDate,
                item.artUnitType
            ].join(','));
            articles.push(item.articleId);
        });
        return {
            items: items.join(','),
            articles: articles.join(',')
        };
    }
    static getItemsAsJSONString(data) {
        const items = [];
        data.forEach((item)=>{
            items.push({
                source: item.source,
                catitemboid: item.catItemId,
                catitemartinternalno: item.articleId,
                stocktype: item.stockType,
                stockloc: item.stockLocation,
                dispo: item.dispo,
                dispodate: item.dispoDate,
                loadingtype: item.loadingType,
                template: item.asyncTemplate
            });
        });
        return {
            catitems: JSON.stringify({
                items: items
            })
        };
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== 1) return;
        const list = response.dataAsJson.items;
        const responseItem = list[0];
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            element: undefined
        };
        this.refreshStock(item, responseItem);
    }
    refreshStock(_item, responseItem) {
        const { html: html } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? (0, $fbcf93c2a0aa5bcb$export$c537b38001c583b7)(html) : html;
        const tooltip = this.querySelector('tk-tooltip');
        tooltip && tooltip.remove();
        this.insertAdjacentHTML('beforeend', htmlString);
    }
}


var $6406837936bc2cfc$var$ArticleDataType = /*#__PURE__*/ function(ArticleDataType) {
    ArticleDataType["PRICE"] = "price";
    ArticleDataType["STOCK"] = "stock";
    return ArticleDataType;
}($6406837936bc2cfc$var$ArticleDataType || {});
class $6406837936bc2cfc$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.prices = [], this.stocks = [], this.isCustomPriceURL = false, this.isCustomStockURL = false;
    }
    addPrice(item) {
        this.prices.push(item);
        this.handlePrice();
    }
    addStock(item) {
        this.stocks.push(item);
        this.handleStock();
    }
    handlePrice() {
        const elements = this.querySelectorAll('[data-tk-price-wrapper]');
        const filteredList = Array.from(elements).filter((element)=>!element.closest('[data-tk-product-tile][data-tk-url]'));
        if (filteredList.length !== this.prices.length) return;
        const url = filteredList.at(0)?.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.isCustomPriceURL = url !== (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshPriceData.bind(this),
            payload: this.getPreparedData("price")
        });
    }
    handleStock() {
        const elements = this.querySelectorAll('[data-tk-stock-wrapper]');
        const filteredList = Array.from(elements).filter((element)=>!element.closest('[data-tk-product-tile][data-tk-url]'));
        if (filteredList.length !== this.stocks.length) return;
        const url = filteredList.at(0)?.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.isCustomStockURL = url !== (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshStockData.bind(this),
            payload: this.getPreparedData("stock")
        });
    }
    getPreparedData(type) {
        return {
            type: type,
            ...this.getListByType(type)
        };
    }
    getListByType(type) {
        const handler = {
            price: ()=>this.getPriceData(),
            stock: ()=>this.getStockData()
        };
        return handler[type]();
    }
    getPriceData() {
        const items = this.isCustomPriceURL ? (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039).getItemsAsEntrypoint(this.prices) : (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039).getItemsAsJSONString(this.prices);
        return items;
    }
    getStockData() {
        const items = this.isCustomStockURL ? (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsEntrypoint(this.stocks) : (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsJSONString(this.stocks);
        return items;
    }
    refreshPriceData(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== this.prices.length) return;
        const list = response.dataAsJson.items;
        this.prices.forEach((item, index)=>{
            const responseItem = list[index];
            const { element: element } = item;
            element && element.refreshPrice(item, responseItem);
        });
    }
    refreshStockData(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== this.stocks.length) return;
        const list = response.dataAsJson.items;
        this.stocks.forEach((item, index)=>{
            const responseItem = list[index];
            const { element: element } = item;
            element && element.refreshStock(item, responseItem);
        });
    }
}







var $2c226fea39ede692$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["ADD"] = "add";
    Actions["ADDED"] = "added";
    Actions["DELETED"] = "deleted";
    Actions["MOVED"] = "moved";
    Actions["MOVE"] = "move";
    return Actions;
}({});
class $2c226fea39ede692$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('button') || undefined;
        this.artBoId = this.getAttribute('data-tk-art-bo-id') || '';
        this.type = this.getAttribute('data-tk-type') || '';
        this.artNumber = this.getAttribute('data-tk-art-number') || '';
        this.asyncCountId = this.getAttribute('data-tk-async-count-id') || '';
        this.multiFavoritesAction = this.getAttribute('data-tk-multi-favorites-action') || '';
        this.onList = this.getAttribute('data-tk-on-list') || '';
        this.saldocBoIdTarget = this.getAttribute('data-tk-saldoc-bo-id-target') || '';
        this.saldocBoIdSource = this.getAttribute('data-tk-saldoc-bo-id-source') || '';
        this.maxList = Number(this.getAttribute('data-tk-max-list'));
        this.maxPosition = Number(this.getAttribute('data-tk-max-position'));
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-button--selected';
        this.listName = this.getAttribute('data-tk-list-name') || '';
        this.selectedOption = Number(this.getAttribute('data-tk-selected-option')) || 1;
        this.isGuestUser = this.hasAttribute('data-tk-guest-user');
    }
    connectedCallback() {
        if (!this.button) throw new Error('Favorite: Button is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.send.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    async send(event) {
        const formValidator = this.closest('[data-tk-form-validator]');
        const formElement = formValidator?.form;
        if (formElement) {
            const formData = new FormData(formElement);
            const optionElements = formElement.querySelectorAll('input[name="favorite-option"]');
            const optionElementList = Array.from(optionElements);
            const selectedOptionIndex = optionElementList.findIndex((element)=>element.checked);
            // if the selected option is `existing`, then take the `saldocBoIdTarget`
            if (selectedOptionIndex === this.selectedOption) {
                const selectElement = formElement.querySelector('select');
                const selectedOption = selectElement?.selectedOptions.item(0);
                this.saldocBoIdTarget = selectedOption?.getAttribute('data-tk-saldoc-bo-id-target') || '';
            }
            if (this.listName === '') {
                const { length: length } = formData.getAll('field-name');
                this.listName = length > 1 ? formData.getAll('field-name')?.at(selectedOptionIndex)?.toString() || '' : formData.get('field-name')?.toString() || '';
            } else this.listName = formData.get('field-name')?.toString() || '';
            if (this.multiFavoritesAction === "added" || this.multiFavoritesAction === "moved") this.checkMaximum(formElement, selectedOptionIndex);
            await this.saveListToSessionVar(this.listName);
        }
        const isFormValid = await formValidator?.isFormValid();
        if (formValidator && !isFormValid) return;
        const data = {
            Type: 'favorite',
            ArtFavorite_ArtNo: this.artNumber,
            ArtFavorite_ArtBoId: this.artBoId,
            ArtFavorite_ListName: this.listName,
            ArtFavorite_MultiAction: this.multiFavoritesAction,
            ArtFavorite_OnList: this.onList,
            ArtFavorite_SalDocBoIdSource: this.saldocBoIdSource,
            ArtFavorite_SalDocBoIdTarget: this.saldocBoIdTarget,
            maxLists: String(this.maxList),
            maxPositions: String(this.maxPosition)
        };
        Object.keys(this.dataset).filter((key)=>key.startsWith('opSaldocitem.')).forEach((key)=>{
            data[key.substring(2).toLowerCase()] = this.dataset[key];
        });
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshContent.bind(this, event),
            payload: data,
            showMessages: false
        });
    }
    refreshContent(event, response) {
        if (!response) return;
        if (response.success && response.messages?.length === 0 && (response.dataAsJson.action === "add" || response.dataAsJson.action === "move")) {
            if (this.isGuestUser && this.listName !== '') {
                const html = document.createElement('div');
                html.innerHTML = response.dataAsJson.message;
                const favoriteButton = html.querySelector('[data-tk-saldoc-bo-id-target]');
                const saldocBoIdTarget = favoriteButton?.getAttribute('data-tk-saldoc-bo-id-target');
                const saldocBoId = favoriteButton?.getAttribute('data-tk-saldoc-bo-id');
                saldocBoIdTarget && (this.saldocBoIdTarget = saldocBoIdTarget);
                this.multiFavoritesAction = "added";
                this.setAttribute('data-tk-on-list', `#${saldocBoId}#`);
                this.setAttribute('data-tk-saldoc-bo-id-target', this.saldocBoIdTarget);
                this.send(event);
            } else {
                const { message: message } = response.dataAsJson;
                const dialog = (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).renderDialog({
                    content: message,
                    className: 'tk-dialog tk-dialog--max-width',
                    tag: 'dialog'
                });
                const favoriteButton = dialog.querySelector('tk-favorite-button');
                if (favoriteButton) favoriteButton.addButton = this;
                dialog.showModal();
                this.pushListener({
                    event: 'close',
                    element: dialog,
                    action: ()=>dialog.remove()
                });
            }
        } else {
            const dialog = this.closest('dialog');
            const { action: action, artBoId: artBoId, favoriteCount: favoriteCount } = response.dataAsJson;
            action !== "added" && dialog?.close();
            const actionHandler = {
                added: ()=>this.addedItem(response),
                deleted: ()=>this.deleteArticle(artBoId, response),
                moved: ()=>this.deleteArticle(artBoId, response),
                ["add"] () {
                    throw new Error('Function not implemented.');
                },
                ["move"] () {
                    throw new Error('Function not implemented.');
                }
            };
            actionHandler[action]();
            if (this.isGuestUser) return;
            $2c226fea39ede692$export$2e2bcd8739ae039.syncInfo(favoriteCount);
        }
    }
    addedItem(response) {
        const { messages: messages } = response;
        const dialog = this.closest('dialog');
        // check for empty value
        if (!response.dataAsJson.salDocName) return;
        dialog?.close();
        messages?.forEach((message)=>{
            (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(message);
        });
        if (this.addButton) {
            this.addButton.setAttribute('data-tk-on-list', response.dataAsJson.onList);
            this.addButton.button.classList.add(this.activeClassName);
            this.addButton.onList = response.dataAsJson.onList;
        }
        this.button.setAttribute('data-tk-on-list', response.dataAsJson.onList);
        this.button.classList.add(this.activeClassName);
        this.onList = response.dataAsJson.onList;
        this.saldocBoIdTarget = response.dataAsJson.salDocBoIdTarget;
        this.setAttribute('data-tk-multi-favorites-action', 'added');
        $2c226fea39ede692$export$2e2bcd8739ae039.updateItemsCount(this.multiFavoritesAction);
        if (this.isGuestUser) {
            console.log('set multiFavoritesAction to deleted');
            this.setAttribute('data-tk-multi-favorites-action', 'deleted');
            this.multiFavoritesAction = "deleted";
        }
        this.pushTrackItem(response.dataAsJson);
    }
    deleteArticle(id, response) {
        const article = document.querySelector(`[data-tk-article-id="${id}"]`);
        if (!article) return;
        if (article.getAttribute('data-tk-item-number')) {
            article.remove();
            const contextMenu = this.closest('[data-tk-context-items]');
            if (!contextMenu) return;
            contextMenu.remove();
            $2c226fea39ede692$export$2e2bcd8739ae039.syncCounter();
        }
        $2c226fea39ede692$export$2e2bcd8739ae039.updateItemsCount(this.multiFavoritesAction);
        this.button?.removeAttribute('data-tk-on-list');
        this.button?.classList.remove(this.activeClassName);
        this.removeAttribute('data-tk-on-list');
        this.setAttribute('data-tk-multi-favorites-action', 'add');
        this.multiFavoritesAction = "add";
        this.saldocBoIdTarget = '';
        const { messages: messages } = response;
        messages?.forEach((message)=>{
            (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(message);
        });
    }
    checkMaximum(formElement, selectedOptionIndex) {
        // if the selected option is `existing`, check positions
        const selectElement = formElement.querySelector('select');
        const selectedOption = selectElement?.selectedOptions.item(0);
        const countPositions = Number(selectedOption?.getAttribute('data-tk-saldoc-count-positions'));
        if (selectedOptionIndex === 0 && countPositions > this.maxPosition) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, 'Maximum erreicht an Positionen.');
            throw new Error('Rechead maximum of positions in this list');
        }
    }
    pushTrackItem(data) {
        const { action: action, artNo: artNo } = data;
        const trackerElement = document.querySelector('[data-tk-tracker-wrapper]');
        trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                type: (0, $588d148f2c9ac202$export$4120f82005ec4b2d).FAVORITE_UPDATE,
                item: {
                    action: action,
                    location: window.location.href,
                    category: 'Wishlist',
                    name: artNo,
                    value: '1'
                }
            }
        }));
    }
    /**
     * Save last used favorite list in session variable
     * to preselect it when adding another article to favorites
     */ async saveListToSessionVar(listName) {
        const url = this.getAttribute('data-tk-sessionvar-url');
        if (!url) return;
        const data = {
            listName: listName
        };
        await (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: ()=>null,
            payload: data,
            showMessages: false
        });
    }
    static syncCounter() {
        const counterElement = document.querySelector('[data-tk-favorite-counter]');
        const listElement = document.querySelector('[data-tk-article-list-grid]');
        if (!counterElement || !listElement) return;
        counterElement.textContent = String(listElement.childElementCount);
    }
    static syncInfo(quantity) {
        const infoElement = document.querySelector('[data-tk-favorite-info]');
        if (!infoElement) return;
        infoElement.setAttribute('data-tk-quantity', String(quantity));
    }
    static updateItemsCount(action) {
        // TODO: After the next WAS update, the item count should be included in the response when not logged in. Until then workaround with + 1
        const favoriteInfoElement = document.querySelector('[data-tk-favorite-info]');
        if (!favoriteInfoElement) return;
        const previousItemscount = favoriteInfoElement.getAttribute('data-tk-quantity') ? parseInt(favoriteInfoElement.getAttribute('data-tk-quantity'), 10) : 0;
        favoriteInfoElement.setAttribute('data-tk-quantity', (action === "deleted" ? previousItemscount - 1 : previousItemscount + 1).toString());
    }
}



class $38c77688df6cd108$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            'data-tk-quantity'
        ];
    }
    constructor(){
        super();
        this.anchor = this.querySelector('a') || undefined;
        this.counter = this.anchor?.querySelector('[data-tk-counter-info') || undefined;
        this.quantity = Number(this.getAttribute('data-tk-quantity'));
        this.isMulti = this.hasAttribute('data-tk-is-multi');
        this.href = this.getAttribute('data-tk-href') || '';
        this.emptyClassName = this.getAttribute('data-tk-empty-class-name') || 'tk-button__counter--empty';
    }
    attributeChangedCallback(name, _oldValue, newValue) {
        if (name === 'data-tk-quantity' && this.counter) {
            if (!this.anchor) return;
            this.anchor.setAttribute('data-count', newValue);
            if (Number(newValue) === 0) this.counter?.classList.add(this.emptyClassName);
            else {
                this.counter?.classList.remove(this.emptyClassName);
                this.counter.textContent = newValue;
            }
        }
    }
}



var $9a3403e3213d867d$var$HoverState = /*#__PURE__*/ function(HoverState) {
    HoverState["ACTIVE"] = "active";
    HoverState["INACTIVE"] = "inactive";
    return HoverState;
}($9a3403e3213d867d$var$HoverState || {});
class $9a3403e3213d867d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector('input, select, textarea');
        this.labelElement = this.querySelector('label') || undefined;
        this.isMaterial = this.hasAttribute('data-tk-is-material');
        this.materialClass = this.getAttribute('data-tk-material-class') || 'tk-form-material';
        this.materialNumberInputClass = this.getAttribute('data-tk-material-number-input-class') || 'tk-form-material--number';
        this.materialLabelInsideClass = this.getAttribute('data-tk-material-label-inside-class') || 'tk-form-material--label-inside';
        this.materialSelectFocussedClass = this.getAttribute('data-tk-material-select-focussed-class') || 'tk-form-select--focussed';
        this.materialLoadedClass = this.getAttribute('data-tk-material-loaded-class') || 'tk-form-material--loaded';
        this.isPasswordInput = this.hasAttribute('data-tk-toggle-password');
        this.disableOnAddonClick = this.hasAttribute('data-tk-disable-on-addon-click');
        this.addonElement = this.querySelector('[data-tk-addon]') || undefined;
        this.waitForSurroundingContent = this.closest('[data-wait-for-surrounding-content]') || undefined;
        this.addonSuffixDistance = 0;
        this.addonPrefixDistance = 0;
        this.addonDefaultPadding = parseInt(this.getAttribute('data-tk-addon-default-padding') || '0', 10) || 4;
        this.onTransitionEnd = ()=>{};
        this.isBoolean = this.hasAttribute('data-tk-boolean');
        this.checkboxElement = this.querySelector('input[type="checkbox"]') || undefined;
        this.hiddenElement = this.querySelector('input[type="hidden"]') || undefined;
        this.defaultValue = this.hiddenElement?.value || '0';
        this.mask = this.getAttribute('data-tk-mask') || undefined;
        this.hintMaxLength = Number(this.getAttribute('data-tk-hint-max-length')) || undefined;
        this.hintWarningClassName = this.getAttribute('data-tk-hint-warning-class-name') || 'text--warning';
        this.hintCriticalClassName = this.getAttribute('data-tk-hint-critical-class-nameh') || 'text--error';
    }
    connectedCallback() {
        if (this.isNumberInput() || this.waitForSurroundingContent) {
            this.onDomContentLoaded();
            return;
        }
        this.checkRequiredAttribute();
        this.registerAddonClickedListener();
        this.registerAddonHoverListener();
        this.registerShowPasswordClickedListener();
        this.initMaterialInput();
        this.observeDisabledAttribute();
        this.registerMaskListener();
        this.registerHintMaxLengthListener();
        if (!this.isBoolean) return;
        this.registerBooleanListener();
        this.checkboxElement && this.toggleBoolean(this.checkboxElement);
    }
    /**
     * For the Material Number Input or forms inside of tables, it is necessary that all surrounding elements have been
     * fullyloaded before the Material Number Element itself is displayed.
     * This is because the position of the label in the collapsed state
     * needs to be calculated for the Material Number Input. This calculation depends on the surrounding elements
     */ onDomContentLoaded() {
        document.addEventListener('DOMContentLoaded', ()=>{
            this.checkRequiredAttribute();
            this.registerAddonClickedListener();
            this.registerAddonHoverListener();
            this.registerShowPasswordClickedListener();
            this.initMaterialInput();
            this.observeDisabledAttribute();
        });
    }
    // #region Required
    checkRequiredAttribute() {
        if (!this.labelElement || !this.fieldElement || !this.fieldElement.hasAttribute('required')) return;
        this.labelElement.textContent = `${this.labelElement.textContent} *`;
    }
    // #endregion
    // #region disabled
    observeDisabledAttribute() {
        if (!this.fieldElement || !this.labelElement) return;
        // inital check
        this.checkDisabledAttribute();
        const observerConfig = {
            attributes: true,
            attributeFilter: [
                'disabled'
            ]
        };
        const onCheckDiabledAttribute = this.checkDisabledAttribute.bind(this);
        const observer = new MutationObserver(onCheckDiabledAttribute);
        observer.observe(this.fieldElement, observerConfig);
    }
    checkDisabledAttribute() {
        const addDisabledClass = this.fieldElement.hasAttribute('disabled');
        this.classList.toggle('tk-form-input--disabled', addDisabledClass);
    }
    // #endregion
    // #region Addon
    registerAddonClickedListener() {
        if (!this.addonElement || this.disableOnAddonClick) return;
        const addonClickHandler = this.onAddonClicked.bind(this);
        this.pushListener({
            event: 'click',
            element: this.addonElement,
            action: addonClickHandler
        });
    }
    registerAddonHoverListener() {
        if (!this.addonElement) return;
        const onHoverStartHandler = this.onAddonHover.bind(this, "active");
        this.pushListener({
            event: 'mouseenter',
            element: this.addonElement,
            action: onHoverStartHandler
        });
        const onHoverEndHandler = this.onAddonHover.bind(this, "inactive");
        this.pushListener({
            event: 'mouseleave',
            element: this.addonElement,
            action: onHoverEndHandler
        });
    }
    registerBooleanListener() {
        if (!this.checkboxElement || !this.hiddenElement) return;
        const onInput = this.handleBoolean.bind(this);
        this.pushListener({
            event: 'input',
            element: this.checkboxElement,
            action: onInput
        });
    }
    registerHintMaxLengthListener() {
        if (!this.fieldElement || !this.hintMaxLength) return;
        const action = this.handleHintMaxLength.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: action
        });
    }
    handleBoolean(event) {
        const target = event.target;
        this.toggleBoolean(target);
    }
    toggleBoolean(element) {
        if (element.checked) this.hiddenElement.value = element.value;
        else this.hiddenElement.value = this.defaultValue;
    }
    onAddonHover(hoverState) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error('No Input element found');
        this.classList.toggle('tk-form--addon-hover', hoverState === "active" && !this.fieldElement.disabled);
    }
    onAddonClicked() {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error('No Input element found');
        if (this.isPasswordInput) return;
        this.fieldElement.focus();
        const lastCharPosition = this.fieldElement.value.length;
        const isNumberInput = this.fieldElement.type === 'number';
        if (isNumberInput) this.fieldElement.setAttribute('type', 'text');
        this.fieldElement.setSelectionRange(lastCharPosition, lastCharPosition);
        if (isNumberInput) this.fieldElement.setAttribute('type', 'number');
    }
    registerShowPasswordClickedListener() {
        if (!this.isPasswordInput || !this.addonElement) return;
        const passwordShowClickHandler = this.onPasswordShowClicked.bind(this);
        this.pushListener({
            event: 'mousedown',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'mouseup',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'touchstart',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'touchend',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
    }
    onPasswordShowClicked(event) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement)) throw new Error('Missing input element');
        if (event.type === 'mousedown' || event.type === 'touchstart') this.fieldElement.type = 'text';
        else this.fieldElement.type = 'password';
    }
    // #endregion
    // #region Material
    initMaterialInput() {
        if (!this.isMaterial) return;
        if (!this.fieldElement) throw new Error('No element found');
        this.classList.add(this.materialClass);
        if (this.isNumberInput()) this.classList.add(this.materialNumberInputClass);
        this.registerLabelTransitionEndListener();
        this.calculateAddonWidth();
        this.setMaterialLabelState();
        this.registerMaterialValueChangeListener();
        this.registerMaterialSelectFocusChangeListener();
    }
    /**
     * This function is mainly used to check whether a valid value has been
     * set for the data-tk-addon attribute
     * @returns addonType: string representing the addon type
     */ getAddonType() {
        if (!this.addonElement) throw new Error('Missing addon');
        const addonType = this.addonElement.getAttribute('data-tk-addon');
        if (addonType !== 'prefix' && addonType !== 'suffix') throw new Error('Wrong addon type');
        return addonType;
    }
    /**
     * Checks whether the element contains a value or not. This information is required
     * to determine whether the label should be displayed inside or outside the element.
     * @returns isEmptyElement: boolean
     */ checkForValue() {
        let isEmptyElement;
        if (this.fieldElement instanceof HTMLSelectElement) {
            const selectedOption = this.querySelector('option:checked');
            const isPlaceholderOption = selectedOption?.hasAttribute('data-tk-empty-option');
            isEmptyElement = isPlaceholderOption;
        } else isEmptyElement = this.fieldElement?.value === '';
        return isEmptyElement;
    }
    /**
     * This function implements the material functionality by displaying the label either
     * inside or outside the control, depending on the content
     */ setMaterialLabelState() {
        // check input value
        const isEmptyMaterialInput = this.checkForValue();
        if (isEmptyMaterialInput) {
            this.classList.add(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error('Missing label element');
            if (this.isNumberInput()) this.setupMaterialNumberLabelStyle();
            if (!this.isNumberInput()) this.setupMaterialDefaultLabelStyle();
        } else {
            this.classList.remove(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error('Missing label element');
            this.labelElement.removeAttribute('style');
        }
    }
    /**
     * This function calculates the label position for a material input that is not of type
     * number and where the label is located within the input
     */ setupMaterialDefaultLabelStyle() {
        if (this.addonPrefixDistance === 0 && this.addonSuffixDistance === 0) return;
        this.labelElement.style.marginLeft = this.addonPrefixDistance > 0 ? `${this.addonPrefixDistance + this.addonDefaultPadding}px` : '0px';
        this.labelElement.style.marginRight = this.addonSuffixDistance > 0 ? `${this.addonSuffixDistance + this.addonDefaultPadding}px` : '0px';
        this.labelElement.style.paddingInline = '0';
    }
    /**
     * This function calculates the label position for a material input of type Number where
     *  the label is located within the input
     */ setupMaterialNumberLabelStyle() {
        this.labelElement.style.paddingInline = '0';
        const labelWidthWithPadding = this.labelElement.getBoundingClientRect().width;
        const computedLabelStyle = window.getComputedStyle(this.labelElement);
        const labelPaddingLeft = parseFloat(computedLabelStyle.paddingLeft);
        const labelPaddingRight = parseFloat(computedLabelStyle.paddingRight);
        const labelWidth = labelWidthWithPadding - labelPaddingLeft - labelPaddingRight;
        const formControlWidth = this.getBoundingClientRect().width;
        const computetInputStyle = window.getComputedStyle(this.fieldElement);
        const inputPaddingRight = parseFloat(computetInputStyle.paddingRight);
        const addonWidth = this.addonElement && this.getAddonType() === 'suffix' ? this.addonElement.getBoundingClientRect().width : 0;
        const xOffset = Math.round(formControlWidth - labelWidth - addonWidth - inputPaddingRight);
        this.labelElement.style.paddingLeft = `${xOffset}px`;
    }
    /**
     * This function checks whether the current control has an addon. If so, depending
     * on the type of control, it checks whether the material label requires additional
     * spacing in the folded state
     */ calculateAddonWidth() {
        if (!this.addonElement) return;
        if (this.fieldElement instanceof HTMLSelectElement) return;
        /* The text is displayed right-aligned for the number inputs.
        They must therefore be treated separately */ const isNumberInput = this.isNumberInput();
        const addonType = this.getAddonType();
        if (!isNumberInput && addonType === 'prefix') this.addonPrefixDistance = this.addonElement.offsetWidth;
        else if (isNumberInput && addonType === 'suffix') this.addonSuffixDistance = this.addonElement.offsetWidth;
    }
    /**
     * Checks whether the input is of type Number. This information is required because
     * the text does not start on the left when the number input is collapsed
     * @returns boolean: representing is input of type number
     */ isNumberInput() {
        if (!(this.fieldElement instanceof HTMLInputElement)) return false;
        return this.fieldElement && this.fieldElement.type === 'number';
    }
    /**
     * Listener for material control value changes
     */ registerMaterialValueChangeListener() {
        const onValueChanged = this.setMaterialLabelState.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: onValueChanged
        });
    }
    /**
     * Is required so that a class can be added to the focused material select
     * element that colors the text of the select white
     */ registerMaterialSelectFocusChangeListener() {
        if (!(this.fieldElement instanceof HTMLSelectElement)) return;
        const onFocusChanged = this.onMaterialSelectFocusChanged.bind(this);
        this.pushListener({
            event: 'focusin',
            element: this.fieldElement,
            action: onFocusChanged
        });
        this.pushListener({
            event: 'focusout',
            element: this.fieldElement,
            action: onFocusChanged
        });
    }
    /**
     * This function is used to add a class to the focused material select, which sets
     * the font to white if no option has been selected
     * @param event: Used to determin if focus has been set or removed
     */ onMaterialSelectFocusChanged(event) {
        const { type: type } = event;
        if (type === 'focusin') this.classList.add(this.materialSelectFocussedClass);
        else this.classList.remove(this.materialSelectFocussedClass);
    }
    /**
     * This function fades in the material element as soon as the label is in
     * the correct position
     */ registerLabelTransitionEndListener() {
        if (!this.labelElement) throw new Error('Missing label element');
        this.onTransitionEnd = this.addMaterialLoadedModifier.bind(this);
        this.pushListener({
            event: 'transitionend',
            element: this.labelElement,
            action: this.onTransitionEnd
        });
    }
    addMaterialLoadedModifier() {
        this.classList.add(this.materialLoadedClass);
        this.labelElement.removeEventListener('transitionend', this.onTransitionEnd);
    }
    // #endregion
    registerMaskListener() {
        if (!this.mask || !(this.fieldElement instanceof HTMLInputElement)) return;
        const options = JSON.parse(this.mask);
        const onMaskInput = this.onMaskInput.bind(this, options);
        try {
            this.pushListener({
                event: 'input',
                element: this.fieldElement,
                action: onMaskInput
            });
            this.pushListener({
                event: 'paste',
                element: this.fieldElement,
                action: onMaskInput
            });
        } catch (error) {
            console.warn('Invalid mask config:', this.mask, error);
        }
    }
    onMaskInput(options, event) {
        const target = event.currentTarget;
        if (options.type === 'slug') {
            const normalizeCharMap = {
                "\xe9": 'e',
                "\xe8": 'e',
                "\xf6": 'oe',
                "\xe4": 'ae',
                "\xfc": 'ue',
                "\xe0": 'a',
                "\xee": 'i'
            };
            const normalized = target.value.split('').map((char)=>normalizeCharMap[char] ?? char).join('');
            const value = normalized.toLowerCase().replace(/[^a-z0-9\s_-]/g, '') // only lower case letters, numbers, spaces, -, _
            .replace(/[\s_]+/g, '-') // Spaces or underscores → hyphen
            .replace(/-+/g, '-') // Avoid double hyphens
            .replace(/^-+|-+$/g, ''); // no hyphens at the beginning or end
            target.value = value;
            return;
        }
        let value = target.value.replace(/[^a-zA-Z0-9]/g, '');
        if (options.uppercase) value = value.toUpperCase();
        const result = [];
        let idx = 0;
        for(let i = 0; i < options.blocks.length; i++){
            const blockLen = options.blocks[i];
            const part = value.substring(idx, idx + blockLen);
            if (!part) break;
            result.push(part);
            idx += blockLen;
        }
        const withDelimiters = result.map((part, i)=>{
            if (i < options.delimiters.length) return part + options.delimiters[i];
            return part;
        });
        target.value = withDelimiters.join('').substring(0, target.maxLength || 100);
    }
    handleHintMaxLength(event) {
        if (!this.hintMaxLength) return;
        const target = event.currentTarget;
        const length = target.value.length;
        const wrapperElement = this.querySelector('[data-tk-hint-max-length-wrapper]');
        const counterElement = this.querySelector('[data-tk-hint-max-length-counter]');
        if (!wrapperElement || !counterElement) return;
        counterElement.textContent = String(length);
        wrapperElement.classList.toggle(this.hintWarningClassName, length >= this.hintMaxLength * 0.9);
        wrapperElement.classList.toggle(this.hintCriticalClassName, length >= this.hintMaxLength);
    }
}








class $cb17fd7e698c018c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.listWrapperClassName = this.getAttribute('data-tk-zip-list-class') || 'tk-form-zipcity__list';
        this.fieldCountry = this.querySelector('[data-tk-zip-country]') || undefined;
        this.fieldZip = this.querySelector('[data-tk-zip-zip]') || undefined;
        this.fieldCity = this.querySelector('[data-tk-zip-city]') || undefined;
        this.lastSearchTerm = '';
        this.selectedField = undefined;
        this.listWrapper = document.createElement('div');
        this.listWrapper.classList.add(this.listWrapperClassName);
        this.listWrapper.hidden = true;
        this.loadingSpinnerTimeout = null;
        this.clearDataTimeout = null;
        this.inputObject = {
            inputField: undefined,
            dropdown: this.listWrapper,
            listItemSelected: undefined,
            data: []
        };
    }
    connectedCallback() {
        this.registerListener();
    }
    registerListener() {
        if (!this.fieldZip && !this.fieldCity) return;
        const onInputHandler = this.searchZipCity.bind(this);
        const onClickHandler = this.toggleDropdown.bind(this);
        const onSelectHandler = this.selectItem.bind(this);
        const onChangeHandler = this.clearFormFields.bind(this);
        const onInputKeyNavigationHandler = this.inputKeyNavigation.bind(this);
        const onDropdownKeyNavigationHandler = this.dropdownKeyNavigation.bind(this);
        this.pushListener({
            event: 'click',
            element: this.fieldZip,
            action: onClickHandler
        });
        this.pushListener({
            event: 'click',
            element: this.fieldCity,
            action: onClickHandler
        });
        this.pushListener({
            event: 'click',
            element: this.inputObject.dropdown,
            action: onSelectHandler
        });
        this.pushListener({
            event: 'input',
            element: this.fieldZip,
            action: onInputHandler
        });
        this.pushListener({
            event: 'input',
            element: this.fieldCity,
            action: onInputHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.fieldZip,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.fieldCity,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.inputObject.dropdown,
            action: onDropdownKeyNavigationHandler
        });
        if (this.fieldCountry) this.pushListener({
            event: 'change',
            element: this.fieldCountry,
            action: onChangeHandler
        });
    }
    inputKeyNavigation(event) {
        if (!(event.code === 'Tab' || event.code === 'Enter' || event.code === 'ArrowDown')) return;
        this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.dropdown?.classList.remove('hide');
        this.inputObject.listItemSelected.focus();
        event.preventDefault();
    }
    dropdownKeyNavigation(event) {
        const keyActions = {
            ArrowDown: ()=>this.handleArrowKey(true),
            ArrowUp: ()=>this.handleArrowKey(false),
            Enter: ()=>this.selectItem(event),
            Space: ()=>this.selectItem(event),
            Tab: ()=>this.hideDropdown(true),
            Escape: ()=>this.hideDropdown(true)
        };
        const action = keyActions[event.code];
        if (!action) return;
        action();
        event.preventDefault();
    }
    handleArrowKey(isDown) {
        if (this.inputObject.listItemSelected) {
            const nextElement = isDown ? this.inputObject.listItemSelected.nextElementSibling : this.inputObject.listItemSelected.previousElementSibling;
            if (nextElement instanceof HTMLElement) this.inputObject.listItemSelected = nextElement;
        } else this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.listItemSelected.focus();
        this.setScroller();
    }
    hideDropdown(isHidden = false) {
        if (this.inputObject.dropdown) {
            if (!isHidden) {
                this.showLoadingAnimation();
                this.listWrapper.style.border = 'unset';
            }
            this.inputObject.dropdown.hidden = isHidden;
        }
    }
    toggleDropdown() {
        if (this.inputObject.dropdown && this.inputObject.dropdown.hasChildNodes()) this.inputObject.dropdown.hidden = !this.inputObject.dropdown.hidden;
    }
    setScroller() {
        const { dropdown: dropdown, listItemSelected: listItemSelected } = this.inputObject;
        if (!dropdown || !listItemSelected) return;
        const index = Array.from(dropdown.children).indexOf(listItemSelected);
        const elHeight = listItemSelected.offsetHeight;
        const { scrollTop: scrollTop } = dropdown;
        const viewport = scrollTop + dropdown.offsetHeight;
        const elOffset = elHeight * index;
        if (elOffset >= scrollTop && elOffset + elHeight <= viewport) return;
        dropdown.scrollTop = elOffset;
    }
    setInputObject() {
        if (!this.selectedField?.parentElement?.querySelector(`.${this.listWrapperClassName}`)) this.selectedField?.insertAdjacentElement('afterend', this.listWrapper);
        this.inputObject.inputField = this.selectedField;
    }
    searchZipCity(event) {
        this.selectedField = event.target;
        const value = this.selectedField.value.trim();
        if (value.length < 2) {
            this.clearDataTimeout && clearTimeout(this.clearDataTimeout);
            this.clearDataTimeout = setTimeout(()=>{
                this.clearData();
            }, 300);
            return;
        }
        this.lastSearchTerm = value;
        this.setInputObject();
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.callApi(value);
        }, 300);
    }
    callApi(value) {
        if (!this.inputObject.dropdown) return;
        this.hideDropdown(false);
        if (this.lastSearchTerm !== value) return;
        const zipCity = this.parseZipCity(value);
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCity).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: urlObject.toString(),
            resolveHandler: this.refreshResultList.bind(this),
            decodeJSONResponse: false
        });
    }
    parseZipCity(value) {
        let zip;
        let city;
        const country = this.fieldCountry?.value?.toLowerCase() || 'ch';
        const arr = value.split(' ');
        const numberRegex = /^[0-9]+$/;
        const regexTest = arr.find((elem)=>numberRegex.test(elem));
        if (regexTest === undefined) zip = '';
        else zip = regexTest;
        if (!zip) {
            if (arr.length > 1) zip = +arr[1] || '';
        }
        zip = zip.toString();
        city = value.replace(zip, '').trim();
        if (city === 'undefined') city = '';
        return {
            zip: zip,
            city: city,
            country: country
        };
    }
    refreshResultList(response) {
        if (!response) return;
        this.clearData();
        if (Array.isArray(response)) response.forEach((element)=>{
            const listItemTpl = `
                <button type="button" class="tk-form-list-item"
                    data-tk-country="${element.country}"
                    data-tk-zip="${element.zip}"
                    data-tk-city="${element.city}"
                    tabindex="-1"
                >
                    <span class="tk-form__label">
                        ${element.zip} ${element.city}
                    </span>
                </button>`;
            this.inputObject.dropdown.insertAdjacentHTML('beforeend', listItemTpl);
            this.inputObject.data?.push({
                zip: element.zip,
                city: element.city,
                country: element.country
            });
        });
        if (this.inputObject.data.length === 0) {
            const listItemTpl = `
                <div class="spacer-p-2">
                    <div class="tk-message tk-message--info tk-message--fullwidth">
                        <span class="tk-message__icon">
                            <i class="tk-icon-warning"></i>
                        </span>
                        <span class="tk-message__label">${(0, $86b3c5b6d66bd808$export$97a703132b664051).noMatchFound}</span>
                    </div>
                </div>`;
            this.inputObject.dropdown.insertAdjacentHTML('beforeend', listItemTpl);
        }
        this.listWrapper.style.border = '';
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.inputObject.dropdown.hidden = false;
    }
    selectItem(event) {
        let selectedItem = event.target;
        selectedItem = selectedItem.closest('[data-tk-zip]');
        if (!selectedItem) return;
        const zip = selectedItem.getAttribute('data-tk-zip');
        const city = selectedItem.getAttribute('data-tk-city');
        const country = selectedItem.getAttribute('data-tk-country');
        if (this.fieldZip) this.fieldZip.value = zip;
        if (this.fieldCity) this.fieldCity.value = city;
        if (this.fieldCountry) this.fieldCountry.value = country;
        this.inputObject.inputField.focus();
        this.clearData();
    }
    clearFormFields() {
        this.clearData();
        this.fieldCity.value = '';
        this.fieldZip.value = '';
    }
    clearData() {
        if (this.inputObject.dropdown) {
            this.hideDropdown(true);
            this.inputObject.dropdown.replaceChildren();
        }
        this.inputObject.data = [];
    }
    showLoadingAnimation() {
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.loadingSpinnerTimeout = setTimeout(()=>{
            this.listWrapper.innerHTML = `
                <div class="tk-progress tk-progress--infinite tk-progress--breakout">
                    <div class="tk-progress__bar"></div>
                </div>`;
        }, 300);
    }
    static async isValidZipCity(form) {
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const zipCityElem = {
            country: form.querySelector('[data-tk-zip-country]') || '',
            zip: form.querySelector('[data-tk-zip-zip]') || '',
            city: form.querySelector('[data-tk-zip-city]') || ''
        };
        const zipCityValue = {
            country: zipCityElem.country.value,
            zip: zipCityElem.zip.value,
            city: zipCityElem.city.value
        };
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCityValue).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: urlObject.toString(),
                decodeJSONResponse: false,
                resolveHandler: (response)=>{
                    let isValid = false;
                    if (Array.isArray(response)) response.some((item)=>{
                        isValid = $cb17fd7e698c018c$export$2e2bcd8739ae039.shallowObjectEquality(zipCityValue, item);
                        return isValid;
                    });
                    resolve(isValid);
                }
            });
        });
    }
    static shallowObjectEquality(object1, object2) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);
        let isEqual = true;
        if (keys1.length !== keys2.length) {
            isEqual = false;
            return isEqual;
        }
        keys1.forEach((key)=>{
            if (object1[key] !== object2[key]) {
                isEqual = false;
                return isEqual;
            }
        });
        return isEqual;
    }
}


var $21a7ddce6a8de4e2$var$matchType = /*#__PURE__*/ function(matchType) {
    matchType["Some"] = "SOME";
    matchType["Full"] = "FULLMATCH";
    return matchType;
}($21a7ddce6a8de4e2$var$matchType || {});
class $21a7ddce6a8de4e2$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.validationList = [];
        this.form = this.querySelector('form') || undefined;
        this.fieldWrapperSelector = this.getAttribute('data-tk-field-wrapper-selector') || '[data-tk-field-wrapper]';
        this.formErrorClassName = this.getAttribute('data-tk-form-error-class-name') || 'tk-form--error';
        this.fieldHintClassName = this.getAttribute('data-tk-field-hint-class-name') || 'tk-form__hint';
        this.shouldValidateInline = this.hasAttribute('data-tk-should-validate-inline');
        this.passwordStrengthMeter = this.querySelector('[data-tk-password-strength-meter]') || undefined;
        this.passwordNewElement = this.querySelector('[data-tk-password-new]') || undefined;
        this.passwordRepeatElement = this.querySelector('[data-tk-password-repeat]') || undefined;
        this.passwordValidClassName = this.getAttribute('data-tk-password-valid-class-name') || 'tk-form--valid';
        this.passwordInvalidClassName = this.getAttribute('data-tk-password-valid-class-name') || 'tk-form--invalid';
        this.googleRecaptcha = this.querySelector('[data-tk-google-recaptcha]') || undefined;
        // Selects an element that is clicked when the enter key is pressed
        this.preventEnterDefaultAction = this.getAttribute('data-tk-enter-data-attribute-selector') || undefined;
    }
    connectedCallback() {
        if (!this.form) return;
        this.validationList = [];
        this.setNoValidateForm();
        this.searchFieldElements();
        this.registerSubmitListener();
        this.registerPasswordListener();
        this.shouldValidateInline && this.registerFieldValidationListener();
    }
    setNoValidateForm() {
        if (!this.form) return;
        this.form.noValidate = true;
    }
    searchFieldElements() {
        const formElements = this.querySelectorAll('input, select, textarea');
        const formElementList = Array.from(formElements);
        const filteredFormElements = formElementList.filter((element)=>!element.disabled);
        filteredFormElements.forEach((element)=>{
            const wrapper = element.closest(this.fieldWrapperSelector);
            wrapper && this.validationList.push({
                element: element,
                wrapper: wrapper,
                messages: $21a7ddce6a8de4e2$export$2e2bcd8739ae039.generateValidityMessages(element)
            });
        });
    }
    registerSubmitListener() {
        if (!this.form) return;
        const onSubmitHandler = this.validateForm.bind(this);
        this.pushListener({
            event: 'submit',
            element: this.form,
            action: onSubmitHandler
        });
    }
    registerPasswordListener() {
        if (!(this.passwordStrengthMeter && this.passwordNewElement && this.passwordRepeatElement)) return;
        const onValidatePassword = this.validatePassword.bind(this);
        this.pushListener({
            event: 'input',
            element: this.passwordNewElement,
            action: onValidatePassword
        });
        this.pushListener({
            event: 'input',
            element: this.passwordRepeatElement,
            action: onValidatePassword
        });
    }
    registerFieldValidationListener() {
        this.validationList.forEach((item)=>{
            const onValidation = this.validateField.bind(this, item);
            this.pushListener({
                event: 'blur',
                element: item.element,
                action: onValidation
            });
            this.pushListener({
                event: 'input',
                element: item.element,
                action: onValidation
            });
        });
    }
    async validateRecaptcha() {
        if (!this.googleRecaptcha) return true;
        return new Promise((resolve)=>{
            window.grecaptcha.ready(async ()=>{
                const siteKey = this.googleRecaptcha.getAttribute('data-tk-site-key');
                if (!siteKey) return resolve(false);
                const token = await window.grecaptcha.execute(siteKey, {
                    action: 'submit'
                });
                if (!token) return resolve(false);
                this.googleRecaptcha.value = token;
                resolve(true);
            });
        });
    }
    async validateZipCity() {
        const validationList = [];
        const fieldElements = this.querySelectorAll('[data-tk-field-check-zip-city]');
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const input = element.querySelector('input');
            if (!input) return true;
            const isValid = await (0, $cb17fd7e698c018c$export$2e2bcd8739ae039).isValidZipCity(this.form);
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).typeMismatch);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    async validateByAPI() {
        const validationList = [];
        const fieldElements = this.querySelectorAll('[data-tk-field-check-api]');
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const apiURL = element.getAttribute('data-tk-field-check-api');
            const input = element.querySelector('input');
            if (!input || !apiURL || input.value === '') return true;
            const response = await $21a7ddce6a8de4e2$export$2e2bcd8739ae039.fetchExistAPI(apiURL, input.value);
            const { isValid: isValid } = response.dataAsJson;
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$35e6ad2b040b8403).existigName);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    static async fetchExistAPI(url, value) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                payload: {
                    value: value
                },
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    async validateForm(event) {
        event.preventDefault();
        const isFormValid = await this.isFormValid();
        if (!isFormValid) return;
        if (this.preventEnterDefaultAction) {
            const elemntToClick = document.querySelector(`[${this.preventEnterDefaultAction}]`);
            elemntToClick?.querySelector('button')?.click();
            return;
        }
        this.form?.submit();
    }
    async isFormValid() {
        await this.validateFields();
        const areFieldsValid = this.validationList.every((item)=>item.element.validity.valid);
        if (!areFieldsValid) return false;
        const isValid = await this.validateByAPI() && await this.validateZipCity();
        const isRecaptchaValid = await this.validateRecaptcha();
        return (!this.passwordStrengthMeter || this.checkPasswordStengthMeter()) && this.checkPasswordMatching() && isValid && isRecaptchaValid;
    }
    async validateFields() {
        this.validationList.forEach((item)=>{
            this.validateField(item);
        });
        this.firstElementToScrollTo = undefined;
    }
    validateField(item) {
        this.removeMessage(item);
        if (!item.element.validity.valid) this.showMessage(item);
    }
    showMessage(item) {
        const validityList = $21a7ddce6a8de4e2$export$2e2bcd8739ae039.createValidityDictionary(item.element);
        const invalidMessage = validityList.find((validity)=>validity.value);
        const message = invalidMessage ? item.messages.find((message)=>message.key === invalidMessage.key)?.value || '' : item.element.validationMessage;
        this.createElementMessage(item, message);
    }
    createElementMessage(item, message) {
        const spanElement = document.createElement('span');
        spanElement.classList.add(this.fieldHintClassName);
        spanElement.textContent = $21a7ddce6a8de4e2$export$2e2bcd8739ae039.replacePlaceholders(message, item.element);
        item.messageElement = spanElement;
        item.wrapper.classList.add(this.formErrorClassName);
        item.wrapper.insertAdjacentElement('beforeend', spanElement);
        if (this.firstElementToScrollTo) return;
        this.firstElementToScrollTo = item.messageElement;
        this.firstElementToScrollTo.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
    removeMessage(item) {
        const spanElement = item.messageElement;
        if (!spanElement) return;
        spanElement.remove();
        item.wrapper.classList.remove(this.formErrorClassName);
    }
    static createValidityDictionary(element) {
        const { validity: validity } = element;
        const validityList = [];
        for(const key in validity){
            const validityItem = {
                key: key,
                value: Boolean(validity[key])
            };
            validityList.push(validityItem);
        }
        return validityList;
    }
    static generateValidityMessages(element) {
        const list = [];
        const customErrorPrefix = 'data-tk-error-msg-';
        const attributeList = element.getAttributeNames().filter((name)=>name.startsWith(customErrorPrefix));
        attributeList.forEach((key)=>{
            const keyFormatted = key.replace(customErrorPrefix, '').replace(/-./g, (x)=>x[1].toUpperCase());
            const value = element.getAttribute(key);
            value && list.push({
                key: keyFormatted,
                value: value
            });
        });
        if (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91) {
            const messages = (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91);
            Object.entries(messages).forEach((entry)=>{
                const [key, value] = entry;
                const foundMessage = list.filter((item)=>item.key === key);
                !foundMessage.length && list.push({
                    key: key,
                    value: value
                });
            });
        }
        return list;
    }
    static replacePlaceholders(value, element) {
        const dictionary = {
            '{minLength}': element.getAttribute('minlength') || '',
            '{maxLength}': element.getAttribute('maxlength') || '',
            '{length}': element.value.length.toString() || '',
            '{step}': element.getAttribute('step') || '',
            '{min}': element.getAttribute('min') || '',
            '{max}': element.getAttribute('max') || '',
            '{currentValue}': element.value
        };
        const re = new RegExp(Object.keys(dictionary).join('|'), 'gi');
        return value.replace(re, (matched)=>dictionary[matched]);
    }
    checkPasswordStengthMeter() {
        const patterns = this.getPasswordPatterns();
        return patterns.every((item)=>item.element?.classList.contains(this.passwordValidClassName));
    }
    checkPasswordMatching() {
        let isValid;
        const newPasswordItem = this.validationList.find((item)=>item.element === this.passwordNewElement);
        const repeatPasswordItem = this.validationList.find((item)=>item.element === this.passwordRepeatElement);
        if (!newPasswordItem || !repeatPasswordItem) return true;
        if (newPasswordItem.element.value !== repeatPasswordItem.element.value) {
            this.removeMessage(repeatPasswordItem);
            this.createElementMessage(repeatPasswordItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).passwordNotMatching);
            isValid = false;
        } else isValid = true;
        return isValid;
    }
    validatePassword(event) {
        const target = event.currentTarget;
        const patterns = this.getPasswordPatterns();
        patterns.forEach((item)=>{
            const regex = new RegExp(item.pattern || '', item.matchtype === "FULLMATCH" ? 'g' : '');
            const regexpMatch = target.value.match(regex);
            if (item.matchtype === "SOME") {
                if (regexpMatch) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
            if (item.matchtype === "FULLMATCH") {
                if (regexpMatch?.length === target.value.length) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
        });
    }
    getPasswordPatterns() {
        const characterPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-character-pattern]');
        const upperPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-upper-pattern]');
        const numberPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-number-pattern]');
        const allowedSymbolPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-allowed-symbols-pattern]');
        const characterPattern = characterPatternElement?.getAttribute('data-tk-pwd-character-pattern');
        const upperPattern = upperPatternElement?.getAttribute('data-tk-pwd-upper-pattern');
        const numberPattern = numberPatternElement?.getAttribute('data-tk-pwd-number-pattern');
        const allowedSymbolPattern = allowedSymbolPatternElement?.getAttribute('data-tk-pwd-allowed-symbols-pattern');
        return [
            {
                pattern: characterPattern,
                element: characterPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: upperPattern,
                element: upperPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: numberPattern,
                element: numberPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: allowedSymbolPattern,
                element: allowedSymbolPatternElement,
                matchtype: "FULLMATCH"
            }
        ];
    }
}



class $7217ff2f9b2d295c$export$2e2bcd8739ae039 extends (0, $21a7ddce6a8de4e2$export$2e2bcd8739ae039) {
    validateField(item) {
        this.removeMessage(item);
        // Always check email fields first to properly clear/set custom validity
        if (item.element instanceof HTMLInputElement && item.element.type.toLowerCase() === 'email') {
            this.validateEmailField(item);
            return;
        }
        if (!item.element.validity.valid) this.showMessage(item);
    }
    validateEmailField(item) {
        const element = item.element;
        if (!(element instanceof HTMLInputElement) || element.type.toLowerCase() !== 'email') return;
        const value = element.value.trim();
        if (value === '') {
            element.setCustomValidity('');
            return;
        }
        const atIndex = value.indexOf('@');
        const dotIndex = value.lastIndexOf('.');
        const hasValidFormat = atIndex > 0 && dotIndex > atIndex + 1 && dotIndex < value.length - 1;
        if (hasValidFormat) {
            element.setCustomValidity('');
            return;
        }
        const customTypeMismatchMessage = element.getAttribute('data-tk-error-msg-type-mismatch') || '';
        const fallbackMessage = (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).typeMismatch || element.validationMessage;
        const message = customTypeMismatchMessage || fallbackMessage;
        element.setCustomValidity(message);
        this.createElementMessage(item, message);
    }
}



class $59575c6d2ba9e740$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.accordionHead = this.querySelector('[data-tk-accordion-head]') || undefined;
        this.accordionBody = this.querySelector('[data-tk-accordion-body]') || undefined;
        this.accordionIcon = this.querySelector('[data-tk-accordion-icon]') || undefined;
        this.accordionIcons = {
            iconAdd: this.getAttribute('data-tk-icon-open') || 'tk-icon-add',
            iconRemove: this.getAttribute('data-tk-icon-collapse') || 'tk-icon-remove'
        };
        this.isActive = this.hasAttribute('data-tk-accordion-is-active');
        this.isHeaderLink = this.accordionHead && this.accordionHead.hasAttribute('data-tk-accordion-link');
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-tabs-accordion--active';
    }
    connectedCallback() {
        if ((!this.accordionHead || !this.accordionBody || !this.accordionIcon) && !this.isHeaderLink) throw new Error('Accordion: Elements are missing!');
        this.setAccordionState(this.isActive);
        this.registerListener();
    }
    registerListener() {
        const eventHandler = this.toggleEvent.bind(this);
        this.pushListener({
            event: 'click',
            element: this.accordionHead,
            action: eventHandler
        });
    }
    toggleEvent() {
        this.toggleMarkupElements();
    }
    toggleMarkupElements() {
        this.classList.toggle(this.activeClassName);
        this.accordionIcon?.classList.toggle(this.accordionIcons.iconAdd);
        this.accordionIcon?.classList.toggle(this.accordionIcons.iconRemove);
    }
    setAccordionState(isActive) {
        if (isActive) {
            this.classList.toggle(this.activeClassName);
            this.accordionIcon?.classList.add(this.accordionIcons.iconRemove);
        } else this.accordionIcon?.classList.add(this.accordionIcons.iconAdd);
    }
}





const $f8125d35cd9a4f7a$var$storeRegistry = {};
async function $f8125d35cd9a4f7a$export$7d8a5b498da695ac(stores) {
    Object.keys(stores).forEach((key)=>{
        $f8125d35cd9a4f7a$var$storeRegistry[key] = stores[key];
    });
    await Promise.all(Object.values(stores).map((store)=>store.startInitialization()));
}
function $f8125d35cd9a4f7a$export$6ccbb43953eebf8(storeName) {
    const store = $f8125d35cd9a4f7a$var$storeRegistry[storeName];
    if (!store) throw new Error(`Store not found: ${storeName}`);
    return store;
}
async function $f8125d35cd9a4f7a$export$be9343d232c38cbb(key) {
    const store = $f8125d35cd9a4f7a$var$storeRegistry[key];
    if (store) return store.isInitialized;
    return Promise.reject(`Store ${key} not found`);
}


var $cc14b9b65c9c652e$export$7df56cf357be2b81 = /*#__PURE__*/ function(CompareButtonType) {
    CompareButtonType["ADD"] = "add";
    CompareButtonType["REMOVE"] = "remove";
    CompareButtonType["REMOVE_ALL"] = "removeAll";
    return CompareButtonType;
}({});
class $cc14b9b65c9c652e$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('button') || undefined;
        this.counter = this.button?.querySelector('[data-tk-counter-info') || undefined;
        this.activeClass = this.getAttribute('data-tk-compare-active-class') || 'tk-compare-button--active';
        this.articleId = Number(this.getAttribute('data-tk-article-id') || 0);
        this.categoryId = Number(this.getAttribute('data-tk-category-id') || 0);
        this.categoryName = this.getAttribute('data-tk-category-name') || undefined;
        this.type = this.getAttribute('data-tk-type') || "add";
    }
    async connectedCallback() {
        if (!this.button) throw new Error('Compare: Button is missing!');
        await (0, $f8125d35cd9a4f7a$export$be9343d232c38cbb)('compareStore');
        this.store = (0, $f8125d35cd9a4f7a$export$6ccbb43953eebf8)('compareStore');
        this.initializeDatabase();
        this.registerClickListener();
    }
    disconnectedCallback() {
        this.unsubscribe && this.unsubscribe();
    }
    registerClickListener() {
        this.pushListener({
            event: 'click',
            element: this,
            action: this.runActionByType.bind(this)
        });
    }
    async runActionByType() {
        if (!this.store) return;
        const handler = {
            add: this.toggle.bind(this),
            remove: this.remove.bind(this),
            removeAll: this.clearAll.bind(this)
        };
        handler[this.type]();
    }
    initializeDatabase() {
        if (!this.store) return;
        this.unsubscribe = this.store.subscribe(()=>this.render());
        this.render();
    }
    clearAll() {
        if (!this.store) return;
        this.button.disabled = true;
        this.store.clearAll().then(()=>{
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).allRemoved.text);
            this.button.disabled = false;
        });
    }
    async remove() {
        if (!this.categoryId || !this.articleId || !this.store) throw new Error('Category or article id is missing!');
        const category = this.store.getCategoryById(this.categoryId);
        if (!category) return;
        const filteredArticles = category.articleIds.filter((id)=>id !== this.articleId);
        if (filteredArticles.length === 0) {
            await this.store.removeCategoryById(this.categoryId);
            const categories = this.store?.getState().categories;
            this.store?.switchCategory(categories?.at(0)?.id || 0);
        } else {
            category.articleIds = filteredArticles;
            await this.store.patchCategoryById(this.categoryId, category);
        }
    }
    async toggle() {
        if (!this.categoryId || !this.articleId || !this.store) throw new Error('Category or article id is missing!');
        const category = this.store.getCategoryById(this.categoryId);
        if (category) await this.updateExistingCategory(category);
        else await this.createNewCategory();
    }
    async updateExistingCategory(category) {
        const articleExists = category.articleIds.includes(this.articleId);
        if (articleExists) {
            category.articleIds = category.articleIds.filter((id)=>id !== this.articleId);
            const articleCount = this.store?.getArticleCountByCategoryId(category.id);
            if (articleCount === 0) await this.store?.removeCategoryById(this.categoryId);
            else await this.store?.patchCategoryById(this.categoryId, category);
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).removed.text);
        } else {
            category.articleIds.push(this.articleId);
            await this.store?.patchCategoryById(this.categoryId, category);
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).added.text);
        }
    }
    async createNewCategory() {
        const newCategory = {
            id: this.categoryId,
            name: this.categoryName || '',
            articleIds: [
                this.articleId
            ]
        };
        await this.store?.patchCategoryById(this.categoryId, newCategory);
        (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).added.text);
    }
    checkAvailability() {
        if (!this.store) return;
        const { currentCategoryId: currentCategoryId } = this.store.getState();
        const currentCategory = this.store.getCategoryById(currentCategoryId);
        this.button.hidden = !currentCategory;
    }
    render() {
        if (this.type === "add") {
            const category = this.store?.getCategoryById(this.categoryId);
            if (!category) {
                this.classList.remove(this.activeClass);
                return;
            }
            this.classList.toggle(this.activeClass, category.articleIds.includes(this.articleId));
        } else if (this.type === "removeAll") this.checkAvailability();
    }
}



class $407d2fd9d876caa3$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.targetElement = this.querySelector('input[type="hidden"]') || undefined;
        this.toggleWrapper = this.querySelector('[data-tk-selection-toggles]') || undefined;
        this.selectWrapper = this.querySelector('[data-tk-selection-select]') || undefined;
        this.maxVisible = Number(this.getAttribute('data-tk-max-visible')) || 3;
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-selection--loaded';
    }
    connectedCallback() {
        if (!this.targetElement || !this.toggleWrapper || !this.selectWrapper) throw new Error('Selection: Elements are missing!');
        this.registerInputListener();
        this.switchView();
        this.classList.add(this.loadedClassName);
    }
    registerInputListener() {
        const fieldElements = this.toggleWrapper.querySelectorAll('input');
        const selectElement = this.selectWrapper.querySelector('select');
        const onInput = this.syncTargetElement.bind(this);
        fieldElements.forEach((fieldElement)=>{
            this.pushListener({
                event: 'input',
                element: fieldElement,
                action: onInput
            });
        });
        selectElement && this.pushListener({
            event: 'input',
            element: selectElement,
            action: onInput
        });
    }
    syncTargetElement(event) {
        const target = event.target;
        const selectedTarget = target instanceof HTMLInputElement ? target : target.options[target.selectedIndex];
        const { dataset: dataset } = selectedTarget;
        this.targetElement.value = selectedTarget.value;
        Object.keys(this.targetElement.dataset).forEach((key)=>{
            delete this.targetElement.dataset[key];
        });
        Object.keys(dataset).forEach((key)=>{
            this.targetElement.dataset[key] = dataset[key];
        });
        this.targetElement?.dispatchEvent(new Event('change'));
    }
    switchView() {
        if (this.toggleWrapper.childElementCount > this.maxVisible) {
            this.toggleWrapper.hidden = true;
            this.selectWrapper.hidden = false;
        } else {
            this.toggleWrapper.hidden = false;
            this.selectWrapper.hidden = true;
        }
    }
}



/* global AggregateError */ var $5cb5cad21d2394b5$exports = {};
$5cb5cad21d2394b5$exports = JSON.parse("{\"name\":\"@uppy/store-default\",\"description\":\"The default simple object-based store for Uppy.\",\"version\":\"4.3.2\",\"license\":\"MIT\",\"main\":\"lib/index.js\",\"type\":\"module\",\"scripts\":{\"build\":\"tsc --build tsconfig.build.json\",\"typecheck\":\"tsc --build\",\"test\":\"vitest run --environment=jsdom --silent='passed-only'\"},\"keywords\":[\"file uploader\",\"uppy\",\"uppy-store\"],\"homepage\":\"https://uppy.io\",\"bugs\":{\"url\":\"https://github.com/transloadit/uppy/issues\"},\"devDependencies\":{\"jsdom\":\"^26.1.0\",\"typescript\":\"^5.8.3\",\"vitest\":\"^3.2.4\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/transloadit/uppy.git\"},\"files\":[\"src\",\"lib\",\"dist\",\"CHANGELOG.md\"]}");


/**
 * Default store that keeps state in a simple object.
 */ class $f790bad313c52a0f$var$DefaultStore {
    static VERSION = (0, (/*@__PURE__*/$parcel$interopDefault($5cb5cad21d2394b5$exports))).version;
    state = {};
    #callbacks = new Set();
    getState() {
        return this.state;
    }
    setState(patch) {
        const prevState = {
            ...this.state
        };
        const nextState = {
            ...this.state,
            ...patch
        };
        this.state = nextState;
        this.#publish(prevState, nextState, patch);
    }
    subscribe(listener) {
        this.#callbacks.add(listener);
        return ()=>{
            this.#callbacks.delete(listener);
        };
    }
    #publish(...args) {
        this.#callbacks.forEach((listener)=>{
            listener(...args);
        });
    }
}
var $f790bad313c52a0f$export$2e2bcd8739ae039 = $f790bad313c52a0f$var$DefaultStore;


/**
 * Takes a full filename string and returns an object {name, extension}
 */ function $09afbe8d004816d5$export$2e2bcd8739ae039(fullFileName) {
    const lastDot = fullFileName.lastIndexOf('.');
    // these count as no extension: "no-dot", "trailing-dot."
    if (lastDot === -1 || lastDot === fullFileName.length - 1) return {
        name: fullFileName,
        extension: undefined
    };
    return {
        name: fullFileName.slice(0, lastDot),
        extension: fullFileName.slice(lastDot + 1)
    };
}


// ___Why not add the mime-types package?
//    It's 19.7kB gzipped, and we only need mime types for well-known extensions (for file previews).
// ___Where to take new extensions from?
//    https://github.com/jshttp/mime-db/blob/master/db.json
var $92507ee89880573c$export$2e2bcd8739ae039 = {
    __proto__: null,
    md: 'text/markdown',
    markdown: 'text/markdown',
    mp4: 'video/mp4',
    mp3: 'audio/mp3',
    svg: 'image/svg+xml',
    jpg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
    gif: 'image/gif',
    heic: 'image/heic',
    heif: 'image/heif',
    yaml: 'text/yaml',
    yml: 'text/yaml',
    csv: 'text/csv',
    tsv: 'text/tab-separated-values',
    tab: 'text/tab-separated-values',
    avi: 'video/x-msvideo',
    mks: 'video/x-matroska',
    mkv: 'video/x-matroska',
    mov: 'video/quicktime',
    dicom: 'application/dicom',
    doc: 'application/msword',
    msg: 'application/vnd.ms-outlook',
    docm: 'application/vnd.ms-word.document.macroenabled.12',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    dot: 'application/msword',
    dotm: 'application/vnd.ms-word.template.macroenabled.12',
    dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    xla: 'application/vnd.ms-excel',
    xlam: 'application/vnd.ms-excel.addin.macroenabled.12',
    xlc: 'application/vnd.ms-excel',
    xlf: 'application/x-xliff+xml',
    xlm: 'application/vnd.ms-excel',
    xls: 'application/vnd.ms-excel',
    xlsb: 'application/vnd.ms-excel.sheet.binary.macroenabled.12',
    xlsm: 'application/vnd.ms-excel.sheet.macroenabled.12',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xlt: 'application/vnd.ms-excel',
    xltm: 'application/vnd.ms-excel.template.macroenabled.12',
    xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    xlw: 'application/vnd.ms-excel',
    txt: 'text/plain',
    text: 'text/plain',
    conf: 'text/plain',
    log: 'text/plain',
    pdf: 'application/pdf',
    zip: 'application/zip',
    '7z': 'application/x-7z-compressed',
    rar: 'application/x-rar-compressed',
    tar: 'application/x-tar',
    gz: 'application/gzip',
    dmg: 'application/x-apple-diskimage'
};


function $d70a5ddc0e61f36b$export$2e2bcd8739ae039(file) {
    if (file.type) return file.type;
    const fileExtension = file.name ? (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.name).extension?.toLowerCase() : null;
    if (fileExtension && fileExtension in (0, $92507ee89880573c$export$2e2bcd8739ae039)) // else, see if we can map extension to a mime type
    return (0, $92507ee89880573c$export$2e2bcd8739ae039)[fileExtension];
    // if all fails, fall back to a generic byte stream type
    return 'application/octet-stream';
}


function $d67267bb9859462b$var$encodeCharacter(character) {
    return character.charCodeAt(0).toString(32);
}
function $d67267bb9859462b$var$encodeFilename(name) {
    let suffix = '';
    return name.replace(/[^A-Z0-9]/gi, (character)=>{
        suffix += `-${$d67267bb9859462b$var$encodeCharacter(character)}`;
        return '/';
    }) + suffix;
}
function $d67267bb9859462b$export$2e2bcd8739ae039(file, instanceId) {
    // It's tempting to do `[items].filter(Boolean).join('-')` here, but that
    // is slower! simple string concatenation is fast
    let id = instanceId || 'uppy';
    if (typeof file.name === 'string') id += `-${$d67267bb9859462b$var$encodeFilename(file.name.toLowerCase())}`;
    if (file.type !== undefined) id += `-${file.type}`;
    if (file.meta && typeof file.meta.relativePath === 'string') id += `-${$d67267bb9859462b$var$encodeFilename(file.meta.relativePath.toLowerCase())}`;
    if (file.data.size !== undefined) id += `-${file.data.size}`;
    if (file.data.lastModified !== undefined) id += `-${file.data.lastModified}`;
    return id;
}
// If the provider has a stable, unique ID, then we can use that to identify the file.
// Then we don't have to generate our own ID, and we can add the same file many times if needed (different path)
function $d67267bb9859462b$var$hasFileStableId(file) {
    if (!file.isRemote || !file.remote) return false;
    // These are the providers that it seems like have stable IDs for their files. The other's I haven't checked yet.
    const stableIdProviders = new Set([
        'box',
        'dropbox',
        'drive',
        'facebook',
        'unsplash'
    ]);
    return stableIdProviders.has(file.remote.provider);
}
function $d67267bb9859462b$export$2ff5b23440673856(file, instanceId) {
    if ($d67267bb9859462b$var$hasFileStableId(file)) return file.id;
    const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(file);
    return $d67267bb9859462b$export$2e2bcd8739ae039({
        ...file,
        type: fileType
    }, instanceId);
}




function $a85fd1efd23057e0$var$insertReplacement(source, rx, replacement) {
    const newParts = [];
    source.forEach((chunk)=>{
        // When the source contains multiple placeholders for interpolation,
        // we should ignore chunks that are not strings, because those
        // can be JSX objects and will be otherwise incorrectly turned into strings.
        // Without this condition we’d get this: [object Object] hello [object Object] my <button>
        if (typeof chunk !== 'string') return newParts.push(chunk);
        return rx[Symbol.split](chunk).forEach((raw, i, list)=>{
            if (raw !== '') newParts.push(raw);
            // Interlace with the `replacement` value
            if (i < list.length - 1) newParts.push(replacement);
        });
    });
    return newParts;
}
/**
 * Takes a string with placeholder variables like `%{smart_count} file selected`
 * and replaces it with values from options `{smart_count: 5}`
 *
 * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
 * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
 *
 * @param phrase that needs interpolation, with placeholders
 * @param options with values that will be used to replace placeholders
 */ function $a85fd1efd23057e0$var$interpolate(phrase, options) {
    const dollarRegex = /\$/g;
    const dollarBillsYall = '$$$$';
    let interpolated = [
        phrase
    ];
    if (options == null) return interpolated;
    for (const arg of Object.keys(options))if (arg !== '_') {
        // Ensure replacement value is escaped to prevent special $-prefixed
        // regex replace tokens. the "$$$$" is needed because each "$" needs to
        // be escaped with "$" itself, and we need two in the resulting output.
        let replacement = options[arg];
        if (typeof replacement === 'string') replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall);
        // We create a new `RegExp` each time instead of using a more-efficient
        // string replace so that the same argument can be replaced multiple times
        // in the same phrase.
        interpolated = $a85fd1efd23057e0$var$insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, 'g'), replacement);
    }
    return interpolated;
}
const $a85fd1efd23057e0$var$defaultOnMissingKey = (key)=>{
    throw new Error(`missing string: ${key}`);
};
class $a85fd1efd23057e0$export$2e2bcd8739ae039 {
    locale;
    constructor(locales, { onMissingKey: onMissingKey = $a85fd1efd23057e0$var$defaultOnMissingKey } = {}){
        this.locale = {
            strings: {},
            pluralize (n) {
                if (n === 1) return 0;
                return 1;
            }
        };
        if (Array.isArray(locales)) locales.forEach(this.#apply, this);
        else this.#apply(locales);
        this.#onMissingKey = onMissingKey;
    }
    #onMissingKey;
    #apply(locale) {
        if (!locale?.strings) return;
        const prevLocale = this.locale;
        Object.assign(this.locale, {
            strings: {
                ...prevLocale.strings,
                ...locale.strings
            },
            pluralize: locale.pluralize || prevLocale.pluralize
        });
    }
    /**
     * Public translate method
     *
     * @param key
     * @param options with values that will be used later to replace placeholders in string
     * @returns string translated (and interpolated)
     */ translate(key, options) {
        return this.translateArray(key, options).join('');
    }
    /**
     * Get a translation and return the translated and interpolated parts as an array.
     *
     * @returns The translated and interpolated parts, in order.
     */ translateArray(key, options) {
        let string = this.locale.strings[key];
        if (string == null) {
            this.#onMissingKey(key);
            string = key;
        }
        const hasPluralForms = typeof string === 'object';
        if (hasPluralForms) {
            if (options && typeof options.smart_count !== 'undefined') {
                const plural = this.locale.pluralize(options.smart_count);
                return $a85fd1efd23057e0$var$interpolate(string[plural], options);
            }
            throw new Error('Attempted to use a string with plural forms, but no value was given for %{smart_count}');
        }
        if (typeof string !== 'string') throw new Error(`string was not a string`);
        return $a85fd1efd23057e0$var$interpolate(string, options);
    }
}


var $a50c1ad1c2867517$exports = {};
var $8284bc2b60dc4bc4$exports = {};
var $db5dfd0661742a1a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $db5dfd0661742a1a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$db5dfd0661742a1a$exports = $db5dfd0661742a1a$var$isObject;


var $1c50bd4ee78fb504$exports = {};
var $67910ad3df1b1086$exports = {};
var $fb170ba8a9c2191f$exports = {};
/** Detect free variable `global` from Node.js. */ var $fb170ba8a9c2191f$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$fb170ba8a9c2191f$exports = $fb170ba8a9c2191f$var$freeGlobal;


/** Detect free variable `self`. */ var $67910ad3df1b1086$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $67910ad3df1b1086$var$root = $fb170ba8a9c2191f$exports || $67910ad3df1b1086$var$freeSelf || Function('return this')();
$67910ad3df1b1086$exports = $67910ad3df1b1086$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1c50bd4ee78fb504$var$now = function() {
    return $67910ad3df1b1086$exports.Date.now();
};
$1c50bd4ee78fb504$exports = $1c50bd4ee78fb504$var$now;


var $e588870a06e690e1$exports = {};
var $3b7784db2f170e31$exports = {};
var $85eafef3a7f213a3$exports = {};
/** Used to match a single whitespace character. */ var $85eafef3a7f213a3$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $85eafef3a7f213a3$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $85eafef3a7f213a3$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$85eafef3a7f213a3$exports = $85eafef3a7f213a3$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $3b7784db2f170e31$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $3b7784db2f170e31$var$baseTrim(string) {
    return string ? string.slice(0, $85eafef3a7f213a3$exports(string) + 1).replace($3b7784db2f170e31$var$reTrimStart, '') : string;
}
$3b7784db2f170e31$exports = $3b7784db2f170e31$var$baseTrim;



var $b7350b23d035986b$exports = {};
var $852d1f971b259156$exports = {};
var $a090581360ce8173$exports = {};

/** Built-in value references. */ var $a090581360ce8173$var$Symbol = $67910ad3df1b1086$exports.Symbol;
$a090581360ce8173$exports = $a090581360ce8173$var$Symbol;


var $f2cc4cee927d37c7$exports = {};

/** Used for built-in method references. */ var $f2cc4cee927d37c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f2cc4cee927d37c7$var$hasOwnProperty = $f2cc4cee927d37c7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f2cc4cee927d37c7$var$nativeObjectToString = $f2cc4cee927d37c7$var$objectProto.toString;
/** Built-in value references. */ var $f2cc4cee927d37c7$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f2cc4cee927d37c7$var$getRawTag(value) {
    var isOwn = $f2cc4cee927d37c7$var$hasOwnProperty.call(value, $f2cc4cee927d37c7$var$symToStringTag), tag = value[$f2cc4cee927d37c7$var$symToStringTag];
    try {
        value[$f2cc4cee927d37c7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f2cc4cee927d37c7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f2cc4cee927d37c7$var$symToStringTag] = tag;
        else delete value[$f2cc4cee927d37c7$var$symToStringTag];
    }
    return result;
}
$f2cc4cee927d37c7$exports = $f2cc4cee927d37c7$var$getRawTag;


var $934b51efa189f09c$exports = {};
/** Used for built-in method references. */ var $934b51efa189f09c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $934b51efa189f09c$var$nativeObjectToString = $934b51efa189f09c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $934b51efa189f09c$var$objectToString(value) {
    return $934b51efa189f09c$var$nativeObjectToString.call(value);
}
$934b51efa189f09c$exports = $934b51efa189f09c$var$objectToString;


/** `Object#toString` result references. */ var $852d1f971b259156$var$nullTag = '[object Null]', $852d1f971b259156$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $852d1f971b259156$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $852d1f971b259156$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $852d1f971b259156$var$undefinedTag : $852d1f971b259156$var$nullTag;
    return $852d1f971b259156$var$symToStringTag && $852d1f971b259156$var$symToStringTag in Object(value) ? $f2cc4cee927d37c7$exports(value) : $934b51efa189f09c$exports(value);
}
$852d1f971b259156$exports = $852d1f971b259156$var$baseGetTag;


var $5475ba594a8bdf91$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5475ba594a8bdf91$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$5475ba594a8bdf91$exports = $5475ba594a8bdf91$var$isObjectLike;


/** `Object#toString` result references. */ var $b7350b23d035986b$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b7350b23d035986b$var$isSymbol(value) {
    return typeof value == 'symbol' || $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $b7350b23d035986b$var$symbolTag;
}
$b7350b23d035986b$exports = $b7350b23d035986b$var$isSymbol;


/** Used as references for various `Number` constants. */ var $e588870a06e690e1$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $e588870a06e690e1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e588870a06e690e1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e588870a06e690e1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e588870a06e690e1$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e588870a06e690e1$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($b7350b23d035986b$exports(value)) return $e588870a06e690e1$var$NAN;
    if ($db5dfd0661742a1a$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $db5dfd0661742a1a$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $3b7784db2f170e31$exports(value);
    var isBinary = $e588870a06e690e1$var$reIsBinary.test(value);
    return isBinary || $e588870a06e690e1$var$reIsOctal.test(value) ? $e588870a06e690e1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e588870a06e690e1$var$reIsBadHex.test(value) ? $e588870a06e690e1$var$NAN : +value;
}
$e588870a06e690e1$exports = $e588870a06e690e1$var$toNumber;


/** Error message constants. */ var $8284bc2b60dc4bc4$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8284bc2b60dc4bc4$var$nativeMax = Math.max, $8284bc2b60dc4bc4$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $8284bc2b60dc4bc4$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($8284bc2b60dc4bc4$var$FUNC_ERROR_TEXT);
    wait = $e588870a06e690e1$exports(wait) || 0;
    if ($db5dfd0661742a1a$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $8284bc2b60dc4bc4$var$nativeMax($e588870a06e690e1$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $8284bc2b60dc4bc4$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1c50bd4ee78fb504$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1c50bd4ee78fb504$exports());
    }
    function debounced() {
        var time = $1c50bd4ee78fb504$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$8284bc2b60dc4bc4$exports = $8284bc2b60dc4bc4$var$debounce;



/** Error message constants. */ var $a50c1ad1c2867517$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $a50c1ad1c2867517$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($a50c1ad1c2867517$var$FUNC_ERROR_TEXT);
    if ($db5dfd0661742a1a$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $8284bc2b60dc4bc4$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$a50c1ad1c2867517$exports = $a50c1ad1c2867517$var$throttle;


var $1713863f3a962559$exports = {};
/**
* Create an event emitter with namespaces
* @name createNamespaceEmitter
* @example
* var emitter = require('./index')()
*
* emitter.on('*', function () {
*   console.log('all events emitted', this.event)
* })
*
* emitter.on('example', function () {
*   console.log('example event emitted')
* })
*/ $1713863f3a962559$exports = function createNamespaceEmitter() {
    var emitter = {};
    var _fns = emitter._fns = {};
    /**
  * Emit an event. Optionally namespace the event. Handlers are fired in the order in which they were added with exact matches taking precedence. Separate the namespace and event with a `:`
  * @name emit
  * @param {String} event – the name of the event, with optional namespace
  * @param {...*} data – up to 6 arguments that are passed to the event listener
  * @example
  * emitter.emit('example')
  * emitter.emit('demo:test')
  * emitter.emit('data', { example: true}, 'a string', 1)
  */ emitter.emit = function emit(event, arg1, arg2, arg3, arg4, arg5, arg6) {
        var toEmit = getListeners(event);
        if (toEmit.length) emitAll(event, toEmit, [
            arg1,
            arg2,
            arg3,
            arg4,
            arg5,
            arg6
        ]);
    };
    /**
  * Create en event listener.
  * @name on
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.on('example', function () {})
  * emitter.on('demo', function () {})
  */ emitter.on = function on(event, fn) {
        if (!_fns[event]) _fns[event] = [];
        _fns[event].push(fn);
    };
    /**
  * Create en event listener that fires once.
  * @name once
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.once('example', function () {})
  * emitter.once('demo', function () {})
  */ emitter.once = function once(event, fn) {
        function one() {
            fn.apply(this, arguments);
            emitter.off(event, one);
        }
        this.on(event, one);
    };
    /**
  * Stop listening to an event. Stop all listeners on an event by only passing the event name. Stop a single listener by passing that event handler as a callback.
  * You must be explicit about what will be unsubscribed: `emitter.off('demo')` will unsubscribe an `emitter.on('demo')` listener,
  * `emitter.off('demo:example')` will unsubscribe an `emitter.on('demo:example')` listener
  * @name off
  * @param {String} event
  * @param {Function} [fn] – the specific handler
  * @example
  * emitter.off('example')
  * emitter.off('demo', function () {})
  */ emitter.off = function off(event, fn) {
        var keep = [];
        if (event && fn) {
            var fns = this._fns[event];
            var i = 0;
            var l = fns ? fns.length : 0;
            for(i; i < l; i++)if (fns[i] !== fn) keep.push(fns[i]);
        }
        keep.length ? this._fns[event] = keep : delete this._fns[event];
    };
    function getListeners(e) {
        var out = _fns[e] ? _fns[e] : [];
        var idx = e.indexOf(':');
        var args = idx === -1 ? [
            e
        ] : [
            e.substring(0, idx),
            e.substring(idx + 1)
        ];
        var keys = Object.keys(_fns);
        var i = 0;
        var l = keys.length;
        for(i; i < l; i++){
            var key = keys[i];
            if (key === '*') out = out.concat(_fns[key]);
            if (args.length === 2 && args[0] === key) {
                out = out.concat(_fns[key]);
                break;
            }
        }
        return out;
    }
    function emitAll(e, fns, args) {
        var i = 0;
        var l = fns.length;
        for(i; i < l; i++){
            if (!fns[i]) break;
            fns[i].event = e;
            fns[i].apply(fns[i], args);
        }
    }
    return emitter;
};


let $3c82c89e950acc97$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $3c82c89e950acc97$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size | 0;
        while(i-- > 0)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $3c82c89e950acc97$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size | 0;
    while(i-- > 0)id += $3c82c89e950acc97$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $94030acc6687e321$exports = {};
$94030acc6687e321$exports = JSON.parse("{\"name\":\"@uppy/core\",\"description\":\"Core module for the extensible JavaScript file upload widget with support for drag&drop, resumable uploads, previews, restrictions, file processing/encoding, remote providers like Instagram, Dropbox, Google Drive, S3 and more :dog:\",\"version\":\"4.5.3\",\"license\":\"MIT\",\"main\":\"lib/index.js\",\"style\":\"dist/style.min.css\",\"type\":\"module\",\"sideEffects\":[\"*.css\"],\"scripts\":{\"build\":\"tsc --build tsconfig.build.json\",\"build:css\":\"sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css\",\"typecheck\":\"tsc --build\",\"test\":\"vitest run --environment=jsdom --silent='passed-only'\"},\"keywords\":[\"file uploader\",\"uppy\",\"uppy-plugin\"],\"homepage\":\"https://uppy.io\",\"bugs\":{\"url\":\"https://github.com/transloadit/uppy/issues\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/transloadit/uppy.git\"},\"files\":[\"src\",\"lib\",\"dist\",\"CHANGELOG.md\"],\"dependencies\":{\"@transloadit/prettier-bytes\":\"^0.3.4\",\"@uppy/store-default\":\"^4.3.2\",\"@uppy/utils\":\"^6.2.2\",\"lodash\":\"^4.17.21\",\"mime-match\":\"^1.0.2\",\"namespace-emitter\":\"^2.0.1\",\"nanoid\":\"^5.0.9\",\"preact\":\"^10.5.13\"},\"devDependencies\":{\"@types/deep-freeze\":\"^0\",\"cssnano\":\"^7.0.7\",\"deep-freeze\":\"^0.0.1\",\"jsdom\":\"^26.1.0\",\"postcss\":\"^8.5.6\",\"postcss-cli\":\"^11.0.1\",\"sass\":\"^1.89.2\",\"typescript\":\"^5.8.3\",\"vitest\":\"^3.2.4\"}}");


function $77bbd1edc6b4e0f3$export$2e2bcd8739ae039(fileType, fileDescriptor) {
    if (fileDescriptor.name) return fileDescriptor.name;
    if (fileType.split('/')[0] === 'image') return `${fileType.split('/')[0]}.${fileType.split('/')[1]}`;
    return 'noname';
}


var $721644b39e57ffe9$export$2e2bcd8739ae039 = {
    strings: {
        addBulkFilesFailed: {
            0: 'Failed to add %{smart_count} file due to an internal error',
            1: 'Failed to add %{smart_count} files due to internal errors'
        },
        youCanOnlyUploadX: {
            0: 'You can only upload %{smart_count} file',
            1: 'You can only upload %{smart_count} files'
        },
        youHaveToAtLeastSelectX: {
            0: 'You have to select at least %{smart_count} file',
            1: 'You have to select at least %{smart_count} files'
        },
        aggregateExceedsSize: 'You selected %{size} of files, but maximum allowed size is %{sizeAllowed}',
        exceedsSize: '%{file} exceeds maximum allowed size of %{size}',
        missingRequiredMetaField: 'Missing required meta fields',
        missingRequiredMetaFieldOnFile: 'Missing required meta fields in %{fileName}',
        inferiorSize: 'This file is smaller than the allowed size of %{size}',
        youCanOnlyUploadFileTypes: 'You can only upload: %{types}',
        noMoreFilesAllowed: 'Cannot add more files',
        noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
        companionError: 'Connection with Companion failed',
        authAborted: 'Authentication aborted',
        companionUnauthorizeHint: 'To unauthorize to your %{provider} account, please go to %{url}',
        failedToUpload: 'Failed to upload %{file}',
        noInternetConnection: 'No Internet connection',
        connectedToInternet: 'Connected to the Internet',
        // Strings for remote providers
        noFilesFound: 'You have no files or folders here',
        noSearchResults: 'Unfortunately, there are no results for this search',
        selectX: {
            0: 'Select %{smart_count}',
            1: 'Select %{smart_count}'
        },
        allFilesFromFolderNamed: 'All files from folder %{name}',
        openFolderNamed: 'Open folder %{name}',
        cancel: 'Cancel',
        logOut: 'Log out',
        logIn: 'Log in',
        pickFiles: 'Pick files',
        pickPhotos: 'Pick photos',
        filter: 'Filter',
        resetFilter: 'Reset filter',
        loading: 'Loading...',
        loadedXFiles: 'Loaded %{numFiles} files',
        authenticateWithTitle: 'Please authenticate with %{pluginName} to select files',
        authenticateWith: 'Connect to %{pluginName}',
        signInWithGoogle: 'Sign in with Google',
        searchImages: 'Search for images',
        enterTextToSearch: 'Enter text to search for images',
        search: 'Search',
        resetSearch: 'Reset search',
        emptyFolderAdded: 'No files were added from empty folder',
        addedNumFiles: 'Added %{numFiles} file(s)',
        folderAlreadyAdded: 'The folder "%{folder}" was already added',
        folderAdded: {
            0: 'Added %{smart_count} file from %{folder}',
            1: 'Added %{smart_count} files from %{folder}'
        },
        additionalRestrictionsFailed: '%{count} additional restrictions were not fulfilled',
        unnamed: 'Unnamed',
        pleaseWait: 'Please wait'
    }
};


/**
 * Adds zero to strings shorter than two characters.
 */ function $cd89119ba1e2ad9d$var$pad(number) {
    return number < 10 ? `0${number}` : number.toString();
}
function $cd89119ba1e2ad9d$export$2e2bcd8739ae039() {
    const date = new Date();
    const hours = $cd89119ba1e2ad9d$var$pad(date.getHours());
    const minutes = $cd89119ba1e2ad9d$var$pad(date.getMinutes());
    const seconds = $cd89119ba1e2ad9d$var$pad(date.getSeconds());
    return `${hours}:${minutes}:${seconds}`;
}


// Swallow all logs, except errors.
// default if logger is not set or debug: false
const $b03b26a8a191c595$export$51086a57eba987c9 = {
    debug: ()=>{},
    warn: ()=>{},
    error: (...args)=>console.error(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args)
};
// Print logs to console with namespace + timestamp,
// set by logger: Uppy.debugLogger or debug: true
const $b03b26a8a191c595$export$e6a390ea6399b7d8 = {
    debug: (...args)=>console.debug(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args),
    warn: (...args)=>console.warn(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args),
    error: (...args)=>console.error(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args)
};


var $06e80194017bcce5$exports = {};
"use strict";
$06e80194017bcce5$exports = function prettierBytes(input) {
    if (typeof input !== 'number' || Number.isNaN(input)) throw new TypeError(`Expected a number, got ${typeof input}`);
    const neg = input < 0;
    let num = Math.abs(input);
    if (neg) num = -num;
    if (num === 0) return '0 B';
    const units = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
    const value = Number(num / 1024 ** exponent);
    const unit = units[exponent];
    return `${value >= 10 || value % 1 === 0 ? Math.round(value) : value.toFixed(1)} ${unit}`;
};


var $34b5d77a3aae6147$exports = {};
var $bf27c8b296b096af$exports = {};
/* jshint node: true */ 'use strict';
/**
  # wildcard

  Very simple wildcard matching, which is designed to provide the same
  functionality that is found in the
  [eve](https://github.com/adobe-webplatform/eve) eventing library.

  ## Usage

  It works with strings:

  <<< examples/strings.js

  Arrays:

  <<< examples/arrays.js

  Objects (matching against keys):

  <<< examples/objects.js

  While the library works in Node, if you are are looking for file-based
  wildcard matching then you should have a look at:

  <https://github.com/isaacs/node-glob>
**/ function $bf27c8b296b096af$var$WildcardMatcher(text, separator) {
    this.text = text = text || '';
    this.hasWild = ~text.indexOf('*');
    this.separator = separator;
    this.parts = text.split(separator);
}
$bf27c8b296b096af$var$WildcardMatcher.prototype.match = function(input) {
    var matches = true;
    var parts = this.parts;
    var ii;
    var partsCount = parts.length;
    var testParts;
    if (typeof input == 'string' || input instanceof String) {
        if (!this.hasWild && this.text != input) matches = false;
        else {
            testParts = (input || '').split(this.separator);
            for(ii = 0; matches && ii < partsCount; ii++){
                if (parts[ii] === '*') continue;
                else if (ii < testParts.length) matches = parts[ii] === testParts[ii];
                else matches = false;
            }
            // If matches, then return the component parts
            matches = matches && testParts;
        }
    } else if (typeof input.splice == 'function') {
        matches = [];
        for(ii = input.length; ii--;)if (this.match(input[ii])) matches[matches.length] = input[ii];
    } else if (typeof input == 'object') {
        matches = {};
        for(var key in input)if (this.match(key)) matches[key] = input[key];
    }
    return matches;
};
$bf27c8b296b096af$exports = function(text, test, separator) {
    var matcher = new $bf27c8b296b096af$var$WildcardMatcher(text, separator || /[\/\.]/);
    if (typeof test != 'undefined') return matcher.match(test);
    return matcher;
};


var $34b5d77a3aae6147$var$reMimePartSplit = /[\/\+\.]/;
/**
  # mime-match

  A simple function to checker whether a target mime type matches a mime-type
  pattern (e.g. image/jpeg matches image/jpeg OR image/*).

  ## Example Usage

  <<< example.js

**/ $34b5d77a3aae6147$exports = function(target, pattern) {
    function test(pattern) {
        var result = $bf27c8b296b096af$exports(pattern, target, $34b5d77a3aae6147$var$reMimePartSplit);
        // ensure that we have a valid mime type (should have two parts)
        return result && result.length >= 2;
    }
    return pattern ? test(pattern.split(';')[0]) : test;
};


const $3044940369c0f03d$export$ba43bf67f3d48107 = {
    maxFileSize: null,
    minFileSize: null,
    maxTotalFileSize: null,
    maxNumberOfFiles: null,
    minNumberOfFiles: null,
    allowedFileTypes: null,
    requiredMetaFields: []
};
class $3044940369c0f03d$export$e4d147272ce048a7 extends Error {
    isUserFacing;
    file;
    constructor(message, opts){
        super(message);
        this.isUserFacing = opts?.isUserFacing ?? true;
        if (opts?.file) this.file = opts.file; // only some restriction errors are related to a particular file
    }
    isRestriction = true;
}
class $3044940369c0f03d$export$c464a380a24dd3b8 {
    getI18n;
    getOpts;
    constructor(getOpts, getI18n){
        this.getI18n = getI18n;
        this.getOpts = ()=>{
            const opts = getOpts();
            if (opts.restrictions?.allowedFileTypes != null && !Array.isArray(opts.restrictions.allowedFileTypes)) throw new TypeError('`restrictions.allowedFileTypes` must be an array');
            return opts;
        };
    }
    // Because these operations are slow, we cannot run them for every file (if we are adding multiple files)
    validateAggregateRestrictions(existingFiles, addingFiles) {
        const { maxTotalFileSize: maxTotalFileSize, maxNumberOfFiles: maxNumberOfFiles } = this.getOpts().restrictions;
        if (maxNumberOfFiles) {
            const nonGhostFiles = existingFiles.filter((f)=>!f.isGhost);
            if (nonGhostFiles.length + addingFiles.length > maxNumberOfFiles) throw new $3044940369c0f03d$export$e4d147272ce048a7(`${this.getI18n()('youCanOnlyUploadX', {
                smart_count: maxNumberOfFiles
            })}`);
        }
        if (maxTotalFileSize) {
            const totalFilesSize = [
                ...existingFiles,
                ...addingFiles
            ].reduce((total, f)=>total + (f.size ?? 0), 0);
            if (totalFilesSize > maxTotalFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('aggregateExceedsSize', {
                sizeAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(maxTotalFileSize),
                size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalFilesSize)
            }));
        }
    }
    validateSingleFile(file) {
        const { maxFileSize: maxFileSize, minFileSize: minFileSize, allowedFileTypes: allowedFileTypes } = this.getOpts().restrictions;
        if (allowedFileTypes) {
            const isCorrectFileType = allowedFileTypes.some((type)=>{
                // check if this is a mime-type
                if (type.includes('/')) {
                    if (!file.type) return false;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($34b5d77a3aae6147$exports)))(file.type.replace(/;.*?$/, ''), type);
                }
                // otherwise this is likely an extension
                if (type[0] === '.' && file.extension) return file.extension.toLowerCase() === type.slice(1).toLowerCase();
                return false;
            });
            if (!isCorrectFileType) {
                const allowedFileTypesString = allowedFileTypes.join(', ');
                throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('youCanOnlyUploadFileTypes', {
                    types: allowedFileTypesString
                }), {
                    file: file
                });
            }
        }
        // We can't check maxFileSize if the size is unknown.
        if (maxFileSize && file.size != null && file.size > maxFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('exceedsSize', {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(maxFileSize),
            file: file.name ?? this.getI18n()('unnamed')
        }), {
            file: file
        });
        // We can't check minFileSize if the size is unknown.
        if (minFileSize && file.size != null && file.size < minFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('inferiorSize', {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(minFileSize)
        }), {
            file: file
        });
    }
    validate(existingFiles, addingFiles) {
        addingFiles.forEach((addingFile)=>{
            this.validateSingleFile(addingFile);
        });
        this.validateAggregateRestrictions(existingFiles, addingFiles);
    }
    validateMinNumberOfFiles(files) {
        const { minNumberOfFiles: minNumberOfFiles } = this.getOpts().restrictions;
        if (minNumberOfFiles && Object.keys(files).length < minNumberOfFiles) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('youHaveToAtLeastSelectX', {
            smart_count: minNumberOfFiles
        }));
    }
    getMissingRequiredMetaFields(file) {
        const error = new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()('missingRequiredMetaFieldOnFile', {
            fileName: file.name ?? this.getI18n()('unnamed')
        }));
        const { requiredMetaFields: requiredMetaFields } = this.getOpts().restrictions;
        const missingFields = [];
        for (const field of requiredMetaFields)if (!Object.hasOwn(file.meta, field) || file.meta[field] === '') missingFields.push(field);
        return {
            missingFields: missingFields,
            error: error
        };
    }
}


// Edge 15.x does not fire 'progress' events on uploads.
// See https://github.com/transloadit/uppy/issues/945
// And https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12224510/
function $d0281443a9bf1cf1$export$2e2bcd8739ae039(userAgent) {
    // Allow passing in userAgent for tests
    if (userAgent == null && typeof navigator !== 'undefined') userAgent = navigator.userAgent;
    // Assume it works because basically everything supports progress events.
    if (!userAgent) return true;
    const m = /Edge\/(\d+\.\d+)/.exec(userAgent);
    if (!m) return true;
    const edgeVersion = m[1];
    const version = edgeVersion.split('.', 2);
    const major = parseInt(version[0], 10);
    const minor = parseInt(version[1], 10);
    // Worked before:
    // Edge 40.15063.0.0
    // Microsoft EdgeHTML 15.15063
    if (major < 15 || major === 15 && minor < 15063) return true;
    // Fixed in:
    // Microsoft EdgeHTML 18.18218
    if (major > 18 || major === 18 && minor >= 18218) return true;
    // other versions don't work.
    return false;
}


const $b16b91c7840d3bff$var$defaultUploadState = {
    totalProgress: 0,
    allowNewUpload: true,
    error: null,
    recoveredState: null
};
class $b16b91c7840d3bff$export$1c95bea2669f592b {
    static VERSION = (0, (/*@__PURE__*/$parcel$interopDefault($94030acc6687e321$exports))).version;
    #plugins = Object.create(null);
    #restricter;
    #storeUnsubscribe;
    #emitter = (0, (/*@__PURE__*/$parcel$interopDefault($1713863f3a962559$exports)))();
    #preProcessors = new Set();
    #uploaders = new Set();
    #postProcessors = new Set();
    defaultLocale;
    locale;
    // The user optionally passes in options, but we set defaults for missing options.
    // We consider all options present after the contructor has run.
    opts;
    store;
    // Warning: do not use this from a plugin, as it will cause the plugins' translations to be missing
    i18n;
    i18nArray;
    scheduledAutoProceed = null;
    wasOffline = false;
    /**
     * Instantiate Uppy
     */ constructor(opts){
        this.defaultLocale = (0, $721644b39e57ffe9$export$2e2bcd8739ae039);
        const defaultOptions = {
            id: 'uppy',
            autoProceed: false,
            allowMultipleUploadBatches: true,
            debug: false,
            restrictions: (0, $3044940369c0f03d$export$ba43bf67f3d48107),
            meta: {},
            onBeforeFileAdded: (file, files)=>!Object.hasOwn(files, file.id),
            onBeforeUpload: (files)=>files,
            store: new (0, $f790bad313c52a0f$export$2e2bcd8739ae039)(),
            logger: (0, $b03b26a8a191c595$export$51086a57eba987c9),
            infoTimeout: 5000
        };
        const merged = {
            ...defaultOptions,
            ...opts
        };
        // Merge default options with the ones set by user,
        // making sure to merge restrictions too
        this.opts = {
            ...merged,
            restrictions: {
                ...defaultOptions.restrictions,
                ...opts?.restrictions
            }
        };
        // Support debug: true for backwards-compatability, unless logger is set in opts
        // opts instead of this.opts to avoid comparing objects — we set logger: justErrorsLogger in defaultOptions
        if (opts?.logger && opts.debug) this.log('You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.', 'warning');
        else if (opts?.debug) this.opts.logger = (0, $b03b26a8a191c595$export$e6a390ea6399b7d8);
        this.log(`Using Core v${$b16b91c7840d3bff$export$1c95bea2669f592b.VERSION}`);
        this.i18nInit();
        this.store = this.opts.store;
        this.setState({
            ...$b16b91c7840d3bff$var$defaultUploadState,
            plugins: {},
            files: {},
            currentUploads: {},
            capabilities: {
                uploadProgress: (0, $d0281443a9bf1cf1$export$2e2bcd8739ae039)(),
                individualCancellation: true,
                resumableUploads: false
            },
            meta: {
                ...this.opts.meta
            },
            info: []
        });
        this.#restricter = new (0, $3044940369c0f03d$export$c464a380a24dd3b8)(()=>this.opts, ()=>this.i18n);
        this.#storeUnsubscribe = this.store.subscribe((prevState, nextState, patch)=>{
            this.emit('state-update', prevState, nextState, patch);
            this.updateAll(nextState);
        });
        // Exposing uppy object on window for debugging and testing
        if (this.opts.debug && typeof window !== 'undefined') // @ts-ignore Mutating the global object for debug purposes
        window[this.opts.id] = this;
        this.#addListeners();
    }
    emit(event, ...args) {
        this.#emitter.emit(event, ...args);
    }
    on(event, callback) {
        this.#emitter.on(event, callback);
        return this;
    }
    once(event, callback) {
        this.#emitter.once(event, callback);
        return this;
    }
    off(event, callback) {
        this.#emitter.off(event, callback);
        return this;
    }
    /**
     * Iterate on all plugins and run `update` on them.
     * Called each time state changes.
     *
     */ updateAll(state) {
        this.iteratePlugins((plugin)=>{
            plugin.update(state);
        });
    }
    /**
     * Updates state with a patch
     */ setState(patch) {
        this.store.setState(patch);
    }
    /**
     * Returns current state.
     */ getState() {
        return this.store.getState();
    }
    patchFilesState(filesWithNewState) {
        const existingFilesState = this.getState().files;
        this.setState({
            files: {
                ...existingFilesState,
                ...Object.fromEntries(Object.entries(filesWithNewState).map(([fileID, newFileState])=>[
                        fileID,
                        {
                            ...existingFilesState[fileID],
                            ...newFileState
                        }
                    ]))
            }
        });
    }
    /**
     * Shorthand to set state for a specific file.
     */ setFileState(fileID, state) {
        if (!this.getState().files[fileID]) throw new Error(`Can\u{2019}t set state for ${fileID} (the file could have been removed)`);
        this.patchFilesState({
            [fileID]: state
        });
    }
    i18nInit() {
        const onMissingKey = (key)=>this.log(`Missing i18n string: ${key}`, 'error');
        const translator = new (0, $a85fd1efd23057e0$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.opts.locale
        ], {
            onMissingKey: onMissingKey
        });
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.locale = translator.locale;
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts,
            restrictions: {
                ...this.opts.restrictions,
                ...newOpts?.restrictions
            }
        };
        if (newOpts.meta) this.setMeta(newOpts.meta);
        this.i18nInit();
        if (newOpts.locale) this.iteratePlugins((plugin)=>{
            plugin.setOptions(newOpts);
        });
        // Note: this is not the preact `setState`, it's an internal function that has the same name.
        this.setState(undefined); // so that UI re-renders with new options
    }
    resetProgress() {
        const defaultProgress = {
            percentage: 0,
            bytesUploaded: false,
            uploadComplete: false,
            uploadStarted: null
        };
        const files = {
            ...this.getState().files
        };
        const updatedFiles = Object.create(null);
        Object.keys(files).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...files[fileID],
                progress: {
                    ...files[fileID].progress,
                    ...defaultProgress
                },
                // @ts-expect-error these typed are inserted
                // into the namespace in their respective packages
                // but core isn't ware of those
                tus: undefined,
                transloadit: undefined
            };
        });
        this.setState({
            files: updatedFiles,
            ...$b16b91c7840d3bff$var$defaultUploadState
        });
    }
    clear() {
        const { capabilities: capabilities, currentUploads: currentUploads } = this.getState();
        if (Object.keys(currentUploads).length > 0 && !capabilities.individualCancellation) throw new Error('The installed uploader plugin does not allow removing files during an upload.');
        this.setState({
            ...$b16b91c7840d3bff$var$defaultUploadState,
            files: {}
        });
    }
    addPreProcessor(fn) {
        this.#preProcessors.add(fn);
    }
    removePreProcessor(fn) {
        return this.#preProcessors.delete(fn);
    }
    addPostProcessor(fn) {
        this.#postProcessors.add(fn);
    }
    removePostProcessor(fn) {
        return this.#postProcessors.delete(fn);
    }
    addUploader(fn) {
        this.#uploaders.add(fn);
    }
    removeUploader(fn) {
        return this.#uploaders.delete(fn);
    }
    setMeta(data) {
        const updatedMeta = {
            ...this.getState().meta,
            ...data
        };
        const updatedFiles = {
            ...this.getState().files
        };
        Object.keys(updatedFiles).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...updatedFiles[fileID],
                meta: {
                    ...updatedFiles[fileID].meta,
                    ...data
                }
            };
        });
        this.log('Adding metadata:');
        this.log(data);
        this.setState({
            meta: updatedMeta,
            files: updatedFiles
        });
    }
    setFileMeta(fileID, data) {
        const updatedFiles = {
            ...this.getState().files
        };
        if (!updatedFiles[fileID]) {
            this.log(`Was trying to set metadata for a file that has been removed: ${fileID}`);
            return;
        }
        const newMeta = {
            ...updatedFiles[fileID].meta,
            ...data
        };
        updatedFiles[fileID] = {
            ...updatedFiles[fileID],
            meta: newMeta
        };
        this.setState({
            files: updatedFiles
        });
    }
    /**
     * Get a file object.
     */ getFile(fileID) {
        return this.getState().files[fileID];
    }
    /**
     * Get all files in an array.
     */ getFiles() {
        const { files: files } = this.getState();
        return Object.values(files);
    }
    getFilesByIds(ids) {
        return ids.map((id)=>this.getFile(id));
    }
    getObjectOfFilesPerState() {
        const { files: filesObject, totalProgress: totalProgress, error: error } = this.getState();
        const files = Object.values(filesObject);
        const inProgressFiles = [];
        const newFiles = [];
        const startedFiles = [];
        const uploadStartedFiles = [];
        const pausedFiles = [];
        const completeFiles = [];
        const erroredFiles = [];
        const inProgressNotPausedFiles = [];
        const processingFiles = [];
        for (const file of files){
            const { progress: progress } = file;
            if (!progress.uploadComplete && progress.uploadStarted) {
                inProgressFiles.push(file);
                if (!file.isPaused) inProgressNotPausedFiles.push(file);
            }
            if (!progress.uploadStarted) newFiles.push(file);
            if (progress.uploadStarted || progress.preprocess || progress.postprocess) startedFiles.push(file);
            if (progress.uploadStarted) uploadStartedFiles.push(file);
            if (file.isPaused) pausedFiles.push(file);
            if (progress.uploadComplete) completeFiles.push(file);
            if (file.error) erroredFiles.push(file);
            if (progress.preprocess || progress.postprocess) processingFiles.push(file);
        }
        return {
            newFiles: newFiles,
            startedFiles: startedFiles,
            uploadStartedFiles: uploadStartedFiles,
            pausedFiles: pausedFiles,
            completeFiles: completeFiles,
            erroredFiles: erroredFiles,
            inProgressFiles: inProgressFiles,
            inProgressNotPausedFiles: inProgressNotPausedFiles,
            processingFiles: processingFiles,
            isUploadStarted: uploadStartedFiles.length > 0,
            isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
            isAllErrored: !!error && erroredFiles.length === files.length,
            isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
            isUploadInProgress: inProgressFiles.length > 0,
            isSomeGhost: files.some((file)=>file.isGhost)
        };
    }
    #informAndEmit(errors) {
        for (const error of errors){
            if (error.isRestriction) this.emit('restriction-failed', error.file, error);
            else this.emit('error', error, error.file);
            this.log(error, 'warning');
        }
        const userFacingErrors = errors.filter((error)=>error.isUserFacing);
        // don't flood the user: only show the first 4 toasts
        const maxNumToShow = 4;
        const firstErrors = userFacingErrors.slice(0, maxNumToShow);
        const additionalErrors = userFacingErrors.slice(maxNumToShow);
        firstErrors.forEach(({ message: message, details: details = '' })=>{
            this.info({
                message: message,
                details: details
            }, 'error', this.opts.infoTimeout);
        });
        if (additionalErrors.length > 0) this.info({
            message: this.i18n('additionalRestrictionsFailed', {
                count: additionalErrors.length
            })
        });
    }
    validateRestrictions(file, files = this.getFiles()) {
        try {
            this.#restricter.validate(files, [
                file
            ]);
        } catch (err) {
            return err;
        }
        return null;
    }
    validateSingleFile(file) {
        try {
            this.#restricter.validateSingleFile(file);
        } catch (err) {
            return err.message;
        }
        return null;
    }
    validateAggregateRestrictions(files) {
        const existingFiles = this.getFiles();
        try {
            this.#restricter.validateAggregateRestrictions(existingFiles, files);
        } catch (err) {
            return err.message;
        }
        return null;
    }
    #checkRequiredMetaFieldsOnFile(file) {
        const { missingFields: missingFields, error: error } = this.#restricter.getMissingRequiredMetaFields(file);
        if (missingFields.length > 0) {
            this.setFileState(file.id, {
                missingRequiredMetaFields: missingFields,
                error: error.message
            });
            this.log(error.message);
            this.emit('restriction-failed', file, error);
            return false;
        }
        if (missingFields.length === 0 && file.missingRequiredMetaFields) this.setFileState(file.id, {
            missingRequiredMetaFields: []
        });
        return true;
    }
    #checkRequiredMetaFields(files) {
        let success = true;
        for (const file of Object.values(files))if (!this.#checkRequiredMetaFieldsOnFile(file)) success = false;
        return success;
    }
    #assertNewUploadAllowed(file) {
        const { allowNewUpload: allowNewUpload } = this.getState();
        if (allowNewUpload === false) {
            const error = new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n('noMoreFilesAllowed'), {
                file: file
            });
            this.#informAndEmit([
                error
            ]);
            throw error;
        }
    }
    checkIfFileAlreadyExists(fileID) {
        const { files: files } = this.getState();
        if (files[fileID] && !files[fileID].isGhost) return true;
        return false;
    }
    /**
     * Create a file state object based on user-provided `addFile()` options.
     */ #transformFile(fileDescriptorOrFile) {
        // Uppy expects files in { name, type, size, data } format.
        // If the actual File object is passed from input[type=file] or drag-drop,
        // we normalize it to match Uppy file object
        const file = fileDescriptorOrFile instanceof File ? {
            name: fileDescriptorOrFile.name,
            type: fileDescriptorOrFile.type,
            size: fileDescriptorOrFile.size,
            data: fileDescriptorOrFile
        } : fileDescriptorOrFile;
        const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(file);
        const fileName = (0, $77bbd1edc6b4e0f3$export$2e2bcd8739ae039)(fileType, file);
        const fileExtension = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(fileName).extension;
        const id = (0, $d67267bb9859462b$export$2ff5b23440673856)(file, this.getID());
        const meta = file.meta || {};
        meta.name = fileName;
        meta.type = fileType;
        // `null` means the size is unknown.
        const size = Number.isFinite(file.data.size) ? file.data.size : null;
        return {
            source: file.source || '',
            id: id,
            name: fileName,
            extension: fileExtension || '',
            meta: {
                ...this.getState().meta,
                ...meta
            },
            type: fileType,
            data: file.data,
            progress: {
                percentage: 0,
                bytesUploaded: false,
                bytesTotal: size,
                uploadComplete: false,
                uploadStarted: null
            },
            size: size,
            isGhost: false,
            isRemote: file.isRemote || false,
            remote: file.remote,
            preview: file.preview
        };
    }
    // Schedule an upload if `autoProceed` is enabled.
    #startIfAutoProceed() {
        if (this.opts.autoProceed && !this.scheduledAutoProceed) this.scheduledAutoProceed = setTimeout(()=>{
            this.scheduledAutoProceed = null;
            this.upload().catch((err)=>{
                if (!err.isRestriction) this.log(err.stack || err.message || err);
            });
        }, 4);
    }
    #checkAndUpdateFileState(filesToAdd) {
        let { files: existingFiles } = this.getState();
        // create a copy of the files object only once
        let nextFilesState = {
            ...existingFiles
        };
        const validFilesToAdd = [];
        const errors = [];
        for (const fileToAdd of filesToAdd)try {
            let newFile = this.#transformFile(fileToAdd);
            // If a file has been recovered (Golden Retriever), but we were unable to recover its data (probably too large),
            // users are asked to re-select these half-recovered files and then this method will be called again.
            // In order to keep the progress, meta and everything else, we keep the existing file,
            // but we replace `data`, and we remove `isGhost`, because the file is no longer a ghost now
            const isGhost = existingFiles[newFile.id]?.isGhost;
            if (isGhost) {
                const existingFileState = existingFiles[newFile.id];
                newFile = {
                    ...existingFileState,
                    isGhost: false,
                    data: fileToAdd.data
                };
                this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
            }
            const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, nextFilesState);
            // update state after onBeforeFileAdded
            existingFiles = this.getState().files;
            nextFilesState = {
                ...existingFiles,
                ...nextFilesState
            };
            if (!onBeforeFileAddedResult && this.checkIfFileAlreadyExists(newFile.id)) throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n('noDuplicates', {
                fileName: newFile.name ?? this.i18n('unnamed')
            }), {
                file: fileToAdd
            });
            // Pass through reselected files from Golden Retriever
            if (onBeforeFileAddedResult === false && !isGhost) // Don’t show UI info for this error, as it should be done by the developer
            throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)('Cannot add the file because onBeforeFileAdded returned false.', {
                isUserFacing: false,
                file: fileToAdd
            });
            else if (typeof onBeforeFileAddedResult === 'object' && onBeforeFileAddedResult !== null) newFile = onBeforeFileAddedResult;
            this.#restricter.validateSingleFile(newFile);
            // need to add it to the new local state immediately, so we can use the state to validate the next files too
            nextFilesState[newFile.id] = newFile;
            validFilesToAdd.push(newFile);
        } catch (err) {
            errors.push(err);
        }
        try {
            // need to run this separately because it's much more slow, so if we run it inside the for-loop it will be very slow
            // when many files are added
            this.#restricter.validateAggregateRestrictions(Object.values(existingFiles), validFilesToAdd);
        } catch (err) {
            errors.push(err);
            // If we have any aggregate error, don't allow adding this batch
            return {
                nextFilesState: existingFiles,
                validFilesToAdd: [],
                errors: errors
            };
        }
        return {
            nextFilesState: nextFilesState,
            validFilesToAdd: validFilesToAdd,
            errors: errors
        };
    }
    /**
     * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
     * try to guess file type in a clever way, check file against restrictions,
     * and start an upload if `autoProceed === true`.
     */ addFile(file) {
        this.#assertNewUploadAllowed(file);
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = this.#checkAndUpdateFileState([
            file
        ]);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        this.#informAndEmit(restrictionErrors);
        if (errors.length > 0) throw errors[0];
        this.setState({
            files: nextFilesState
        });
        const [firstValidFileToAdd] = validFilesToAdd;
        this.emit('file-added', firstValidFileToAdd);
        this.emit('files-added', validFilesToAdd);
        this.log(`Added file: ${firstValidFileToAdd.name}, ${firstValidFileToAdd.id}, mime type: ${firstValidFileToAdd.type}`);
        this.#startIfAutoProceed();
        return firstValidFileToAdd.id;
    }
    /**
     * Add multiple files to `state.files`. See the `addFile()` documentation.
     *
     * If an error occurs while adding a file, it is logged and the user is notified.
     * This is good for UI plugins, but not for programmatic use.
     * Programmatic users should usually still use `addFile()` on individual files.
     */ addFiles(fileDescriptors) {
        this.#assertNewUploadAllowed();
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = this.#checkAndUpdateFileState(fileDescriptors);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        this.#informAndEmit(restrictionErrors);
        const nonRestrictionErrors = errors.filter((error)=>!error.isRestriction);
        if (nonRestrictionErrors.length > 0) {
            let message = 'Multiple errors occurred while adding files:\n';
            nonRestrictionErrors.forEach((subError)=>{
                message += `\n * ${subError.message}`;
            });
            this.info({
                message: this.i18n('addBulkFilesFailed', {
                    smart_count: nonRestrictionErrors.length
                }),
                details: message
            }, 'error', this.opts.infoTimeout);
            if (typeof AggregateError === 'function') throw new AggregateError(nonRestrictionErrors, message);
            else {
                const err = new Error(message);
                // @ts-expect-error fallback when AggregateError is not available
                err.errors = nonRestrictionErrors;
                throw err;
            }
        }
        // OK, we haven't thrown an error, we can start updating state and emitting events now:
        this.setState({
            files: nextFilesState
        });
        validFilesToAdd.forEach((file)=>{
            this.emit('file-added', file);
        });
        this.emit('files-added', validFilesToAdd);
        if (validFilesToAdd.length > 5) this.log(`Added batch of ${validFilesToAdd.length} files`);
        else Object.values(validFilesToAdd).forEach((file)=>{
            this.log(`Added file: ${file.name}\n id: ${file.id}\n type: ${file.type}`);
        });
        if (validFilesToAdd.length > 0) this.#startIfAutoProceed();
    }
    removeFiles(fileIDs) {
        const { files: files, currentUploads: currentUploads } = this.getState();
        const updatedFiles = {
            ...files
        };
        const updatedUploads = {
            ...currentUploads
        };
        const removedFiles = Object.create(null);
        fileIDs.forEach((fileID)=>{
            if (files[fileID]) {
                removedFiles[fileID] = files[fileID];
                delete updatedFiles[fileID];
            }
        });
        // Remove files from the `fileIDs` list in each upload.
        function fileIsNotRemoved(uploadFileID) {
            return removedFiles[uploadFileID] === undefined;
        }
        Object.keys(updatedUploads).forEach((uploadID)=>{
            const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved);
            // Remove the upload if no files are associated with it anymore.
            if (newFileIDs.length === 0) {
                delete updatedUploads[uploadID];
                return;
            }
            const { capabilities: capabilities } = this.getState();
            if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation) throw new Error('The installed uploader plugin does not allow removing files during an upload.');
            updatedUploads[uploadID] = {
                ...currentUploads[uploadID],
                fileIDs: newFileIDs
            };
        });
        const stateUpdate = {
            currentUploads: updatedUploads,
            files: updatedFiles
        };
        // If all files were removed - allow new uploads,
        // and clear recoveredState
        if (Object.keys(updatedFiles).length === 0) {
            stateUpdate.allowNewUpload = true;
            stateUpdate.error = null;
            stateUpdate.recoveredState = null;
        }
        this.setState(stateUpdate);
        this.#updateTotalProgressThrottled();
        const removedFileIDs = Object.keys(removedFiles);
        removedFileIDs.forEach((fileID)=>{
            this.emit('file-removed', removedFiles[fileID]);
        });
        if (removedFileIDs.length > 5) this.log(`Removed ${removedFileIDs.length} files`);
        else this.log(`Removed files: ${removedFileIDs.join(', ')}`);
    }
    removeFile(fileID) {
        this.removeFiles([
            fileID
        ]);
    }
    pauseResume(fileID) {
        if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).progress.uploadComplete) return undefined;
        const file = this.getFile(fileID);
        const wasPaused = file.isPaused || false;
        const isPaused = !wasPaused;
        this.setFileState(fileID, {
            isPaused: isPaused
        });
        this.emit('upload-pause', file, isPaused);
        return isPaused;
    }
    pauseAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: true
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit('pause-all');
    }
    resumeAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit('resume-all');
    }
    #getFilesToRetry() {
        const { files: files } = this.getState();
        return Object.keys(files).filter((fileId)=>{
            const file = files[fileId];
            // Only retry files that have errors AND don't have missing required metadata
            return file.error && (!file.missingRequiredMetaFields || file.missingRequiredMetaFields.length === 0);
        });
    }
    async #doRetryAll() {
        const filesToRetry = this.#getFilesToRetry();
        const updatedFiles = {
            ...this.getState().files
        };
        filesToRetry.forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...updatedFiles[fileID],
                isPaused: false,
                error: null
            };
        });
        this.setState({
            files: updatedFiles,
            error: null
        });
        this.emit('retry-all', this.getFilesByIds(filesToRetry));
        if (filesToRetry.length === 0) return {
            successful: [],
            failed: []
        };
        const uploadID = this.#createUpload(filesToRetry, {
            forceAllowNewUpload: true
        });
        return this.#runUpload(uploadID);
    }
    async retryAll() {
        const result = await this.#doRetryAll();
        this.emit('complete', result);
        return result;
    }
    cancelAll() {
        this.emit('cancel-all');
        const { files: files } = this.getState();
        const fileIDs = Object.keys(files);
        if (fileIDs.length) this.removeFiles(fileIDs);
        this.setState($b16b91c7840d3bff$var$defaultUploadState);
    }
    retryUpload(fileID) {
        this.setFileState(fileID, {
            error: null,
            isPaused: false
        });
        this.emit('upload-retry', this.getFile(fileID));
        const uploadID = this.#createUpload([
            fileID
        ], {
            forceAllowNewUpload: true
        });
        return this.#runUpload(uploadID);
    }
    logout() {
        this.iteratePlugins((plugin)=>{
            plugin.provider?.logout?.();
        });
    }
    #handleUploadProgress = (file, progress)=>{
        const fileInState = file ? this.getFile(file.id) : undefined;
        if (file == null || !fileInState) {
            this.log(`Not setting progress for a file that has been removed: ${file?.id}`);
            return;
        }
        if (fileInState.progress.percentage === 100) {
            this.log(`Not setting progress for a file that has been already uploaded: ${file.id}`);
            return;
        }
        const newProgress = {
            bytesTotal: progress.bytesTotal,
            // bytesTotal may be null or zero; in that case we can't divide by it
            percentage: progress.bytesTotal != null && Number.isFinite(progress.bytesTotal) && progress.bytesTotal > 0 ? Math.round(progress.bytesUploaded / progress.bytesTotal * 100) : undefined
        };
        if (fileInState.progress.uploadStarted != null) this.setFileState(file.id, {
            progress: {
                ...fileInState.progress,
                ...newProgress,
                bytesUploaded: progress.bytesUploaded
            }
        });
        else this.setFileState(file.id, {
            progress: {
                ...fileInState.progress,
                ...newProgress
            }
        });
        this.#updateTotalProgressThrottled();
    };
    #updateTotalProgress() {
        const totalProgress = this.#calculateTotalProgress();
        let totalProgressPercent = null;
        if (totalProgress != null) {
            totalProgressPercent = Math.round(totalProgress * 100);
            if (totalProgressPercent > 100) totalProgressPercent = 100;
            else if (totalProgressPercent < 0) totalProgressPercent = 0;
        }
        this.emit('progress', totalProgressPercent ?? 0);
        this.setState({
            totalProgress: totalProgressPercent ?? 0
        });
    }
    // ___Why throttle at 500ms?
    //    - We must throttle at >250ms for superfocus in Dashboard to work well
    //    (because animation takes 0.25s, and we want to wait for all animations to be over before refocusing).
    //    [Practical Check]: if thottle is at 100ms, then if you are uploading a file,
    //    and click 'ADD MORE FILES', - focus won't activate in Firefox.
    //    - We must throttle at around >500ms to avoid performance lags.
    //    [Practical Check] Firefox, try to upload a big file for a prolonged period of time. Laptop will start to heat up.
    #updateTotalProgressThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($a50c1ad1c2867517$exports)))(()=>this.#updateTotalProgress(), 500, {
        leading: true,
        trailing: true
    });
    [Symbol.for('uppy test: updateTotalProgress')]() {
        return this.#updateTotalProgress();
    }
    #calculateTotalProgress() {
        // calculate total progress, using the number of files currently uploading,
        // between 0 and 1 and sum of individual progress of each file
        const files = this.getFiles();
        // note: also includes files that have completed uploading:
        const filesInProgress = files.filter((file)=>{
            return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
        });
        if (filesInProgress.length === 0) return 0;
        if (filesInProgress.every((file)=>file.progress.uploadComplete)) // If every uploading file is complete, and we're still getting progress, it probably means
        // there's a bug somewhere in some progress reporting code (maybe not even our code)
        // and we're still getting progress, so let's just assume it means a 100% progress
        return 1;
        const isSizedFile = (file)=>file.progress.bytesTotal != null && file.progress.bytesTotal !== 0;
        const sizedFilesInProgress = filesInProgress.filter(isSizedFile);
        const unsizedFilesInProgress = filesInProgress.filter((file)=>!isSizedFile(file));
        if (sizedFilesInProgress.every((file)=>file.progress.uploadComplete) && unsizedFilesInProgress.length > 0 && !unsizedFilesInProgress.every((file)=>file.progress.uploadComplete)) // we are done with uploading all files of known size, however
        // there is at least one file with unknown size still uploading,
        // and we cannot say anything about their progress
        // In any case, return null because it doesn't make any sense to show a progress
        return null;
        const totalFilesSize = sizedFilesInProgress.reduce((acc, file)=>acc + (file.progress.bytesTotal ?? 0), 0);
        const totalUploadedSize = sizedFilesInProgress.reduce((acc, file)=>acc + (file.progress.bytesUploaded || 0), 0);
        return totalFilesSize === 0 ? 0 : totalUploadedSize / totalFilesSize;
    }
    /**
     * Registers listeners for all global actions, like:
     * `error`, `file-removed`, `upload-progress`
     */ #addListeners() {
        // Type inference only works for inline functions so we have to type it again
        const errorHandler = (error, file, response)=>{
            let errorMsg = error.message || 'Unknown error';
            if (error.details) errorMsg += ` ${error.details}`;
            this.setState({
                error: errorMsg
            });
            if (file != null && file.id in this.getState().files) this.setFileState(file.id, {
                error: errorMsg,
                response: response
            });
        };
        this.on('error', errorHandler);
        this.on('upload-error', (file, error, response)=>{
            errorHandler(error, file, response);
            if (typeof error === 'object' && error.message) {
                this.log(error.message, 'error');
                const newError = new Error(this.i18n('failedToUpload', {
                    file: file?.name ?? ''
                })); // we may want a new custom error here
                newError.isUserFacing = true; // todo maybe don't do this with all errors?
                newError.details = error.message;
                if (error.details) newError.details += ` ${error.details}`;
                this.#informAndEmit([
                    newError
                ]);
            } else this.#informAndEmit([
                error
            ]);
        });
        let uploadStalledWarningRecentlyEmitted = null;
        this.on('upload-stalled', (error, files)=>{
            const { message: message } = error;
            const details = files.map((file)=>file.meta.name).join(', ');
            if (!uploadStalledWarningRecentlyEmitted) {
                this.info({
                    message: message,
                    details: details
                }, 'warning', this.opts.infoTimeout);
                uploadStalledWarningRecentlyEmitted = setTimeout(()=>{
                    uploadStalledWarningRecentlyEmitted = null;
                }, this.opts.infoTimeout);
            }
            this.log(`${message} ${details}`.trim(), 'warning');
        });
        this.on('upload', ()=>{
            this.setState({
                error: null
            });
        });
        const onUploadStarted = (files)=>{
            const filesFiltered = files.filter((file)=>{
                const exists = file != null && this.getFile(file.id);
                if (!exists) this.log(`Not setting progress for a file that has been removed: ${file?.id}`);
                return exists;
            });
            const filesState = Object.fromEntries(filesFiltered.map((file)=>[
                    file.id,
                    {
                        progress: {
                            uploadStarted: Date.now(),
                            uploadComplete: false,
                            bytesUploaded: 0,
                            bytesTotal: file.size
                        }
                    }
                ]));
            this.patchFilesState(filesState);
        };
        this.on('upload-start', onUploadStarted);
        this.on('upload-progress', this.#handleUploadProgress);
        this.on('upload-success', (file, uploadResp)=>{
            if (file == null || !this.getFile(file.id)) {
                this.log(`Not setting progress for a file that has been removed: ${file?.id}`);
                return;
            }
            const currentProgress = this.getFile(file.id).progress;
            this.setFileState(file.id, {
                progress: {
                    ...currentProgress,
                    postprocess: this.#postProcessors.size > 0 ? {
                        mode: 'indeterminate'
                    } : undefined,
                    uploadComplete: true,
                    percentage: 100,
                    bytesUploaded: currentProgress.bytesTotal
                },
                response: uploadResp,
                uploadURL: uploadResp.uploadURL,
                isPaused: false
            });
            // Remote providers sometimes don't tell us the file size,
            // but we can know how many bytes we uploaded once the upload is complete.
            if (file.size == null) this.setFileState(file.id, {
                size: uploadResp.bytesUploaded || currentProgress.bytesTotal
            });
            this.#updateTotalProgressThrottled();
        });
        this.on('preprocess-progress', (file, progress)=>{
            if (file == null || !this.getFile(file.id)) {
                this.log(`Not setting progress for a file that has been removed: ${file?.id}`);
                return;
            }
            this.setFileState(file.id, {
                progress: {
                    ...this.getFile(file.id).progress,
                    preprocess: progress
                }
            });
        });
        this.on('preprocess-complete', (file)=>{
            if (file == null || !this.getFile(file.id)) {
                this.log(`Not setting progress for a file that has been removed: ${file?.id}`);
                return;
            }
            const files = {
                ...this.getState().files
            };
            files[file.id] = {
                ...files[file.id],
                progress: {
                    ...files[file.id].progress
                }
            };
            delete files[file.id].progress.preprocess;
            this.setState({
                files: files
            });
        });
        this.on('postprocess-progress', (file, progress)=>{
            if (file == null || !this.getFile(file.id)) {
                this.log(`Not setting progress for a file that has been removed: ${file?.id}`);
                return;
            }
            this.setFileState(file.id, {
                progress: {
                    ...this.getState().files[file.id].progress,
                    postprocess: progress
                }
            });
        });
        this.on('postprocess-complete', (file)=>{
            if (file == null || !this.getFile(file.id)) {
                this.log(`Not setting progress for a file that has been removed: ${file?.id}`);
                return;
            }
            const files = {
                ...this.getState().files
            };
            files[file.id] = {
                ...files[file.id],
                progress: {
                    ...files[file.id].progress
                }
            };
            delete files[file.id].progress.postprocess;
            this.setState({
                files: files
            });
        });
        this.on('restored', ()=>{
            // Files may have changed--ensure progress is still accurate.
            this.#updateTotalProgressThrottled();
        });
        // @ts-expect-error should fix itself when dashboard it typed (also this doesn't belong here)
        this.on('dashboard:file-edit-complete', (file)=>{
            if (file) this.#checkRequiredMetaFieldsOnFile(file);
        });
        // show informer if offline
        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('online', this.#updateOnlineStatus);
            window.addEventListener('offline', this.#updateOnlineStatus);
            setTimeout(this.#updateOnlineStatus, 3000);
        }
    }
    updateOnlineStatus() {
        const online = window.navigator.onLine ?? true;
        if (!online) {
            this.emit('is-offline');
            this.info(this.i18n('noInternetConnection'), 'error', 0);
            this.wasOffline = true;
        } else {
            this.emit('is-online');
            if (this.wasOffline) {
                this.emit('back-online');
                this.info(this.i18n('connectedToInternet'), 'success', 3000);
                this.wasOffline = false;
            }
        }
    }
    #updateOnlineStatus = this.updateOnlineStatus.bind(this);
    getID() {
        return this.opts.id;
    }
    /**
     * Registers a plugin with Core.
     */ use(Plugin, // We want to let the plugin decide whether `opts` is optional or not
    // so we spread the argument rather than defining `opts:` ourselves.
    ...args) {
        if (typeof Plugin !== 'function') {
            const msg = `Expected a plugin class, but got ${Plugin === null ? 'null' : typeof Plugin}.` + ' Please verify that the plugin was imported and spelled correctly.';
            throw new TypeError(msg);
        }
        // Instantiate
        const plugin = new Plugin(this, ...args);
        const pluginId = plugin.id;
        if (!pluginId) throw new Error('Your plugin must have an id');
        if (!plugin.type) throw new Error('Your plugin must have a type');
        const existsPluginAlready = this.getPlugin(pluginId);
        if (existsPluginAlready) {
            const msg = `Already found a plugin named '${existsPluginAlready.id}'. ` + `Tried to use: '${pluginId}'.\n` + 'Uppy plugins must have unique `id` options.';
            throw new Error(msg);
        }
        // @ts-expect-error does exist
        if (Plugin.VERSION) // @ts-expect-error does exist
        this.log(`Using ${pluginId} v${Plugin.VERSION}`);
        if (plugin.type in this.#plugins) this.#plugins[plugin.type].push(plugin);
        else this.#plugins[plugin.type] = [
            plugin
        ];
        plugin.install();
        this.emit('plugin-added', plugin);
        return this;
    }
    /**
     * Find one Plugin by name.
     */ getPlugin(id) {
        for (const plugins of Object.values(this.#plugins)){
            const foundPlugin = plugins.find((plugin)=>plugin.id === id);
            if (foundPlugin != null) return foundPlugin;
        }
        return undefined;
    }
    [Symbol.for('uppy test: getPlugins')](type) {
        return this.#plugins[type];
    }
    /**
     * Iterate through all `use`d plugins.
     *
     */ iteratePlugins(method) {
        Object.values(this.#plugins).flat(1).forEach(method);
    }
    /**
     * Uninstall and remove a plugin.
     *
     * @param {object} instance The plugin instance to remove.
     */ removePlugin(instance) {
        this.log(`Removing plugin ${instance.id}`);
        this.emit('plugin-remove', instance);
        if (instance.uninstall) instance.uninstall();
        const list = this.#plugins[instance.type];
        // list.indexOf failed here, because Vue3 converted the plugin instance
        // to a Proxy object, which failed the strict comparison test:
        // obj !== objProxy
        const index = list.findIndex((item)=>item.id === instance.id);
        if (index !== -1) list.splice(index, 1);
        const state = this.getState();
        const updatedState = {
            plugins: {
                ...state.plugins,
                [instance.id]: undefined
            }
        };
        this.setState(updatedState);
    }
    /**
     * Uninstall all plugins and close down this Uppy instance.
     */ destroy() {
        this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`);
        this.cancelAll();
        this.#storeUnsubscribe();
        this.iteratePlugins((plugin)=>{
            this.removePlugin(plugin);
        });
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('online', this.#updateOnlineStatus);
            window.removeEventListener('offline', this.#updateOnlineStatus);
        }
    }
    hideInfo() {
        const { info: info } = this.getState();
        this.setState({
            info: info.slice(1)
        });
        this.emit('info-hidden');
    }
    /**
     * Set info message in `state.info`, so that UI plugins like `Informer`
     * can display the message.
     */ info(message, type = 'info', duration = 3000) {
        const isComplexMessage = typeof message === 'object';
        this.setState({
            info: [
                ...this.getState().info,
                {
                    type: type,
                    message: isComplexMessage ? message.message : message,
                    details: isComplexMessage ? message.details : null
                }
            ]
        });
        setTimeout(()=>this.hideInfo(), duration);
        this.emit('info-visible');
    }
    /**
     * Passes messages to a function, provided in `opts.logger`.
     * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
     */ log(message, type) {
        const { logger: logger } = this.opts;
        switch(type){
            case 'error':
                logger.error(message);
                break;
            case 'warning':
                logger.warn(message);
                break;
            default:
                logger.debug(message);
                break;
        }
    }
    // We need to store request clients by a unique ID, so we can share RequestClient instances across files
    // this allows us to do rate limiting and synchronous operations like refreshing provider tokens
    // example: refreshing tokens: if each file has their own requestclient,
    // we don't have any way to synchronize all requests in order to
    // - block all requests
    // - refresh the token
    // - unblock all requests and allow them to run with a the new access token
    // back when we had a requestclient per file, once an access token expired,
    // all 6 files would go ahead and refresh the token at the same time
    // (calling /refresh-token up to 6 times), which will probably fail for some providers
    #requestClientById = new Map();
    registerRequestClient(id, client) {
        this.#requestClientById.set(id, client);
    }
    /** @protected */ getRequestClientForFile(file) {
        if (!file.remote) throw new Error(`Tried to get RequestClient for a non-remote file ${file.id}`);
        const requestClient = this.#requestClientById.get(file.remote.requestClientId);
        if (requestClient == null) throw new Error(`requestClientId "${file.remote.requestClientId}" not registered for file "${file.id}"`);
        return requestClient;
    }
    /**
     * Restore an upload by its ID.
     */ restore(uploadID) {
        this.log(`Core: attempting to restore upload "${uploadID}"`);
        if (!this.getState().currentUploads[uploadID]) {
            this.#removeUpload(uploadID);
            return Promise.reject(new Error('Nonexistent upload'));
        }
        return this.#runUpload(uploadID);
    }
    /**
     * Create an upload for a bunch of files.
     *
     */ #createUpload(fileIDs, opts = {}) {
        // uppy.retryAll sets this to true — when retrying we want to ignore `allowNewUpload: false`
        const { forceAllowNewUpload: forceAllowNewUpload = false } = opts;
        const { allowNewUpload: allowNewUpload, currentUploads: currentUploads } = this.getState();
        if (!allowNewUpload && !forceAllowNewUpload) throw new Error('Cannot create a new upload: already uploading.');
        const uploadID = (0, $3c82c89e950acc97$export$ac4959f4f1338dfc)();
        this.emit('upload', uploadID, this.getFilesByIds(fileIDs));
        this.setState({
            allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
            currentUploads: {
                ...currentUploads,
                [uploadID]: {
                    fileIDs: fileIDs,
                    step: 0,
                    result: {}
                }
            }
        });
        return uploadID;
    }
    [Symbol.for('uppy test: createUpload')](...args) {
        // @ts-expect-error https://github.com/microsoft/TypeScript/issues/47595
        return this.#createUpload(...args);
    }
    #getUpload(uploadID) {
        const { currentUploads: currentUploads } = this.getState();
        return currentUploads[uploadID];
    }
    /**
     * Add data to an upload's result object.
     */ addResultData(uploadID, data) {
        if (!this.#getUpload(uploadID)) {
            this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
            return;
        }
        const { currentUploads: currentUploads } = this.getState();
        const currentUpload = {
            ...currentUploads[uploadID],
            result: {
                ...currentUploads[uploadID].result,
                ...data
            }
        };
        this.setState({
            currentUploads: {
                ...currentUploads,
                [uploadID]: currentUpload
            }
        });
    }
    /**
     * Remove an upload, eg. if it has been canceled or completed.
     *
     */ #removeUpload(uploadID) {
        const currentUploads = {
            ...this.getState().currentUploads
        };
        delete currentUploads[uploadID];
        this.setState({
            currentUploads: currentUploads
        });
    }
    /**
     * Run an upload. This picks up where it left off in case the upload is being restored.
     */ async #runUpload(uploadID) {
        const getCurrentUpload = ()=>{
            const { currentUploads: currentUploads } = this.getState();
            return currentUploads[uploadID];
        };
        let currentUpload = getCurrentUpload();
        const steps = [
            ...this.#preProcessors,
            ...this.#uploaders,
            ...this.#postProcessors
        ];
        try {
            for(let step = currentUpload.step || 0; step < steps.length; step++){
                if (!currentUpload) break;
                const fn = steps[step];
                this.setState({
                    currentUploads: {
                        ...this.getState().currentUploads,
                        [uploadID]: {
                            ...currentUpload,
                            step: step
                        }
                    }
                });
                const { fileIDs: fileIDs } = currentUpload;
                // TODO give this the `updatedUpload` object as its only parameter maybe?
                // Otherwise when more metadata may be added to the upload this would keep getting more parameters
                await fn(fileIDs, uploadID);
                // Update currentUpload value in case it was modified asynchronously.
                currentUpload = getCurrentUpload();
            }
        } catch (err) {
            this.#removeUpload(uploadID);
            throw err;
        }
        // Set result data.
        if (currentUpload) {
            // Mark postprocessing step as complete if necessary; this addresses a case where we might get
            // stuck in the postprocessing UI while the upload is fully complete.
            // If the postprocessing steps do not do any work, they may not emit postprocessing events at
            // all, and never mark the postprocessing as complete. This is fine on its own but we
            // introduced code in the @uppy/core upload-success handler to prepare postprocessing progress
            // state if any postprocessors are registered. That is to avoid a "flash of completed state"
            // before the postprocessing plugins can emit events.
            //
            // So, just in case an upload with postprocessing plugins *has* completed *without* emitting
            // postprocessing completion, we do it instead.
            currentUpload.fileIDs.forEach((fileID)=>{
                const file = this.getFile(fileID);
                if (file?.progress.postprocess) this.emit('postprocess-complete', file);
            });
            const files = currentUpload.fileIDs.map((fileID)=>this.getFile(fileID));
            const successful = files.filter((file)=>!file.error);
            const failed = files.filter((file)=>file.error);
            this.addResultData(uploadID, {
                successful: successful,
                failed: failed,
                uploadID: uploadID
            });
            // Update currentUpload value in case it was modified asynchronously.
            currentUpload = getCurrentUpload();
        }
        // Emit completion events.
        // This is in a separate function so that the `currentUploads` variable
        // always refers to the latest state. In the handler right above it refers
        // to an outdated object without the `.result` property.
        let result;
        if (currentUpload) {
            result = currentUpload.result;
            this.#removeUpload(uploadID);
        }
        if (result == null) {
            this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
            result = {
                successful: [],
                failed: [],
                uploadID: uploadID
            };
        }
        return result;
    }
    /**
     * Start an upload for all the files that are not currently being uploaded.
     */ async upload() {
        if (!this.#plugins.uploader?.length) this.log('No uploader type plugins are used', 'warning');
        let { files: files } = this.getState();
        // retry any failed files from a previous upload() call
        const filesToRetry = this.#getFilesToRetry();
        if (filesToRetry.length > 0) {
            const retryResult = await this.#doRetryAll(); // we don't want the complete event to fire
            const hasNewFiles = this.getFiles().filter((file)=>file.progress.uploadStarted == null).length > 0;
            // if no new files, make it idempotent and return
            if (!hasNewFiles) {
                this.emit('complete', retryResult);
                return retryResult;
            }
            ({ files: files } = this.getState());
        }
        // If no files to retry, proceed with original upload() behavior for new files
        const onBeforeUploadResult = this.opts.onBeforeUpload(files);
        if (onBeforeUploadResult === false) return Promise.reject(new Error('Not starting the upload because onBeforeUpload returned false'));
        if (onBeforeUploadResult && typeof onBeforeUploadResult === 'object') {
            files = onBeforeUploadResult;
            // Updating files in state, because uploader plugins receive file IDs,
            // and then fetch the actual file object from state
            this.setState({
                files: files
            });
        }
        return Promise.resolve().then(()=>this.#restricter.validateMinNumberOfFiles(files)).catch((err)=>{
            this.#informAndEmit([
                err
            ]);
            throw err;
        }).then(()=>{
            if (!this.#checkRequiredMetaFields(files)) throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n('missingRequiredMetaField'));
        }).catch((err)=>{
            // Doing this in a separate catch because we already emited and logged
            // all the errors in `checkRequiredMetaFields` so we only throw a generic
            // missing fields error here.
            throw err;
        }).then(async ()=>{
            const { currentUploads: currentUploads } = this.getState();
            // get a list of files that are currently assigned to uploads
            const currentlyUploadingFiles = Object.values(currentUploads).flatMap((curr)=>curr.fileIDs);
            const waitingFileIDs = [];
            Object.keys(files).forEach((fileID)=>{
                const file = this.getFile(fileID);
                // if the file hasn't started uploading and hasn't already been assigned to an upload..
                if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) waitingFileIDs.push(file.id);
            });
            const uploadID = this.#createUpload(waitingFileIDs);
            const result = await this.#runUpload(uploadID);
            this.emit('complete', result);
            return result;
        }).catch((err)=>{
            this.emit('error', err);
            this.log(err, 'error');
            throw err;
        });
    }
}
var $b16b91c7840d3bff$export$2e2bcd8739ae039 = $b16b91c7840d3bff$export$1c95bea2669f592b;


/**
 * Check if an object is a DOM element. Duck-typing based on `nodeType`.
 */ function $dcdea5a9bf8353ff$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    if (!('nodeType' in obj)) return false;
    return obj.nodeType === Node.ELEMENT_NODE;
}


function $1866f8238923bb5d$var$findDOMElement(element, context = document) {
    if (typeof element === 'string') return context.querySelector(element);
    if ((0, $dcdea5a9bf8353ff$export$2e2bcd8739ae039)(element)) return element;
    return null;
}
var $1866f8238923bb5d$export$2e2bcd8739ae039 = $1866f8238923bb5d$var$findDOMElement;


/**
 * Get the declared text direction for an element.
 */ function $82cce0c04a5d7a26$var$getTextDirection(element) {
    // There is another way to determine text direction using getComputedStyle(), as done here:
    // https://github.com/pencil-js/text-direction/blob/2a235ce95089b3185acec3b51313cbba921b3811/text-direction.js
    //
    // We do not use that approach because we are interested specifically in the _declared_ text direction.
    // If no text direction is declared, we have to provide our own explicit text direction so our
    // bidirectional CSS style sheets work.
    while(element && !element.dir)element = element.parentNode;
    return element?.dir;
}
var $82cce0c04a5d7a26$export$2e2bcd8739ae039 = $82cce0c04a5d7a26$var$getTextDirection;


var $4d2e93495e50cc85$var$n, $4d2e93495e50cc85$export$41c562ebe57d11e2, $4d2e93495e50cc85$var$u, $4d2e93495e50cc85$export$a8257692ac88316c, $4d2e93495e50cc85$var$i, $4d2e93495e50cc85$var$o, $4d2e93495e50cc85$var$r, $4d2e93495e50cc85$var$e, $4d2e93495e50cc85$var$f, $4d2e93495e50cc85$var$c, $4d2e93495e50cc85$var$s, $4d2e93495e50cc85$var$a, $4d2e93495e50cc85$var$h, $4d2e93495e50cc85$var$p = {}, $4d2e93495e50cc85$var$v = [], $4d2e93495e50cc85$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $4d2e93495e50cc85$var$d = Array.isArray;
function $4d2e93495e50cc85$var$w(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $4d2e93495e50cc85$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $4d2e93495e50cc85$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, e = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = u[r];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $4d2e93495e50cc85$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === e[r] && (e[r] = l.defaultProps[r]);
    return $4d2e93495e50cc85$var$m(l, e, i, o, null);
}
function $4d2e93495e50cc85$var$m(n, t, i, o, r) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$4d2e93495e50cc85$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode && $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode(e), e;
}
function $4d2e93495e50cc85$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $4d2e93495e50cc85$export$ffb0004e005737fa(n) {
    return n.children;
}
function $4d2e93495e50cc85$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $4d2e93495e50cc85$var$S(n, l) {
    if (null == l) return n.__ ? $4d2e93495e50cc85$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $4d2e93495e50cc85$var$S(n) : null;
}
function $4d2e93495e50cc85$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $4d2e93495e50cc85$var$C(n);
    }
}
function $4d2e93495e50cc85$var$M(n) {
    (!n.__d && (n.__d = !0) && $4d2e93495e50cc85$var$i.push(n) && !$4d2e93495e50cc85$var$$.__r++ || $4d2e93495e50cc85$var$o != $4d2e93495e50cc85$export$41c562ebe57d11e2.debounceRendering) && (($4d2e93495e50cc85$var$o = $4d2e93495e50cc85$export$41c562ebe57d11e2.debounceRendering) || $4d2e93495e50cc85$var$r)($4d2e93495e50cc85$var$$);
}
function $4d2e93495e50cc85$var$$() {
    for(var n, u, t, o, r, f, c, s = 1; $4d2e93495e50cc85$var$i.length;)$4d2e93495e50cc85$var$i.length > s && $4d2e93495e50cc85$var$i.sort($4d2e93495e50cc85$var$e), n = $4d2e93495e50cc85$var$i.shift(), s = $4d2e93495e50cc85$var$i.length, n.__d && (t = void 0, o = void 0, r = (o = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $4d2e93495e50cc85$var$w({}, o)).__v = o.__v + 1, $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode && $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode(t), $4d2e93495e50cc85$var$O(u.__P, t, o, u.__n, u.__P.namespaceURI, 32 & o.__u ? [
        r
    ] : null, f, null == r ? $4d2e93495e50cc85$var$S(o) : r, !!(32 & o.__u), c), t.__v = o.__v, t.__.__k[t.__i] = t, $4d2e93495e50cc85$var$N(f, t, c), o.__e = o.__ = null, t.__e != r && $4d2e93495e50cc85$var$C(t)));
    $4d2e93495e50cc85$var$$.__r = 0;
}
function $4d2e93495e50cc85$var$I(n, l, u, t, i, o, r, e, f, c, s) {
    var a, h, y, d, w, g, _, m = t && t.__k || $4d2e93495e50cc85$var$v, b = l.length;
    for(f = $4d2e93495e50cc85$var$P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $4d2e93495e50cc85$var$p : m[y.__i] || $4d2e93495e50cc85$var$p, y.__i = a, g = $4d2e93495e50cc85$var$O(n, y, h, i, o, r, e, f, c, s), d = y.__e, y.ref && h.ref != y.ref && (h.ref && $4d2e93495e50cc85$var$B(h.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $4d2e93495e50cc85$var$A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : d && (f = d.nextSibling), y.__u &= -7);
    return u.__e = w, f;
}
function $4d2e93495e50cc85$var$P(n, l, u, t, i) {
    var o, r, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), o = 0; o < i; o++)null != (r = l[o]) && "boolean" != typeof r && "function" != typeof r ? ("string" == typeof r || "number" == typeof r || "bigint" == typeof r || r.constructor == String ? r = n.__k[o] = $4d2e93495e50cc85$var$m(null, r, null, null, null) : $4d2e93495e50cc85$var$d(r) ? r = n.__k[o] = $4d2e93495e50cc85$var$m($4d2e93495e50cc85$export$ffb0004e005737fa, {
        children: r
    }, null, null, null) : void 0 === r.constructor && r.__b > 0 ? r = n.__k[o] = $4d2e93495e50cc85$var$m(r.type, r.props, r.key, r.ref ? r.ref : null, r.__v) : n.__k[o] = r, f = o + h, r.__ = n, r.__b = n.__b + 1, e = null, -1 != (c = r.__i = $4d2e93495e50cc85$var$L(r, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof r.type && (r.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, r.__u |= 4))) : n.__k[o] = null;
    if (a) for(o = 0; o < s; o++)null != (e = u[o]) && 0 == (2 & e.__u) && (e.__e == t && (t = $4d2e93495e50cc85$var$S(e)), $4d2e93495e50cc85$var$D(e, e));
    return t;
}
function $4d2e93495e50cc85$var$A(n, l, u, t) {
    var i, o;
    if ("function" == typeof n.type) {
        for(i = n.__k, o = 0; i && o < i.length; o++)i[o] && (i[o].__ = n, l = $4d2e93495e50cc85$var$A(i[o], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $4d2e93495e50cc85$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $4d2e93495e50cc85$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($4d2e93495e50cc85$var$d(n) ? n.some(function(n) {
        $4d2e93495e50cc85$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $4d2e93495e50cc85$var$L(n, l, u, t) {
    var i, o, r, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, o = u + 1; i >= 0 || o < l.length;)if (null != (c = l[r = i >= 0 ? i-- : o++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return r;
    }
    return -1;
}
function $4d2e93495e50cc85$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $4d2e93495e50cc85$var$y.test(l) ? u : u + "px";
}
function $4d2e93495e50cc85$var$j(n, l, u, t, i) {
    var o, r;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $4d2e93495e50cc85$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $4d2e93495e50cc85$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) o = l != (l = l.replace($4d2e93495e50cc85$var$f, "$1")), r = l.toLowerCase(), l = r in n || "onFocusOut" == l || "onFocusIn" == l ? r.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $4d2e93495e50cc85$var$c, n.addEventListener(l, o ? $4d2e93495e50cc85$var$a : $4d2e93495e50cc85$var$s, o)) : n.removeEventListener(l, o ? $4d2e93495e50cc85$var$a : $4d2e93495e50cc85$var$s, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $4d2e93495e50cc85$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $4d2e93495e50cc85$var$c++;
            else if (u.t < t.u) return;
            return t($4d2e93495e50cc85$export$41c562ebe57d11e2.event ? $4d2e93495e50cc85$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $4d2e93495e50cc85$var$O(n, u, t, i, o, r, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        f = u.__e = t.__e
    ]), (a = $4d2e93495e50cc85$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $4d2e93495e50cc85$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $4d2e93495e50cc85$var$E), C && C.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $4d2e93495e50cc85$var$w({}, h.__s)), $4d2e93495e50cc85$var$w(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M)) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $4d2e93495e50cc85$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $4d2e93495e50cc85$var$w($4d2e93495e50cc85$var$w({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $4d2e93495e50cc85$export$ffb0004e005737fa && null == a.key && (L = $4d2e93495e50cc85$var$V(a.props.children)), f = $4d2e93495e50cc85$var$I(n, $4d2e93495e50cc85$var$d(L) ? L : [
            L
        ], u, t, i, o, r, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                r[r.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = r.length; T--;)$4d2e93495e50cc85$var$g(r[T]);
                $4d2e93495e50cc85$var$z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $4d2e93495e50cc85$var$z(u);
        $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $4d2e93495e50cc85$var$q(t.__e, u, t, i, o, r, e, c, s);
    return (a = $4d2e93495e50cc85$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $4d2e93495e50cc85$var$z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach($4d2e93495e50cc85$var$z);
}
function $4d2e93495e50cc85$var$N(n, u, t) {
    for(var i = 0; i < t.length; i++)$4d2e93495e50cc85$var$B(t[i], t[++i], t[++i]);
    $4d2e93495e50cc85$export$41c562ebe57d11e2.__c && $4d2e93495e50cc85$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $4d2e93495e50cc85$var$V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $4d2e93495e50cc85$var$d(n) ? n.map($4d2e93495e50cc85$var$V) : $4d2e93495e50cc85$var$w({}, n);
}
function $4d2e93495e50cc85$var$q(u, t, i, o, r, e, f, c, s) {
    var a, h, v, y, w, _, m, b = i.props || $4d2e93495e50cc85$var$p, k = t.props, x = t.type;
    if ("svg" == x ? r = "http://www.w3.org/2000/svg" : "math" == x ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((w = e[a]) && "setAttribute" in w == !!x && (x ? w.localName == x : 3 == w.nodeType)) {
            u = w, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(r, x, k.is && k), c && ($4d2e93495e50cc85$export$41c562ebe57d11e2.__m && $4d2e93495e50cc85$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $4d2e93495e50cc85$var$n.call(u.childNodes), !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(w = u.attributes[a]).name] = w.value;
        for(a in b)if (w = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = w;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $4d2e93495e50cc85$var$j(u, a, null, w, r);
        }
        for(a in k)w = k[a], "children" == a ? y = w : "dangerouslySetInnerHTML" == a ? h = w : "value" == a ? _ = w : "checked" == a ? m = w : c && "function" != typeof w || b[a] === w || $4d2e93495e50cc85$var$j(u, a, w, b[a], r);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $4d2e93495e50cc85$var$I("template" == t.type ? u.content : u, $4d2e93495e50cc85$var$d(y) ? y : [
            y
        ], t, i, o, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : r, e, f, e ? e[0] : i.__k && $4d2e93495e50cc85$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$4d2e93495e50cc85$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $4d2e93495e50cc85$var$j(u, a, _, b[a], r), a = "checked", null != m && m != u[a] && $4d2e93495e50cc85$var$j(u, a, m, b[a], r));
    }
    return u;
}
function $4d2e93495e50cc85$var$B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $4d2e93495e50cc85$var$D(n, u, t) {
    var i, o;
    if ($4d2e93495e50cc85$export$41c562ebe57d11e2.unmount && $4d2e93495e50cc85$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $4d2e93495e50cc85$var$B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $4d2e93495e50cc85$var$D(i[o], u, t || "function" != typeof n.type);
    t || $4d2e93495e50cc85$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $4d2e93495e50cc85$var$E(n, l, u) {
    return this.constructor(n, u);
}
function $4d2e93495e50cc85$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, e, f;
    t == document && (t = document.documentElement), $4d2e93495e50cc85$export$41c562ebe57d11e2.__ && $4d2e93495e50cc85$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $4d2e93495e50cc85$var$O(t, u = (!o && i || t).__k = $4d2e93495e50cc85$export$c8a8987d4410bf2d($4d2e93495e50cc85$export$ffb0004e005737fa, null, [
        u
    ]), r || $4d2e93495e50cc85$var$p, $4d2e93495e50cc85$var$p, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $4d2e93495e50cc85$var$n.call(t.childNodes) : null, e, !o && i ? i : r ? r.__e : t.firstChild, o, f), $4d2e93495e50cc85$var$N(e, u, f);
}
function $4d2e93495e50cc85$export$fa8d919ba61d84db(n, l) {
    $4d2e93495e50cc85$export$b3890eb0ae9dca99(n, l, $4d2e93495e50cc85$export$fa8d919ba61d84db);
}
function $4d2e93495e50cc85$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, e, f = $4d2e93495e50cc85$var$w({}, l.props);
    for(r in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = void 0 === u[r] && null != e ? e[r] : u[r];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $4d2e93495e50cc85$var$n.call(arguments, 2) : t), $4d2e93495e50cc85$var$m(l.type, f, i || l.key, o || l.ref, null);
}
function $4d2e93495e50cc85$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $4d2e93495e50cc85$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $4d2e93495e50cc85$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$4d2e93495e50cc85$var$n = $4d2e93495e50cc85$var$v.slice, $4d2e93495e50cc85$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $4d2e93495e50cc85$var$u = 0, $4d2e93495e50cc85$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $4d2e93495e50cc85$var$w({}, this.state), "function" == typeof n && (n = n($4d2e93495e50cc85$var$w({}, u), this.props)), n && $4d2e93495e50cc85$var$w(u, n), null != n && this.__v && (l && this._sb.push(l), $4d2e93495e50cc85$var$M(this));
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $4d2e93495e50cc85$var$M(this));
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.render = $4d2e93495e50cc85$export$ffb0004e005737fa, $4d2e93495e50cc85$var$i = [], $4d2e93495e50cc85$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $4d2e93495e50cc85$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $4d2e93495e50cc85$var$$.__r = 0, $4d2e93495e50cc85$var$f = /(PointerCapture)$|Capture$/i, $4d2e93495e50cc85$var$c = 0, $4d2e93495e50cc85$var$s = $4d2e93495e50cc85$var$F(!1), $4d2e93495e50cc85$var$a = $4d2e93495e50cc85$var$F(!0), $4d2e93495e50cc85$var$h = 0;



var $e28f05d17e052ff9$var$t, $e28f05d17e052ff9$var$r, $e28f05d17e052ff9$var$u, $e28f05d17e052ff9$var$i, $e28f05d17e052ff9$var$o = 0, $e28f05d17e052ff9$var$f = [], $e28f05d17e052ff9$var$c = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2), $e28f05d17e052ff9$var$e = $e28f05d17e052ff9$var$c.__b, $e28f05d17e052ff9$var$a = $e28f05d17e052ff9$var$c.__r, $e28f05d17e052ff9$var$v = $e28f05d17e052ff9$var$c.diffed, $e28f05d17e052ff9$var$l = $e28f05d17e052ff9$var$c.__c, $e28f05d17e052ff9$var$m = $e28f05d17e052ff9$var$c.unmount, $e28f05d17e052ff9$var$s = $e28f05d17e052ff9$var$c.__;
function $e28f05d17e052ff9$var$p(n, t) {
    $e28f05d17e052ff9$var$c.__h && $e28f05d17e052ff9$var$c.__h($e28f05d17e052ff9$var$r, n, $e28f05d17e052ff9$var$o || t), $e28f05d17e052ff9$var$o = 0;
    var u = $e28f05d17e052ff9$var$r.__H || ($e28f05d17e052ff9$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $e28f05d17e052ff9$export$60241385465d0a34(n) {
    return $e28f05d17e052ff9$var$o = 1, $e28f05d17e052ff9$export$13e3392192263954($e28f05d17e052ff9$var$D, n);
}
function $e28f05d17e052ff9$export$13e3392192263954(n, u, i) {
    var o = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $e28f05d17e052ff9$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $e28f05d17e052ff9$var$r, !$e28f05d17e052ff9$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $e28f05d17e052ff9$var$r.__f = !0;
        var c = $e28f05d17e052ff9$var$r.shouldComponentUpdate, e = $e28f05d17e052ff9$var$r.componentWillUpdate;
        $e28f05d17e052ff9$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $e28f05d17e052ff9$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $e28f05d17e052ff9$export$6d9c69b0de29b591(n, u) {
    var i = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 3);
    !$e28f05d17e052ff9$var$c.__s && $e28f05d17e052ff9$var$C(i.__H, u) && (i.__ = n, i.u = u, $e28f05d17e052ff9$var$r.__H.__h.push(i));
}
function $e28f05d17e052ff9$export$e5c5a5f917a5871c(n, u) {
    var i = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 4);
    !$e28f05d17e052ff9$var$c.__s && $e28f05d17e052ff9$var$C(i.__H, u) && (i.__ = n, i.u = u, $e28f05d17e052ff9$var$r.__h.push(i));
}
function $e28f05d17e052ff9$export$b8f5890fc79d6aca(n) {
    return $e28f05d17e052ff9$var$o = 5, $e28f05d17e052ff9$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $e28f05d17e052ff9$export$d5a552a76deda3c2(n, t, r) {
    $e28f05d17e052ff9$var$o = 6, $e28f05d17e052ff9$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $e28f05d17e052ff9$export$1538c33de8887b59(n, r) {
    var u = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 7);
    return $e28f05d17e052ff9$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $e28f05d17e052ff9$export$35808ee640e87ca7(n, t) {
    return $e28f05d17e052ff9$var$o = 8, $e28f05d17e052ff9$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $e28f05d17e052ff9$export$fae74005e78b1a27(n) {
    var u = $e28f05d17e052ff9$var$r.context[n.__c], i = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($e28f05d17e052ff9$var$r)), u.props.value) : n.__;
}
function $e28f05d17e052ff9$export$dc8fbce3eb94dc1e(n, t) {
    $e28f05d17e052ff9$var$c.useDebugValue && $e28f05d17e052ff9$var$c.useDebugValue(t ? t(n) : n);
}
function $e28f05d17e052ff9$export$c052f6604b7d51fe(n) {
    var u = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 10), i = $e28f05d17e052ff9$export$60241385465d0a34();
    return u.__ = n, $e28f05d17e052ff9$var$r.componentDidCatch || ($e28f05d17e052ff9$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $e28f05d17e052ff9$export$f680877a34711e37() {
    var n = $e28f05d17e052ff9$var$p($e28f05d17e052ff9$var$t++, 11);
    if (!n.__) {
        for(var u = $e28f05d17e052ff9$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $e28f05d17e052ff9$var$j() {
    for(var n; n = $e28f05d17e052ff9$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($e28f05d17e052ff9$var$z), n.__H.__h.forEach($e28f05d17e052ff9$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $e28f05d17e052ff9$var$c.__e(t, n.__v);
    }
}
$e28f05d17e052ff9$var$c.__b = function(n) {
    $e28f05d17e052ff9$var$r = null, $e28f05d17e052ff9$var$e && $e28f05d17e052ff9$var$e(n);
}, $e28f05d17e052ff9$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $e28f05d17e052ff9$var$s && $e28f05d17e052ff9$var$s(n, t);
}, $e28f05d17e052ff9$var$c.__r = function(n) {
    $e28f05d17e052ff9$var$a && $e28f05d17e052ff9$var$a(n), $e28f05d17e052ff9$var$t = 0;
    var i = ($e28f05d17e052ff9$var$r = n.__c).__H;
    i && ($e28f05d17e052ff9$var$u === $e28f05d17e052ff9$var$r ? (i.__h = [], $e28f05d17e052ff9$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($e28f05d17e052ff9$var$z), i.__h.forEach($e28f05d17e052ff9$var$B), i.__h = [], $e28f05d17e052ff9$var$t = 0)), $e28f05d17e052ff9$var$u = $e28f05d17e052ff9$var$r;
}, $e28f05d17e052ff9$var$c.diffed = function(n) {
    $e28f05d17e052ff9$var$v && $e28f05d17e052ff9$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $e28f05d17e052ff9$var$f.push(t) && $e28f05d17e052ff9$var$i === $e28f05d17e052ff9$var$c.requestAnimationFrame || (($e28f05d17e052ff9$var$i = $e28f05d17e052ff9$var$c.requestAnimationFrame) || $e28f05d17e052ff9$var$w)($e28f05d17e052ff9$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $e28f05d17e052ff9$var$u = $e28f05d17e052ff9$var$r = null;
}, $e28f05d17e052ff9$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($e28f05d17e052ff9$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $e28f05d17e052ff9$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $e28f05d17e052ff9$var$c.__e(r, n.__v);
        }
    }), $e28f05d17e052ff9$var$l && $e28f05d17e052ff9$var$l(n, t);
}, $e28f05d17e052ff9$var$c.unmount = function(n) {
    $e28f05d17e052ff9$var$m && $e28f05d17e052ff9$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $e28f05d17e052ff9$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $e28f05d17e052ff9$var$c.__e(t, r.__v));
};
var $e28f05d17e052ff9$var$k = "function" == typeof requestAnimationFrame;
function $e28f05d17e052ff9$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $e28f05d17e052ff9$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $e28f05d17e052ff9$var$k && (t = requestAnimationFrame(r));
}
function $e28f05d17e052ff9$var$z(n) {
    var t = $e28f05d17e052ff9$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $e28f05d17e052ff9$var$r = t;
}
function $e28f05d17e052ff9$var$B(n) {
    var t = $e28f05d17e052ff9$var$r;
    n.__c = n.__(), $e28f05d17e052ff9$var$r = t;
}
function $e28f05d17e052ff9$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $e28f05d17e052ff9$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $2c57945ee961e217$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $2c57945ee961e217$var$E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $2c57945ee961e217$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $e28f05d17e052ff9$export$60241385465d0a34)({
        t: {
            __: e,
            u: t
        }
    }), u = r[0].t, o = r[1];
    return (0, $e28f05d17e052ff9$export$e5c5a5f917a5871c)(function() {
        u.__ = e, u.u = t, $2c57945ee961e217$var$x(u) && o({
            t: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(function() {
        return $2c57945ee961e217$var$x(u) && o({
            t: u
        }), n(function() {
            $2c57945ee961e217$var$x(u) && o({
                t: u
            });
        });
    }, [
        n
    ]), e;
}
function $2c57945ee961e217$var$x(n) {
    var t, e, r = n.u, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
function $2c57945ee961e217$export$7568632d0d33d16d(n) {
    n();
}
function $2c57945ee961e217$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $2c57945ee961e217$export$7b286972b8d8ccbf() {
    return [
        !1,
        $2c57945ee961e217$export$7568632d0d33d16d
    ];
}
var $2c57945ee961e217$export$aaabe4eda9ed9969 = (0, $e28f05d17e052ff9$export$e5c5a5f917a5871c);
function $2c57945ee961e217$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $2c57945ee961e217$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $2c57945ee961e217$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u.type = n, u;
}
($2c57945ee961e217$export$221d75b3f55bb0bd.prototype = new (0, $4d2e93495e50cc85$export$16fa2f45be04daa8)).isPureReactComponent = !0, $2c57945ee961e217$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $2c57945ee961e217$var$E(this.props, n) || $2c57945ee961e217$var$E(this.state, t);
};
var $2c57945ee961e217$var$T = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__b;
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $2c57945ee961e217$var$T && $2c57945ee961e217$var$T(n);
};
var $2c57945ee961e217$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $2c57945ee961e217$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $2c57945ee961e217$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $2c57945ee961e217$var$A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $2c57945ee961e217$var$L = function(n, t) {
    return null == n ? null : (0, $4d2e93495e50cc85$export$47e4c5b300681277)((0, $4d2e93495e50cc85$export$47e4c5b300681277)(n).map(t));
}, $2c57945ee961e217$export$dca3b0875bd9a954 = {
    map: $2c57945ee961e217$var$L,
    forEach: $2c57945ee961e217$var$L,
    count: function(n) {
        return n ? (0, $4d2e93495e50cc85$export$47e4c5b300681277)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $4d2e93495e50cc85$export$47e4c5b300681277)
}, $2c57945ee961e217$var$F = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__e;
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $2c57945ee961e217$var$F(n, t, e, r);
};
var $2c57945ee961e217$var$U = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).unmount;
function $2c57945ee961e217$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $2c57945ee961e217$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $2c57945ee961e217$var$V(n, t, e);
    })), n;
}
function $2c57945ee961e217$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $2c57945ee961e217$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $2c57945ee961e217$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $2c57945ee961e217$var$j(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $2c57945ee961e217$export$488013bae63b21da(n) {
    var e, r, u, o = null;
    function i(i) {
        if (e || (e = n()).then(function(n) {
            n && (o = n.default || n), u = !0;
        }, function(n) {
            r = n, u = !0;
        }), r) throw r;
        if (!u) throw e;
        return o ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(o, i) : null;
    }
    return i.displayName = "Lazy", i.__f = !0, i;
}
function $2c57945ee961e217$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $2c57945ee961e217$var$U && $2c57945ee961e217$var$U(n);
}, ($2c57945ee961e217$export$74bf444e3cd11ea5.prototype = new (0, $4d2e93495e50cc85$export$16fa2f45be04daa8)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.o && (r.o = []), r.o.push(e);
    var u = $2c57945ee961e217$var$j(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $2c57945ee961e217$var$W(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.o.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $2c57945ee961e217$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $2c57945ee961e217$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $2c57945ee961e217$var$V(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $2c57945ee961e217$var$H = function(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $2c57945ee961e217$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $2c57945ee961e217$var$Y(n) {
    var e = this, r = n.h;
    if (e.componentWillUnmount = function() {
        (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(null, e.v), e.v = null, e.h = null;
    }, e.h && e.h !== r && e.componentWillUnmount(), !e.v) {
        for(var u = e.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        e.h = r, e.v = {
            nodeType: 1,
            parentNode: r,
            childNodes: [],
            __k: {
                __m: u.__m
            },
            contains: function() {
                return !0;
            },
            insertBefore: function(n, t) {
                this.childNodes.push(n), e.h.insertBefore(n, t);
            },
            removeChild: function(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.h.removeChild(n);
            }
        };
    }
    (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)((0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($2c57945ee961e217$var$Z, {
        context: e.context
    }, n.__v), e.v);
}
function $2c57945ee961e217$export$d39a5bbd09211389(n, e) {
    var r = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($2c57945ee961e217$var$Y, {
        __v: n,
        h: e
    });
    return r.containerInfo = e, r;
}
($2c57945ee961e217$export$998bcd577473dd93.prototype = new (0, $4d2e93495e50cc85$export$16fa2f45be04daa8)).__a = function(n) {
    var t = this, e = $2c57945ee961e217$var$j(t.__v), r = t.l.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $2c57945ee961e217$var$H(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $2c57945ee961e217$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var t = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.l.set(t[e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $2c57945ee961e217$export$998bcd577473dd93.prototype.componentDidUpdate = $2c57945ee961e217$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.l.forEach(function(t, e) {
        $2c57945ee961e217$var$H(n, e, t);
    });
};
var $2c57945ee961e217$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $2c57945ee961e217$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $2c57945ee961e217$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $2c57945ee961e217$var$K = /[A-Z0-9]/g, $2c57945ee961e217$var$Q = "undefined" != typeof document, $2c57945ee961e217$var$X = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $2c57945ee961e217$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $2c57945ee961e217$export$fa8d919ba61d84db(n, t, e) {
    return (0, $4d2e93495e50cc85$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $4d2e93495e50cc85$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $4d2e93495e50cc85$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $2c57945ee961e217$var$en = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).event;
function $2c57945ee961e217$var$rn() {}
function $2c57945ee961e217$var$un() {
    return this.cancelBubble;
}
function $2c57945ee961e217$var$on() {
    return this.defaultPrevented;
}
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).event = function(n) {
    return $2c57945ee961e217$var$en && (n = $2c57945ee961e217$var$en(n)), n.persist = $2c57945ee961e217$var$rn, n.isPropagationStopped = $2c57945ee961e217$var$un, n.isDefaultPrevented = $2c57945ee961e217$var$on, n.nativeEvent = n;
};
var $2c57945ee961e217$var$ln, $2c57945ee961e217$var$cn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $2c57945ee961e217$var$fn = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).vnode;
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 === e.indexOf("-");
        for(var i in t){
            var l = t[i];
            if (!("value" === i && "defaultValue" in t && null == l || $2c57945ee961e217$var$Q && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var c = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === l ? l = "" : "translate" === c && "no" === l ? l = !1 : "o" === c[0] && "n" === c[1] ? "ondoubleclick" === c ? i = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || $2c57945ee961e217$var$X(t.type) ? "onfocus" === c ? i = "onfocusin" : "onblur" === c ? i = "onfocusout" : $2c57945ee961e217$var$J.test(i) && (i = c) : c = i = "oninput" : o && $2c57945ee961e217$var$G.test(i) ? i = i.replace($2c57945ee961e217$var$K, "-$&").toLowerCase() : null === l && (l = void 0), "oninput" === c && u[i = c] && (i = "oninputCapture"), u[i] = l;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $2c57945ee961e217$var$cn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $2c57945ee961e217$var$q, $2c57945ee961e217$var$fn && $2c57945ee961e217$var$fn(n);
};
var $2c57945ee961e217$var$an = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__r;
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__r = function(n) {
    $2c57945ee961e217$var$an && $2c57945ee961e217$var$an(n), $2c57945ee961e217$var$ln = n.__c;
};
var $2c57945ee961e217$var$sn = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).diffed;
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).diffed = function(n) {
    $2c57945ee961e217$var$sn && $2c57945ee961e217$var$sn(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $2c57945ee961e217$var$ln = null;
};
var $2c57945ee961e217$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $2c57945ee961e217$var$ln.__n[n.__c].props.value;
            },
            useCallback: (0, $e28f05d17e052ff9$export$35808ee640e87ca7),
            useContext: (0, $e28f05d17e052ff9$export$fae74005e78b1a27),
            useDebugValue: (0, $e28f05d17e052ff9$export$dc8fbce3eb94dc1e),
            useDeferredValue: $2c57945ee961e217$export$6a7bc4e911dc01cf,
            useEffect: (0, $e28f05d17e052ff9$export$6d9c69b0de29b591),
            useId: (0, $e28f05d17e052ff9$export$f680877a34711e37),
            useImperativeHandle: (0, $e28f05d17e052ff9$export$d5a552a76deda3c2),
            useInsertionEffect: $2c57945ee961e217$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $e28f05d17e052ff9$export$e5c5a5f917a5871c),
            useMemo: (0, $e28f05d17e052ff9$export$1538c33de8887b59),
            useReducer: (0, $e28f05d17e052ff9$export$13e3392192263954),
            useRef: (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca),
            useState: (0, $e28f05d17e052ff9$export$60241385465d0a34),
            useSyncExternalStore: $2c57945ee961e217$export$306c0aa65ff9ec16,
            useTransition: $2c57945ee961e217$export$7b286972b8d8ccbf
        }
    }
}, $2c57945ee961e217$export$83d89fbfd8236492 = "18.3.1";
function $2c57945ee961e217$export$d38cd72104c1f0e9(n) {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d).bind(null, n);
}
function $2c57945ee961e217$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $2c57945ee961e217$var$q;
}
function $2c57945ee961e217$export$9522e17588c12572(n) {
    return $2c57945ee961e217$export$a8257692ac88316c(n) && n.type === (0, $4d2e93495e50cc85$export$ffb0004e005737fa);
}
function $2c57945ee961e217$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $2c57945ee961e217$export$e530037191fcd5d7(n) {
    return $2c57945ee961e217$export$a8257692ac88316c(n) ? (0, $4d2e93495e50cc85$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $2c57945ee961e217$export$502457920280e6be(n) {
    return !!n.__k && ((0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(null, n), !0);
}
function $2c57945ee961e217$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $2c57945ee961e217$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $2c57945ee961e217$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $2c57945ee961e217$export$5f8d39834fd61797 = (0, $4d2e93495e50cc85$export$ffb0004e005737fa), $2c57945ee961e217$export$45a5e7f76e0caa8d = $2c57945ee961e217$export$a8257692ac88316c, $2c57945ee961e217$export$2e2bcd8739ae039 = {
    useState: (0, $e28f05d17e052ff9$export$60241385465d0a34),
    useId: (0, $e28f05d17e052ff9$export$f680877a34711e37),
    useReducer: (0, $e28f05d17e052ff9$export$13e3392192263954),
    useEffect: (0, $e28f05d17e052ff9$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $e28f05d17e052ff9$export$e5c5a5f917a5871c),
    useInsertionEffect: $2c57945ee961e217$export$aaabe4eda9ed9969,
    useTransition: $2c57945ee961e217$export$7b286972b8d8ccbf,
    useDeferredValue: $2c57945ee961e217$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $2c57945ee961e217$export$306c0aa65ff9ec16,
    startTransition: $2c57945ee961e217$export$7568632d0d33d16d,
    useRef: (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $e28f05d17e052ff9$export$d5a552a76deda3c2),
    useMemo: (0, $e28f05d17e052ff9$export$1538c33de8887b59),
    useCallback: (0, $e28f05d17e052ff9$export$35808ee640e87ca7),
    useContext: (0, $e28f05d17e052ff9$export$fae74005e78b1a27),
    useDebugValue: (0, $e28f05d17e052ff9$export$dc8fbce3eb94dc1e),
    version: "18.3.1",
    Children: $2c57945ee961e217$export$dca3b0875bd9a954,
    render: $2c57945ee961e217$export$b3890eb0ae9dca99,
    hydrate: $2c57945ee961e217$export$fa8d919ba61d84db,
    unmountComponentAtNode: $2c57945ee961e217$export$502457920280e6be,
    createPortal: $2c57945ee961e217$export$d39a5bbd09211389,
    createElement: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d),
    createContext: (0, $4d2e93495e50cc85$export$fd42f52fd3ae1109),
    createFactory: $2c57945ee961e217$export$d38cd72104c1f0e9,
    cloneElement: $2c57945ee961e217$export$e530037191fcd5d7,
    createRef: (0, $4d2e93495e50cc85$export$7d1e3a5e95ceca43),
    Fragment: (0, $4d2e93495e50cc85$export$ffb0004e005737fa),
    isValidElement: $2c57945ee961e217$export$a8257692ac88316c,
    isElement: $2c57945ee961e217$export$45a5e7f76e0caa8d,
    isFragment: $2c57945ee961e217$export$9522e17588c12572,
    isMemo: $2c57945ee961e217$export$56885ab8b9c456ab,
    findDOMNode: $2c57945ee961e217$export$466bfc07425424d5,
    Component: (0, $4d2e93495e50cc85$export$16fa2f45be04daa8),
    PureComponent: $2c57945ee961e217$export$221d75b3f55bb0bd,
    memo: $2c57945ee961e217$export$7c73462e0d25e514,
    forwardRef: $2c57945ee961e217$export$257a8862b851cb5b,
    flushSync: $2c57945ee961e217$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $2c57945ee961e217$export$c78a37762a8d58e1,
    StrictMode: $2c57945ee961e217$export$5f8d39834fd61797,
    Suspense: $2c57945ee961e217$export$74bf444e3cd11ea5,
    SuspenseList: $2c57945ee961e217$export$998bcd577473dd93,
    lazy: $2c57945ee961e217$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $2c57945ee961e217$export$ae55be85d98224ed
};


/**
 * Core plugin logic that all plugins share.
 *
 * BasePlugin does not contain DOM rendering so it can be used for plugins
 * without a user interface.
 *
 * See `Plugin` for the extended version with Preact rendering for interfaces.
 */ 
class $336df15d01030489$export$2e2bcd8739ae039 {
    uppy;
    opts;
    id;
    defaultLocale;
    i18n;
    i18nArray;
    type;
    VERSION;
    constructor(uppy, opts){
        this.uppy = uppy;
        this.opts = opts ?? {};
    }
    getPluginState() {
        const { plugins: plugins } = this.uppy.getState();
        return plugins?.[this.id] || {};
    }
    setPluginState(update) {
        const { plugins: plugins } = this.uppy.getState();
        this.uppy.setState({
            plugins: {
                ...plugins,
                [this.id]: {
                    ...plugins[this.id],
                    ...update
                }
            }
        });
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts
        };
        this.setPluginState(undefined); // so that UI re-renders with new options
        this.i18nInit();
    }
    i18nInit() {
        const translator = new (0, $a85fd1efd23057e0$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.uppy.locale,
            this.opts.locale
        ]);
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.setPluginState(undefined); // so that UI re-renders and we see the updated locale
    }
    /**
     * Extendable methods
     * ==================
     * These methods are here to serve as an overview of the extendable methods as well as
     * making them not conditional in use, such as `if (this.afterUpdate)`.
     */ addTarget(plugin) {
        throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
    }
    install() {}
    uninstall() {}
    update(state) {}
    // Called after every state update, after everything's mounted. Debounced.
    afterUpdate() {}
}


/**
 * Defer a frequent call to the microtask queue.
 */ function $5d08dd66a9cc6899$var$debounce(fn) {
    let calling = null;
    let latestArgs;
    return (...args)=>{
        latestArgs = args;
        if (!calling) calling = Promise.resolve().then(()=>{
            calling = null;
            // At this point `args` may be different from the most
            // recent state, if multiple calls happened since this task
            // was queued. So we use the `latestArgs`, which definitely
            // is the most recent call.
            return fn(...latestArgs);
        });
        return calling;
    };
}
/**
 * UIPlugin is the extended version of BasePlugin to incorporate rendering with Preact.
 * Use this for plugins that need a user interface.
 *
 * For plugins without an user interface, see BasePlugin.
 */ class $5d08dd66a9cc6899$var$UIPlugin extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    #updateUI;
    isTargetDOMEl;
    el;
    parent;
    title;
    getTargetPlugin(target) {
        let targetPlugin;
        if (typeof target?.addTarget === 'function') {
            // Targeting a plugin *instance*
            targetPlugin = target;
            if (!(targetPlugin instanceof $5d08dd66a9cc6899$var$UIPlugin)) console.warn(new Error('The provided plugin is not an instance of UIPlugin. This is an indication of a bug with the way Uppy is bundled.', {
                cause: {
                    targetPlugin: targetPlugin,
                    UIPlugin: $5d08dd66a9cc6899$var$UIPlugin
                }
            }));
        } else if (typeof target === 'function') {
            // Targeting a plugin type
            const Target = target;
            // Find the target plugin instance.
            this.uppy.iteratePlugins((p)=>{
                if (p instanceof Target) targetPlugin = p;
            });
        }
        return targetPlugin;
    }
    /**
     * Check if supplied `target` is a DOM element or an `object`.
     * If it’s an object — target is a plugin, and we search `plugins`
     * for a plugin with same name and return its target.
     */ mount(target, plugin) {
        const callerPluginName = plugin.id;
        const targetElement = (0, $1866f8238923bb5d$export$2e2bcd8739ae039)(target);
        if (targetElement) {
            this.isTargetDOMEl = true;
            // When target is <body> with a single <div> element,
            // Preact thinks it’s the Uppy root element in there when doing a diff,
            // and destroys it. So we are creating a fragment (could be empty div)
            const uppyRootElement = document.createElement('div');
            uppyRootElement.classList.add('uppy-Root');
            // API for plugins that require a synchronous rerender.
            this.#updateUI = $5d08dd66a9cc6899$var$debounce((state)=>{
                // plugin could be removed, but this.rerender is debounced below,
                // so it could still be called even after uppy.removePlugin or uppy.destroy
                // hence the check
                if (!this.uppy.getPlugin(this.id)) return;
                (0, $2c57945ee961e217$export$b3890eb0ae9dca99)(this.render(state, uppyRootElement), uppyRootElement);
                this.afterUpdate();
            });
            this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`);
            if (this.opts.replaceTargetContent) // Doing render(h(null), targetElement), which should have been
            // a better way, since because the component might need to do additional cleanup when it is removed,
            // stopped working — Preact just adds null into target, not replacing
            targetElement.innerHTML = '';
            (0, $2c57945ee961e217$export$b3890eb0ae9dca99)(this.render(this.uppy.getState(), uppyRootElement), uppyRootElement);
            this.el = uppyRootElement;
            targetElement.appendChild(uppyRootElement);
            // Set the text direction if the page has not defined one.
            uppyRootElement.dir = this.opts.direction || (0, $82cce0c04a5d7a26$export$2e2bcd8739ae039)(uppyRootElement) || 'ltr';
            this.onMount();
            return this.el;
        }
        const targetPlugin = this.getTargetPlugin(target);
        if (targetPlugin) {
            this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`);
            this.parent = targetPlugin;
            this.el = targetPlugin.addTarget(plugin);
            this.onMount();
            return this.el;
        }
        this.uppy.log(`Not installing ${callerPluginName}`);
        let message = `Invalid target option given to ${callerPluginName}.`;
        if (typeof target === 'function') message += " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly.";
        else message += "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.";
        throw new Error(message);
    }
    /**
     * Called when plugin is mounted, whether in DOM or into another plugin.
     * Needed because sometimes plugins are mounted separately/after `install`,
     * so this.el and this.parent might not be available in `install`.
     * This is the case with @uppy/react plugins, for example.
     */ render(state, container) {
        throw new Error('Extend the render method to add your plugin to a DOM element');
    }
    update(state) {
        if (this.el != null) this.#updateUI?.(state);
    }
    unmount() {
        if (this.isTargetDOMEl) this.el?.remove();
        this.onUnmount();
    }
    onMount() {}
    onUnmount() {}
}
var $5d08dd66a9cc6899$export$2e2bcd8739ae039 = $5d08dd66a9cc6899$var$UIPlugin;



var $1fd71c045d4a7be8$var$t = /["&<]/;
function $1fd71c045d4a7be8$var$n(r) {
    if (0 === r.length || !1 === $1fd71c045d4a7be8$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $1fd71c045d4a7be8$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $1fd71c045d4a7be8$var$f = 0, $1fd71c045d4a7be8$var$i = Array.isArray;
function $1fd71c045d4a7be8$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$1fd71c045d4a7be8$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).vnode && (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).vnode(l), l;
}
function $1fd71c045d4a7be8$export$45700d561b2268ac(r) {
    var t = $1fd71c045d4a7be8$export$34b9dba7ce09269b((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $1fd71c045d4a7be8$var$c = {}, $1fd71c045d4a7be8$var$p = /[A-Z]/g;
function $1fd71c045d4a7be8$export$991f6ffe102e5bac(e, t) {
    if ((0, $4d2e93495e50cc85$export$41c562ebe57d11e2).attr) {
        var f = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == typeof r && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $1fd71c045d4a7be8$var$c[u] || ($1fd71c045d4a7be8$var$c[u] = u.replace($1fd71c045d4a7be8$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $1fd71c045d4a7be8$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $1fd71c045d4a7be8$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $1fd71c045d4a7be8$var$n("" + t) + '"';
}
function $1fd71c045d4a7be8$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($1fd71c045d4a7be8$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $1fd71c045d4a7be8$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $1fd71c045d4a7be8$var$n("" + r);
}




var $cd482327f74531d9$exports = {};
$cd482327f74531d9$exports = JSON.parse("{\"name\":\"@uppy/informer\",\"description\":\"A notification and error pop-up bar for Uppy.\",\"version\":\"4.3.2\",\"license\":\"MIT\",\"main\":\"lib/index.js\",\"style\":\"dist/style.min.css\",\"type\":\"module\",\"scripts\":{\"build\":\"tsc --build tsconfig.build.json\",\"build:css\":\"sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css\",\"typecheck\":\"tsc --build\"},\"keywords\":[\"file uploader\",\"uppy\",\"uppy-plugin\",\"notification\",\"bar\",\"ui\"],\"homepage\":\"https://uppy.io\",\"bugs\":{\"url\":\"https://github.com/transloadit/uppy/issues\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/transloadit/uppy.git\"},\"files\":[\"src\",\"lib\",\"dist\",\"CHANGELOG.md\"],\"dependencies\":{\"@uppy/utils\":\"^6.2.2\",\"preact\":\"^10.5.13\"},\"peerDependencies\":{\"@uppy/core\":\"^4.5.2\"},\"devDependencies\":{\"cssnano\":\"^7.0.7\",\"postcss\":\"^8.5.6\",\"postcss-cli\":\"^11.0.1\",\"sass\":\"^1.89.2\",\"typescript\":\"^5.8.3\"}}");




const $aaa56faedf37f661$var$TRANSITION_MS = 300;
class $aaa56faedf37f661$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    ref = (0, $4d2e93495e50cc85$export$7d1e3a5e95ceca43)();
    componentWillEnter(callback) {
        this.ref.current.style.opacity = '1';
        this.ref.current.style.transform = 'none';
        setTimeout(callback, $aaa56faedf37f661$var$TRANSITION_MS);
    }
    componentWillLeave(callback) {
        this.ref.current.style.opacity = '0';
        this.ref.current.style.transform = 'translateY(350%)';
        setTimeout(callback, $aaa56faedf37f661$var$TRANSITION_MS);
    }
    render() {
        const { children: children } = this.props;
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: "uppy-Informer-animated",
            ref: this.ref,
            children: children
        });
    }
}


// INFO: not typing copy pasted libarary code
// @ts-nocheck
/**
 * @source https://github.com/developit/preact-transition-group
 */ 
function $39136bc8da03ed4c$var$assign(obj, props) {
    return Object.assign(obj, props);
}
function $39136bc8da03ed4c$var$getKey(vnode, fallback) {
    return vnode?.key ?? fallback;
}
function $39136bc8da03ed4c$var$linkRef(component, name) {
    // biome-ignore lint/suspicious/noAssignInExpressions: ...
    const cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
    return cache[name] || // biome-ignore lint/suspicious/noAssignInExpressions: ...
    (cache[name] = (c)=>{
        component.refs[name] = c;
    });
}
function $39136bc8da03ed4c$var$getChildMapping(children) {
    const out = {};
    for(let i = 0; i < children.length; i++)if (children[i] != null) {
        const key = $39136bc8da03ed4c$var$getKey(children[i], i.toString(36));
        out[key] = children[i];
    }
    return out;
}
function $39136bc8da03ed4c$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    const getValueForKey = (key)=>Object.hasOwn(next, key) ? next[key] : prev[key];
    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    const nextKeysPending = {};
    let pendingKeys = [];
    for(const prevKey in prev){
        if (Object.hasOwn(next, prevKey)) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    const childMapping = {};
    for(const nextKey in next){
        if (Object.hasOwn(nextKeysPending, nextKey)) for(let i = 0; i < nextKeysPending[nextKey].length; i++){
            const pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    }
    // Finally, add the keys which didn't appear before any key in `next`
    for(let i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
const $39136bc8da03ed4c$var$identity = (i)=>i;
class $39136bc8da03ed4c$var$TransitionGroup extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(props, context){
        super(props, context);
        this.refs = {};
        this.state = {
            children: $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children)) || [])
        };
        this.performAppear = this.performAppear.bind(this);
        this.performEnter = this.performEnter.bind(this);
        this.performLeave = this.performLeave.bind(this);
    }
    componentWillMount() {
        this.currentlyTransitioningKeys = {};
        this.keysToAbortLeave = [];
        this.keysToEnter = [];
        this.keysToLeave = [];
    }
    componentDidMount() {
        const initialChildMapping = this.state.children;
        for(const key in initialChildMapping)if (initialChildMapping[key]) // this.performAppear(getKey(initialChildMapping[key], key));
        this.performAppear(key);
    }
    componentWillReceiveProps(nextProps) {
        const nextChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(nextProps.children) || []);
        const prevChildMapping = this.state.children;
        this.setState((prevState)=>({
                children: $39136bc8da03ed4c$var$mergeChildMappings(prevState.children, nextChildMapping)
            }));
        let key;
        for(key in nextChildMapping)if (Object.hasOwn(nextChildMapping, key)) {
            const hasPrev = prevChildMapping && Object.hasOwn(prevChildMapping, key);
            // We should re-enter the component and abort its leave function
            if (nextChildMapping[key] && hasPrev && this.currentlyTransitioningKeys[key]) {
                this.keysToEnter.push(key);
                this.keysToAbortLeave.push(key);
            } else if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) this.keysToEnter.push(key);
        }
        for(key in prevChildMapping)if (Object.hasOwn(prevChildMapping, key)) {
            const hasNext = nextChildMapping && Object.hasOwn(nextChildMapping, key);
            if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) this.keysToLeave.push(key);
        }
    }
    componentDidUpdate() {
        const { keysToEnter: keysToEnter } = this;
        this.keysToEnter = [];
        keysToEnter.forEach(this.performEnter);
        const { keysToLeave: keysToLeave } = this;
        this.keysToLeave = [];
        keysToLeave.forEach(this.performLeave);
    }
    _finishAbort(key) {
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) this.keysToAbortLeave.splice(idx, 1);
    }
    performAppear(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component?.componentWillAppear) component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
        else this._handleDoneAppearing(key);
    }
    _handleDoneAppearing(key) {
        const component = this.refs[key];
        if (component?.componentDidAppear) component.componentDidAppear();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (!currentChildMapping || !Object.hasOwn(currentChildMapping, key)) // This was removed before it had fully appeared. Remove it.
        this.performLeave(key);
    }
    performEnter(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component?.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));
        else this._handleDoneEntering(key);
    }
    _handleDoneEntering(key) {
        const component = this.refs[key];
        if (component?.componentDidEnter) component.componentDidEnter();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (!currentChildMapping || !Object.hasOwn(currentChildMapping, key)) // This was removed before it had fully entered. Remove it.
        this.performLeave(key);
    }
    performLeave(key) {
        // If we should immediately abort this leave function,
        // don't run the leave transition at all.
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component?.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
        else // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        this._handleDoneLeaving(key);
    }
    _handleDoneLeaving(key) {
        // If we should immediately abort the leave,
        // then skip this altogether
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        const component = this.refs[key];
        if (component?.componentDidLeave) component.componentDidLeave();
        delete this.currentlyTransitioningKeys[key];
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (currentChildMapping && Object.hasOwn(currentChildMapping, key)) // This entered again before it fully left. Add it again.
        this.performEnter(key);
        else {
            const children = $39136bc8da03ed4c$var$assign({}, this.state.children);
            delete children[key];
            this.setState({
                children: children
            });
        }
    }
    render({ childFactory: childFactory, transitionLeave: transitionLeave, transitionName: transitionName, transitionAppear: transitionAppear, transitionEnter: transitionEnter, transitionLeaveTimeout: transitionLeaveTimeout, transitionEnterTimeout: transitionEnterTimeout, transitionAppearTimeout: transitionAppearTimeout, component: component, ...props }, { children: children }) {
        // TODO: we could get rid of the need for the wrapper node
        // by cloning a single child
        const childrenToRender = Object.entries(children).map(([key, child])=>{
            if (!child) return undefined;
            const ref = $39136bc8da03ed4c$var$linkRef(this, key);
            return (0, $4d2e93495e50cc85$export$e530037191fcd5d7)(childFactory(child), {
                ref: ref,
                key: key
            });
        }).filter(Boolean);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(component, props, childrenToRender);
    }
}
$39136bc8da03ed4c$var$TransitionGroup.defaultProps = {
    component: 'span',
    childFactory: $39136bc8da03ed4c$var$identity
};
var $39136bc8da03ed4c$export$2e2bcd8739ae039 = $39136bc8da03ed4c$var$TransitionGroup;


class $2d1e3e0d76faae78$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    static VERSION = (0, (/*@__PURE__*/$parcel$interopDefault($cd482327f74531d9$exports))).version;
    constructor(uppy, opts){
        super(uppy, opts);
        this.type = 'progressindicator';
        this.id = this.opts.id || 'Informer';
        this.title = 'Informer';
    }
    render = (state)=>{
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: "uppy uppy-Informer",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $39136bc8da03ed4c$export$2e2bcd8739ae039), {
                children: state.info.map((info)=>(0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $aaa56faedf37f661$export$2e2bcd8739ae039), {
                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("p", {
                            role: "alert",
                            children: [
                                info.message,
                                ' ',
                                info.details && // biome-ignore lint/a11y/useKeyWithClickEvents: ...
                                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                                    "aria-label": info.details,
                                    "data-microtip-position": "top-left",
                                    "data-microtip-size": "medium",
                                    role: "tooltip",
                                    onClick: ()=>alert(`${info.message} \n\n ${info.details}`),
                                    children: "?"
                                })
                            ]
                        })
                    }, info.message))
            })
        });
    };
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
    }
}








function $616f0acd28bd0dc4$var$GoogleIcon() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
            fill: "none",
            "fill-rule": "evenodd",
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("circle", {
                    fill: "#FFF",
                    cx: "13",
                    cy: "13",
                    r: "13"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M21.64 13.205c0-.639-.057-1.252-.164-1.841H13v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
                    fill: "#4285F4",
                    "fill-rule": "nonzero"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M13 22c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H4.957v2.332A8.997 8.997 0 0013 22z",
                    fill: "#34A853",
                    "fill-rule": "nonzero"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M7.964 14.71A5.41 5.41 0 017.682 13c0-.593.102-1.17.282-1.71V8.958H4.957A8.996 8.996 0 004 13c0 1.452.348 2.827.957 4.042l3.007-2.332z",
                    fill: "#FBBC05",
                    "fill-rule": "nonzero"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M13 7.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C17.463 4.891 15.426 4 13 4a8.997 8.997 0 00-8.043 4.958l3.007 2.332C8.672 9.163 10.656 7.58 13 7.58z",
                    fill: "#EA4335",
                    "fill-rule": "nonzero"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M4 4h18v18H4z"
                })
            ]
        })
    });
}
function $616f0acd28bd0dc4$var$DefaultForm({ pluginName: pluginName, i18n: i18n, onAuth: onAuth }) {
    // In order to comply with Google's brand we need to create a different button
    // for the Google Drive plugin
    const isGoogleDrive = pluginName === 'Google Drive';
    const onSubmit = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((e)=>{
        e.preventDefault();
        onAuth();
    }, [
        onAuth
    ]);
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("form", {
        onSubmit: onSubmit,
        children: isGoogleDrive ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
            type: "submit",
            className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn uppy-Provider-btn-google",
            "data-uppy-super-focusable": true,
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($616f0acd28bd0dc4$var$GoogleIcon, {}),
                i18n('signInWithGoogle')
            ]
        }) : (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
            type: "submit",
            className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn",
            "data-uppy-super-focusable": true,
            children: i18n('authenticateWith', {
                pluginName: pluginName
            })
        })
    });
}
const $616f0acd28bd0dc4$var$defaultRenderForm = ({ pluginName: pluginName, i18n: i18n, onAuth: onAuth })=>(0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($616f0acd28bd0dc4$var$DefaultForm, {
        pluginName: pluginName,
        i18n: i18n,
        onAuth: onAuth
    });
function $616f0acd28bd0dc4$export$2e2bcd8739ae039({ loading: loading, pluginName: pluginName, pluginIcon: pluginIcon, i18n: i18n, handleAuth: handleAuth, renderForm: renderForm = $616f0acd28bd0dc4$var$defaultRenderForm }) {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Provider-auth",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-Provider-authIcon",
                children: pluginIcon()
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-Provider-authTitle",
                children: i18n('authenticateWithTitle', {
                    pluginName: pluginName
                })
            }),
            renderForm({
                pluginName: pluginName,
                i18n: i18n,
                loading: loading,
                onAuth: handleAuth
            })
        ]
    });
}


const $e9666b53892dc87f$var$getAuthHeader = (token)=>({
        authorization: `Bearer ${token}`
    });
const $e9666b53892dc87f$var$injectedScripts = new Set();
let $e9666b53892dc87f$var$driveApiLoaded = false;
// https://stackoverflow.com/a/39008859/6519037
async function $e9666b53892dc87f$var$injectScript(src) {
    if ($e9666b53892dc87f$var$injectedScripts.has(src)) return;
    await new Promise((resolve, reject)=>{
        const script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', ()=>resolve());
        script.addEventListener('error', (e)=>reject(e.error));
        document.head.appendChild(script);
    });
    $e9666b53892dc87f$var$injectedScripts.add(src);
}
async function $e9666b53892dc87f$export$854131c89fb1de23(pickerType) {
    await Promise.all([
        $e9666b53892dc87f$var$injectScript('https://accounts.google.com/gsi/client'),
        (async ()=>{
            await $e9666b53892dc87f$var$injectScript('https://apis.google.com/js/api.js');
            if (pickerType === 'drive' && !$e9666b53892dc87f$var$driveApiLoaded) {
                await new Promise((resolve)=>gapi.load('client:picker', ()=>resolve()));
                await gapi.client.load('https://www.googleapis.com/discovery/v1/apis/drive/v3/rest');
                $e9666b53892dc87f$var$driveApiLoaded = true;
            }
        })()
    ]);
}
async function $e9666b53892dc87f$var$isTokenValid(accessToken, signal) {
    const response = await fetch(`https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=${encodeURIComponent(accessToken)}`, {
        signal: signal
    });
    if (response.ok) return true;
    // console.warn('Token is invalid or expired:', response.status, await response.text());
    // Token is invalid or expired
    return false;
}
async function $e9666b53892dc87f$export$be1f35f80d3e29cc({ pickerType: pickerType, clientId: clientId, accessToken: accessToken }) {
    const response = await new Promise((resolve, reject)=>{
        const scopes = pickerType === 'drive' ? [
            'https://www.googleapis.com/auth/drive.file'
        ] : [
            'https://www.googleapis.com/auth/photospicker.mediaitems.readonly'
        ];
        const tokenClient = google.accounts.oauth2.initTokenClient({
            client_id: clientId,
            // Authorization scopes required by the API; multiple scopes can be included, separated by spaces.
            scope: scopes.join(' '),
            callback: resolve,
            error_callback: reject
        });
        if (accessToken === null) // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({
            prompt: 'consent'
        });
        else // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({
            prompt: ''
        });
    });
    if (response.error) throw new Error(`OAuth2 error: ${response.error}`);
    return response.access_token;
}
async function $e9666b53892dc87f$export$a0973bcfe11b05c9(accessToken) {
    await new Promise((resolve)=>google.accounts.oauth2.revoke(accessToken, resolve));
}
class $e9666b53892dc87f$export$b9721ef022f71a68 extends Error {
    constructor(){
        super('Invalid or expired token');
        this.name = 'InvalidTokenError';
    }
}
async function $e9666b53892dc87f$export$b2a09a28761946e6({ token: token, apiKey: apiKey, appId: appId, onFilesPicked: onFilesPicked, signal: signal }) {
    // google drive picker will crash hard if given an invalid token, so we need to check it first
    // https://github.com/transloadit/uppy/pull/5443#pullrequestreview-2452439265
    if (!await $e9666b53892dc87f$var$isTokenValid(token, signal)) throw new $e9666b53892dc87f$export$b9721ef022f71a68();
    const onPicked = (picked)=>{
        if (picked.action === google.picker.Action.PICKED) // console.log('Picker response', JSON.stringify(picked, null, 2));
        onFilesPicked(picked.docs.map((doc)=>({
                platform: 'drive',
                id: doc.id,
                name: doc.name,
                mimeType: doc.mimeType
            })), token);
    };
    const picker = new google.picker.PickerBuilder().enableFeature(google.picker.Feature.NAV_HIDDEN).enableFeature(google.picker.Feature.MULTISELECT_ENABLED).setDeveloperKey(apiKey).setAppId(appId).setOAuthToken(token).addView(new google.picker.DocsView(google.picker.ViewId.DOCS).setIncludeFolders(true)// Note: setEnableDrives doesn't seem to work
    // .setEnableDrives(true)
    .setSelectFolderEnabled(false).setMode(google.picker.DocsViewMode.LIST))// NOTE: photos is broken and results in an error being returned from Google
    // I think it's the old Picasa photos
    // .addView(google.picker.ViewId.PHOTOS)
    .setCallback(onPicked).build();
    picker.setVisible(true);
    signal?.addEventListener('abort', ()=>picker.dispose());
}
async function $e9666b53892dc87f$export$15c530b5c99413ec({ token: token, pickingSession: pickingSession, onPickingSessionChange: onPickingSessionChange, signal: signal }) {
    // https://developers.google.com/photos/picker/guides/get-started-picker
    const headers = $e9666b53892dc87f$var$getAuthHeader(token);
    let newPickingSession = pickingSession;
    if (newPickingSession == null) {
        const createSessionResponse = await fetch('https://photospicker.googleapis.com/v1/sessions', {
            method: 'post',
            headers: headers,
            signal: signal
        });
        if (createSessionResponse.status === 401) {
            const resp = await createSessionResponse.json();
            if (resp.error?.status === 'UNAUTHENTICATED') throw new $e9666b53892dc87f$export$b9721ef022f71a68();
        }
        if (!createSessionResponse.ok) throw new Error('Failed to create a session');
        newPickingSession = await createSessionResponse.json();
        onPickingSessionChange(newPickingSession);
    }
    const w = window.open(newPickingSession.pickerUri);
    signal?.addEventListener('abort', ()=>w?.close());
}
async function $e9666b53892dc87f$var$resolvePickedPhotos({ accessToken: accessToken, pickingSession: pickingSession, signal: signal }) {
    const headers = $e9666b53892dc87f$var$getAuthHeader(accessToken);
    let pageToken;
    let mediaItems = [];
    do {
        const pageSize = 100;
        const response = await fetch(`https://photospicker.googleapis.com/v1/mediaItems?${new URLSearchParams({
            sessionId: pickingSession.id,
            pageSize: String(pageSize),
            ...pageToken && {
                pageToken: pageToken
            }
        }).toString()}`, {
            headers: headers,
            signal: signal
        });
        if (!response.ok) throw new Error('Failed to get a media items');
        const { mediaItems: batchMediaItems, nextPageToken: nextPageToken } = await response.json();
        pageToken = nextPageToken;
        mediaItems.push(...batchMediaItems);
    }while (pageToken);
    // Filter out items that aren't fully processed or ready
    mediaItems = mediaItems.flatMap((i)=>i.type === 'PHOTO' || i.type === 'VIDEO' && i.mediaFile.mediaFileMetadata.videoMetadata.processingStatus === 'READY' ? [
            i
        ] : []);
    // Transform media items into picked items with appropriate metadata
    return mediaItems.map((mediaItem)=>{
        const { id: id, type: type, mediaFile: { mimeType: mimeType, filename: filename, baseUrl: baseUrl } } = mediaItem;
        return {
            platform: 'photos',
            id: id,
            mimeType: mimeType,
            // we want the original resolution, so we don't append any parameter to the baseUrl
            // https://developers.google.com/photos/library/guides/access-media-items#base-urls
            url: type === 'VIDEO' ? `${baseUrl}=dv` : `${baseUrl}=d`,
            name: filename,
            metadata: {
                // Note that metadata keys `filename` and `type` have special meanings in Companion
                // and should not be overridden
                googlePhotosFileType: mediaItem.type,
                createTime: mediaItem.createTime,
                width: mediaItem.mediaFile.mediaFileMetadata.width,
                height: mediaItem.mediaFile.mediaFileMetadata.height,
                ...mediaItem.type === 'PHOTO' && {
                    cameraMake: mediaItem.mediaFile.mediaFileMetadata.photoMetadata?.cameraMake,
                    cameraModel: mediaItem.mediaFile.mediaFileMetadata.photoMetadata?.cameraModel,
                    focalLength: mediaItem.mediaFile.mediaFileMetadata.photoMetadata?.focalLength,
                    apertureFNumber: mediaItem.mediaFile.mediaFileMetadata.photoMetadata?.apertureFNumber,
                    isoEquivalent: mediaItem.mediaFile.mediaFileMetadata.photoMetadata?.isoEquivalent,
                    exposureTime: mediaItem.mediaFile.mediaFileMetadata.photoMetadata?.exposureTime
                },
                ...mediaItem.type === 'VIDEO' && {
                    cameraMake: mediaItem.mediaFile.mediaFileMetadata.videoMetadata.cameraMake,
                    cameraModel: mediaItem.mediaFile.mediaFileMetadata.videoMetadata.cameraModel,
                    fps: mediaItem.mediaFile.mediaFileMetadata.videoMetadata.fps,
                    processingStatus: mediaItem.mediaFile.mediaFileMetadata.videoMetadata.processingStatus
                }
            }
        };
    });
}
async function $e9666b53892dc87f$export$3e1980f2a996ac0a({ pickingSessionRef: pickingSessionRef, accessTokenRef: accessTokenRef, signal: signal, onFilesPicked: onFilesPicked, onError: onError }) {
    // if we have an active session, poll it until it either times out, or the user selects some photos.
    // Note that the user can also just close the page, but we get no indication of that from Google when polling,
    // so we just have to continue polling in the background, so we can react to it
    // in case the user opens the photo selector again. Hence the infinite for loop
    for(let interval = 1;;)try {
        if (pickingSessionRef.current != null) interval = parseFloat(pickingSessionRef.current.pollingConfig.pollInterval);
        else interval = 1;
        await Promise.race([
            new Promise((resolve)=>setTimeout(resolve, interval * 1000)),
            new Promise((_resolve, reject)=>{
                signal.addEventListener('abort', reject);
            })
        ]);
        signal.throwIfAborted();
        const accessToken = accessTokenRef.current;
        const pickingSession = pickingSessionRef.current;
        if (pickingSession != null && accessToken != null) {
            const headers = $e9666b53892dc87f$var$getAuthHeader(accessToken);
            // https://developers.google.com/photos/picker/reference/rest/v1/sessions
            const response = await fetch(`https://photospicker.googleapis.com/v1/sessions/${encodeURIComponent(pickingSession.id)}`, {
                headers: headers,
                signal: signal
            });
            if (!response.ok) throw new Error('Failed to get session');
            const json = await response.json();
            if (json.mediaItemsSet) {
                // console.log('User picked!', json)
                const resolvedPhotos = await $e9666b53892dc87f$var$resolvePickedPhotos({
                    accessToken: accessToken,
                    pickingSession: pickingSession,
                    signal: signal
                });
                pickingSessionRef.current = undefined;
                onFilesPicked(resolvedPhotos, accessToken);
            }
            if (pickingSession.pollingConfig.timeoutIn === '0s') pickingSessionRef.current = undefined;
        }
    } catch (err) {
        if (err instanceof Error && err.name === 'AbortError') return;
        // just report the error and continue polling
        onError(err);
    }
}



const $9705f384a874042e$export$66c805c125a4bed5 = ()=>(0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "32",
        height: "32",
        viewBox: "-7 -7 73 73",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
            fill: "none",
            "fill-rule": "evenodd",
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M-3-3h64v64H-3z"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
                    "fill-rule": "nonzero",
                    children: [
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                            fill: "#FBBC04",
                            d: "M14.8 13.4c8.1 0 14.7 6.6 14.7 14.8v1.3H1.3c-.7 0-1.3-.6-1.3-1.3C0 20 6.6 13.4 14.8 13.4z"
                        }),
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                            fill: "#EA4335",
                            d: "M45.6 14.8c0 8.1-6.6 14.7-14.8 14.7h-1.3V1.3c0-.7.6-1.3 1.3-1.3C39 0 45.6 6.6 45.6 14.8z"
                        }),
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                            fill: "#4285F4",
                            d: "M44.3 45.6c-8.2 0-14.8-6.6-14.8-14.8v-1.3h28.2c.7 0 1.3.6 1.3 1.3 0 8.2-6.6 14.8-14.8 14.8z"
                        }),
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                            fill: "#34A853",
                            d: "M13.4 44.3c0-8.2 6.6-14.8 14.8-14.8h1.3v28.2c0 .7-.6 1.3-1.3 1.3-8.2 0-14.8-6.6-14.8-14.8z"
                        })
                    ]
                })
            ]
        })
    });
const $9705f384a874042e$export$e16bd899bb4eebf9 = ()=>(0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
            fillRule: "nonzero",
            fill: "none",
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M6.663 22.284l.97 1.62c.202.34.492.609.832.804l3.465-5.798H5c0 .378.1.755.302 1.096l1.361 2.278z",
                    fill: "#0066DA"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M16 12.09l-3.465-5.798c-.34.195-.63.463-.832.804l-6.4 10.718A2.15 2.15 0 005 18.91h6.93L16 12.09z",
                    fill: "#00AC47"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M23.535 24.708c.34-.195.63-.463.832-.804l.403-.67 1.928-3.228c.201-.34.302-.718.302-1.096h-6.93l1.474 2.802 1.991 2.996z",
                    fill: "#EA4335"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M16 12.09l3.465-5.798A2.274 2.274 0 0018.331 6h-4.662c-.403 0-.794.11-1.134.292L16 12.09z",
                    fill: "#00832D"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M20.07 18.91h-8.14l-3.465 5.798c.34.195.73.292 1.134.292h12.802c.403 0 .794-.11 1.134-.292L20.07 18.91z",
                    fill: "#2684FC"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M23.497 12.455l-3.2-5.359a2.252 2.252 0 00-.832-.804L16 12.09l4.07 6.82h6.917c0-.377-.1-.755-.302-1.096l-3.188-5.359z",
                    fill: "#FFBA00"
                })
            ]
        })
    });


function $9b69c11e05f2f8a9$var$useStore(store, key) {
    const [value, setValueState] = (0, $e28f05d17e052ff9$export$60241385465d0a34)();
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        (async ()=>{
            setValueState(await store.getItem(key));
        })();
    }, [
        key,
        store
    ]);
    const setValue = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)(async (v)=>{
        setValueState(v);
        if (v == null) return store.removeItem(key);
        return store.setItem(key, v);
    }, [
        key,
        store
    ]);
    return [
        value,
        setValue
    ];
}
function $9b69c11e05f2f8a9$export$2e2bcd8739ae039({ uppy: uppy, i18n: i18n, clientId: clientId, onFilesPicked: onFilesPicked, pickerType: pickerType, apiKey: apiKey, appId: appId, storage: storage }) {
    const [loading, setLoading] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(false);
    const [accessToken, setAccessTokenStored] = $9b69c11e05f2f8a9$var$useStore(storage, `uppy:google-${pickerType}-picker:accessToken`);
    const pickingSessionRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const accessTokenRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)(accessToken);
    const shownPickerRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)(false);
    const setAccessToken = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((t)=>{
        uppy.log('Access token updated');
        setAccessTokenStored(t);
        accessTokenRef.current = t;
    }, [
        setAccessTokenStored,
        uppy
    ]);
    // keep access token in sync with the ref
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        accessTokenRef.current = accessToken;
    }, [
        accessToken
    ]);
    const showPicker = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)(async (signal)=>{
        let newAccessToken = accessToken;
        const doShowPicker = async (token)=>{
            if (pickerType === 'drive') await (0, $e9666b53892dc87f$export$b2a09a28761946e6)({
                token: token,
                apiKey: apiKey,
                appId: appId,
                onFilesPicked: onFilesPicked,
                signal: signal
            });
            else {
                // photos
                const onPickingSessionChange = (newPickingSession)=>{
                    pickingSessionRef.current = newPickingSession;
                };
                await (0, $e9666b53892dc87f$export$15c530b5c99413ec)({
                    token: token,
                    pickingSession: pickingSessionRef.current,
                    onPickingSessionChange: onPickingSessionChange,
                    signal: signal
                });
            }
        };
        setLoading(true);
        try {
            try {
                await (0, $e9666b53892dc87f$export$854131c89fb1de23)(pickerType);
                if (newAccessToken == null) newAccessToken = await (0, $e9666b53892dc87f$export$be1f35f80d3e29cc)({
                    clientId: clientId,
                    pickerType: pickerType
                });
                if (newAccessToken == null) throw new Error();
                await doShowPicker(newAccessToken);
                shownPickerRef.current = true;
                setAccessToken(newAccessToken);
            } catch (err) {
                if (err instanceof (0, $e9666b53892dc87f$export$b9721ef022f71a68)) {
                    uppy.log('Token is invalid or expired, reauthenticating');
                    newAccessToken = await (0, $e9666b53892dc87f$export$be1f35f80d3e29cc)({
                        pickerType: pickerType,
                        accessToken: newAccessToken,
                        clientId: clientId
                    });
                    // now try again:
                    await doShowPicker(newAccessToken);
                    shownPickerRef.current = true;
                    setAccessToken(newAccessToken);
                } else throw err;
            }
        } catch (err) {
            if (err instanceof Error && 'type' in err && err.type === 'popup_closed') ;
            else {
                setAccessToken(null);
                uppy.log(err);
            }
        } finally{
            setLoading(false);
        }
    }, [
        accessToken,
        apiKey,
        appId,
        clientId,
        onFilesPicked,
        pickerType,
        setAccessToken,
        uppy
    ]);
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        const abortController = new AbortController();
        (0, $e9666b53892dc87f$export$3e1980f2a996ac0a)({
            pickingSessionRef: pickingSessionRef,
            accessTokenRef: accessTokenRef,
            signal: abortController.signal,
            onFilesPicked: onFilesPicked,
            onError: (err)=>uppy.log(err)
        });
        return ()=>abortController.abort();
    }, [
        onFilesPicked,
        uppy
    ]);
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        // when mounting, once we have a token, be nice to the user and automatically show the picker
        // accessToken === undefined means not yet loaded from storage, so wait for that first
        if (accessToken === undefined || shownPickerRef.current) return undefined;
        const abortController = new AbortController();
        showPicker(abortController.signal);
        return ()=>{
            // only abort the picker if it's not yet shown
            if (!shownPickerRef.current) abortController.abort();
        };
    }, [
        accessToken,
        showPicker
    ]);
    const handleLogoutClick = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)(async ()=>{
        if (accessToken) {
            await (0, $e9666b53892dc87f$export$a0973bcfe11b05c9)(accessToken);
            setAccessToken(null);
            pickingSessionRef.current = undefined;
        }
    }, [
        accessToken,
        setAccessToken
    ]);
    if (loading) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        children: [
            i18n('pleaseWait'),
            "..."
        ]
    });
    if (accessToken == null) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $616f0acd28bd0dc4$export$2e2bcd8739ae039), {
        pluginName: pickerType === 'drive' ? i18n('pluginNameGoogleDrivePicker') : i18n('pluginNameGooglePhotosPicker'),
        pluginIcon: pickerType === 'drive' ? (0, $9705f384a874042e$export$e16bd899bb4eebf9) : (0, $9705f384a874042e$export$66c805c125a4bed5),
        handleAuth: showPicker,
        i18n: i18n,
        loading: loading
    });
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        style: {
            textAlign: 'center'
        },
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary",
                style: {
                    display: 'block',
                    marginBottom: '1em'
                },
                disabled: loading,
                onClick: ()=>showPicker(),
                children: pickerType === 'drive' ? i18n('pickFiles') : i18n('pickPhotos')
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn",
                disabled: loading,
                onClick: handleLogoutClick,
                children: i18n('logOut')
            })
        ]
    });
}




function $d0cca3c9705b0857$export$2e2bcd8739ae039(file) {
    return {
        ...file,
        type: file.mimeType,
        extension: file.name ? (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.name).extension : null
    };
}


var $02c2aab7657be691$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($02c2aab7657be691$exports) {
        classNames.default = classNames;
        $02c2aab7657be691$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $b965f41edea7ed13$exports = {};
$b965f41edea7ed13$exports = JSON.parse("{\"name\":\"@uppy/provider-views\",\"description\":\"View library for Uppy remote provider plugins.\",\"version\":\"4.5.3\",\"license\":\"MIT\",\"main\":\"lib/index.js\",\"style\":\"dist/style.min.css\",\"type\":\"module\",\"scripts\":{\"build\":\"tsc --build tsconfig.build.json\",\"build:css\":\"sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css\",\"typecheck\":\"tsc --build\",\"test\":\"vitest run --environment=jsdom --silent='passed-only'\"},\"keywords\":[\"file uploader\",\"uppy\"],\"homepage\":\"https://uppy.io\",\"bugs\":{\"url\":\"https://github.com/transloadit/uppy/issues\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/transloadit/uppy.git\"},\"files\":[\"src\",\"lib\",\"dist\",\"CHANGELOG.md\"],\"dependencies\":{\"@uppy/utils\":\"^6.2.2\",\"classnames\":\"^2.2.6\",\"nanoid\":\"^5.0.9\",\"p-queue\":\"^8.0.0\",\"preact\":\"^10.5.13\"},\"devDependencies\":{\"@types/gapi\":\"^0.0.47\",\"@types/google.accounts\":\"^0.0.14\",\"@types/google.picker\":\"^0.0.42\",\"cssnano\":\"^7.0.7\",\"jsdom\":\"^26.1.0\",\"postcss\":\"^8.5.6\",\"postcss-cli\":\"^11.0.1\",\"sass\":\"^1.89.2\",\"typescript\":\"^5.8.3\",\"vitest\":\"^3.2.4\"},\"peerDependencies\":{\"@uppy/core\":\"^4.5.3\"}}");





const $aba06cd85441b3f8$var$STYLE_INNER = {
    position: 'relative',
    // Disabled for our use case: the wrapper elements around FileList already deal with overflow,
    // and this additional property would hide things that we want to show.
    //
    // overflow: 'hidden',
    width: '100%',
    minHeight: '100%'
};
const $aba06cd85441b3f8$var$STYLE_CONTENT = {
    position: 'absolute',
    top: 0,
    left: 0,
    // Because the `top` value gets set to some offset, this `height` being 100% would make the scrollbar
    // stretch far beyond the content. For our use case, the content div actually can get its height from
    // the elements inside it, so we don't need to specify a `height` property at all.
    //
    // height: '100%',
    width: '100%',
    overflow: 'visible'
};
class $aba06cd85441b3f8$var$VirtualList extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        // The currently focused node, used to retain focus when the visible rows change.
        // To avoid update loops, this should not cause state updates, so it's kept as a plain property.
        this.focusElement = null;
        this.state = {
            offset: 0,
            height: 0
        };
    }
    componentDidMount() {
        this.resize();
        window.addEventListener('resize', this.handleResize);
    }
    // TODO: refactor to stable lifecycle method
    componentWillUpdate() {
        if (this.base.contains(document.activeElement)) this.focusElement = document.activeElement;
    }
    componentDidUpdate() {
        // Maintain focus when rows are added and removed.
        if (this.focusElement?.parentNode && document.activeElement !== this.focusElement) this.focusElement.focus();
        this.focusElement = null;
        this.resize();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    handleScroll = ()=>{
        this.setState({
            offset: this.base.scrollTop
        });
    };
    handleResize = ()=>{
        this.resize();
    };
    resize() {
        const { height: height } = this.state;
        if (height !== this.base.offsetHeight) this.setState({
            height: this.base.offsetHeight
        });
    }
    render({ data: data, rowHeight: rowHeight, renderRow: renderRow, overscanCount: overscanCount = 10, ...props }) {
        const { offset: offset, height: height } = this.state;
        // first visible row index
        let start = Math.floor(offset / rowHeight);
        // actual number of visible rows (without overscan)
        let visibleRowCount = Math.floor(height / rowHeight);
        // Overscan: render blocks of rows modulo an overscan row count
        // This dramatically reduces DOM writes during scrolling
        if (overscanCount) {
            start = Math.max(0, start - start % overscanCount);
            visibleRowCount += overscanCount;
        }
        // last visible + overscan row index + padding to allow keyboard focus to travel past the visible area
        const end = start + visibleRowCount + 4;
        // data slice currently in viewport plus overscan items
        const selection = data.slice(start, end);
        const styleInner = {
            ...$aba06cd85441b3f8$var$STYLE_INNER,
            height: data.length * rowHeight
        };
        const styleContent = {
            ...$aba06cd85441b3f8$var$STYLE_CONTENT,
            top: start * rowHeight
        };
        // The `role="presentation"` attributes ensure that these wrapper elements are not treated as list
        // items by accessibility and outline tools.
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            onScroll: this.handleScroll,
            ...props,
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                role: "presentation",
                style: styleInner,
                children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                    role: "presentation",
                    style: styleContent,
                    children: selection.map(renderRow)
                })
            })
        });
    }
}
var $aba06cd85441b3f8$export$2e2bcd8739ae039 = $aba06cd85441b3f8$var$VirtualList;







function $eeb730e0d52603b2$var$FileIcon() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: 11,
        height: 14.5,
        viewBox: "0 0 44 58",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
            d: "M27.437.517a1 1 0 0 0-.094.03H4.25C2.037.548.217 2.368.217 4.58v48.405c0 2.212 1.82 4.03 4.03 4.03H39.03c2.21 0 4.03-1.818 4.03-4.03V15.61a1 1 0 0 0-.03-.28 1 1 0 0 0 0-.093 1 1 0 0 0-.03-.032 1 1 0 0 0 0-.03 1 1 0 0 0-.032-.063 1 1 0 0 0-.03-.063 1 1 0 0 0-.032 0 1 1 0 0 0-.03-.063 1 1 0 0 0-.032-.03 1 1 0 0 0-.03-.063 1 1 0 0 0-.063-.062l-14.593-14a1 1 0 0 0-.062-.062A1 1 0 0 0 28 .708a1 1 0 0 0-.374-.157 1 1 0 0 0-.156 0 1 1 0 0 0-.03-.03l-.003-.003zM4.25 2.547h22.218v9.97c0 2.21 1.82 4.03 4.03 4.03h10.564v36.438a2.02 2.02 0 0 1-2.032 2.032H4.25c-1.13 0-2.032-.9-2.032-2.032V4.58c0-1.13.902-2.032 2.03-2.032zm24.218 1.345l10.375 9.937.75.718H30.5c-1.13 0-2.032-.9-2.032-2.03V3.89z"
        })
    });
}
function $eeb730e0d52603b2$var$FolderIcon() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        style: {
            minWidth: 16,
            marginRight: 3
        },
        viewBox: "0 0 276.157 276.157",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
            d: "M273.08 101.378c-3.3-4.65-8.86-7.32-15.254-7.32h-24.34V67.59c0-10.2-8.3-18.5-18.5-18.5h-85.322c-3.63 0-9.295-2.875-11.436-5.805l-6.386-8.735c-4.982-6.814-15.104-11.954-23.546-11.954H58.73c-9.292 0-18.638 6.608-21.737 15.372l-2.033 5.752c-.958 2.71-4.72 5.37-7.596 5.37H18.5C8.3 49.09 0 57.39 0 67.59v167.07c0 .886.16 1.73.443 2.52.152 3.306 1.18 6.424 3.053 9.064 3.3 4.652 8.86 7.32 15.255 7.32h188.487c11.395 0 23.27-8.425 27.035-19.18l40.677-116.188c2.11-6.035 1.43-12.164-1.87-16.816zM18.5 64.088h8.864c9.295 0 18.64-6.607 21.738-15.37l2.032-5.75c.96-2.712 4.722-5.373 7.597-5.373h29.565c3.63 0 9.295 2.876 11.437 5.806l6.386 8.735c4.982 6.815 15.104 11.954 23.546 11.954h85.322c1.898 0 3.5 1.602 3.5 3.5v26.47H69.34c-11.395 0-23.27 8.423-27.035 19.178L15 191.23V67.59c0-1.898 1.603-3.5 3.5-3.5zm242.29 49.15l-40.676 116.188c-1.674 4.78-7.812 9.135-12.877 9.135H18.75c-1.447 0-2.576-.372-3.02-.997-.442-.625-.422-1.814.057-3.18l40.677-116.19c1.674-4.78 7.812-9.134 12.877-9.134h188.487c1.448 0 2.577.372 3.02.997.443.625.423 1.814-.056 3.18z"
        })
    });
}
function $eeb730e0d52603b2$var$VideoIcon() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        style: {
            width: 16,
            marginRight: 4
        },
        viewBox: "0 0 58 58",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                d: "M36.537 28.156l-11-7a1.005 1.005 0 0 0-1.02-.033C24.2 21.3 24 21.635 24 22v14a1 1 0 0 0 1.537.844l11-7a1.002 1.002 0 0 0 0-1.688zM26 34.18V23.82L34.137 29 26 34.18z"
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                d: "M57 6H1a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM10 28H2v-9h8v9zm-8 2h8v9H2v-9zm10 10V8h34v42H12V40zm44-12h-8v-9h8v9zm-8 2h8v9h-8v-9zm8-22v9h-8V8h8zM2 8h8v9H2V8zm0 42v-9h8v9H2zm54 0h-8v-9h8v9z"
            })
        ]
    });
}
function $eeb730e0d52603b2$export$2e2bcd8739ae039({ itemIconString: itemIconString, alt: alt }) {
    if (itemIconString === null) return null;
    switch(itemIconString){
        case 'file':
            return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($eeb730e0d52603b2$var$FileIcon, {});
        case 'folder':
            return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($eeb730e0d52603b2$var$FolderIcon, {});
        case 'video':
            return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($eeb730e0d52603b2$var$VideoIcon, {});
        default:
            return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("img", {
                src: itemIconString,
                alt: alt,
                referrerPolicy: "no-referrer",
                loading: "lazy",
                width: 16,
                height: 16
            });
    }
}


function $79441ec2d5893efa$var$GridItem({ file: file, toggleCheckbox: toggleCheckbox, className: className, isDisabled: isDisabled, restrictionError: restrictionError, showTitles: showTitles, children: children = null, i18n: i18n }) {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("li", {
        className: className,
        title: isDisabled && restrictionError ? restrictionError : undefined,
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("input", {
                type: "checkbox",
                className: "uppy-u-reset uppy-ProviderBrowserItem-checkbox uppy-ProviderBrowserItem-checkbox--grid",
                onChange: toggleCheckbox,
                name: "listitem",
                id: file.id,
                checked: file.status === 'checked',
                disabled: isDisabled,
                "data-uppy-super-focusable": true
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("label", {
                htmlFor: file.id,
                "aria-label": file.data.name ?? i18n('unnamed'),
                className: "uppy-u-reset uppy-ProviderBrowserItem-inner",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
                        itemIconString: file.data.thumbnail || file.data.icon
                    }),
                    showTitles && (file.data.name ?? i18n('unnamed')),
                    children
                ]
            })
        ]
    });
}
var $79441ec2d5893efa$export$2e2bcd8739ae039 = $79441ec2d5893efa$var$GridItem;




function $9b946df2ba2b33d0$export$2e2bcd8739ae039({ file: file, openFolder: openFolder, className: className, isDisabled: isDisabled, restrictionError: restrictionError, toggleCheckbox: toggleCheckbox, showTitles: showTitles, i18n: i18n }) {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("li", {
        className: className,
        title: file.status !== 'checked' && restrictionError ? restrictionError : undefined,
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("input", {
                type: "checkbox",
                className: "uppy-u-reset uppy-ProviderBrowserItem-checkbox",
                onChange: toggleCheckbox,
                // for the <label/>
                name: "listitem",
                id: file.id,
                checked: file.status === 'checked',
                "aria-label": file.data.isFolder ? i18n('allFilesFromFolderNamed', {
                    name: file.data.name ?? i18n('unnamed')
                }) : null,
                disabled: isDisabled,
                "data-uppy-super-focusable": true
            }),
            file.data.isFolder ? // button to open a folder
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowserItem-inner",
                onClick: ()=>openFolder(file.id),
                "aria-label": i18n('openFolderNamed', {
                    name: file.data.name ?? i18n('unnamed')
                }),
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-ProviderBrowserItem-iconWrap",
                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
                            itemIconString: file.data.icon
                        })
                    }),
                    showTitles && file.data.name ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                        children: file.data.name
                    }) : i18n('unnamed')
                ]
            }) : // label for a checkbox
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("label", {
                htmlFor: file.id,
                className: "uppy-u-reset uppy-ProviderBrowserItem-inner",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-ProviderBrowserItem-iconWrap",
                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
                            itemIconString: file.data.icon
                        })
                    }),
                    showTitles && (file.data.name ?? i18n('unnamed'))
                ]
            })
        ]
    });
}


function $7f388d6d579fe299$export$2e2bcd8739ae039(props) {
    const { viewType: viewType, toggleCheckbox: toggleCheckbox, showTitles: showTitles, i18n: i18n, openFolder: openFolder, file: file, utmSource: utmSource } = props;
    const restrictionError = file.type === 'folder' ? null : file.restrictionError;
    const isDisabled = !!restrictionError && file.status !== 'checked';
    const ourProps = {
        file: file,
        openFolder: openFolder,
        toggleCheckbox: toggleCheckbox,
        utmSource: utmSource,
        i18n: i18n,
        viewType: viewType,
        showTitles: showTitles,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-ProviderBrowserItem', {
            'uppy-ProviderBrowserItem--disabled': isDisabled
        }, {
            'uppy-ProviderBrowserItem--noPreview': file.data.icon === 'video'
        }, {
            'uppy-ProviderBrowserItem--is-checked': file.status === 'checked'
        }, {
            'uppy-ProviderBrowserItem--is-partial': file.status === 'partial'
        }),
        isDisabled: isDisabled,
        restrictionError: restrictionError
    };
    switch(viewType){
        case 'grid':
            return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $79441ec2d5893efa$export$2e2bcd8739ae039), {
                ...ourProps
            });
        case 'list':
            return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $9b946df2ba2b33d0$export$2e2bcd8739ae039), {
                ...ourProps
            });
        case 'unsplash':
            return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $79441ec2d5893efa$export$2e2bcd8739ae039), {
                ...ourProps,
                children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("a", {
                    href: `${file.data.author.url}?utm_source=${utmSource}&utm_medium=referral`,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "uppy-ProviderBrowserItem-author",
                    tabIndex: -1,
                    children: file.data.author.name
                })
            });
        default:
            throw new Error(`There is no such type ${viewType}`);
    }
}


function $ffc120143b595bcb$var$Browser(props) {
    const { displayedPartialTree: displayedPartialTree, viewType: viewType, toggleCheckbox: toggleCheckbox, handleScroll: handleScroll, showTitles: showTitles, i18n: i18n, isLoading: isLoading, openFolder: openFolder, noResultsLabel: noResultsLabel, virtualList: virtualList, utmSource: utmSource } = props;
    const [isShiftKeyPressed, setIsShiftKeyPressed] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(false);
    // This records whether the user is holding the SHIFT key this very moment.
    // Typically, this is implemented using `onClick((e) => e.shiftKey)` -
    // however we can't use that, because for accessibility reasons
    // we're using html tags that don't support `e.shiftKey` property (see #3768).
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        const handleKeyUp = (e)=>{
            if (e.key === 'Shift') setIsShiftKeyPressed(false);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Shift') setIsShiftKeyPressed(true);
        };
        document.addEventListener('keyup', handleKeyUp);
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keyup', handleKeyUp);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    if (isLoading) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Provider-loading",
        children: typeof isLoading === 'string' ? isLoading : i18n('loading')
    });
    if (displayedPartialTree.length === 0) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Provider-empty",
        children: noResultsLabel
    });
    const renderItem = (item)=>(0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $7f388d6d579fe299$export$2e2bcd8739ae039), {
            viewType: viewType,
            toggleCheckbox: (event)=>{
                event.stopPropagation();
                event.preventDefault();
                // Prevent shift-clicking from highlighting file names
                // (https://stackoverflow.com/a/1527797/3192470)
                document.getSelection()?.removeAllRanges();
                toggleCheckbox(item, isShiftKeyPressed);
            },
            showTitles: showTitles,
            i18n: i18n,
            openFolder: openFolder,
            file: item,
            utmSource: utmSource
        }, item.id);
    // todo remove virtuallist option and always use virtual list
    if (virtualList) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-ProviderBrowser-body",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $aba06cd85441b3f8$export$2e2bcd8739ae039), {
            className: "uppy-ProviderBrowser-list",
            data: displayedPartialTree,
            renderRow: renderItem,
            rowHeight: 35.5
        })
    });
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-ProviderBrowser-body",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("ul", {
            className: "uppy-ProviderBrowser-list",
            onScroll: handleScroll,
            // making <ul> not focusable for firefox
            tabIndex: -1,
            children: displayedPartialTree.map(renderItem)
        })
    });
}
var $ffc120143b595bcb$export$2e2bcd8739ae039 = $ffc120143b595bcb$var$Browser;





/**
 * We're interested in all 'checked' leaves of this tree,
 * but we don't yet know how many files there are inside of each checked folder.
 * `getNumberOfSelectedFiles()` returns the most intuitive number we can show to the user
 * in this situation.
 */ const $3599f082ce07508f$var$getNumberOfSelectedFiles = (partialTree)=>{
    const checkedLeaves = partialTree.filter((item)=>{
        if (item.type === 'file' && item.status === 'checked') return true;
        if (item.type === 'folder' && item.status === 'checked') {
            const doesItHaveChildren = partialTree.some((i)=>i.type !== 'root' && i.parentId === item.id);
            return !doesItHaveChildren;
        }
        return false;
    });
    return checkedLeaves.length;
};
var $3599f082ce07508f$export$2e2bcd8739ae039 = $3599f082ce07508f$var$getNumberOfSelectedFiles;


function $4ab2a94a3ee5ad67$export$2e2bcd8739ae039({ cancelSelection: cancelSelection, donePicking: donePicking, i18n: i18n, partialTree: partialTree, validateAggregateRestrictions: validateAggregateRestrictions }) {
    const aggregateRestrictionError = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        return validateAggregateRestrictions(partialTree);
    }, [
        partialTree,
        validateAggregateRestrictions
    ]);
    const nOfSelectedFiles = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        return (0, $3599f082ce07508f$export$2e2bcd8739ae039)(partialTree);
    }, [
        partialTree
    ]);
    if (nOfSelectedFiles === 0) return null;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-ProviderBrowser-footer",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-ProviderBrowser-footer-buttons",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-u-reset uppy-c-btn uppy-c-btn-primary', {
                            'uppy-c-btn--disabled': aggregateRestrictionError
                        }),
                        disabled: !!aggregateRestrictionError,
                        onClick: donePicking,
                        type: "button",
                        children: i18n('selectX', {
                            smart_count: nOfSelectedFiles
                        })
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link",
                        onClick: cancelSelection,
                        type: "button",
                        children: i18n('cancel')
                    })
                ]
            }),
            aggregateRestrictionError && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-ProviderBrowser-footer-error",
                children: aggregateRestrictionError
            })
        ]
    });
}



let $a0ee3b646e338d67$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $a0ee3b646e338d67$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size | 0;
        while(i-- > 0)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $a0ee3b646e338d67$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size | 0;
    while(i-- > 0)id += $a0ee3b646e338d67$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};



function $f173600a8ed11ef3$var$SearchInput({ searchString: searchString, setSearchString: setSearchString, submitSearchString: submitSearchString, wrapperClassName: wrapperClassName, inputClassName: inputClassName, inputLabel: inputLabel, clearSearchLabel: clearSearchLabel = '', showButton: showButton = false, buttonLabel: buttonLabel = '', buttonCSSClassName: buttonCSSClassName = '' }) {
    const onInput = (e)=>{
        setSearchString(e.target.value);
    };
    const submit = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        ev.preventDefault();
        submitSearchString();
    }, [
        submitSearchString
    ]);
    // We do this to avoid nested <form>s
    // (See https://github.com/transloadit/uppy/pull/5050#discussion_r1640392516)
    const [form] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(()=>{
        const formEl = document.createElement('form');
        formEl.setAttribute('tabindex', '-1');
        formEl.id = (0, $a0ee3b646e338d67$export$ac4959f4f1338dfc)();
        return formEl;
    });
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        document.body.appendChild(form);
        form.addEventListener('submit', submit);
        return ()=>{
            form.removeEventListener('submit', submit);
            document.body.removeChild(form);
        };
    }, [
        form,
        submit
    ]);
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("section", {
        className: wrapperClassName,
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("input", {
                className: `uppy-u-reset ${inputClassName}`,
                type: "search",
                "aria-label": inputLabel,
                placeholder: inputLabel,
                value: searchString,
                onInput: onInput,
                form: form.id,
                "data-uppy-super-focusable": true
            }),
            !showButton && // 🔍
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                "aria-hidden": "true",
                focusable: "false",
                className: "uppy-c-icon uppy-ProviderBrowser-searchFilterIcon",
                width: "12",
                height: "12",
                viewBox: "0 0 12 12",
                children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M8.638 7.99l3.172 3.172a.492.492 0 1 1-.697.697L7.91 8.656a4.977 4.977 0 0 1-2.983.983C2.206 9.639 0 7.481 0 4.819 0 2.158 2.206 0 4.927 0c2.721 0 4.927 2.158 4.927 4.82a4.74 4.74 0 0 1-1.216 3.17zm-3.71.685c2.176 0 3.94-1.726 3.94-3.856 0-2.129-1.764-3.855-3.94-3.855C2.75.964.984 2.69.984 4.819c0 2.13 1.765 3.856 3.942 3.856z"
                })
            }),
            !showButton && searchString && // ❌
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                className: "uppy-u-reset uppy-ProviderBrowser-searchFilterReset",
                type: "button",
                "aria-label": clearSearchLabel,
                title: clearSearchLabel,
                onClick: ()=>setSearchString(''),
                children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                    "aria-hidden": "true",
                    focusable: "false",
                    className: "uppy-c-icon",
                    viewBox: "0 0 19 19",
                    children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                        d: "M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z"
                    })
                })
            }),
            showButton && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                className: `uppy-u-reset uppy-c-btn uppy-c-btn-primary ${buttonCSSClassName}`,
                type: "submit",
                form: form.id,
                children: buttonLabel
            })
        ]
    });
}
var $f173600a8ed11ef3$export$2e2bcd8739ae039 = $f173600a8ed11ef3$var$SearchInput;



// TODO: document what is a "tagFile" or get rid of this concept
const $67e1a0ee3f34a25a$var$getTagFile = (file, plugin, provider)=>{
    const tagFile = {
        id: file.id,
        source: plugin.id,
        name: file.name || file.id,
        type: file.mimeType,
        isRemote: true,
        data: file,
        preview: file.thumbnail || undefined,
        meta: {
            authorName: file.author?.name,
            authorUrl: file.author?.url,
            // We need to do this `|| null` check, because null value
            // for .relDirPath is `undefined` and for .relativePath is `null`.
            // I do think we should just use `null` everywhere.
            relativePath: file.relDirPath || null,
            absolutePath: file.absDirPath
        },
        body: {
            fileId: file.id
        },
        remote: {
            companionUrl: plugin.opts.companionUrl,
            url: `${provider.fileUrl(file.requestPath)}`,
            body: {
                fileId: file.id
            },
            providerName: provider.name,
            provider: provider.provider,
            requestClientId: provider.provider
        }
    };
    return tagFile;
};
var $67e1a0ee3f34a25a$export$2e2bcd8739ae039 = $67e1a0ee3f34a25a$var$getTagFile;


const $8e91ea798ebec2b3$var$addFiles = (companionFiles, plugin, provider)=>{
    const tagFiles = companionFiles.map((f)=>(0, $67e1a0ee3f34a25a$export$2e2bcd8739ae039)(f, plugin, provider));
    const filesToAdd = [];
    const filesAlreadyAdded = [];
    tagFiles.forEach((tagFile)=>{
        if (plugin.uppy.checkIfFileAlreadyExists((0, $d67267bb9859462b$export$2ff5b23440673856)(tagFile, plugin.uppy.getID()))) filesAlreadyAdded.push(tagFile);
        else filesToAdd.push(tagFile);
    });
    if (filesToAdd.length > 0) plugin.uppy.info(plugin.uppy.i18n('addedNumFiles', {
        numFiles: filesToAdd.length
    }));
    if (filesAlreadyAdded.length > 0) plugin.uppy.info(`Not adding ${filesAlreadyAdded.length} files because they already exist`);
    plugin.uppy.addFiles(filesToAdd);
};
var $8e91ea798ebec2b3$export$2e2bcd8739ae039 = $8e91ea798ebec2b3$var$addFiles;


// Shift-clicking selects a single consecutive list of items
// starting at the previous click.
const $3af8f69ec184395c$var$getClickedRange = (clickedId, displayedPartialTree, isShiftKeyPressed, lastCheckbox)=>{
    const lastCheckboxIndex = displayedPartialTree.findIndex((item)=>item.id === lastCheckbox);
    if (lastCheckboxIndex !== -1 && isShiftKeyPressed) {
        const newCheckboxIndex = displayedPartialTree.findIndex((item)=>item.id === clickedId);
        const clickedRange = displayedPartialTree.slice(Math.min(lastCheckboxIndex, newCheckboxIndex), Math.max(lastCheckboxIndex, newCheckboxIndex) + 1);
        return clickedRange.map((item)=>item.id);
    }
    return [
        clickedId
    ];
};
var $3af8f69ec184395c$export$2e2bcd8739ae039 = $3af8f69ec184395c$var$getClickedRange;


const $4ac650d5250ead28$var$handleError = (uppy)=>(error)=>{
        // authError just means we're not authenticated, don't report it
        if (error.isAuthError) return;
        // AbortError means the user has clicked "cancel" on an operation
        if (error.name === 'AbortError') {
            uppy.log('Aborting request', 'warning');
            return;
        }
        uppy.log(error, 'error');
        if (error.name === 'UserFacingApiError') uppy.info({
            message: uppy.i18n('companionError'),
            details: uppy.i18n(error.message)
        }, 'warning', 5000);
    };
var $4ac650d5250ead28$export$2e2bcd8739ae039 = $4ac650d5250ead28$var$handleError;


const $15f8d756dc46e018$var$getBreadcrumbs = (partialTree, currentFolderId)=>{
    let folder = partialTree.find((f)=>f.id === currentFolderId);
    let breadcrumbs = [];
    while(true){
        breadcrumbs = [
            folder,
            ...breadcrumbs
        ];
        if (folder.type === 'root') break;
        const currentParentId = folder.parentId;
        folder = partialTree.find((f)=>f.id === currentParentId);
    }
    return breadcrumbs;
};
var $15f8d756dc46e018$export$2e2bcd8739ae039 = $15f8d756dc46e018$var$getBreadcrumbs;


const $9b79bc726c3450f4$var$getPath = (partialTree, id, cache)=>{
    const sId = id === null ? 'null' : id;
    if (cache[sId]) return cache[sId];
    const file = partialTree.find((f)=>f.id === id);
    if (file.type === 'root') return [];
    const meAndParentPath = [
        ...$9b79bc726c3450f4$var$getPath(partialTree, file.parentId, cache),
        file
    ];
    cache[sId] = meAndParentPath;
    return meAndParentPath;
};
// See "Uppy file properties" documentation for `.absolutePath` and `.relativePath`
// (https://uppy.io/docs/uppy/#working-with-uppy-files)
const $9b79bc726c3450f4$var$getCheckedFilesWithPaths = (partialTree)=>{
    // Equivalent to `const cache = {}`, but makes keys such as 'hasOwnProperty' safe too
    const cache = Object.create(null);
    // We're only interested in injecting paths into 'checked' files
    const checkedFiles = partialTree.filter((item)=>item.type === 'file' && item.status === 'checked');
    const companionFilesWithInjectedPaths = checkedFiles.map((file)=>{
        const absFolders = $9b79bc726c3450f4$var$getPath(partialTree, file.id, cache);
        const firstCheckedFolderIndex = absFolders.findIndex((i)=>i.type === 'folder' && i.status === 'checked');
        const relFolders = absFolders.slice(firstCheckedFolderIndex);
        const absDirPath = `/${absFolders.map((i)=>i.data.name).join('/')}`;
        const relDirPath = relFolders.length === 1 ? // (https://github.com/transloadit/uppy/pull/4537#issuecomment-1629136652)
        undefined : relFolders.map((i)=>i.data.name).join('/');
        return {
            ...file.data,
            absDirPath: absDirPath,
            relDirPath: relDirPath
        };
    });
    return companionFilesWithInjectedPaths;
};
var $9b79bc726c3450f4$export$2e2bcd8739ae039 = $9b79bc726c3450f4$var$getCheckedFilesWithPaths;



// p-queue does not have a `"main"` field in its `package.json`, and that makes `import/no-unresolved` freak out.
// We can safely ignore it because bundlers will happily use the `"exports"` field instead.
var $11d558640132ea3e$exports = {};
"use strict";


/**
 * One-level copying is sufficient as mutations within our `partialTree` are limited to properties
 * such as `.status`, `.cached`, `.nextPagePath`, and not `.data = { THIS }`.
 */ const $ca2a09feaf67815d$var$shallowClone = (partialTree)=>{
    return partialTree.map((item)=>({
            ...item
        }));
};
var $ca2a09feaf67815d$export$2e2bcd8739ae039 = $ca2a09feaf67815d$var$shallowClone;


const $742a2dde4df138bd$var$recursivelyFetch = async (queue, poorTree, poorFolder, apiList, validateSingleFile)=>{
    let items = [];
    let currentPath = poorFolder.cached ? poorFolder.nextPagePath : poorFolder.id;
    while(currentPath){
        const response = await apiList(currentPath);
        items = items.concat(response.items);
        currentPath = response.nextPagePath;
    }
    const newFolders = items.filter((i)=>i.isFolder === true);
    const newFiles = items.filter((i)=>i.isFolder === false);
    const folders = newFolders.map((folder)=>({
            type: 'folder',
            id: folder.requestPath,
            cached: false,
            nextPagePath: null,
            status: 'checked',
            parentId: poorFolder.id,
            data: folder
        }));
    const files = newFiles.map((file)=>{
        const restrictionError = validateSingleFile(file);
        return {
            type: 'file',
            id: file.requestPath,
            restrictionError: restrictionError,
            status: restrictionError ? 'unchecked' : 'checked',
            parentId: poorFolder.id,
            data: file
        };
    });
    poorFolder.cached = true;
    poorFolder.nextPagePath = null;
    poorTree.push(...files, ...folders);
    folders.forEach(async (folder)=>{
        queue.add(()=>$742a2dde4df138bd$var$recursivelyFetch(queue, poorTree, folder, apiList, validateSingleFile));
    });
};
const $742a2dde4df138bd$var$afterFill = async (partialTree, apiList, validateSingleFile, reportProgress)=>{
    const queue = new (0, (/*@__PURE__*/$parcel$interopDefault($11d558640132ea3e$exports)))({
        concurrency: 6
    });
    // fill up the missing parts of a partialTree!
    const poorTree = (0, $ca2a09feaf67815d$export$2e2bcd8739ae039)(partialTree);
    const poorFolders = poorTree.filter((item)=>item.type === 'folder' && item.status === 'checked' && // either "not yet cached at all" or "some pages are left to fetch"
        (item.cached === false || item.nextPagePath));
    // per each poor folder, recursively fetch all files and make them .checked!
    poorFolders.forEach((poorFolder)=>{
        queue.add(()=>$742a2dde4df138bd$var$recursivelyFetch(queue, poorTree, poorFolder, apiList, validateSingleFile));
    });
    queue.on('completed', ()=>{
        const nOfFilesChecked = poorTree.filter((i)=>i.type === 'file' && i.status === 'checked').length;
        reportProgress(nOfFilesChecked);
    });
    await queue.onIdle();
    return poorTree;
};
var $742a2dde4df138bd$export$2e2bcd8739ae039 = $742a2dde4df138bd$var$afterFill;


const $75b69938e29d602a$var$afterOpenFolder = (oldPartialTree, discoveredItems, clickedFolder, currentPagePath, validateSingleFile)=>{
    const discoveredFolders = discoveredItems.filter((i)=>i.isFolder === true);
    const discoveredFiles = discoveredItems.filter((i)=>i.isFolder === false);
    const isParentFolderChecked = clickedFolder.type === 'folder' && clickedFolder.status === 'checked';
    const folders = discoveredFolders.map((folder)=>({
            type: 'folder',
            id: folder.requestPath,
            cached: false,
            nextPagePath: null,
            status: isParentFolderChecked ? 'checked' : 'unchecked',
            parentId: clickedFolder.id,
            data: folder
        }));
    const files = discoveredFiles.map((file)=>{
        const restrictionError = validateSingleFile(file);
        return {
            type: 'file',
            id: file.requestPath,
            restrictionError: restrictionError,
            status: isParentFolderChecked && !restrictionError ? 'checked' : 'unchecked',
            parentId: clickedFolder.id,
            data: file
        };
    });
    // just doing `clickedFolder.cached = true` in a non-mutating way
    const updatedClickedFolder = {
        ...clickedFolder,
        cached: true,
        nextPagePath: currentPagePath
    };
    const partialTreeWithUpdatedClickedFolder = oldPartialTree.map((folder)=>folder.id === updatedClickedFolder.id ? updatedClickedFolder : folder);
    const newPartialTree = [
        ...partialTreeWithUpdatedClickedFolder,
        ...folders,
        ...files
    ];
    return newPartialTree;
};
var $75b69938e29d602a$export$2e2bcd8739ae039 = $75b69938e29d602a$var$afterOpenFolder;


const $6157a596a45fd763$var$afterScrollFolder = (oldPartialTree, currentFolderId, items, nextPagePath, validateSingleFile)=>{
    const currentFolder = oldPartialTree.find((i)=>i.id === currentFolderId);
    const newFolders = items.filter((i)=>i.isFolder === true);
    const newFiles = items.filter((i)=>i.isFolder === false);
    // just doing `scrolledFolder.nextPagePath = ...` in a non-mutating way
    const scrolledFolder = {
        ...currentFolder,
        nextPagePath: nextPagePath
    };
    const partialTreeWithUpdatedScrolledFolder = oldPartialTree.map((folder)=>folder.id === scrolledFolder.id ? scrolledFolder : folder);
    const isParentFolderChecked = scrolledFolder.type === 'folder' && scrolledFolder.status === 'checked';
    const folders = newFolders.map((folder)=>({
            type: 'folder',
            id: folder.requestPath,
            cached: false,
            nextPagePath: null,
            status: isParentFolderChecked ? 'checked' : 'unchecked',
            parentId: scrolledFolder.id,
            data: folder
        }));
    const files = newFiles.map((file)=>{
        const restrictionError = validateSingleFile(file);
        return {
            type: 'file',
            id: file.requestPath,
            restrictionError: restrictionError,
            status: isParentFolderChecked && !restrictionError ? 'checked' : 'unchecked',
            parentId: scrolledFolder.id,
            data: file
        };
    });
    const newPartialTree = [
        ...partialTreeWithUpdatedScrolledFolder,
        ...folders,
        ...files
    ];
    return newPartialTree;
};
var $6157a596a45fd763$export$2e2bcd8739ae039 = $6157a596a45fd763$var$afterScrollFolder;



/*
  FROM        | TO

  root        |  root
    folder    |    folder
    folder ✅︎  |    folder ✅︎
      file    |      file ✅︎
      file    |      file ✅︎
      folder  |      folder ✅︎
        file  |        file ✅︎
    file      |    file
    file      |    file
*/ const $28868daa484a498f$var$percolateDown = (tree, id, shouldMarkAsChecked)=>{
    const children = tree.filter((item)=>item.type !== 'root' && item.parentId === id);
    children.forEach((item)=>{
        item.status = shouldMarkAsChecked && !(item.type === 'file' && item.restrictionError) ? 'checked' : 'unchecked';
        $28868daa484a498f$var$percolateDown(tree, item.id, shouldMarkAsChecked);
    });
};
/*
  FROM         | TO

  root         |  root
    folder     |    folder
    folder     |    folder [▬] ('partial' status)
      file     |      file
      folder   |      folder ✅︎
        file ✅︎ |       file ✅︎
    file       |    file
    file       |    file
*/ const $28868daa484a498f$var$percolateUp = (tree, id)=>{
    const folder = tree.find((item)=>item.id === id);
    if (folder.type === 'root') return;
    const validChildren = tree.filter((item)=>// is a child
        item.type !== 'root' && item.parentId === folder.id && // does pass validations
        !(item.type === 'file' && item.restrictionError));
    const areAllChildrenChecked = validChildren.every((item)=>item.status === 'checked');
    const areAllChildrenUnchecked = validChildren.every((item)=>item.status === 'unchecked');
    if (areAllChildrenChecked) folder.status = 'checked';
    else if (areAllChildrenUnchecked) folder.status = 'unchecked';
    else folder.status = 'partial';
    $28868daa484a498f$var$percolateUp(tree, folder.parentId);
};
const $28868daa484a498f$var$afterToggleCheckbox = (oldTree, clickedRange)=>{
    const tree = (0, $ca2a09feaf67815d$export$2e2bcd8739ae039)(oldTree);
    if (clickedRange.length >= 2) {
        // We checked two or more items
        const newlyCheckedItems = tree.filter((item)=>item.type !== 'root' && clickedRange.includes(item.id));
        newlyCheckedItems.forEach((item)=>{
            if (item.type === 'file') item.status = item.restrictionError ? 'unchecked' : 'checked';
            else item.status = 'checked';
        });
        newlyCheckedItems.forEach((item)=>{
            $28868daa484a498f$var$percolateDown(tree, item.id, true);
        });
        $28868daa484a498f$var$percolateUp(tree, newlyCheckedItems[0].parentId);
    } else {
        // We checked exactly one item
        const clickedItem = tree.find((item)=>item.id === clickedRange[0]);
        clickedItem.status = clickedItem.status === 'checked' ? 'unchecked' : 'checked';
        $28868daa484a498f$var$percolateDown(tree, clickedItem.id, clickedItem.status === 'checked');
        $28868daa484a498f$var$percolateUp(tree, clickedItem.parentId);
    }
    return tree;
};
var $28868daa484a498f$export$2e2bcd8739ae039 = $28868daa484a498f$var$afterToggleCheckbox;


var $561f5272d8ac5b76$export$2e2bcd8739ae039 = {
    afterOpenFolder: $75b69938e29d602a$export$2e2bcd8739ae039,
    afterScrollFolder: $6157a596a45fd763$export$2e2bcd8739ae039,
    afterToggleCheckbox: $28868daa484a498f$export$2e2bcd8739ae039,
    afterFill: $742a2dde4df138bd$export$2e2bcd8739ae039
};


const $b5a8e6b281aacb12$var$shouldHandleScroll = (event)=>{
    const { scrollHeight: scrollHeight, scrollTop: scrollTop, offsetHeight: offsetHeight } = event.target;
    const scrollPosition = scrollHeight - (scrollTop + offsetHeight);
    return scrollPosition < 50;
};
var $b5a8e6b281aacb12$export$2e2bcd8739ae039 = $b5a8e6b281aacb12$var$shouldHandleScroll;







function $48839592a474f204$export$2e2bcd8739ae039(props) {
    const { openFolder: openFolder, title: title, breadcrumbsIcon: breadcrumbsIcon, breadcrumbs: breadcrumbs, i18n: i18n } = props;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Provider-breadcrumbs",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-Provider-breadcrumbsIcon",
                children: breadcrumbsIcon
            }),
            breadcrumbs.map((folder, index)=>(0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
                    children: [
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                            type: "button",
                            className: "uppy-u-reset uppy-c-btn",
                            onClick: ()=>openFolder(folder.id),
                            children: folder.type === 'root' ? title : folder.data.name ?? i18n('unnamed')
                        }, folder.id),
                        breadcrumbs.length === index + 1 ? '' : ' / '
                    ]
                }))
        ]
    });
}




function $4ee9dcacd7f26785$export$2e2bcd8739ae039({ i18n: i18n, logout: logout, username: username }) {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
        children: [
            username && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                className: "uppy-ProviderBrowser-user",
                children: username
            }, "username"),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                type: "button",
                onClick: logout,
                className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowser-userLogout",
                children: i18n('logOut')
            }, "logout")
        ]
    });
}


function $6b1b801e011f359f$export$2e2bcd8739ae039(props) {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-ProviderBrowser-header",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-ProviderBrowser-headerBar', !props.showBreadcrumbs && 'uppy-ProviderBrowser-headerBar--simple'),
            children: [
                props.showBreadcrumbs && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $48839592a474f204$export$2e2bcd8739ae039), {
                    openFolder: props.openFolder,
                    breadcrumbs: props.breadcrumbs,
                    breadcrumbsIcon: props.pluginIcon?.(),
                    title: props.title,
                    i18n: props.i18n
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $4ee9dcacd7f26785$export$2e2bcd8739ae039), {
                    logout: props.logout,
                    username: props.username,
                    i18n: props.i18n
                })
            ]
        })
    });
}


function $671181bcc8a0cf10$export$b9ab270927e310e4() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
            d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
        })
    });
}
const $671181bcc8a0cf10$var$getDefaultState = (rootFolderId)=>({
        authenticated: undefined,
        partialTree: [
            {
                type: 'root',
                id: rootFolderId,
                cached: false,
                nextPagePath: null
            }
        ],
        currentFolderId: rootFolderId,
        searchString: '',
        didFirstRender: false,
        username: null,
        loading: false
    });
class $671181bcc8a0cf10$export$2e2bcd8739ae039 {
    static VERSION = (0, (/*@__PURE__*/$parcel$interopDefault($b965f41edea7ed13$exports))).version;
    plugin;
    provider;
    opts;
    isHandlingScroll = false;
    lastCheckbox = null;
    constructor(plugin, opts){
        this.plugin = plugin;
        this.provider = opts.provider;
        const defaultOptions = {
            viewType: 'list',
            showTitles: true,
            showFilter: true,
            showBreadcrumbs: true,
            loadAllFiles: false,
            virtualList: false
        };
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        this.openFolder = this.openFolder.bind(this);
        this.logout = this.logout.bind(this);
        this.handleAuth = this.handleAuth.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.resetPluginState = this.resetPluginState.bind(this);
        this.donePicking = this.donePicking.bind(this);
        this.render = this.render.bind(this);
        this.cancelSelection = this.cancelSelection.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        // Set default state for the plugin
        this.resetPluginState();
        // todo
        // @ts-expect-error this should be typed in @uppy/dashboard.
        this.plugin.uppy.on('dashboard:close-panel', this.resetPluginState);
        this.plugin.uppy.registerRequestClient(this.provider.provider, this.provider);
    }
    resetPluginState() {
        this.plugin.setPluginState($671181bcc8a0cf10$var$getDefaultState(this.plugin.rootFolderId));
    }
    tearDown() {
    // Nothing.
    }
    setLoading(loading) {
        this.plugin.setPluginState({
            loading: loading
        });
    }
    cancelSelection() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const newPartialTree = partialTree.map((item)=>item.type === 'root' ? item : {
                ...item,
                status: 'unchecked'
            });
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
    }
    #abortController;
    async #withAbort(op) {
        // prevent multiple requests in parallel from causing race conditions
        this.#abortController?.abort();
        const abortController = new AbortController();
        this.#abortController = abortController;
        const cancelRequest = ()=>{
            abortController.abort();
        };
        try {
            // @ts-expect-error this should be typed in @uppy/dashboard.
            // Even then I don't think we can make this work without adding dashboard
            // as a dependency to provider-views.
            this.plugin.uppy.on('dashboard:close-panel', cancelRequest);
            this.plugin.uppy.on('cancel-all', cancelRequest);
            await op(abortController.signal);
        } finally{
            // @ts-expect-error this should be typed in @uppy/dashboard.
            // Even then I don't think we can make this work without adding dashboard
            // as a dependency to provider-views.
            this.plugin.uppy.off('dashboard:close-panel', cancelRequest);
            this.plugin.uppy.off('cancel-all', cancelRequest);
            this.#abortController = undefined;
        }
    }
    async openFolder(folderId) {
        this.lastCheckbox = null;
        // Returning cached folder
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const clickedFolder = partialTree.find((folder)=>folder.id === folderId);
        if (clickedFolder.cached) {
            this.plugin.setPluginState({
                currentFolderId: folderId,
                searchString: ''
            });
            return;
        }
        this.setLoading(true);
        await this.#withAbort(async (signal)=>{
            let currentPagePath = folderId;
            let currentItems = [];
            do {
                const { username: username, nextPagePath: nextPagePath, items: items } = await this.provider.list(currentPagePath, {
                    signal: signal
                });
                // It's important to set the username during one of our first fetches
                this.plugin.setPluginState({
                    username: username
                });
                currentPagePath = nextPagePath;
                currentItems = currentItems.concat(items);
                this.setLoading(this.plugin.uppy.i18n('loadedXFiles', {
                    numFiles: currentItems.length
                }));
            }while (this.opts.loadAllFiles && currentPagePath);
            const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterOpenFolder(partialTree, currentItems, clickedFolder, currentPagePath, this.validateSingleFile);
            this.plugin.setPluginState({
                partialTree: newPartialTree,
                currentFolderId: folderId,
                searchString: ''
            });
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
        this.setLoading(false);
    }
    /**
     * Removes session token on client side.
     */ async logout() {
        await this.#withAbort(async (signal)=>{
            const res = await this.provider.logout({
                signal: signal
            });
            // res.ok is from the JSON body, not to be confused with Response.ok
            if (res.ok) {
                if (!res.revoked) {
                    const message = this.plugin.uppy.i18n('companionUnauthorizeHint', {
                        provider: this.plugin.title,
                        url: res.manual_revoke_url
                    });
                    this.plugin.uppy.info(message, 'info', 7000);
                }
                this.plugin.setPluginState({
                    ...$671181bcc8a0cf10$var$getDefaultState(this.plugin.rootFolderId),
                    authenticated: false
                });
            }
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
    }
    async handleAuth(authFormData) {
        await this.#withAbort(async (signal)=>{
            this.setLoading(true);
            await this.provider.login({
                authFormData: authFormData,
                signal: signal
            });
            this.plugin.setPluginState({
                authenticated: true
            });
            await Promise.all([
                this.provider.fetchPreAuthToken(),
                this.openFolder(this.plugin.rootFolderId)
            ]);
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
        this.setLoading(false);
    }
    async handleScroll(event) {
        const { partialTree: partialTree, currentFolderId: currentFolderId } = this.plugin.getPluginState();
        const currentFolder = partialTree.find((i)=>i.id === currentFolderId);
        if ((0, $b5a8e6b281aacb12$export$2e2bcd8739ae039)(event) && !this.isHandlingScroll && currentFolder.nextPagePath) {
            this.isHandlingScroll = true;
            await this.#withAbort(async (signal)=>{
                const { nextPagePath: nextPagePath, items: items } = await this.provider.list(currentFolder.nextPagePath, {
                    signal: signal
                });
                const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterScrollFolder(partialTree, currentFolderId, items, nextPagePath, this.validateSingleFile);
                this.plugin.setPluginState({
                    partialTree: newPartialTree
                });
            }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
            this.isHandlingScroll = false;
        }
    }
    validateSingleFile = (file)=>{
        const companionFile = (0, $d0cca3c9705b0857$export$2e2bcd8739ae039)(file);
        const result = this.plugin.uppy.validateSingleFile(companionFile);
        return result;
    };
    async donePicking() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        this.setLoading(true);
        await this.#withAbort(async (signal)=>{
            // 1. Enrich our partialTree by fetching all 'checked' but not-yet-fetched folders
            const enrichedTree = await (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterFill(partialTree, (path)=>this.provider.list(path, {
                    signal: signal
                }), this.validateSingleFile, (n)=>{
                this.setLoading(this.plugin.uppy.i18n('addedNumFiles', {
                    numFiles: n
                }));
            });
            // 2. Now that we know how many files there are - recheck aggregateRestrictions!
            const aggregateRestrictionError = this.validateAggregateRestrictions(enrichedTree);
            if (aggregateRestrictionError) {
                this.plugin.setPluginState({
                    partialTree: enrichedTree
                });
                return;
            }
            // 3. Add files
            const companionFiles = (0, $9b79bc726c3450f4$export$2e2bcd8739ae039)(enrichedTree);
            (0, $8e91ea798ebec2b3$export$2e2bcd8739ae039)(companionFiles, this.plugin, this.provider);
            // 4. Reset state
            this.resetPluginState();
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
        this.setLoading(false);
    }
    toggleCheckbox(ourItem, isShiftKeyPressed) {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const clickedRange = (0, $3af8f69ec184395c$export$2e2bcd8739ae039)(ourItem.id, this.getDisplayedPartialTree(), isShiftKeyPressed, this.lastCheckbox);
        const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterToggleCheckbox(partialTree, clickedRange);
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
        this.lastCheckbox = ourItem.id;
    }
    getDisplayedPartialTree = ()=>{
        const { partialTree: partialTree, currentFolderId: currentFolderId, searchString: searchString } = this.plugin.getPluginState();
        const inThisFolder = partialTree.filter((item)=>item.type !== 'root' && item.parentId === currentFolderId);
        const filtered = searchString === '' ? inThisFolder : inThisFolder.filter((item)=>(item.data.name ?? this.plugin.uppy.i18n('unnamed')).toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
        return filtered;
    };
    getBreadcrumbs = ()=>{
        const { partialTree: partialTree, currentFolderId: currentFolderId } = this.plugin.getPluginState();
        return (0, $15f8d756dc46e018$export$2e2bcd8739ae039)(partialTree, currentFolderId);
    };
    getSelectedAmount = ()=>{
        const { partialTree: partialTree } = this.plugin.getPluginState();
        return (0, $3599f082ce07508f$export$2e2bcd8739ae039)(partialTree);
    };
    validateAggregateRestrictions = (partialTree)=>{
        const checkedFiles = partialTree.filter((item)=>item.type === 'file' && item.status === 'checked');
        const uppyFiles = checkedFiles.map((file)=>file.data);
        return this.plugin.uppy.validateAggregateRestrictions(uppyFiles);
    };
    render(state, viewOptions = {}) {
        const { didFirstRender: didFirstRender } = this.plugin.getPluginState();
        const { i18n: i18n } = this.plugin.uppy;
        if (!didFirstRender) {
            this.plugin.setPluginState({
                didFirstRender: true
            });
            this.provider.fetchPreAuthToken();
            this.openFolder(this.plugin.rootFolderId);
        }
        const opts = {
            ...this.opts,
            ...viewOptions
        };
        const { authenticated: authenticated, loading: loading } = this.plugin.getPluginState();
        const pluginIcon = this.plugin.icon || $671181bcc8a0cf10$export$b9ab270927e310e4;
        if (authenticated === false) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $616f0acd28bd0dc4$export$2e2bcd8739ae039), {
            pluginName: this.plugin.title,
            pluginIcon: pluginIcon,
            handleAuth: this.handleAuth,
            i18n: this.plugin.uppy.i18n,
            renderForm: opts.renderAuthForm,
            loading: loading
        });
        const { partialTree: partialTree, username: username, searchString: searchString } = this.plugin.getPluginState();
        const breadcrumbs = this.getBreadcrumbs();
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-ProviderBrowser', `uppy-ProviderBrowser-viewType--${opts.viewType}`),
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $6b1b801e011f359f$export$2e2bcd8739ae039), {
                    showBreadcrumbs: opts.showBreadcrumbs,
                    openFolder: this.openFolder,
                    breadcrumbs: breadcrumbs,
                    pluginIcon: pluginIcon,
                    title: this.plugin.title,
                    logout: this.logout,
                    username: username,
                    i18n: i18n
                }),
                opts.showFilter && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $f173600a8ed11ef3$export$2e2bcd8739ae039), {
                    searchString: searchString,
                    setSearchString: (s)=>{
                        this.plugin.setPluginState({
                            searchString: s
                        });
                    },
                    submitSearchString: ()=>{},
                    inputLabel: i18n('filter'),
                    clearSearchLabel: i18n('resetFilter'),
                    wrapperClassName: "uppy-ProviderBrowser-searchFilter",
                    inputClassName: "uppy-ProviderBrowser-searchFilterInput"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $ffc120143b595bcb$export$2e2bcd8739ae039), {
                    toggleCheckbox: this.toggleCheckbox,
                    displayedPartialTree: this.getDisplayedPartialTree(),
                    openFolder: this.openFolder,
                    virtualList: opts.virtualList,
                    noResultsLabel: i18n('noFilesFound'),
                    handleScroll: this.handleScroll,
                    viewType: opts.viewType,
                    showTitles: opts.showTitles,
                    i18n: this.plugin.uppy.i18n,
                    isLoading: loading,
                    utmSource: "Companion"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $4ab2a94a3ee5ad67$export$2e2bcd8739ae039), {
                    partialTree: partialTree,
                    donePicking: this.donePicking,
                    cancelSelection: this.cancelSelection,
                    i18n: i18n,
                    validateAggregateRestrictions: this.validateAggregateRestrictions
                })
            ]
        });
    }
}


















const $3174b53b600a62c5$var$defaultState = {
    loading: false,
    searchString: '',
    partialTree: [
        {
            type: 'root',
            id: null,
            cached: false,
            nextPagePath: null
        }
    ],
    currentFolderId: null,
    isInputMode: true
};
const $3174b53b600a62c5$var$defaultOptions = {
    viewType: 'grid',
    showTitles: true,
    showFilter: true,
    utmSource: 'Companion'
};
class $3174b53b600a62c5$export$2e2bcd8739ae039 {
    static VERSION = (0, (/*@__PURE__*/$parcel$interopDefault($b965f41edea7ed13$exports))).version;
    plugin;
    provider;
    opts;
    isHandlingScroll = false;
    lastCheckbox = null;
    constructor(plugin, opts){
        this.plugin = plugin;
        this.provider = opts.provider;
        this.opts = {
            ...$3174b53b600a62c5$var$defaultOptions,
            ...opts
        };
        this.setSearchString = this.setSearchString.bind(this);
        this.search = this.search.bind(this);
        this.resetPluginState = this.resetPluginState.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.donePicking = this.donePicking.bind(this);
        this.cancelSelection = this.cancelSelection.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.render = this.render.bind(this);
        // Set default state for the plugin
        this.resetPluginState();
        // @ts-expect-error this should be typed in @uppy/dashboard.
        this.plugin.uppy.on('dashboard:close-panel', this.resetPluginState);
        this.plugin.uppy.registerRequestClient(this.provider.provider, this.provider);
    }
    tearDown() {
    // Nothing.
    }
    setLoading(loading) {
        this.plugin.setPluginState({
            loading: loading
        });
    }
    resetPluginState() {
        this.plugin.setPluginState($3174b53b600a62c5$var$defaultState);
    }
    cancelSelection() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const newPartialTree = partialTree.map((item)=>item.type === 'root' ? item : {
                ...item,
                status: 'unchecked'
            });
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
    }
    async search() {
        const { searchString: searchString } = this.plugin.getPluginState();
        if (searchString === '') return;
        this.setLoading(true);
        try {
            const response = await this.provider.search(searchString);
            const newPartialTree = [
                {
                    type: 'root',
                    id: null,
                    cached: false,
                    nextPagePath: response.nextPageQuery
                },
                ...response.items.map((item)=>({
                        type: 'file',
                        id: item.requestPath,
                        status: 'unchecked',
                        parentId: null,
                        data: item
                    }))
            ];
            this.plugin.setPluginState({
                partialTree: newPartialTree,
                isInputMode: false
            });
        } catch (error) {
            (0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy)(error);
        }
        this.setLoading(false);
    }
    async handleScroll(event) {
        const { partialTree: partialTree, searchString: searchString } = this.plugin.getPluginState();
        const root = partialTree.find((i)=>i.type === 'root');
        if ((0, $b5a8e6b281aacb12$export$2e2bcd8739ae039)(event) && !this.isHandlingScroll && root.nextPagePath) {
            this.isHandlingScroll = true;
            try {
                const response = await this.provider.search(searchString, root.nextPagePath);
                const newRoot = {
                    ...root,
                    nextPagePath: response.nextPageQuery
                };
                const oldItems = partialTree.filter((i)=>i.type !== 'root');
                const newPartialTree = [
                    newRoot,
                    ...oldItems,
                    ...response.items.map((item)=>({
                            type: 'file',
                            id: item.requestPath,
                            status: 'unchecked',
                            parentId: null,
                            data: item
                        }))
                ];
                this.plugin.setPluginState({
                    partialTree: newPartialTree
                });
            } catch (error) {
                (0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy)(error);
            }
            this.isHandlingScroll = false;
        }
    }
    async donePicking() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        // 1. Add files
        const companionFiles = (0, $9b79bc726c3450f4$export$2e2bcd8739ae039)(partialTree);
        (0, $8e91ea798ebec2b3$export$2e2bcd8739ae039)(companionFiles, this.plugin, this.provider);
        // 2. Reset state
        this.resetPluginState();
    }
    toggleCheckbox(ourItem, isShiftKeyPressed) {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const clickedRange = (0, $3af8f69ec184395c$export$2e2bcd8739ae039)(ourItem.id, this.getDisplayedPartialTree(), isShiftKeyPressed, this.lastCheckbox);
        const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterToggleCheckbox(partialTree, clickedRange);
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
        this.lastCheckbox = ourItem.id;
    }
    validateSingleFile = (file)=>{
        const companionFile = (0, $d0cca3c9705b0857$export$2e2bcd8739ae039)(file);
        const result = this.plugin.uppy.validateSingleFile(companionFile);
        return result;
    };
    getDisplayedPartialTree = ()=>{
        const { partialTree: partialTree } = this.plugin.getPluginState();
        return partialTree.filter((item)=>item.type !== 'root');
    };
    setSearchString = (searchString)=>{
        this.plugin.setPluginState({
            searchString: searchString
        });
        if (searchString === '') this.plugin.setPluginState({
            partialTree: []
        });
    };
    validateAggregateRestrictions = (partialTree)=>{
        const checkedFiles = partialTree.filter((item)=>item.type === 'file' && item.status === 'checked');
        const uppyFiles = checkedFiles.map((file)=>file.data);
        return this.plugin.uppy.validateAggregateRestrictions(uppyFiles);
    };
    render(state, viewOptions = {}) {
        const { isInputMode: isInputMode, searchString: searchString, loading: loading, partialTree: partialTree } = this.plugin.getPluginState();
        const { i18n: i18n } = this.plugin.uppy;
        const opts = {
            ...this.opts,
            ...viewOptions
        };
        if (isInputMode) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $f173600a8ed11ef3$export$2e2bcd8739ae039), {
            searchString: searchString,
            setSearchString: this.setSearchString,
            submitSearchString: this.search,
            inputLabel: i18n('enterTextToSearch'),
            buttonLabel: i18n('searchImages'),
            wrapperClassName: "uppy-SearchProvider",
            inputClassName: "uppy-c-textInput uppy-SearchProvider-input",
            showButton: true,
            buttonCSSClassName: "uppy-SearchProvider-searchButton"
        });
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-ProviderBrowser', `uppy-ProviderBrowser-viewType--${opts.viewType}`),
            children: [
                opts.showFilter && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $f173600a8ed11ef3$export$2e2bcd8739ae039), {
                    searchString: searchString,
                    setSearchString: this.setSearchString,
                    submitSearchString: this.search,
                    inputLabel: i18n('search'),
                    clearSearchLabel: i18n('resetSearch'),
                    wrapperClassName: "uppy-ProviderBrowser-searchFilter",
                    inputClassName: "uppy-ProviderBrowser-searchFilterInput"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $ffc120143b595bcb$export$2e2bcd8739ae039), {
                    toggleCheckbox: this.toggleCheckbox,
                    displayedPartialTree: this.getDisplayedPartialTree(),
                    handleScroll: this.handleScroll,
                    openFolder: async ()=>{},
                    noResultsLabel: i18n('noSearchResults'),
                    viewType: opts.viewType,
                    showTitles: opts.showTitles,
                    isLoading: loading,
                    i18n: i18n,
                    virtualList: false,
                    utmSource: this.opts.utmSource
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $4ab2a94a3ee5ad67$export$2e2bcd8739ae039), {
                    partialTree: partialTree,
                    donePicking: this.donePicking,
                    cancelSelection: this.cancelSelection,
                    i18n: i18n,
                    validateAggregateRestrictions: this.validateAggregateRestrictions
                })
            ]
        });
    }
}







/**
 * Low-pass filter using Exponential Moving Averages (aka exponential smoothing)
 * Filters a sequence of values by updating the mixing the previous output value
 * with the new input using the exponential window function
 *
 * @param newValue the n-th value of the sequence
 * @param previousSmoothedValue the exponential average of the first n-1 values
 * @param halfLife value of `dt` to move the smoothed value halfway between `previousFilteredValue` and `newValue`
 * @param dt time elapsed between adding the (n-1)th and the n-th values
 * @returns the exponential average of the first n values
 */ function $4e5b770b58150a1e$export$2e2bcd8739ae039(newValue, previousSmoothedValue, halfLife, dt) {
    if (halfLife === 0 || newValue === previousSmoothedValue) return newValue;
    if (dt === 0) return previousSmoothedValue;
    return newValue + (previousSmoothedValue - newValue) * 2 ** (-dt / halfLife);
}




var $f0153c73a5fa0fd8$exports = {};
$f0153c73a5fa0fd8$exports = JSON.parse("{\"name\":\"@uppy/status-bar\",\"description\":\"A progress bar for Uppy, with many bells and whistles.\",\"version\":\"4.2.3\",\"license\":\"MIT\",\"main\":\"lib/index.js\",\"style\":\"dist/style.min.css\",\"type\":\"module\",\"scripts\":{\"build\":\"tsc --build tsconfig.build.json\",\"build:css\":\"sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css\",\"typecheck\":\"tsc --build\"},\"keywords\":[\"file uploader\",\"uppy\",\"uppy-plugin\",\"progress bar\",\"status bar\",\"progress\",\"upload\",\"eta\",\"speed\"],\"homepage\":\"https://uppy.io\",\"bugs\":{\"url\":\"https://github.com/transloadit/uppy/issues\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/transloadit/uppy.git\"},\"files\":[\"src\",\"lib\",\"dist\",\"CHANGELOG.md\"],\"dependencies\":{\"@transloadit/prettier-bytes\":\"^0.3.4\",\"@uppy/utils\":\"^6.2.2\",\"classnames\":\"^2.2.6\",\"preact\":\"^10.5.13\"},\"peerDependencies\":{\"@uppy/core\":\"^4.5.2\"},\"devDependencies\":{\"cssnano\":\"^7.0.7\",\"postcss\":\"^8.5.6\",\"postcss-cli\":\"^11.0.1\",\"sass\":\"^1.89.2\",\"typescript\":\"^5.8.3\"}}");


var $f9ab456b3e2aaacb$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the status bar while files are being uploaded.
        uploading: 'Uploading',
        // Shown in the status bar once all files have been uploaded.
        complete: 'Complete',
        // Shown in the status bar if an upload failed.
        uploadFailed: 'Upload failed',
        // Shown in the status bar while the upload is paused.
        paused: 'Paused',
        // Used as the label for the button that retries an upload.
        retry: 'Retry',
        // Used as the label for the button that cancels an upload.
        cancel: 'Cancel',
        // Used as the label for the button that pauses an upload.
        pause: 'Pause',
        // Used as the label for the button that resumes an upload.
        resume: 'Resume',
        // Used as the label for the button that resets the upload state after an upload
        done: 'Done',
        // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
        filesUploadedOfTotal: {
            0: '%{complete} of %{smart_count} file uploaded',
            1: '%{complete} of %{smart_count} files uploaded'
        },
        // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
        dataUploadedOfTotal: '%{complete} of %{total}',
        dataUploadedOfUnknown: '%{complete} of unknown',
        // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
        xTimeLeft: '%{time} left',
        // Used as the label for the button that starts an upload.
        uploadXFiles: {
            0: 'Upload %{smart_count} file',
            1: 'Upload %{smart_count} files'
        },
        // Used as the label for the button that starts an upload, if another upload has been started in the past
        // and new files were added later.
        uploadXNewFiles: {
            0: 'Upload +%{smart_count} file',
            1: 'Upload +%{smart_count} files'
        },
        upload: 'Upload',
        retryUpload: 'Retry upload',
        xMoreFilesAdded: {
            0: '%{smart_count} more file added',
            1: '%{smart_count} more files added'
        },
        showErrorDetails: 'Show error details'
    }
};


var $5278b2bb79ab63f5$export$2e2bcd8739ae039 = {
    STATE_ERROR: 'error',
    STATE_WAITING: 'waiting',
    STATE_PREPROCESSING: 'preprocessing',
    STATE_UPLOADING: 'uploading',
    STATE_POSTPROCESSING: 'postprocessing',
    STATE_COMPLETE: 'complete'
};







function $1bd6564471caa0d9$export$2e2bcd8739ae039(rawSeconds) {
    const hours = Math.floor(rawSeconds / 3600) % 24;
    const minutes = Math.floor(rawSeconds / 60) % 60;
    const seconds = Math.floor(rawSeconds % 60);
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}


function $cf4f21df8a3b103f$export$2e2bcd8739ae039(seconds) {
    const time = (0, $1bd6564471caa0d9$export$2e2bcd8739ae039)(seconds);
    // Only display hours and minutes if they are greater than 0 but always
    // display minutes if hours is being displayed
    // Display a leading zero if the there is a preceding unit: 1m 05s, but 5s
    const hoursStr = time.hours === 0 ? '' : `${time.hours}h`;
    const minutesStr = time.minutes === 0 ? '' : `${time.hours === 0 ? time.minutes : ` ${time.minutes.toString(10).padStart(2, '0')}`}m`;
    const secondsStr = time.hours !== 0 ? '' : `${time.minutes === 0 ? time.seconds : ` ${time.seconds.toString(10).padStart(2, '0')}`}s`;
    return `${hoursStr}${minutesStr}${secondsStr}`;
}





const $c0c4f933fc4ac9a2$var$DOT = `\u00B7`;
const $c0c4f933fc4ac9a2$var$renderDot = ()=>` ${$c0c4f933fc4ac9a2$var$DOT} `;
function $c0c4f933fc4ac9a2$export$8fd979504d9f59d1(props) {
    const { newFiles: newFiles, isUploadStarted: isUploadStarted, recoveredState: recoveredState, i18n: i18n, uploadState: uploadState, isSomeGhost: isSomeGhost, startUpload: startUpload } = props;
    const uploadBtnClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-u-reset', 'uppy-c-btn', 'uppy-StatusBar-actionBtn', 'uppy-StatusBar-actionBtn--upload', {
        'uppy-c-btn-primary': uploadState === (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING
    }, {
        'uppy-StatusBar-actionBtn--disabled': isSomeGhost
    });
    const uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n('uploadXNewFiles', {
        smart_count: newFiles
    }) : i18n('uploadXFiles', {
        smart_count: newFiles
    });
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n('uploadXFiles', {
            smart_count: newFiles
        }),
        onClick: startUpload,
        disabled: isSomeGhost,
        "data-uppy-super-focusable": true,
        children: uploadBtnText
    });
}
function $c0c4f933fc4ac9a2$export$d0263dca13d9e524(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
        "aria-label": i18n('retryUpload'),
        onClick: ()=>uppy.retryAll().catch(()=>{
            /* Error reported and handled via an event */ }),
        "data-uppy-super-focusable": true,
        "data-cy": "retry",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                "aria-hidden": "true",
                focusable: "false",
                className: "uppy-c-icon",
                width: "8",
                height: "10",
                viewBox: "0 0 8 10",
                children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
                })
            }),
            i18n('retry')
        ]
    });
}
function $c0c4f933fc4ac9a2$export$bda6e5e4654fa168(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
        type: "button",
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        title: i18n('cancel'),
        "aria-label": i18n('cancel'),
        onClick: ()=>uppy.cancelAll(),
        "data-cy": "cancel",
        "data-uppy-super-focusable": true,
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("circle", {
                        fill: "#888",
                        cx: "8",
                        cy: "8",
                        r: "8"
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                        fill: "#FFF",
                        d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
                    })
                ]
            })
        })
    });
}
function $c0c4f933fc4ac9a2$export$f8fda1be68e432db(props) {
    const { isAllPaused: isAllPaused, i18n: i18n, isAllComplete: isAllComplete, resumableUploads: resumableUploads, uppy: uppy } = props;
    const title = isAllPaused ? i18n('resume') : i18n('pause');
    function togglePauseResume() {
        if (isAllComplete) return;
        if (!resumableUploads) {
            uppy.cancelAll();
            return;
        }
        if (isAllPaused) {
            uppy.resumeAll();
            return;
        }
        uppy.pauseAll();
    }
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
        title: title,
        "aria-label": title,
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        type: "button",
        onClick: togglePauseResume,
        "data-cy": "togglePauseResume",
        "data-uppy-super-focusable": true,
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("circle", {
                        fill: "#888",
                        cx: "8",
                        cy: "8",
                        r: "8"
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                        fill: "#FFF",
                        d: isAllPaused ? 'M6 4.25L11.5 8 6 11.75z' : 'M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z'
                    })
                ]
            })
        })
    });
}
function $c0c4f933fc4ac9a2$export$c5b3ad0eb3665a4a(props) {
    const { i18n: i18n, doneButtonHandler: doneButtonHandler } = props;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
        onClick: doneButtonHandler,
        "data-uppy-super-focusable": true,
        children: i18n('done')
    });
}
function $c0c4f933fc4ac9a2$export$b08b517936747730() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        className: "uppy-StatusBar-spinner",
        "aria-hidden": "true",
        focusable: "false",
        width: "14",
        height: "14",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
            d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
            fillRule: "evenodd"
        })
    });
}
function $c0c4f933fc4ac9a2$export$f10e066f2fffa2e8(props) {
    const { progress: progress } = props;
    const { value: value, mode: mode, message: message } = progress;
    const dot = `\u00B7`;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-StatusBar-content",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($c0c4f933fc4ac9a2$export$b08b517936747730, {}),
            mode === 'determinate' ? `${Math.round(value * 100)}% ${dot} ` : '',
            message
        ]
    });
}
function $c0c4f933fc4ac9a2$export$511da99642518663(props) {
    const { numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, i18n: i18n } = props;
    const ifShowFilesUploadedOfTotal = numUploads > 1;
    const totalUploadedSizeStr = (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalUploadedSize);
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-StatusBar-statusSecondary",
        children: [
            ifShowFilesUploadedOfTotal && i18n('filesUploadedOfTotal', {
                complete: complete,
                smart_count: numUploads
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                className: "uppy-StatusBar-additionalInfo",
                children: [
                    ifShowFilesUploadedOfTotal && $c0c4f933fc4ac9a2$var$renderDot(),
                    totalSize != null ? i18n('dataUploadedOfTotal', {
                        complete: totalUploadedSizeStr,
                        total: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalSize)
                    }) : i18n('dataUploadedOfUnknown', {
                        complete: totalUploadedSizeStr
                    }),
                    $c0c4f933fc4ac9a2$var$renderDot(),
                    totalETA != null && i18n('xTimeLeft', {
                        time: (0, $cf4f21df8a3b103f$export$2e2bcd8739ae039)(totalETA)
                    })
                ]
            })
        ]
    });
}
function $c0c4f933fc4ac9a2$var$FileUploadCount(props) {
    const { i18n: i18n, complete: complete, numUploads: numUploads } = props;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-StatusBar-statusSecondary",
        children: i18n('filesUploadedOfTotal', {
            complete: complete,
            smart_count: numUploads
        })
    });
}
function $c0c4f933fc4ac9a2$var$UploadNewlyAddedFiles(props) {
    const { i18n: i18n, newFiles: newFiles, startUpload: startUpload } = props;
    const uploadBtnClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-u-reset', 'uppy-c-btn', 'uppy-StatusBar-actionBtn', 'uppy-StatusBar-actionBtn--uploadNewlyAdded');
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-StatusBar-statusSecondary",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-StatusBar-statusSecondaryHint",
                children: i18n('xMoreFilesAdded', {
                    smart_count: newFiles
                })
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                type: "button",
                className: uploadBtnClassNames,
                "aria-label": i18n('uploadXFiles', {
                    smart_count: newFiles
                }),
                onClick: startUpload,
                children: i18n('upload')
            })
        ]
    });
}
function $c0c4f933fc4ac9a2$export$2d75d7371a967988(props) {
    const { i18n: i18n, supportsUploadProgress: supportsUploadProgress, totalProgress: totalProgress, showProgressDetails: showProgressDetails, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused, newFiles: newFiles, numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, startUpload: startUpload } = props;
    const showUploadNewlyAddedFiles = newFiles && isUploadStarted;
    if (!isUploadStarted || isAllComplete) return null;
    const title = isAllPaused ? i18n('paused') : i18n('uploading');
    function renderProgressDetails() {
        if (!isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails) {
            if (supportsUploadProgress) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($c0c4f933fc4ac9a2$export$511da99642518663, {
                numUploads: numUploads,
                complete: complete,
                totalUploadedSize: totalUploadedSize,
                totalSize: totalSize,
                totalETA: totalETA,
                i18n: i18n
            });
            return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($c0c4f933fc4ac9a2$var$FileUploadCount, {
                i18n: i18n,
                complete: complete,
                numUploads: numUploads
            });
        }
        return null;
    }
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-StatusBar-content",
        title: title,
        children: [
            !isAllPaused ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($c0c4f933fc4ac9a2$export$b08b517936747730, {}) : null,
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-StatusBar-status",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-StatusBar-statusPrimary",
                        children: supportsUploadProgress && totalProgress !== 0 ? `${title}: ${totalProgress}%` : title
                    }),
                    renderProgressDetails(),
                    showUploadNewlyAddedFiles ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($c0c4f933fc4ac9a2$var$UploadNewlyAddedFiles, {
                        i18n: i18n,
                        newFiles: newFiles,
                        startUpload: startUpload
                    }) : null
                ]
            })
        ]
    });
}
function $c0c4f933fc4ac9a2$export$8dc84f0e764ad25e(props) {
    const { i18n: i18n } = props;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-StatusBar-content",
        // biome-ignore lint/a11y/useSemanticElements: ...
        role: "status",
        title: i18n('complete'),
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: "uppy-StatusBar-status",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-StatusBar-statusPrimary",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                        "aria-hidden": "true",
                        focusable: "false",
                        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
                        width: "15",
                        height: "11",
                        viewBox: "0 0 15 11",
                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                            d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
                        })
                    }),
                    i18n('complete')
                ]
            })
        })
    });
}
function $c0c4f933fc4ac9a2$export$7331502eb9534bdb(props) {
    const { error: error, i18n: i18n, complete: complete, numUploads: numUploads } = props;
    function displayErrorAlert() {
        const errorMessage = `${i18n('uploadFailed')} \n\n ${error}`;
        alert(errorMessage); // TODO: move to custom alert implementation
    }
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-StatusBar-content",
        title: i18n('uploadFailed'),
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                "aria-hidden": "true",
                focusable: "false",
                className: "uppy-StatusBar-statusIndicator uppy-c-icon",
                width: "11",
                height: "11",
                viewBox: "0 0 11 11",
                children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
                })
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-StatusBar-status",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-StatusBar-statusPrimary",
                        children: [
                            i18n('uploadFailed'),
                            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                                className: "uppy-u-reset uppy-StatusBar-details",
                                "aria-label": i18n('showErrorDetails'),
                                "data-microtip-position": "top-right",
                                "data-microtip-size": "medium",
                                onClick: displayErrorAlert,
                                type: "button",
                                children: "?"
                            })
                        ]
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($c0c4f933fc4ac9a2$var$FileUploadCount, {
                        i18n: i18n,
                        complete: complete,
                        numUploads: numUploads
                    })
                ]
            })
        ]
    });
}


function $3d16a6a6f033a885$export$2e2bcd8739ae039(files) {
    const values = [];
    let mode = 'indeterminate';
    let message;
    for (const { progress: progress } of Object.values(files)){
        const { preprocess: preprocess, postprocess: postprocess } = progress;
        // In the future we should probably do this differently. For now we'll take the
        // mode and message from the first file…
        if (message == null && (preprocess || postprocess)) ({ mode: mode, message: message } = preprocess || postprocess);
        if (preprocess?.mode === 'determinate') values.push(preprocess.value);
        if (postprocess?.mode === 'determinate') values.push(postprocess.value);
    }
    const value = values.reduce((total, progressValue)=>{
        return total + progressValue / values.length;
    }, 0);
    return {
        mode: mode,
        message: message,
        value: value
    };
}



const { STATE_ERROR: $4af84b49d740c94f$var$STATE_ERROR, STATE_WAITING: $4af84b49d740c94f$var$STATE_WAITING, STATE_PREPROCESSING: $4af84b49d740c94f$var$STATE_PREPROCESSING, STATE_UPLOADING: $4af84b49d740c94f$var$STATE_UPLOADING, STATE_POSTPROCESSING: $4af84b49d740c94f$var$STATE_POSTPROCESSING, STATE_COMPLETE: $4af84b49d740c94f$var$STATE_COMPLETE } = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039);
function $4af84b49d740c94f$export$2e2bcd8739ae039({ newFiles: newFiles, allowNewUpload: allowNewUpload, isUploadInProgress: isUploadInProgress, isAllPaused: isAllPaused, resumableUploads: resumableUploads, error: error, hideUploadButton: hideUploadButton, hidePauseResumeButton: hidePauseResumeButton = false, hideCancelButton: hideCancelButton = false, hideRetryButton: hideRetryButton = false, recoveredState: recoveredState, uploadState: uploadState, totalProgress: totalProgress, files: files, supportsUploadProgress: supportsUploadProgress, hideAfterFinish: hideAfterFinish = false, isSomeGhost: isSomeGhost, doneButtonHandler: doneButtonHandler, isUploadStarted: isUploadStarted, i18n: i18n, startUpload: startUpload, uppy: uppy, isAllComplete: isAllComplete, showProgressDetails: showProgressDetails, numUploads: numUploads, complete: complete, totalSize: totalSize, totalETA: totalETA, totalUploadedSize: totalUploadedSize }) {
    function getProgressValue() {
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
                {
                    const progress = (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files);
                    if (progress.mode === 'determinate') return progress.value * 100;
                    return totalProgress;
                }
            case $4af84b49d740c94f$var$STATE_ERROR:
                return null;
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return null;
                return totalProgress;
            default:
                return totalProgress;
        }
    }
    function getIsIndeterminate() {
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
                {
                    const { mode: mode } = (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files);
                    return mode === 'indeterminate';
                }
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return true;
                return false;
            default:
                return false;
        }
    }
    const progressValue = getProgressValue();
    const width = progressValue ?? 100;
    const showUploadBtn = !error && newFiles && (!isUploadInProgress && !isAllPaused || recoveredState) && allowNewUpload && !hideUploadButton;
    const showCancelBtn = !hideCancelButton && uploadState !== $4af84b49d740c94f$var$STATE_WAITING && uploadState !== $4af84b49d740c94f$var$STATE_COMPLETE;
    const showPauseResumeBtn = resumableUploads && !hidePauseResumeButton && uploadState === $4af84b49d740c94f$var$STATE_UPLOADING;
    const showRetryBtn = error && !isAllComplete && !hideRetryButton;
    const showDoneBtn = doneButtonHandler && uploadState === $4af84b49d740c94f$var$STATE_COMPLETE;
    const progressClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-StatusBar-progress', {
        'is-indeterminate': getIsIndeterminate()
    });
    const statusBarClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-StatusBar', `is-${uploadState}`, {
        'has-ghosts': isSomeGhost
    });
    const progressBarStateEl = (()=>{
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
                return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $c0c4f933fc4ac9a2$export$f10e066f2fffa2e8), {
                    progress: (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files)
                });
            case $4af84b49d740c94f$var$STATE_COMPLETE:
                return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $c0c4f933fc4ac9a2$export$8dc84f0e764ad25e), {
                    i18n: i18n
                });
            case $4af84b49d740c94f$var$STATE_ERROR:
                return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $c0c4f933fc4ac9a2$export$7331502eb9534bdb), {
                    error: error,
                    i18n: i18n,
                    numUploads: numUploads,
                    complete: complete
                });
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $c0c4f933fc4ac9a2$export$2d75d7371a967988), {
                    i18n: i18n,
                    supportsUploadProgress: supportsUploadProgress,
                    totalProgress: totalProgress,
                    showProgressDetails: showProgressDetails,
                    isUploadStarted: isUploadStarted,
                    isAllComplete: isAllComplete,
                    isAllPaused: isAllPaused,
                    newFiles: newFiles,
                    numUploads: numUploads,
                    complete: complete,
                    totalUploadedSize: totalUploadedSize,
                    totalSize: totalSize,
                    totalETA: totalETA,
                    startUpload: startUpload
                });
            default:
                return null;
        }
    })();
    const atLeastOneAction = showUploadBtn || showRetryBtn || showPauseResumeBtn || showCancelBtn || showDoneBtn;
    const thereIsNothingInside = !atLeastOneAction && !progressBarStateEl;
    const isHidden = thereIsNothingInside || uploadState === $4af84b49d740c94f$var$STATE_COMPLETE && hideAfterFinish;
    if (isHidden) return null;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: statusBarClassNames,
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: progressClassNames,
                style: {
                    width: `${width}%`
                },
                role: "progressbar",
                "aria-label": `${width}%`,
                "aria-valuetext": `${width}%`,
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": progressValue
            }),
            progressBarStateEl,
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-StatusBar-actions",
                children: [
                    showUploadBtn ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $c0c4f933fc4ac9a2$export$8fd979504d9f59d1), {
                        newFiles: newFiles,
                        isUploadStarted: isUploadStarted,
                        recoveredState: recoveredState,
                        i18n: i18n,
                        isSomeGhost: isSomeGhost,
                        startUpload: startUpload,
                        uploadState: uploadState
                    }) : null,
                    showRetryBtn ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $c0c4f933fc4ac9a2$export$d0263dca13d9e524), {
                        i18n: i18n,
                        uppy: uppy
                    }) : null,
                    showPauseResumeBtn ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $c0c4f933fc4ac9a2$export$f8fda1be68e432db), {
                        isAllPaused: isAllPaused,
                        i18n: i18n,
                        isAllComplete: isAllComplete,
                        resumableUploads: resumableUploads,
                        uppy: uppy
                    }) : null,
                    showCancelBtn ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $c0c4f933fc4ac9a2$export$bda6e5e4654fa168), {
                        i18n: i18n,
                        uppy: uppy
                    }) : null,
                    showDoneBtn ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $c0c4f933fc4ac9a2$export$c5b3ad0eb3665a4a), {
                        i18n: i18n,
                        doneButtonHandler: doneButtonHandler
                    }) : null
                ]
            })
        ]
    });
}


const $f22a72e7b80fdb1a$var$speedFilterHalfLife = 2000;
const $f22a72e7b80fdb1a$var$ETAFilterHalfLife = 2000;
function $f22a72e7b80fdb1a$var$getUploadingState(error, isAllComplete, recoveredState, files) {
    if (error) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_ERROR;
    if (isAllComplete) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_COMPLETE;
    if (recoveredState) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING;
    let state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]];
        // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_UPLOADING;
        // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess) state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_PREPROCESSING;
        // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_PREPROCESSING) state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_POSTPROCESSING;
    }
    return state;
}
const $f22a72e7b80fdb1a$var$defaultOptions = {
    hideUploadButton: false,
    hideRetryButton: false,
    hidePauseResumeButton: false,
    hideCancelButton: false,
    showProgressDetails: false,
    hideAfterFinish: true,
    doneButtonHandler: null
};
class $f22a72e7b80fdb1a$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    static VERSION = (0, (/*@__PURE__*/$parcel$interopDefault($f0153c73a5fa0fd8$exports))).version;
    #lastUpdateTime;
    #previousUploadedBytes;
    #previousSpeed;
    #previousETA;
    constructor(uppy, opts){
        super(uppy, {
            ...$f22a72e7b80fdb1a$var$defaultOptions,
            ...opts
        });
        this.id = this.opts.id || 'StatusBar';
        this.title = 'StatusBar';
        this.type = 'progressindicator';
        this.defaultLocale = (0, $f9ab456b3e2aaacb$export$2e2bcd8739ae039);
        this.i18nInit();
        this.render = this.render.bind(this);
        this.install = this.install.bind(this);
    }
    #computeSmoothETA(totalBytes) {
        if (totalBytes.total == null || totalBytes.total === 0) return null;
        const remaining = totalBytes.total - totalBytes.uploaded;
        if (remaining <= 0) return null;
        // When state is restored, lastUpdateTime is still nullish at this point.
        this.#lastUpdateTime ??= performance.now();
        const dt = performance.now() - this.#lastUpdateTime;
        if (dt === 0) return Math.round((this.#previousETA ?? 0) / 100) / 10;
        const uploadedBytesSinceLastTick = totalBytes.uploaded - this.#previousUploadedBytes;
        this.#previousUploadedBytes = totalBytes.uploaded;
        // uploadedBytesSinceLastTick can be negative in some cases (packet loss?)
        // in which case, we wait for next tick to update ETA.
        if (uploadedBytesSinceLastTick <= 0) return Math.round((this.#previousETA ?? 0) / 100) / 10;
        const currentSpeed = uploadedBytesSinceLastTick / dt;
        const filteredSpeed = this.#previousSpeed == null ? currentSpeed : (0, $4e5b770b58150a1e$export$2e2bcd8739ae039)(currentSpeed, this.#previousSpeed, $f22a72e7b80fdb1a$var$speedFilterHalfLife, dt);
        this.#previousSpeed = filteredSpeed;
        const instantETA = remaining / filteredSpeed;
        const updatedPreviousETA = Math.max(this.#previousETA - dt, 0);
        const filteredETA = this.#previousETA == null ? instantETA : (0, $4e5b770b58150a1e$export$2e2bcd8739ae039)(instantETA, updatedPreviousETA, $f22a72e7b80fdb1a$var$ETAFilterHalfLife, dt);
        this.#previousETA = filteredETA;
        this.#lastUpdateTime = performance.now();
        return Math.round(filteredETA / 100) / 10;
    }
    startUpload = ()=>{
        return this.uppy.upload().catch(()=>{
        // Error logged in Core
        });
    };
    render(state) {
        const { capabilities: capabilities, files: files, allowNewUpload: allowNewUpload, totalProgress: totalProgress, error: error, recoveredState: recoveredState } = state;
        const { newFiles: newFiles, startedFiles: startedFiles, completeFiles: completeFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused, isUploadInProgress: isUploadInProgress, isSomeGhost: isSomeGhost } = this.uppy.getObjectOfFilesPerState();
        // If some state was recovered, we want to show Upload button/counter
        // for all the files, because in this case it’s not an Upload button,
        // but “Confirm Restore Button”
        const newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
        const resumableUploads = !!capabilities.resumableUploads;
        const supportsUploadProgress = capabilities.uploadProgress !== false;
        let totalSize = null;
        let totalUploadedSize = 0;
        // Only if all files have a known size, does it make sense to display a total size
        if (startedFiles.every((f)=>f.progress.bytesTotal != null && f.progress.bytesTotal !== 0)) {
            totalSize = 0;
            startedFiles.forEach((file)=>{
                totalSize += file.progress.bytesTotal || 0;
                totalUploadedSize += file.progress.bytesUploaded || 0;
            });
        } else // however uploaded size we will always have
        startedFiles.forEach((file)=>{
            totalUploadedSize += file.progress.bytesUploaded || 0;
        });
        const totalETA = this.#computeSmoothETA({
            uploaded: totalUploadedSize,
            total: totalSize
        });
        return (0, $4af84b49d740c94f$export$2e2bcd8739ae039)({
            error: error,
            uploadState: $f22a72e7b80fdb1a$var$getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
            allowNewUpload: allowNewUpload,
            totalProgress: totalProgress,
            totalSize: totalSize,
            totalUploadedSize: totalUploadedSize,
            isAllComplete: false,
            isAllPaused: isAllPaused,
            isUploadStarted: isUploadStarted,
            isUploadInProgress: isUploadInProgress,
            isSomeGhost: isSomeGhost,
            recoveredState: recoveredState,
            complete: completeFiles.length,
            newFiles: newFilesOrRecovered.length,
            numUploads: startedFiles.length,
            totalETA: totalETA,
            files: files,
            i18n: this.i18n,
            uppy: this.uppy,
            startUpload: this.startUpload,
            doneButtonHandler: this.opts.doneButtonHandler,
            resumableUploads: resumableUploads,
            supportsUploadProgress: supportsUploadProgress,
            showProgressDetails: this.opts.showProgressDetails,
            hideUploadButton: this.opts.hideUploadButton,
            hideRetryButton: this.opts.hideRetryButton,
            hidePauseResumeButton: this.opts.hidePauseResumeButton,
            hideCancelButton: this.opts.hideCancelButton,
            hideAfterFinish: this.opts.hideAfterFinish
        });
    }
    onMount() {
        // Set the text direction if the page has not defined one.
        const element = this.el;
        const direction = (0, $82cce0c04a5d7a26$export$2e2bcd8739ae039)(element);
        if (!direction) element.dir = 'ltr';
    }
    #onUploadStart = ()=>{
        const { recoveredState: recoveredState } = this.uppy.getState();
        this.#previousSpeed = null;
        this.#previousETA = null;
        if (recoveredState) {
            this.#previousUploadedBytes = Object.values(recoveredState.files).reduce((pv, { progress: progress })=>pv + progress.bytesUploaded, 0);
            // We don't set `#lastUpdateTime` at this point because the upload won't
            // actually resume until the user asks for it.
            this.uppy.emit('restore-confirmed');
            return;
        }
        this.#lastUpdateTime = performance.now();
        this.#previousUploadedBytes = 0;
    };
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
        this.uppy.on('upload', this.#onUploadStart);
        // To cover the use case where the status bar is installed while the upload
        // has started, we set `lastUpdateTime` right away.
        this.#lastUpdateTime = performance.now();
        this.#previousUploadedBytes = this.uppy.getFiles().reduce((pv, file)=>pv + file.progress.bytesUploaded, 0);
    }
    uninstall() {
        this.unmount();
        this.uppy.off('upload', this.#onUploadStart);
    }
}





const $8f6efe9c4afa65c2$var$DATA_URL_PATTERN = /^data:([^/]+\/[^,;]+(?:[^,]*?))(;base64)?,([\s\S]*)$/;
function $8f6efe9c4afa65c2$var$dataURItoBlob(dataURI, opts, toFile) {
    // get the base64 data
    const dataURIData = $8f6efe9c4afa65c2$var$DATA_URL_PATTERN.exec(dataURI);
    // user may provide mime type, if not get it from data URI
    const mimeType = opts.mimeType ?? dataURIData?.[1] ?? 'plain/text';
    let data; // We add `!` to tell TS we're OK with `data` being not defined when the dataURI is invalid.
    if (dataURIData?.[2] != null) {
        const binary = atob(decodeURIComponent(dataURIData[3]));
        const bytes = new Uint8Array(binary.length);
        for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
        data = [
            bytes
        ];
    } else if (dataURIData?.[3] != null) data = [
        decodeURIComponent(dataURIData[3])
    ];
    // Convert to a File?
    if (toFile) return new File(data, opts.name || '', {
        type: mimeType
    });
    return new Blob(data, {
        type: mimeType
    });
}
var $8f6efe9c4afa65c2$export$2e2bcd8739ae039 = $8f6efe9c4afa65c2$var$dataURItoBlob;


/**
 * Check if a URL string is an object URL from `URL.createObjectURL`.
 */ function $3b72dc28c9f79a38$export$2e2bcd8739ae039(url) {
    return url.startsWith('blob:');
}


function $2e3a76623b3bbcc9$export$2e2bcd8739ae039(fileType) {
    if (!fileType) return false;
    // list of images that browsers can preview
    return /^[^/]+\/(jpe?g|gif|png|svg|svg\+xml|bmp|webp|avif)$/.test(fileType);
}



var $gnS5A = parcelRequire("gnS5A");
var $6e2928713c8c5964$exports = {};
$6e2928713c8c5964$exports = JSON.parse("{\"name\":\"@uppy/thumbnail-generator\",\"description\":\"Uppy plugin that generates small previews of images to show on your upload UI.\",\"version\":\"4.2.3\",\"license\":\"MIT\",\"main\":\"lib/index.js\",\"type\":\"module\",\"scripts\":{\"build\":\"tsc --build tsconfig.build.json\",\"typecheck\":\"tsc --build\",\"test\":\"vitest run --environment=jsdom --silent='passed-only'\"},\"keywords\":[\"file uploader\",\"uppy\",\"uppy-plugin\",\"thumbnail\",\"preview\",\"resize\"],\"homepage\":\"https://uppy.io\",\"bugs\":{\"url\":\"https://github.com/transloadit/uppy/issues\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/transloadit/uppy.git\"},\"files\":[\"src\",\"lib\",\"dist\",\"CHANGELOG.md\"],\"dependencies\":{\"@uppy/utils\":\"^6.2.2\",\"exifr\":\"^7.0.0\"},\"devDependencies\":{\"jsdom\":\"^26.1.0\",\"namespace-emitter\":\"2.0.1\",\"typescript\":\"^5.8.3\",\"vitest\":\"^3.2.4\"},\"peerDependencies\":{\"@uppy/core\":\"^4.5.3\"}}");


var $7785655e028eb2bd$export$2e2bcd8739ae039 = {
    strings: {
        generatingThumbnails: 'Generating thumbnails...'
    }
};


/**
 * Save a <canvas> element's content to a Blob object.
 *
 */ function $f92c4ad36d89e394$var$canvasToBlob(canvas, type, quality) {
    try {
        canvas.getContext('2d').getImageData(0, 0, 1, 1);
    } catch (err) {
        if (err.code === 18) return Promise.reject(new Error('cannot read image, probably an svg with external resources'));
    }
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, type, quality);
    }).then((blob)=>{
        if (blob === null) throw new Error('cannot read image, probably an svg with external resources');
        return blob;
    });
    return Promise.resolve().then(()=>{
        return (0, $8f6efe9c4afa65c2$export$2e2bcd8739ae039)(canvas.toDataURL(type, quality), {});
    }).then((blob)=>{
        if (blob === null) throw new Error('could not extract blob, probably an old browser');
        return blob;
    });
}
function $f92c4ad36d89e394$var$rotateImage(image, translate) {
    let w = image.width;
    let h = image.height;
    if (translate.deg === 90 || translate.deg === 270) {
        w = image.height;
        h = image.width;
    }
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const context = canvas.getContext('2d');
    context.translate(w / 2, h / 2);
    if (translate.canvas) {
        context.rotate(translate.rad);
        context.scale(translate.scaleX, translate.scaleY);
    }
    context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);
    return canvas;
}
/**
 * Make sure the image doesn’t exceed browser/device canvas limits.
 * For ios with 256 RAM and ie
 */ function $f92c4ad36d89e394$var$protect(image) {
    // https://stackoverflow.com/questions/6081483/maximum-size-of-a-canvas-element
    const ratio = image.width / image.height;
    const maxSquare = 5000000; // ios max canvas square
    const maxSize = 4096; // ie max canvas dimensions
    let maxW = Math.floor(Math.sqrt(maxSquare * ratio));
    let maxH = Math.floor(maxSquare / Math.sqrt(maxSquare * ratio));
    if (maxW > maxSize) {
        maxW = maxSize;
        maxH = Math.round(maxW / ratio);
    }
    if (maxH > maxSize) {
        maxH = maxSize;
        maxW = Math.round(ratio * maxH);
    }
    if (image.width > maxW) {
        const canvas = document.createElement('canvas');
        canvas.width = maxW;
        canvas.height = maxH;
        canvas.getContext('2d').drawImage(image, 0, 0, maxW, maxH);
        return canvas;
    }
    return image;
}
const $f92c4ad36d89e394$var$defaultOptions = {
    thumbnailWidth: null,
    thumbnailHeight: null,
    thumbnailType: 'image/jpeg',
    waitForThumbnailsBeforeUpload: false,
    lazy: false
};
class $f92c4ad36d89e394$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    static VERSION = (0, (/*@__PURE__*/$parcel$interopDefault($6e2928713c8c5964$exports))).version;
    queue;
    queueProcessing;
    defaultThumbnailDimension;
    thumbnailType;
    constructor(uppy, opts){
        super(uppy, {
            ...$f92c4ad36d89e394$var$defaultOptions,
            ...opts
        });
        this.type = 'modifier';
        this.id = this.opts.id || 'ThumbnailGenerator';
        this.title = 'Thumbnail Generator';
        this.queue = [];
        this.queueProcessing = false;
        this.defaultThumbnailDimension = 200;
        this.thumbnailType = this.opts.thumbnailType;
        this.defaultLocale = (0, $7785655e028eb2bd$export$2e2bcd8739ae039);
        this.i18nInit();
        if (this.opts.lazy && this.opts.waitForThumbnailsBeforeUpload) throw new Error('ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.');
    }
    createThumbnail(file, targetWidth, targetHeight) {
        const originalUrl = URL.createObjectURL(file.data);
        const onload = new Promise((resolve, reject)=>{
            const image = new Image();
            image.src = originalUrl;
            image.addEventListener('load', ()=>{
                URL.revokeObjectURL(originalUrl);
                resolve(image);
            });
            image.addEventListener('error', (event)=>{
                URL.revokeObjectURL(originalUrl);
                reject(event.error || new Error('Could not create thumbnail'));
            });
        });
        const orientationPromise = (0, $gnS5A.rotation)(file.data).catch(()=>1);
        return Promise.all([
            onload,
            orientationPromise
        ]).then(([image, orientation])=>{
            const dimensions = this.getProportionalDimensions(image, targetWidth, targetHeight, orientation.deg);
            const rotatedImage = $f92c4ad36d89e394$var$rotateImage(image, orientation);
            const resizedImage = this.resizeImage(rotatedImage, dimensions.width, dimensions.height);
            return $f92c4ad36d89e394$var$canvasToBlob(resizedImage, this.thumbnailType, 80);
        }).then((blob)=>{
            return URL.createObjectURL(blob);
        });
    }
    /**
     * Get the new calculated dimensions for the given image and a target width
     * or height. If both width and height are given, only width is taken into
     * account. If neither width nor height are given, the default dimension
     * is used.
     */ getProportionalDimensions(img, width, height, deg) {
        let aspect = img.width / img.height;
        if (deg === 90 || deg === 270) aspect = img.height / img.width;
        if (width != null) {
            let targetWidth = width;
            // Thumbnail shouldn’t be enlarged / upscaled, only reduced.
            // If img is already smaller than width/height, leave it as is.
            if (img.width < width) targetWidth = img.width;
            return {
                width: targetWidth,
                height: Math.round(targetWidth / aspect)
            };
        }
        if (height != null) {
            let targetHeight = height;
            if (img.height < height) targetHeight = img.height;
            return {
                width: Math.round(targetHeight * aspect),
                height: targetHeight
            };
        }
        return {
            width: this.defaultThumbnailDimension,
            height: Math.round(this.defaultThumbnailDimension / aspect)
        };
    }
    /**
     * Resize an image to the target `width` and `height`.
     *
     * Returns a Canvas with the resized image on it.
     */ resizeImage(image, targetWidth, targetHeight) {
        // Resizing in steps refactored to use a solution from
        // https://blog.uploadcare.com/image-resize-in-browsers-is-broken-e38eed08df01
        let img = $f92c4ad36d89e394$var$protect(image);
        let steps = Math.ceil(Math.log2(img.width / targetWidth));
        if (steps < 1) steps = 1;
        let sW = targetWidth * 2 ** (steps - 1);
        let sH = targetHeight * 2 ** (steps - 1);
        const x = 2;
        while(steps--){
            const canvas = document.createElement('canvas');
            canvas.width = sW;
            canvas.height = sH;
            canvas.getContext('2d').drawImage(img, 0, 0, sW, sH);
            img = canvas;
            sW = Math.round(sW / x);
            sH = Math.round(sH / x);
        }
        return img;
    }
    /**
     * Set the preview URL for a file.
     */ setPreviewURL(fileID, preview) {
        this.uppy.setFileState(fileID, {
            preview: preview
        });
    }
    addToQueue(fileID) {
        this.queue.push(fileID);
        if (this.queueProcessing === false) this.processQueue();
    }
    processQueue() {
        this.queueProcessing = true;
        if (this.queue.length > 0) {
            const current = this.uppy.getFile(this.queue.shift());
            if (!current) {
                this.uppy.log('[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug', 'error');
                return Promise.resolve();
            }
            return this.requestThumbnail(current).catch(()=>{}).then(()=>this.processQueue());
        }
        this.queueProcessing = false;
        this.uppy.log('[ThumbnailGenerator] Emptied thumbnail queue');
        this.uppy.emit('thumbnail:all-generated');
        return Promise.resolve();
    }
    requestThumbnail(file) {
        if ((0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(file.type) && !file.isRemote) return this.createThumbnail(file, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then((preview)=>{
            this.setPreviewURL(file.id, preview);
            this.uppy.log(`[ThumbnailGenerator] Generated thumbnail for ${file.id}`);
            this.uppy.emit('thumbnail:generated', this.uppy.getFile(file.id), preview);
        }).catch((err)=>{
            this.uppy.log(`[ThumbnailGenerator] Failed thumbnail for ${file.id}:`, 'warning');
            this.uppy.log(err, 'warning');
            this.uppy.emit('thumbnail:error', this.uppy.getFile(file.id), err);
        });
        return Promise.resolve();
    }
    onFileAdded = (file)=>{
        if (!file.preview && file.data && (0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(file.type) && !file.isRemote) this.addToQueue(file.id);
    };
    /**
     * Cancel a lazy request for a thumbnail if the thumbnail has not yet been generated.
     */ onCancelRequest = (file)=>{
        const index = this.queue.indexOf(file.id);
        if (index !== -1) this.queue.splice(index, 1);
    };
    /**
     * Clean up the thumbnail for a file. Cancel lazy requests and free the thumbnail URL.
     */ onFileRemoved = (file)=>{
        const index = this.queue.indexOf(file.id);
        if (index !== -1) this.queue.splice(index, 1);
        // Clean up object URLs.
        if (file.preview && (0, $3b72dc28c9f79a38$export$2e2bcd8739ae039)(file.preview)) URL.revokeObjectURL(file.preview);
    };
    onRestored = ()=>{
        const restoredFiles = this.uppy.getFiles().filter((file)=>file.isRestored);
        restoredFiles.forEach((file)=>{
            // Only add blob URLs; they are likely invalid after being restored.
            if (!file.preview || (0, $3b72dc28c9f79a38$export$2e2bcd8739ae039)(file.preview)) this.addToQueue(file.id);
        });
    };
    onAllFilesRemoved = ()=>{
        this.queue = [];
    };
    waitUntilAllProcessed = (fileIDs)=>{
        fileIDs.forEach((fileID)=>{
            const file = this.uppy.getFile(fileID);
            this.uppy.emit('preprocess-progress', file, {
                mode: 'indeterminate',
                message: this.i18n('generatingThumbnails')
            });
        });
        const emitPreprocessCompleteForAll = ()=>{
            fileIDs.forEach((fileID)=>{
                const file = this.uppy.getFile(fileID);
                this.uppy.emit('preprocess-complete', file);
            });
        };
        return new Promise((resolve)=>{
            if (this.queueProcessing) this.uppy.once('thumbnail:all-generated', ()=>{
                emitPreprocessCompleteForAll();
                resolve();
            });
            else {
                emitPreprocessCompleteForAll();
                resolve();
            }
        });
    };
    install() {
        this.uppy.on('file-removed', this.onFileRemoved);
        this.uppy.on('cancel-all', this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.on('thumbnail:request', this.onFileAdded);
            this.uppy.on('thumbnail:cancel', this.onCancelRequest);
        } else {
            this.uppy.on('thumbnail:request', this.onFileAdded);
            this.uppy.on('file-added', this.onFileAdded);
            this.uppy.on('restored', this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.addPreProcessor(this.waitUntilAllProcessed);
    }
    uninstall() {
        this.uppy.off('file-removed', this.onFileRemoved);
        this.uppy.off('cancel-all', this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.off('thumbnail:request', this.onFileAdded);
            this.uppy.off('thumbnail:cancel', this.onCancelRequest);
        } else {
            this.uppy.off('thumbnail:request', this.onFileAdded);
            this.uppy.off('file-added', this.onFileAdded);
            this.uppy.off('restored', this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.removePreProcessor(this.waitUntilAllProcessed);
    }
}



/**
 * Find one or more DOM elements.
 */ function $3da4efa7f88c23a6$var$findAllDOMElements(element) {
    if (typeof element === 'string') {
        const elements = document.querySelectorAll(element);
        return elements.length === 0 ? null : Array.from(elements);
    }
    if (typeof element === 'object' && (0, $dcdea5a9bf8353ff$export$2e2bcd8739ae039)(element)) return [
        element
    ];
    return null;
}
var $3da4efa7f88c23a6$export$2e2bcd8739ae039 = $3da4efa7f88c23a6$var$findAllDOMElements;


/**
 * Converts list into array
 */ var $d737086ca91a9c7d$export$2e2bcd8739ae039 = Array.from;


function $d5d92a586549e3b5$export$2e2bcd8739ae039(dataTransfer) {
    const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(dataTransfer.files);
    return Promise.resolve(files);
}


/**
 * Recursive function, calls the original callback() when the directory is entirely parsed.
 */ function $b08bd893356e01b1$export$2e2bcd8739ae039(directoryReader, oldEntries, logDropError, { onSuccess: onSuccess }) {
    directoryReader.readEntries((entries)=>{
        const newEntries = [
            ...oldEntries,
            ...entries
        ];
        // According to the FileSystem API spec, getFilesAndDirectoriesFromDirectory()
        // must be called until it calls the onSuccess with an empty array.
        if (entries.length) queueMicrotask(()=>{
            $b08bd893356e01b1$export$2e2bcd8739ae039(directoryReader, newEntries, logDropError, {
                onSuccess: onSuccess
            });
        });
        else onSuccess(newEntries);
    }, // Make sure we resolve on error anyway, it's fine if only one directory couldn't be parsed!
    (error)=>{
        logDropError(error);
        onSuccess(oldEntries);
    });
}


/**
 * Polyfill for the new (experimental) getAsFileSystemHandle API (using the popular webkitGetAsEntry behind the scenes)
 * so that we can switch to the getAsFileSystemHandle API once it (hopefully) becomes standard
 */ function $e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(entry, logDropError) {
    if (entry == null) return entry;
    return {
        kind: entry.isFile ? 'file' : entry.isDirectory ? 'directory' : undefined,
        name: entry.name,
        getFile () {
            return new Promise((resolve, reject)=>entry.file(resolve, reject));
        },
        async *values () {
            // If the file is a directory.
            const directoryReader = entry.createReader();
            const entries = await new Promise((resolve)=>{
                (0, $b08bd893356e01b1$export$2e2bcd8739ae039)(directoryReader, [], logDropError, {
                    onSuccess: (dirEntries)=>resolve(dirEntries.map((file)=>$e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(file, logDropError)))
                });
            });
            yield* entries;
        },
        isSameEntry: undefined
    };
}
async function* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
    const getNextRelativePath = ()=>`${relativePath}/${entry.name}`;
    // For each dropped item, - make sure it's a file/directory, and start deepening in!
    if (entry.kind === 'file') {
        const file = await entry.getFile();
        if (file != null) {
            file.relativePath = relativePath ? getNextRelativePath() : null;
            yield file;
        } else if (lastResortFile != null) yield lastResortFile;
    } else if (entry.kind === 'directory') for await (const handle of entry.values())// Recurse on the directory, appending the dir name to the relative path
    yield* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name);
    else if (lastResortFile != null) yield lastResortFile;
}
async function* $e30d9f0f4292db6d$export$2e2bcd8739ae039(dataTransfer, logDropError) {
    // Retrieving the dropped items must happen synchronously
    // otherwise only the first item gets treated and the other ones are garbage collected.
    // https://github.com/transloadit/uppy/pull/3998
    const fileSystemHandles = await Promise.all(Array.from(dataTransfer.items, async (item)=>{
        // biome-ignore lint/style/useConst: ...
        let fileSystemHandle;
        // TODO enable getAsFileSystemHandle API once we can get it working with subdirectories
        // IMPORTANT: Need to check isSecureContext *before* calling getAsFileSystemHandle
        // or else Chrome will crash when running in HTTP: https://github.com/transloadit/uppy/issues/4133
        // if (window.isSecureContext && item.getAsFileSystemHandle != null)
        // fileSystemHandle = await item.getAsFileSystemHandle()
        // `webkitGetAsEntry` exists in all popular browsers (including non-WebKit browsers),
        // however it may be renamed to getAsEntry() in the future, so you should code defensively, looking for both.
        // from https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
        const getAsEntry = ()=>typeof item.getAsEntry === 'function' ? item.getAsEntry() : item.webkitGetAsEntry();
        fileSystemHandle ??= $e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
        return {
            fileSystemHandle: fileSystemHandle,
            lastResortFile: item.getAsFile()
        };
    }));
    for (const { lastResortFile: lastResortFile, fileSystemHandle: fileSystemHandle } of fileSystemHandles){
        // fileSystemHandle and lastResortFile can be null when we drop an url.
        if (fileSystemHandle != null) try {
            yield* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(fileSystemHandle, '', lastResortFile);
        } catch (err) {
            // Example: If dropping a symbolic link, Chromium will throw:
            // "DOMException: A requested file or directory could not be found at the time an operation was processed.",
            // So we will use lastResortFile instead. See https://github.com/transloadit/uppy/issues/3505.
            if (lastResortFile != null) yield lastResortFile;
            else logDropError(err);
        }
        else if (lastResortFile != null) yield lastResortFile;
    }
}


async function $954bacbcaff60289$export$2e2bcd8739ae039(dataTransfer, options) {
    // Get all files from all subdirs. Works (at least) in Chrome, Mozilla, and Safari
    const logDropError = options?.logDropError ?? Function.prototype;
    try {
        const accumulator = [];
        for await (const file of (0, $e30d9f0f4292db6d$export$2e2bcd8739ae039)(dataTransfer, logDropError))accumulator.push(file);
        return accumulator;
    // Otherwise just return all first-order files
    } catch  {
        return (0, $d5d92a586549e3b5$export$2e2bcd8739ae039)(dataTransfer);
    }
}



let $ee6f2436cceea22a$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $ee6f2436cceea22a$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size | 0;
        while(i-- > 0)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $ee6f2436cceea22a$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size | 0;
    while(i-- > 0)id += $ee6f2436cceea22a$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};



var $2ca689b6382edf6b$exports = {};
$2ca689b6382edf6b$exports = JSON.parse("{\"name\":\"@uppy/dashboard\",\"description\":\"Universal UI plugin for Uppy.\",\"version\":\"4.4.3\",\"license\":\"MIT\",\"main\":\"lib/index.js\",\"style\":\"dist/style.min.css\",\"type\":\"module\",\"scripts\":{\"build\":\"tsc --build tsconfig.build.json\",\"build:css\":\"sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css\",\"typecheck\":\"tsc --build\",\"test\":\"vitest run --silent='passed-only'\",\"test:e2e\":\"vitest watch --project browser --browser.headless false\"},\"keywords\":[\"file uploader\",\"uppy\",\"uppy-plugin\",\"dashboard\",\"ui\"],\"homepage\":\"https://uppy.io\",\"bugs\":{\"url\":\"https://github.com/transloadit/uppy/issues\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/transloadit/uppy.git\"},\"files\":[\"src\",\"lib\",\"dist\",\"CHANGELOG.md\"],\"dependencies\":{\"@transloadit/prettier-bytes\":\"^0.3.4\",\"@uppy/informer\":\"^4.3.2\",\"@uppy/provider-views\":\"^4.5.2\",\"@uppy/status-bar\":\"^4.2.3\",\"@uppy/thumbnail-generator\":\"^4.2.2\",\"@uppy/utils\":\"^6.2.2\",\"classnames\":\"^2.2.6\",\"lodash\":\"^4.17.21\",\"nanoid\":\"^5.0.9\",\"preact\":\"^10.5.13\",\"shallow-equal\":\"^3.0.0\"},\"devDependencies\":{\"@uppy/core\":\"^4.5.2\",\"@uppy/google-drive\":\"^4.4.2\",\"@uppy/status-bar\":\"^4.2.3\",\"@uppy/url\":\"^4.3.2\",\"@uppy/webcam\":\"^4.3.2\",\"@vitest/browser\":\"^3.2.4\",\"cssnano\":\"^7.0.7\",\"jsdom\":\"^26.1.0\",\"postcss\":\"^8.5.6\",\"postcss-cli\":\"^11.0.1\",\"resize-observer-polyfill\":\"^1.5.0\",\"sass\":\"^1.89.2\",\"typescript\":\"^5.8.3\",\"vitest\":\"^3.2.4\"},\"peerDependencies\":{\"@uppy/core\":\"^4.5.2\"}}");



/**
 * Checks if the browser supports Drag & Drop (not supported on mobile devices, for example).
 */ function $5e3c26e19f70d299$export$2e2bcd8739ae039() {
    const div = document.body;
    if (!('draggable' in div) || !('ondragstart' in div && 'ondrop' in div)) return false;
    if (!('FormData' in window)) return false;
    if (!('FileReader' in window)) return false;
    return true;
}






class $3f3c0a16d9cbe8a2$var$AddFiles extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    fileInput = null;
    folderInput = null;
    mobilePhotoFileInput = null;
    mobileVideoFileInput = null;
    triggerFileInputClick = ()=>{
        this.fileInput?.click();
    };
    triggerFolderInputClick = ()=>{
        this.folderInput?.click();
    };
    triggerVideoCameraInputClick = ()=>{
        this.mobileVideoFileInput?.click();
    };
    triggerPhotoCameraInputClick = ()=>{
        this.mobilePhotoFileInput?.click();
    };
    onFileInputChange = (event)=>{
        this.props.handleInputChange(event);
        // Clear the input so that Chrome/Safari/etc. can detect file section when the same file is repeatedly selected
        // (see https://github.com/transloadit/uppy/issues/768#issuecomment-2264902758)
        event.currentTarget.value = '';
    };
    renderHiddenInput = (isFolder, refCallback)=>{
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("input", {
            className: "uppy-Dashboard-input",
            hidden: true,
            "aria-hidden": "true",
            tabIndex: -1,
            // @ts-expect-error default types don't yet know about the `webkitdirectory` property
            webkitdirectory: isFolder,
            type: "file",
            name: "files[]",
            multiple: this.props.maxNumberOfFiles !== 1,
            onChange: this.onFileInputChange,
            accept: this.props.allowedFileTypes?.join(', '),
            ref: refCallback
        });
    };
    renderHiddenCameraInput = (type, nativeCameraFacingMode, refCallback)=>{
        const typeToAccept = {
            photo: 'image/*',
            video: 'video/*'
        };
        const accept = typeToAccept[type];
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("input", {
            className: "uppy-Dashboard-input",
            hidden: true,
            "aria-hidden": "true",
            tabIndex: -1,
            type: "file",
            name: `camera-${type}`,
            onChange: this.onFileInputChange,
            capture: nativeCameraFacingMode === '' ? 'environment' : nativeCameraFacingMode,
            accept: accept,
            ref: refCallback
        });
    };
    renderMyDeviceAcquirer = ()=>{
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: "uppy-DashboardTab",
            role: "presentation",
            "data-uppy-acquirer-id": "MyDevice",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerFileInputClick,
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardTab-inner",
                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                            className: "uppy-DashboardTab-iconMyDevice",
                            "aria-hidden": "true",
                            focusable: "false",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                                d: "M8.45 22.087l-1.305-6.674h17.678l-1.572 6.674H8.45zm4.975-12.412l1.083 1.765a.823.823 0 00.715.386h7.951V13.5H8.587V9.675h4.838zM26.043 13.5h-1.195v-2.598c0-.463-.336-.75-.798-.75h-8.356l-1.082-1.766A.823.823 0 0013.897 8H7.728c-.462 0-.815.256-.815.718V13.5h-.956a.97.97 0 00-.746.37.972.972 0 00-.19.81l1.724 8.565c.095.44.484.755.933.755H24c.44 0 .824-.3.929-.727l2.043-8.568a.972.972 0 00-.176-.825.967.967 0 00-.753-.38z",
                                fill: "currentcolor",
                                "fill-rule": "evenodd"
                            })
                        })
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardTab-name",
                        children: this.props.i18n('myDevice')
                    })
                ]
            })
        });
    };
    renderPhotoCamera = ()=>{
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: "uppy-DashboardTab",
            role: "presentation",
            "data-uppy-acquirer-id": "MobilePhotoCamera",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerPhotoCameraInputClick,
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardTab-inner",
                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                            "aria-hidden": "true",
                            focusable: "false",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                                d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
                                fill: "#02B383",
                                "fill-rule": "nonzero"
                            })
                        })
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardTab-name",
                        children: this.props.i18n('takePictureBtn')
                    })
                ]
            })
        });
    };
    renderVideoCamera = ()=>{
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: "uppy-DashboardTab",
            role: "presentation",
            "data-uppy-acquirer-id": "MobileVideoCamera",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerVideoCameraInputClick,
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardTab-inner",
                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                            "aria-hidden": "true",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                                fill: "#FF675E",
                                fillRule: "nonzero",
                                d: "m21.254 14.277 2.941-2.588c.797-.313 1.243.818 1.09 1.554-.01 2.094.02 4.189-.017 6.282-.126.915-1.145 1.08-1.58.34l-2.434-2.142c-.192.287-.504 1.305-.738.468-.104-1.293-.028-2.596-.05-3.894.047-.312.381.823.426 1.069.063-.384.206-.744.362-1.09zm-12.939-3.73c3.858.013 7.717-.025 11.574.02.912.129 1.492 1.237 1.351 2.217-.019 2.412.04 4.83-.03 7.239-.17 1.025-1.166 1.59-2.029 1.429-3.705-.012-7.41.025-11.114-.019-.913-.129-1.492-1.237-1.352-2.217.018-2.404-.036-4.813.029-7.214.136-.82.83-1.473 1.571-1.454z "
                            })
                        })
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardTab-name",
                        children: this.props.i18n('recordVideoBtn')
                    })
                ]
            })
        });
    };
    renderBrowseButton = (text, onClickFn)=>{
        const numberOfAcquirers = this.props.acquirers.length;
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
            type: "button",
            className: "uppy-u-reset uppy-c-btn uppy-Dashboard-browse",
            onClick: onClickFn,
            "data-uppy-super-focusable": numberOfAcquirers === 0,
            children: text
        });
    };
    renderDropPasteBrowseTagline = (numberOfAcquirers)=>{
        const browseFiles = this.renderBrowseButton(this.props.i18n('browseFiles'), this.triggerFileInputClick);
        const browseFolders = this.renderBrowseButton(this.props.i18n('browseFolders'), this.triggerFolderInputClick);
        // in order to keep the i18n CamelCase and options lower (as are defaults) we will want to transform a lower
        // to Camel
        const lowerFMSelectionType = this.props.fileManagerSelectionType;
        const camelFMSelectionType = lowerFMSelectionType.charAt(0).toUpperCase() + lowerFMSelectionType.slice(1);
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            class: "uppy-Dashboard-AddFiles-title",
            children: this.props.disableLocalFiles ? this.props.i18n('importFiles') : numberOfAcquirers > 0 ? this.props.i18nArray(`dropPasteImport${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }) : this.props.i18nArray(`dropPaste${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            })
        });
    };
    [Symbol.for('uppy test: disable unused locale key warning')]() {
        // Those are actually used in `renderDropPasteBrowseTagline` method.
        this.props.i18nArray('dropPasteBoth');
        this.props.i18nArray('dropPasteFiles');
        this.props.i18nArray('dropPasteFolders');
        this.props.i18nArray('dropPasteImportBoth');
        this.props.i18nArray('dropPasteImportFiles');
        this.props.i18nArray('dropPasteImportFolders');
    }
    renderAcquirer = (acquirer)=>{
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: "uppy-DashboardTab",
            role: "presentation",
            "data-uppy-acquirer-id": acquirer.id,
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-cy": acquirer.id,
                "aria-controls": `uppy-DashboardContent-panel--${acquirer.id}`,
                "aria-selected": this.props.activePickerPanel?.id === acquirer.id,
                "data-uppy-super-focusable": true,
                onClick: ()=>this.props.showPanel(acquirer.id),
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardTab-inner",
                        children: acquirer.icon()
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardTab-name",
                        children: acquirer.name
                    })
                ]
            })
        });
    };
    renderAcquirers = (acquirers)=>{
        // Group last two buttons, so we don’t end up with
        // just one button on a new line
        const acquirersWithoutLastTwo = [
            ...acquirers
        ];
        const lastTwoAcquirers = acquirersWithoutLastTwo.splice(acquirers.length - 2, acquirers.length);
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
            children: [
                acquirersWithoutLastTwo.map((acquirer)=>this.renderAcquirer(acquirer)),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                    role: "presentation",
                    style: {
                        'white-space': 'nowrap'
                    },
                    children: lastTwoAcquirers.map((acquirer)=>this.renderAcquirer(acquirer))
                })
            ]
        });
    };
    renderSourcesList = (acquirers, disableLocalFiles)=>{
        const { showNativePhotoCameraButton: showNativePhotoCameraButton, showNativeVideoCameraButton: showNativeVideoCameraButton } = this.props;
        let list = [];
        const myDeviceKey = 'myDevice';
        if (!disableLocalFiles) list.push({
            key: myDeviceKey,
            elements: this.renderMyDeviceAcquirer()
        });
        if (showNativePhotoCameraButton) list.push({
            key: 'nativePhotoCameraButton',
            elements: this.renderPhotoCamera()
        });
        if (showNativeVideoCameraButton) list.push({
            key: 'nativePhotoCameraButton',
            elements: this.renderVideoCamera()
        });
        list.push(...acquirers.map((acquirer)=>({
                key: acquirer.id,
                elements: this.renderAcquirer(acquirer)
            })));
        // doesn't make sense to show only a lonely "My Device"
        const hasOnlyMyDevice = list.length === 1 && list[0].key === myDeviceKey;
        if (hasOnlyMyDevice) list = [];
        // Group last two buttons, so we don’t end up with
        // just one button on a new line
        const listWithoutLastTwo = [
            ...list
        ];
        const lastTwo = listWithoutLastTwo.splice(list.length - 2, list.length);
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
            children: [
                this.renderDropPasteBrowseTagline(list.length),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                    className: "uppy-Dashboard-AddFiles-list",
                    role: "tablist",
                    children: [
                        listWithoutLastTwo.map(({ key: key, elements: elements })=>(0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
                                children: elements
                            }, key)),
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                            role: "presentation",
                            style: {
                                'white-space': 'nowrap'
                            },
                            children: lastTwo.map(({ key: key, elements: elements })=>(0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
                                    children: elements
                                }, key))
                        })
                    ]
                })
            ]
        });
    };
    renderPoweredByUppy() {
        const { i18nArray: i18nArray } = this.props;
        const uppyBranding = (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                    "aria-hidden": "true",
                    focusable: "false",
                    className: "uppy-c-icon uppy-Dashboard-poweredByIcon",
                    width: "11",
                    height: "11",
                    viewBox: "0 0 11 11",
                    children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                        d: "M7.365 10.5l-.01-4.045h2.612L5.5.806l-4.467 5.65h2.604l.01 4.044h3.718z",
                        fillRule: "evenodd"
                    })
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                    className: "uppy-Dashboard-poweredByUppy",
                    children: "Uppy"
                })
            ]
        });
        const linkText = i18nArray('poweredBy', {
            uppy: uppyBranding
        });
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("a", {
            tabIndex: -1,
            href: "https://uppy.io",
            rel: "noreferrer noopener",
            target: "_blank",
            className: "uppy-Dashboard-poweredBy",
            children: linkText
        });
    }
    render() {
        const { showNativePhotoCameraButton: showNativePhotoCameraButton, showNativeVideoCameraButton: showNativeVideoCameraButton, nativeCameraFacingMode: nativeCameraFacingMode } = this.props;
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: "uppy-Dashboard-AddFiles",
            children: [
                this.renderHiddenInput(false, (ref)=>{
                    this.fileInput = ref;
                }),
                this.renderHiddenInput(true, (ref)=>{
                    this.folderInput = ref;
                }),
                showNativePhotoCameraButton && this.renderHiddenCameraInput('photo', nativeCameraFacingMode, (ref)=>{
                    this.mobilePhotoFileInput = ref;
                }),
                showNativeVideoCameraButton && this.renderHiddenCameraInput('video', nativeCameraFacingMode, (ref)=>{
                    this.mobileVideoFileInput = ref;
                }),
                this.renderSourcesList(this.props.acquirers, this.props.disableLocalFiles),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                    className: "uppy-Dashboard-AddFiles-info",
                    children: [
                        this.props.note && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                            className: "uppy-Dashboard-note",
                            children: this.props.note
                        }),
                        this.props.proudlyDisplayPoweredByUppy && this.renderPoweredByUppy()
                    ]
                })
            ]
        });
    }
}
var $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039 = $3f3c0a16d9cbe8a2$var$AddFiles;






const $175934b4bbc4fb46$var$AddFilesPanel = (props)=>{
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-Dashboard-AddFilesPanel', props.className),
        "data-uppy-panelType": "AddFiles",
        "aria-hidden": !props.showAddFilesPanel,
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-DashboardContent-bar",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardContent-title",
                        // biome-ignore lint/a11y/useSemanticElements: ...
                        role: "heading",
                        "aria-level": 1,
                        children: props.i18n('addingMoreFiles')
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                        className: "uppy-DashboardContent-back",
                        type: "button",
                        onClick: ()=>props.toggleAddFilesPanel(false),
                        children: props.i18n('back')
                    })
                ]
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039), {
                ...props
            })
        ]
    });
};
var $175934b4bbc4fb46$export$2e2bcd8739ae039 = $175934b4bbc4fb46$var$AddFilesPanel;





function $d8360bbc75e6a373$var$EditorPanel(props) {
    const file = props.files[props.fileCardFor];
    const handleCancel = ()=>{
        props.uppy.emit('file-editor:cancel', file);
        props.closeFileEditor();
    };
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-DashboardContent-panel', props.className),
        role: "tabpanel",
        "data-uppy-panelType": "FileEditor",
        id: "uppy-DashboardContent-panel--editor",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-DashboardContent-bar",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardContent-title",
                        // biome-ignore lint/a11y/useSemanticElements: ...
                        role: "heading",
                        "aria-level": 1,
                        children: props.i18nArray('editing', {
                            file: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                                className: "uppy-DashboardContent-titleFile",
                                children: file.meta ? file.meta.name : file.name
                            })
                        })
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                        className: "uppy-DashboardContent-back",
                        type: "button",
                        onClick: handleCancel,
                        children: props.i18n('cancel')
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                        className: "uppy-DashboardContent-save",
                        type: "button",
                        onClick: props.saveFileEditor,
                        children: props.i18n('save')
                    })
                ]
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-DashboardContent-panelBody",
                children: props.editors.map((target)=>{
                    return props.uppy.getPlugin(target.id).render(props.state);
                })
            })
        ]
    });
}
var $d8360bbc75e6a373$export$2e2bcd8739ae039 = $d8360bbc75e6a373$var$EditorPanel;









function $7fe1d951359cc6e1$var$iconImage() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
            fill: "#686DE0",
            fillRule: "evenodd",
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
                    fillRule: "nonzero"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z",
                    fillRule: "nonzero"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("circle", {
                    cx: "7.5",
                    cy: "9.5",
                    r: "1.5"
                })
            ]
        })
    });
}
function $7fe1d951359cc6e1$var$iconAudio() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
            d: "M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z",
            fill: "#049BCF",
            fillRule: "nonzero"
        })
    });
}
function $7fe1d951359cc6e1$var$iconVideo() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
            d: "M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z",
            fill: "#19AF67",
            fillRule: "nonzero"
        })
    });
}
function $7fe1d951359cc6e1$var$iconPDF() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
            d: "M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z",
            fill: "#E2514A",
            fillRule: "nonzero"
        })
    });
}
function $7fe1d951359cc6e1$var$iconArchive() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
            d: "M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z",
            fill: "#00C469",
            fillRule: "nonzero"
        })
    });
}
function $7fe1d951359cc6e1$var$iconFile() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
            fill: "#A7AFB7",
            fillRule: "nonzero",
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z"
                })
            ]
        })
    });
}
function $7fe1d951359cc6e1$var$iconText() {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
            d: "M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z",
            fill: "#5A5E69",
            fillRule: "nonzero"
        })
    });
}
function $7fe1d951359cc6e1$export$2e2bcd8739ae039(fileType) {
    const defaultChoice = {
        color: '#838999',
        icon: $7fe1d951359cc6e1$var$iconFile()
    };
    if (!fileType) return defaultChoice;
    const fileTypeGeneral = fileType.split('/')[0];
    const fileTypeSpecific = fileType.split('/')[1];
    // Text
    if (fileTypeGeneral === 'text') return {
        color: '#5a5e69',
        icon: $7fe1d951359cc6e1$var$iconText()
    };
    // Image
    if (fileTypeGeneral === 'image') return {
        color: '#686de0',
        icon: $7fe1d951359cc6e1$var$iconImage()
    };
    // Audio
    if (fileTypeGeneral === 'audio') return {
        color: '#068dbb',
        icon: $7fe1d951359cc6e1$var$iconAudio()
    };
    // Video
    if (fileTypeGeneral === 'video') return {
        color: '#19af67',
        icon: $7fe1d951359cc6e1$var$iconVideo()
    };
    // PDF
    if (fileTypeGeneral === 'application' && fileTypeSpecific === 'pdf') return {
        color: '#e25149',
        icon: $7fe1d951359cc6e1$var$iconPDF()
    };
    // Archive
    const archiveTypes = [
        'zip',
        'x-7z-compressed',
        'x-zip-compressed',
        'x-rar-compressed',
        'x-tar',
        'x-gzip',
        'x-apple-diskimage'
    ];
    if (fileTypeGeneral === 'application' && archiveTypes.indexOf(fileTypeSpecific) !== -1) return {
        color: '#00C469',
        icon: $7fe1d951359cc6e1$var$iconArchive()
    };
    return defaultChoice;
}


// ignore drop/paste events if they are not in input or textarea —
// otherwise when Url plugin adds drop/paste listeners to this.el,
// draging UI elements or pasting anything into any field triggers those events —
// Url treats them as URLs that need to be imported
function $cb1052d4a6aa569a$var$ignoreEvent(ev) {
    const { tagName: tagName } = ev.target;
    if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
        ev.stopPropagation();
        return;
    }
    ev.preventDefault();
    ev.stopPropagation();
}
var $cb1052d4a6aa569a$export$2e2bcd8739ae039 = $cb1052d4a6aa569a$var$ignoreEvent;





function $9e2af7705a2c15c5$export$2e2bcd8739ae039(props) {
    const { file: file } = props;
    if (file.preview) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("img", {
        draggable: false,
        className: "uppy-Dashboard-Item-previewImg",
        alt: file.name,
        src: file.preview
    });
    const { color: color, icon: icon } = (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type);
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-previewIconWrap",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                className: "uppy-Dashboard-Item-previewIcon",
                style: {
                    color: color
                },
                children: icon
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                "aria-hidden": "true",
                focusable: "false",
                className: "uppy-Dashboard-Item-previewIconBg",
                width: "58",
                height: "76",
                viewBox: "0 0 58 76",
                children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("rect", {
                    fill: "#FFF",
                    width: "58",
                    height: "76",
                    rx: "3",
                    fillRule: "evenodd"
                })
            })
        ]
    });
}




function $fca34f2366194ceb$export$2e2bcd8739ae039(props) {
    const { computedMetaFields: computedMetaFields, requiredMetaFields: requiredMetaFields, updateMeta: updateMeta, form: form, formState: formState } = props;
    const fieldCSSClasses = {
        text: 'uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input'
    };
    return computedMetaFields.map((field)=>{
        const id = `uppy-Dashboard-FileCard-input-${field.id}`;
        const required = requiredMetaFields.includes(field.id);
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("fieldset", {
            className: "uppy-Dashboard-FileCard-fieldset",
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("label", {
                    className: "uppy-Dashboard-FileCard-label",
                    htmlFor: id,
                    children: field.name
                }),
                field.render !== undefined ? field.render({
                    value: formState[field.id],
                    onChange: (newVal)=>updateMeta(newVal, field.id),
                    fieldCSSClasses: fieldCSSClasses,
                    required: required,
                    form: form.id
                }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)) : (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("input", {
                    className: fieldCSSClasses.text,
                    id: id,
                    form: form.id,
                    type: field.type || 'text',
                    required: required,
                    value: formState[field.id],
                    placeholder: field.placeholder,
                    onInput: (ev)=>updateMeta(ev.target.value, field.id),
                    "data-uppy-super-focusable": true
                })
            ]
        }, field.id);
    });
}


function $af43f3a66035ecee$export$2e2bcd8739ae039(props) {
    const { files: files, fileCardFor: fileCardFor, toggleFileCard: toggleFileCard, saveFileCard: saveFileCard, metaFields: metaFields, requiredMetaFields: requiredMetaFields, openFileEditor: openFileEditor, i18n: i18n, i18nArray: i18nArray, className: className, canEditFile: canEditFile } = props;
    const getMetaFields = ()=>{
        return typeof metaFields === 'function' ? metaFields(files[fileCardFor]) : metaFields;
    };
    const file = files[fileCardFor];
    const computedMetaFields = getMetaFields() ?? [];
    const showEditButton = canEditFile(file);
    const storedMetaData = {};
    computedMetaFields.forEach((field)=>{
        storedMetaData[field.id] = file.meta[field.id] ?? '';
    });
    const [formState, setFormState] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(storedMetaData);
    const handleSave = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        ev.preventDefault();
        saveFileCard(formState, fileCardFor);
    }, [
        saveFileCard,
        formState,
        fileCardFor
    ]);
    const updateMeta = (newVal, name)=>{
        setFormState({
            ...formState,
            [name]: newVal
        });
    };
    const handleCancel = ()=>{
        toggleFileCard(false);
    };
    const [form] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(()=>{
        const formEl = document.createElement('form');
        formEl.setAttribute('tabindex', '-1');
        formEl.id = (0, $ee6f2436cceea22a$export$ac4959f4f1338dfc)();
        return formEl;
    });
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        document.body.appendChild(form);
        form.addEventListener('submit', handleSave);
        return ()=>{
            form.removeEventListener('submit', handleSave);
            document.body.removeChild(form);
        };
    }, [
        form,
        handleSave
    ]);
    return(// biome-ignore lint/a11y/noStaticElementInteractions: ...
    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-Dashboard-FileCard', className),
        "data-uppy-panelType": "FileCard",
        onDragOver: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDragLeave: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDrop: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onPaste: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-DashboardContent-bar",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardContent-title",
                        // biome-ignore lint/a11y/useSemanticElements: ...
                        role: "heading",
                        "aria-level": 1,
                        children: i18nArray('editing', {
                            file: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                                className: "uppy-DashboardContent-titleFile",
                                children: file.meta ? file.meta.name : file.name
                            })
                        })
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                        className: "uppy-DashboardContent-back",
                        type: "button",
                        form: form.id,
                        title: i18n('finishEditingFile'),
                        onClick: handleCancel,
                        children: i18n('cancel')
                    })
                ]
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-Dashboard-FileCard-inner",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-Dashboard-FileCard-preview",
                        style: {
                            backgroundColor: (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type).color
                        },
                        children: [
                            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $9e2af7705a2c15c5$export$2e2bcd8739ae039), {
                                file: file
                            }),
                            showEditButton && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                                type: "button",
                                className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
                                onClick: (event)=>{
                                    // When opening the image editor we want to save any meta fields changes.
                                    // Otherwise it's confusing for the user to click save in the editor,
                                    // but the changes here are discarded. This bypasses validation,
                                    // but we are okay with that.
                                    handleSave(event);
                                    openFileEditor(file);
                                },
                                children: i18n('editImage')
                            })
                        ]
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-Dashboard-FileCard-info",
                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $fca34f2366194ceb$export$2e2bcd8739ae039), {
                            computedMetaFields: computedMetaFields,
                            requiredMetaFields: requiredMetaFields,
                            updateMeta: updateMeta,
                            form: form,
                            formState: formState
                        })
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-Dashboard-FileCard-actions",
                        children: [
                            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                                className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn",
                                // If `form` attribute is supported, we want a submit button to trigger the form validation.
                                // Otherwise, fallback to a classic button with a onClick event handler.
                                type: "submit",
                                form: form.id,
                                children: i18n('saveChanges')
                            }),
                            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                                className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
                                type: "button",
                                onClick: handleCancel,
                                form: form.id,
                                children: i18n('cancel')
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}









function $4d35db026571eaa3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $4d35db026571eaa3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $4d35db026571eaa3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $4d35db026571eaa3$export$967a6b9924a689f7(a, b);
    return $4d35db026571eaa3$export$3e67810a3f0e9f1c(a, b);
}




/**
 * Copies text to clipboard by creating an almost invisible textarea,
 * adding text there, then running execCommand('copy').
 * Falls back to prompt() when the easy way fails (hello, Safari!)
 * From http://stackoverflow.com/a/30810322
 *
 * @param {string} textToCopy
 * @param {string} fallbackString
 * @returns {Promise}
 */ function $1402db5492a36d8b$export$2e2bcd8739ae039(textToCopy, fallbackString = 'Copy the URL below') {
    return new Promise((resolve)=>{
        const textArea = document.createElement('textarea');
        textArea.setAttribute('style', {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '2em',
            height: '2em',
            padding: 0,
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            background: 'transparent'
        });
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        const magicCopyFailed = ()=>{
            document.body.removeChild(textArea);
            window.prompt(fallbackString, textToCopy);
            resolve();
        };
        try {
            const successful = document.execCommand('copy');
            if (!successful) return magicCopyFailed();
            document.body.removeChild(textArea);
            return resolve();
        } catch (_err) {
            document.body.removeChild(textArea);
            return magicCopyFailed();
        }
    });
}


function $d15239db21f41277$var$EditButton({ file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, metaFields: metaFields, canEditFile: canEditFile, i18n: i18n, onClick: onClick }) {
    if (!uploadInProgressOrComplete && metaFields && metaFields.length > 0 || !uploadInProgressOrComplete && canEditFile(file)) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-action uppy-Dashboard-Item-action--edit",
        type: "button",
        "aria-label": i18n('editFileWithFilename', {
            file: file.meta.name
        }),
        title: i18n('editFileWithFilename', {
            file: file.meta.name
        }),
        onClick: ()=>onClick(),
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon",
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
                fillRule: "evenodd",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                        d: "M1.5 10.793h2.793A1 1 0 0 0 5 10.5L11.5 4a1 1 0 0 0 0-1.414L9.707.793a1 1 0 0 0-1.414 0l-6.5 6.5A1 1 0 0 0 1.5 8v2.793zm1-1V8L9 1.5l1.793 1.793-6.5 6.5H2.5z",
                        fillRule: "nonzero"
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("rect", {
                        x: "1",
                        y: "12.293",
                        width: "11",
                        height: "1",
                        rx: ".5"
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                        fillRule: "nonzero",
                        d: "M6.793 2.5L9.5 5.207l.707-.707L7.5 1.793z"
                    })
                ]
            })
        })
    });
    return null;
}
function $d15239db21f41277$var$RemoveButton({ i18n: i18n, onClick: onClick, file: file }) {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--remove",
        type: "button",
        "aria-label": i18n('removeFile', {
            file: file.meta.name
        }),
        title: i18n('removeFile', {
            file: file.meta.name
        }),
        onClick: ()=>onClick(),
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M9 0C4.034 0 0 4.034 0 9s4.034 9 9 9 9-4.034 9-9-4.034-9-9-9z"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    fill: "#FFF",
                    d: "M13 12.222l-.778.778L9 9.778 5.778 13 5 12.222 8.222 9 5 5.778 5.778 5 9 8.222 12.222 5l.778.778L9.778 9z"
                })
            ]
        })
    });
}
function $d15239db21f41277$var$CopyLinkButton({ file: file, uppy: uppy, i18n: i18n }) {
    const copyLinkToClipboard = (event)=>{
        (0, $1402db5492a36d8b$export$2e2bcd8739ae039)(file.uploadURL, i18n('copyLinkToClipboardFallback')).then(()=>{
            uppy.log('Link copied to clipboard.');
            uppy.info(i18n('copyLinkToClipboardSuccess'), 'info', 3000);
        }).catch(uppy.log)// avoid losing focus
        .then(()=>event.target.focus({
                preventScroll: true
            }));
    };
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--copyLink",
        type: "button",
        "aria-label": i18n('copyLink'),
        title: i18n('copyLink'),
        onClick: (event)=>copyLinkToClipboard(event),
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon",
            width: "14",
            height: "14",
            viewBox: "0 0 14 12",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                d: "M7.94 7.703a2.613 2.613 0 0 1-.626 2.681l-.852.851a2.597 2.597 0 0 1-1.849.766A2.616 2.616 0 0 1 2.764 7.54l.852-.852a2.596 2.596 0 0 1 2.69-.625L5.267 7.099a1.44 1.44 0 0 0-.833.407l-.852.851a1.458 1.458 0 0 0 1.03 2.486c.39 0 .755-.152 1.03-.426l.852-.852c.231-.231.363-.522.406-.824l1.04-1.038zm4.295-5.937A2.596 2.596 0 0 0 10.387 1c-.698 0-1.355.272-1.849.766l-.852.851a2.614 2.614 0 0 0-.624 2.688l1.036-1.036c.041-.304.173-.6.407-.833l.852-.852c.275-.275.64-.426 1.03-.426a1.458 1.458 0 0 1 1.03 2.486l-.852.851a1.442 1.442 0 0 1-.824.406l-1.04 1.04a2.596 2.596 0 0 0 2.683-.628l.851-.85a2.616 2.616 0 0 0 0-3.697zm-6.88 6.883a.577.577 0 0 0 .82 0l3.474-3.474a.579.579 0 1 0-.819-.82L5.355 7.83a.579.579 0 0 0 0 .819z"
            })
        })
    });
}
function $d15239db21f41277$export$2e2bcd8739ae039(props) {
    const { uppy: uppy, file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, canEditFile: canEditFile, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButton: showRemoveButton, i18n: i18n, toggleFileCard: toggleFileCard, openFileEditor: openFileEditor } = props;
    const editAction = ()=>{
        if (metaFields && metaFields.length > 0) toggleFileCard(true, file.id);
        else openFileEditor(file);
    };
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-actionWrapper",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($d15239db21f41277$var$EditButton, {
                i18n: i18n,
                file: file,
                uploadInProgressOrComplete: uploadInProgressOrComplete,
                canEditFile: canEditFile,
                metaFields: metaFields,
                onClick: editAction
            }),
            showLinkToFileUploadResult && file.uploadURL ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($d15239db21f41277$var$CopyLinkButton, {
                file: file,
                uppy: uppy,
                i18n: i18n
            }) : null,
            showRemoveButton ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($d15239db21f41277$var$RemoveButton, {
                i18n: i18n,
                file: file,
                onClick: ()=>uppy.removeFile(file.id)
            }) : null
        ]
    });
}




/**
 * Truncates a string to the given number of chars (maxLength) by inserting '...' in the middle of that string.
 * Partially taken from https://stackoverflow.com/a/5723274/3192470.
 */ const $1e7f833197af6f70$var$separator = '...';
function $1e7f833197af6f70$export$2e2bcd8739ae039(string, maxLength) {
    // Return the empty string if maxLength is zero
    if (maxLength === 0) return '';
    // Return original string if it's already shorter than maxLength
    if (string.length <= maxLength) return string;
    // Return truncated substring appended of the ellipsis char if string can't be meaningfully truncated
    if (maxLength <= $1e7f833197af6f70$var$separator.length + 1) return `${string.slice(0, maxLength - 1)}\u{2026}`;
    const charsToShow = maxLength - $1e7f833197af6f70$var$separator.length;
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);
    return string.slice(0, frontChars) + $1e7f833197af6f70$var$separator + string.slice(-backChars);
}





const $e8c1f4ca43ed49b9$var$metaFieldIdToName = (metaFieldId, metaFields)=>{
    const fields = typeof metaFields === 'function' ? metaFields() : metaFields;
    const field = fields.filter((f)=>f.id === metaFieldId);
    return field[0].name;
};
function $e8c1f4ca43ed49b9$export$2e2bcd8739ae039(props) {
    const { file: file, toggleFileCard: toggleFileCard, i18n: i18n, metaFields: metaFields } = props;
    const { missingRequiredMetaFields: missingRequiredMetaFields } = file;
    if (!missingRequiredMetaFields?.length) return null;
    const metaFieldsString = missingRequiredMetaFields.map((missingMetaField)=>$e8c1f4ca43ed49b9$var$metaFieldIdToName(missingMetaField, metaFields)).join(', ');
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-errorMessage",
        children: [
            i18n('missingRequiredMetaFields', {
                smart_count: missingRequiredMetaFields.length,
                fields: metaFieldsString
            }),
            ' ',
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                type: "button",
                class: "uppy-u-reset uppy-Dashboard-Item-errorMessageBtn",
                onClick: ()=>toggleFileCard(true, file.id),
                children: i18n('editFile')
            })
        ]
    });
}


const $35b148ba1db29747$var$renderFileName = (props)=>{
    const { author: author, name: name } = props.file.meta;
    function getMaxNameLength() {
        if (props.isSingleFile && props.containerHeight >= 350) return 90;
        if (props.containerWidth <= 352) return 35;
        if (props.containerWidth <= 576) return 60;
        // When `author` is present, we want to make sure
        // the file name fits on one line so we can place
        // the author on the second line.
        return author ? 20 : 30;
    }
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-name",
        title: name,
        children: (0, $1e7f833197af6f70$export$2e2bcd8739ae039)(name, getMaxNameLength())
    });
};
const $35b148ba1db29747$var$renderAuthor = (props)=>{
    const { author: author } = props.file.meta;
    const providerName = props.file.remote?.providerName;
    const dot = `\u00B7`;
    if (!author) return null;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-author",
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("a", {
                href: `${author.url}?utm_source=Companion&utm_medium=referral`,
                target: "_blank",
                rel: "noopener noreferrer",
                children: (0, $1e7f833197af6f70$export$2e2bcd8739ae039)(author.name, 13)
            }),
            providerName ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
                children: [
                    ` ${dot} `,
                    providerName,
                    ` ${dot} `
                ]
            }) : null
        ]
    });
};
const $35b148ba1db29747$var$renderFileSize = (props)=>props.file.size && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-statusSize",
        children: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(props.file.size)
    });
const $35b148ba1db29747$var$ReSelectButton = (props)=>props.file.isGhost && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
        children: [
            ' \u2022 ',
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-reSelect",
                type: "button",
                onClick: ()=>props.toggleAddFilesPanel(true),
                children: props.i18n('reSelect')
            })
        ]
    });
const $35b148ba1db29747$var$ErrorButton = ({ file: file, onClick: onClick })=>{
    if (file.error) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-errorDetails",
        "aria-label": file.error,
        "data-microtip-position": "bottom",
        "data-microtip-size": "medium",
        onClick: onClick,
        type: "button",
        children: "?"
    });
    return null;
};
function $35b148ba1db29747$export$2e2bcd8739ae039(props) {
    const { file: file, i18n: i18n, toggleFileCard: toggleFileCard, metaFields: metaFields, toggleAddFilesPanel: toggleAddFilesPanel, isSingleFile: isSingleFile, containerHeight: containerHeight, containerWidth: containerWidth } = props;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-fileInfo",
        "data-uppy-file-source": file.source,
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-Dashboard-Item-fileName",
                children: [
                    $35b148ba1db29747$var$renderFileName({
                        file: file,
                        isSingleFile: isSingleFile,
                        containerHeight: containerHeight,
                        containerWidth: containerWidth
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($35b148ba1db29747$var$ErrorButton, {
                        file: file,
                        onClick: ()=>alert(file.error)
                    })
                ]
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-Dashboard-Item-status",
                children: [
                    $35b148ba1db29747$var$renderAuthor({
                        file: file
                    }),
                    $35b148ba1db29747$var$renderFileSize({
                        file: file
                    }),
                    $35b148ba1db29747$var$ReSelectButton({
                        file: file,
                        toggleAddFilesPanel: toggleAddFilesPanel,
                        i18n: i18n
                    })
                ]
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $e8c1f4ca43ed49b9$export$2e2bcd8739ae039), {
                file: file,
                i18n: i18n,
                toggleFileCard: toggleFileCard,
                metaFields: metaFields
            })
        ]
    });
}







function $bfd13c8521ef3809$export$2e2bcd8739ae039(props) {
    const { file: file, i18n: i18n, toggleFileCard: toggleFileCard, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult } = props;
    const white = 'rgba(255, 255, 255, 0.5)';
    const previewBackgroundColor = file.preview ? white : (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type).color;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-previewInnerWrap",
        style: {
            backgroundColor: previewBackgroundColor
        },
        children: [
            showLinkToFileUploadResult && file.uploadURL && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("a", {
                className: "uppy-Dashboard-Item-previewLink",
                href: file.uploadURL,
                rel: "noreferrer noopener",
                target: "_blank",
                "aria-label": file.meta.name,
                children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                    hidden: true,
                    children: file.meta.name
                })
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $9e2af7705a2c15c5$export$2e2bcd8739ae039), {
                file: file
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $e8c1f4ca43ed49b9$export$2e2bcd8739ae039), {
                file: file,
                i18n: i18n,
                toggleFileCard: toggleFileCard,
                metaFields: metaFields
            })
        ]
    });
}




function $130a6df4f019eb5d$var$onPauseResumeCancelRetry(props) {
    if (props.isUploaded) return;
    if (props.error && !props.hideRetryButton) {
        props.uppy.retryUpload(props.file.id);
        return;
    }
    if (props.resumableUploads && !props.hidePauseResumeButton) props.uppy.pauseResume(props.file.id);
    else if (props.individualCancellation && !props.hideCancelButton) props.uppy.removeFile(props.file.id);
}
function $130a6df4f019eb5d$var$progressIndicatorTitle(props) {
    if (props.isUploaded) return props.i18n('uploadComplete');
    if (props.error) return props.i18n('retryUpload');
    if (props.resumableUploads) {
        if (props.file.isPaused) return props.i18n('resumeUpload');
        return props.i18n('pauseUpload');
    }
    if (props.individualCancellation) return props.i18n('cancelUpload');
    return '';
}
function $130a6df4f019eb5d$var$ProgressIndicatorButton(props) {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-progress",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
            className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-progressIndicator",
            type: "button",
            "aria-label": $130a6df4f019eb5d$var$progressIndicatorTitle(props),
            title: $130a6df4f019eb5d$var$progressIndicatorTitle(props),
            onClick: ()=>$130a6df4f019eb5d$var$onPauseResumeCancelRetry(props),
            children: props.children
        })
    });
}
function $130a6df4f019eb5d$var$ProgressCircleContainer({ children: children }) {
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "70",
        height: "70",
        viewBox: "0 0 36 36",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--circle",
        children: children
    });
}
function $130a6df4f019eb5d$var$ProgressCircle({ progress: progress }) {
    // circle length equals 2 * PI * R
    const circleLength = 2 * Math.PI * 15;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("circle", {
                className: "uppy-Dashboard-Item-progressIcon--bg",
                r: "15",
                cx: "18",
                cy: "18",
                "stroke-width": "2",
                fill: "none"
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("circle", {
                className: "uppy-Dashboard-Item-progressIcon--progress",
                r: "15",
                cx: "18",
                cy: "18",
                transform: "rotate(-90, 18, 18)",
                fill: "none",
                "stroke-width": "2",
                "stroke-dasharray": circleLength,
                "stroke-dashoffset": circleLength - circleLength / 100 * progress
            })
        ]
    });
}
function $130a6df4f019eb5d$export$2e2bcd8739ae039(props) {
    // Nothing if upload has not started
    if (!props.file.progress.uploadStarted) return null;
    if (props.file.progress.percentage === undefined) return null;
    // Green checkmark when complete
    if (props.isUploaded) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-progress",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: "uppy-Dashboard-Item-progressIndicator",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($130a6df4f019eb5d$var$ProgressCircleContainer, {
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("circle", {
                        r: "15",
                        cx: "18",
                        cy: "18",
                        fill: "#1bb240"
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("polygon", {
                        className: "uppy-Dashboard-Item-progressIcon--check",
                        transform: "translate(2, 3)",
                        points: "14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
                    })
                ]
            })
        })
    });
    if (props.recoveredState) return null;
    // Retry button for error
    if (props.error && !props.hideRetryButton) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($130a6df4f019eb5d$var$ProgressIndicatorButton, {
        ...props,
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--retry",
            width: "28",
            height: "31",
            viewBox: "0 0 16 19",
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M7.9 3H10v2H7.9z"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z"
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                    d: "M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z"
                })
            ]
        })
    });
    // Pause/resume button for resumable uploads
    if (props.resumableUploads && !props.hidePauseResumeButton) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($130a6df4f019eb5d$var$ProgressIndicatorButton, {
        ...props,
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($130a6df4f019eb5d$var$ProgressCircleContainer, {
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($130a6df4f019eb5d$var$ProgressCircle, {
                    progress: props.file.progress.percentage
                }),
                props.file.isPaused ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("polygon", {
                    className: "uppy-Dashboard-Item-progressIcon--play",
                    transform: "translate(3, 3)",
                    points: "12 20 12 10 20 15"
                }) : (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
                    className: "uppy-Dashboard-Item-progressIcon--pause",
                    transform: "translate(14.5, 13)",
                    children: [
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("rect", {
                            x: "0",
                            y: "0",
                            width: "2",
                            height: "10",
                            rx: "0"
                        }),
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("rect", {
                            x: "5",
                            y: "0",
                            width: "2",
                            height: "10",
                            rx: "0"
                        })
                    ]
                })
            ]
        })
    });
    // Cancel button for non-resumable uploads if individualCancellation is supported (not bundled)
    if (!props.resumableUploads && props.individualCancellation && !props.hideCancelButton) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($130a6df4f019eb5d$var$ProgressIndicatorButton, {
        ...props,
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($130a6df4f019eb5d$var$ProgressCircleContainer, {
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($130a6df4f019eb5d$var$ProgressCircle, {
                    progress: props.file.progress.percentage
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("polygon", {
                    className: "cancel",
                    transform: "translate(2, 2)",
                    points: "19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
                })
            ]
        })
    });
    // Just progress when buttons are disabled
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-Dashboard-Item-progress",
        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: "uppy-Dashboard-Item-progressIndicator",
            children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($130a6df4f019eb5d$var$ProgressCircleContainer, {
                children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($130a6df4f019eb5d$var$ProgressCircle, {
                    progress: props.file.progress.percentage
                })
            })
        })
    });
}


class $ed540296fca56761$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    componentDidMount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, $4d35db026571eaa3$export$3e67810a3f0e9f1c)(this.props, nextProps);
    }
    // VirtualList mounts FileItems again and they emit `thumbnail:request`
    // Otherwise thumbnails are broken or missing after Golden Retriever restores files
    componentDidUpdate() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    componentWillUnmount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleCancelThumbnail(file);
    }
    render() {
        const { file: file } = this.props;
        const isProcessing = file.progress.preprocess || file.progress.postprocess;
        const isUploaded = !!file.progress.uploadComplete && !isProcessing && !file.error;
        const uploadInProgressOrComplete = !!file.progress.uploadStarted || !!isProcessing;
        const uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing;
        const error = file.error || false;
        // File that Golden Retriever was able to partly restore (only meta, not blob),
        // users still need to re-add it, so it’s a ghost
        const { isGhost: isGhost } = file;
        let showRemoveButton = this.props.individualCancellation ? !isUploaded : !uploadInProgress && !isUploaded;
        if (isUploaded && this.props.showRemoveButtonAfterComplete) showRemoveButton = true;
        const dashboardItemClass = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))({
            'uppy-Dashboard-Item': true,
            'is-inprogress': uploadInProgress && !this.props.recoveredState,
            'is-processing': isProcessing,
            'is-complete': isUploaded,
            'is-error': !!error,
            'is-resumable': this.props.resumableUploads,
            'is-noIndividualCancellation': !this.props.individualCancellation,
            'is-ghost': isGhost
        });
        return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            className: dashboardItemClass,
            id: `uppy_${file.id}`,
            role: this.props.role,
            children: [
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                    className: "uppy-Dashboard-Item-preview",
                    children: [
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $bfd13c8521ef3809$export$2e2bcd8739ae039), {
                            file: file,
                            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
                            i18n: this.props.i18n,
                            toggleFileCard: this.props.toggleFileCard,
                            metaFields: this.props.metaFields
                        }),
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $130a6df4f019eb5d$export$2e2bcd8739ae039), {
                            uppy: this.props.uppy,
                            file: file,
                            error: error,
                            isUploaded: isUploaded,
                            hideRetryButton: this.props.hideRetryButton,
                            hideCancelButton: this.props.hideCancelButton,
                            hidePauseResumeButton: this.props.hidePauseResumeButton,
                            recoveredState: this.props.recoveredState,
                            resumableUploads: this.props.resumableUploads,
                            individualCancellation: this.props.individualCancellation,
                            i18n: this.props.i18n
                        })
                    ]
                }),
                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                    className: "uppy-Dashboard-Item-fileInfoAndButtons",
                    children: [
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $35b148ba1db29747$export$2e2bcd8739ae039), {
                            file: file,
                            containerWidth: this.props.containerWidth,
                            containerHeight: this.props.containerHeight,
                            i18n: this.props.i18n,
                            toggleAddFilesPanel: this.props.toggleAddFilesPanel,
                            toggleFileCard: this.props.toggleFileCard,
                            metaFields: this.props.metaFields,
                            isSingleFile: this.props.isSingleFile
                        }),
                        (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $d15239db21f41277$export$2e2bcd8739ae039), {
                            file: file,
                            metaFields: this.props.metaFields,
                            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
                            showRemoveButton: showRemoveButton,
                            canEditFile: this.props.canEditFile,
                            uploadInProgressOrComplete: uploadInProgressOrComplete,
                            toggleFileCard: this.props.toggleFileCard,
                            openFileEditor: this.props.openFileEditor,
                            uppy: this.props.uppy,
                            i18n: this.props.i18n
                        })
                    ]
                })
            ]
        });
    }
}


function $7a578b6cd2206257$var$chunks(list, size) {
    const chunked = [];
    let currentChunk = [];
    list.forEach((item)=>{
        if (currentChunk.length < size) currentChunk.push(item);
        else {
            chunked.push(currentChunk);
            currentChunk = [
                item
            ];
        }
    });
    if (currentChunk.length) chunked.push(currentChunk);
    return chunked;
}
function $7a578b6cd2206257$export$2e2bcd8739ae039({ id: id, i18n: i18n, uppy: uppy, files: files, resumableUploads: resumableUploads, hideRetryButton: hideRetryButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButtonAfterComplete: showRemoveButtonAfterComplete, metaFields: metaFields, isSingleFile: isSingleFile, toggleFileCard: toggleFileCard, handleRequestThumbnail: handleRequestThumbnail, handleCancelThumbnail: handleCancelThumbnail, recoveredState: recoveredState, individualCancellation: individualCancellation, itemsPerRow: itemsPerRow, openFileEditor: openFileEditor, canEditFile: canEditFile, toggleAddFilesPanel: toggleAddFilesPanel, containerWidth: containerWidth, containerHeight: containerHeight }) {
    // It's not great that this is hardcoded!
    // It's ESPECIALLY not great that this is checking against `itemsPerRow`!
    const rowHeight = itemsPerRow === 1 ? 71 : 200;
    // Sort files by file.isGhost, ghost files first, only if recoveredState is present
    const rows = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        const sortByGhostComesFirst = (file1, file2)=>Number(files[file2].isGhost) - Number(files[file1].isGhost);
        const fileIds = Object.keys(files);
        if (recoveredState) fileIds.sort(sortByGhostComesFirst);
        return $7a578b6cd2206257$var$chunks(fileIds, itemsPerRow);
    }, [
        files,
        itemsPerRow,
        recoveredState
    ]);
    const renderRow = (row)=>(0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
            class: "uppy-Dashboard-filesInner",
            // The `role="presentation` attribute ensures that the list items are properly
            // associated with the `VirtualList` element.
            role: "presentation",
            children: row.map((fileID)=>(0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $ed540296fca56761$export$2e2bcd8739ae039), {
                    uppy: uppy,
                    // FIXME This is confusing, it's actually the Dashboard's plugin ID
                    id: id,
                    // TODO move this to context
                    i18n: i18n,
                    // features
                    resumableUploads: resumableUploads,
                    individualCancellation: individualCancellation,
                    // visual options
                    hideRetryButton: hideRetryButton,
                    hidePauseResumeButton: hidePauseResumeButton,
                    hideCancelButton: hideCancelButton,
                    showLinkToFileUploadResult: showLinkToFileUploadResult,
                    showRemoveButtonAfterComplete: showRemoveButtonAfterComplete,
                    metaFields: metaFields,
                    recoveredState: recoveredState,
                    isSingleFile: isSingleFile,
                    containerWidth: containerWidth,
                    containerHeight: containerHeight,
                    // callbacks
                    toggleFileCard: toggleFileCard,
                    handleRequestThumbnail: handleRequestThumbnail,
                    handleCancelThumbnail: handleCancelThumbnail,
                    role: "listitem",
                    openFileEditor: openFileEditor,
                    canEditFile: canEditFile,
                    toggleAddFilesPanel: toggleAddFilesPanel,
                    file: files[fileID]
                }, fileID))
        }, row[0]);
    if (isSingleFile) return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        class: "uppy-Dashboard-files",
        children: renderRow(rows[0])
    });
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $aba06cd85441b3f8$export$2e2bcd8739ae039), {
        class: "uppy-Dashboard-files",
        role: "list",
        data: rows,
        renderRow: renderRow,
        rowHeight: rowHeight
    });
}







function $e3578ca53f5728a8$var$PickerPanelContent({ activePickerPanel: activePickerPanel, className: className, hideAllPanels: hideAllPanels, i18n: i18n, state: state, uppy: uppy }) {
    const ref = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)(null);
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))('uppy-DashboardContent-panel', className),
        role: "tabpanel",
        "data-uppy-panelType": "PickerPanel",
        id: `uppy-DashboardContent-panel--${activePickerPanel.id}`,
        onDragOver: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDragLeave: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDrop: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onPaste: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-DashboardContent-bar",
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-DashboardContent-title",
                        // biome-ignore lint/a11y/useSemanticElements: ...
                        role: "heading",
                        "aria-level": 1,
                        children: i18n('importFrom', {
                            name: activePickerPanel.name
                        })
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                        className: "uppy-DashboardContent-back",
                        type: "button",
                        onClick: hideAllPanels,
                        children: i18n('cancel')
                    })
                ]
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                ref: ref,
                className: "uppy-DashboardContent-panelBody",
                children: uppy.getPlugin(activePickerPanel.id).render(state, ref.current)
            })
        ]
    });
}
var $e3578ca53f5728a8$export$2e2bcd8739ae039 = $e3578ca53f5728a8$var$PickerPanelContent;




const $915070fc553cba86$var$uploadStates = {
    STATE_ERROR: 'error',
    STATE_WAITING: 'waiting',
    STATE_PREPROCESSING: 'preprocessing',
    STATE_UPLOADING: 'uploading',
    STATE_POSTPROCESSING: 'postprocessing',
    STATE_COMPLETE: 'complete',
    STATE_PAUSED: 'paused'
};
function $915070fc553cba86$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files = {}) {
    if (isAllErrored) return $915070fc553cba86$var$uploadStates.STATE_ERROR;
    if (isAllComplete) return $915070fc553cba86$var$uploadStates.STATE_COMPLETE;
    if (isAllPaused) return $915070fc553cba86$var$uploadStates.STATE_PAUSED;
    let state = $915070fc553cba86$var$uploadStates.STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]];
        // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return $915070fc553cba86$var$uploadStates.STATE_UPLOADING;
        // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess && state !== $915070fc553cba86$var$uploadStates.STATE_UPLOADING) state = $915070fc553cba86$var$uploadStates.STATE_PREPROCESSING;
        // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== $915070fc553cba86$var$uploadStates.STATE_UPLOADING && state !== $915070fc553cba86$var$uploadStates.STATE_PREPROCESSING) state = $915070fc553cba86$var$uploadStates.STATE_POSTPROCESSING;
    }
    return state;
}
function $915070fc553cba86$var$UploadStatus({ files: files, i18n: i18n, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused, inProgressNotPausedFiles: inProgressNotPausedFiles, newFiles: newFiles, processingFiles: processingFiles }) {
    const uploadingState = $915070fc553cba86$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files);
    switch(uploadingState){
        case 'uploading':
            return i18n('uploadingXFiles', {
                smart_count: inProgressNotPausedFiles.length
            });
        case 'preprocessing':
        case 'postprocessing':
            return i18n('processingXFiles', {
                smart_count: processingFiles.length
            });
        case 'paused':
            return i18n('uploadPaused');
        case 'waiting':
            return i18n('xFilesSelected', {
                smart_count: newFiles.length
            });
        case 'complete':
            return i18n('uploadComplete');
        case 'error':
            return i18n('error');
        default:
    }
}
function $915070fc553cba86$var$PanelTopBar(props) {
    const { i18n: i18n, isAllComplete: isAllComplete, hideCancelButton: hideCancelButton, maxNumberOfFiles: maxNumberOfFiles, toggleAddFilesPanel: toggleAddFilesPanel, uppy: uppy } = props;
    let { allowNewUpload: allowNewUpload } = props;
    // TODO maybe this should be done in ../Dashboard.js, then just pass that down as `allowNewUpload`
    if (allowNewUpload && maxNumberOfFiles) allowNewUpload = props.totalFileCount < props.maxNumberOfFiles;
    return (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: "uppy-DashboardContent-bar",
        children: [
            !isAllComplete && !hideCancelButton ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                className: "uppy-DashboardContent-back",
                type: "button",
                onClick: ()=>uppy.cancelAll(),
                children: i18n('cancel')
            }) : (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {}),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-DashboardContent-title",
                children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)($915070fc553cba86$var$UploadStatus, {
                    ...props
                })
            }),
            allowNewUpload ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                className: "uppy-DashboardContent-addMore",
                type: "button",
                "aria-label": i18n('addMoreFiles'),
                title: i18n('addMoreFiles'),
                onClick: ()=>toggleAddFilesPanel(true),
                children: [
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                        "aria-hidden": "true",
                        focusable: "false",
                        className: "uppy-c-icon",
                        width: "15",
                        height: "15",
                        viewBox: "0 0 15 15",
                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                            d: "M8 6.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8v6a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6v-6A.5.5 0 0 1 7 0h.5a.5.5 0 0 1 .5.5v6z"
                        })
                    }),
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                        className: "uppy-DashboardContent-addMoreCaption",
                        children: i18n('addMore')
                    })
                ]
            }) : (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {})
        ]
    });
}
var $915070fc553cba86$export$2e2bcd8739ae039 = $915070fc553cba86$var$PanelTopBar;





const $35cf1967ab48fc35$var$transitionName = 'uppy-transition-slideDownUp';
const $35cf1967ab48fc35$var$duration = 250;
/**
 * Vertical slide transition.
 *
 * This can take a _single_ child component, which _must_ accept a `className` prop.
 *
 * Currently this is specific to the `uppy-transition-slideDownUp` transition,
 * but it should be simple to extend this for any type of single-element
 * transition by setting the CSS name and duration as props.
 */ function $35cf1967ab48fc35$var$Slide({ children: children }) {
    const [cachedChildren, setCachedChildren] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(null);
    const [className, setClassName] = (0, $e28f05d17e052ff9$export$60241385465d0a34)('');
    const enterTimeoutRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const leaveTimeoutRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const animationFrameRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const handleEnterTransition = ()=>{
        setClassName(`${$35cf1967ab48fc35$var$transitionName}-enter`);
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(leaveTimeoutRef.current);
        leaveTimeoutRef.current = undefined;
        animationFrameRef.current = requestAnimationFrame(()=>{
            setClassName(`${$35cf1967ab48fc35$var$transitionName}-enter ${$35cf1967ab48fc35$var$transitionName}-enter-active`);
            enterTimeoutRef.current = setTimeout(()=>{
                setClassName('');
            }, $35cf1967ab48fc35$var$duration);
        });
    };
    const handleLeaveTransition = ()=>{
        setClassName(`${$35cf1967ab48fc35$var$transitionName}-leave`);
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(enterTimeoutRef.current);
        enterTimeoutRef.current = undefined;
        animationFrameRef.current = requestAnimationFrame(()=>{
            setClassName(`${$35cf1967ab48fc35$var$transitionName}-leave ${$35cf1967ab48fc35$var$transitionName}-leave-active`);
            leaveTimeoutRef.current = setTimeout(()=>{
                setCachedChildren(null);
                setClassName('');
            }, $35cf1967ab48fc35$var$duration);
        });
    };
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        const child = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(children)[0];
        if (cachedChildren === child) return;
        if (child && !cachedChildren) handleEnterTransition();
        else if (cachedChildren && !child && !leaveTimeoutRef.current) handleLeaveTransition();
        setCachedChildren(child);
    }, [
        children,
        cachedChildren
    ]); // Dependency array to trigger effect on children change
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        return ()=>{
            clearTimeout(enterTimeoutRef.current);
            clearTimeout(leaveTimeoutRef.current);
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, []); // Cleanup useEffect
    if (!cachedChildren) return null;
    return (0, $4d2e93495e50cc85$export$e530037191fcd5d7)(cachedChildren, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))(className, cachedChildren.props.className)
    });
}
var $35cf1967ab48fc35$export$2e2bcd8739ae039 = $35cf1967ab48fc35$var$Slide;


// http://dev.edenspiekermann.com/2016/02/11/introducing-accessible-modal-dialog
// https://github.com/ghosh/micromodal
const $8dc96b7f61bbef1d$var$WIDTH_XL = 900;
const $8dc96b7f61bbef1d$var$WIDTH_LG = 700;
const $8dc96b7f61bbef1d$var$WIDTH_MD = 576;
const $8dc96b7f61bbef1d$var$HEIGHT_MD = 330;
function $8dc96b7f61bbef1d$export$2e2bcd8739ae039(props) {
    const isNoFiles = props.totalFileCount === 0;
    const isSingleFile = props.totalFileCount === 1;
    const isSizeMD = props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD;
    const isSizeHeightMD = props.containerHeight > $8dc96b7f61bbef1d$var$HEIGHT_MD;
    const dashboardClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))({
        'uppy-Dashboard': true,
        'uppy-Dashboard--isDisabled': props.disabled,
        'uppy-Dashboard--animateOpenClose': props.animateOpenClose,
        'uppy-Dashboard--isClosing': props.isClosing,
        'uppy-Dashboard--isDraggingOver': props.isDraggingOver,
        'uppy-Dashboard--modal': !props.inline,
        'uppy-size--md': props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD,
        'uppy-size--lg': props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_LG,
        'uppy-size--xl': props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_XL,
        'uppy-size--height-md': props.containerHeight > $8dc96b7f61bbef1d$var$HEIGHT_MD,
        // We might want to enable this in the future
        // 'uppy-size--height-lg': props.containerHeight > HEIGHT_LG,
        // 'uppy-size--height-xl': props.containerHeight > HEIGHT_XL,
        'uppy-Dashboard--isAddFilesPanelVisible': props.showAddFilesPanel,
        'uppy-Dashboard--isInnerWrapVisible': props.areInsidesReadyToBeVisible,
        // Only enable “centered single file” mode when Dashboard is tall enough
        'uppy-Dashboard--singleFile': props.singleFileFullScreen && isSingleFile && isSizeHeightMD
    });
    // Important: keep these in sync with the percent width values in `src/components/FileItem/index.scss`.
    let itemsPerRow = 1; // mobile
    if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_XL) itemsPerRow = 5;
    else if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_LG) itemsPerRow = 4;
    else if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD) itemsPerRow = 3;
    const showFileList = props.showSelectedFiles && !isNoFiles;
    const numberOfFilesForRecovery = props.recoveredState ? Object.keys(props.recoveredState.files).length : null;
    const numberOfGhosts = props.files ? Object.keys(props.files).filter((fileID)=>props.files[fileID].isGhost).length : 0;
    const renderRestoredText = ()=>{
        if (numberOfGhosts > 0) return props.i18n('recoveredXFiles', {
            smart_count: numberOfGhosts
        });
        return props.i18n('recoveredAllFiles');
    };
    const dashboard = // biome-ignore lint/a11y/useAriaPropsSupportedByRole: ...
    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
        className: dashboardClassName,
        "data-uppy-theme": props.theme,
        "data-uppy-num-acquirers": props.acquirers.length,
        "data-uppy-drag-drop-supported": !props.disableLocalFiles && (0, $5e3c26e19f70d299$export$2e2bcd8739ae039)(),
        "aria-hidden": props.inline ? 'false' : props.isHidden,
        "aria-disabled": props.disabled,
        "aria-label": !props.inline ? props.i18n('dashboardWindowTitle') : props.i18n('dashboardTitle'),
        onPaste: props.handlePaste,
        onDragOver: props.handleDragOver,
        onDragLeave: props.handleDragLeave,
        onDrop: props.handleDrop,
        children: [
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                "aria-hidden": "true",
                className: "uppy-Dashboard-overlay",
                tabIndex: -1,
                onClick: props.handleClickOutside
            }),
            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                className: "uppy-Dashboard-inner",
                role: props.inline ? undefined : 'dialog',
                style: {
                    width: props.inline && props.width ? props.width : '',
                    height: props.inline && props.height ? props.height : ''
                },
                children: [
                    !props.inline ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("button", {
                        className: "uppy-u-reset uppy-Dashboard-close",
                        type: "button",
                        "aria-label": props.i18n('closeModal'),
                        title: props.i18n('closeModal'),
                        onClick: props.closeModal,
                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("span", {
                            "aria-hidden": "true",
                            children: "\u00D7"
                        })
                    }) : null,
                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                        className: "uppy-Dashboard-innerWrap",
                        children: [
                            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                                className: "uppy-Dashboard-dropFilesHereHint",
                                children: props.i18n('dropHint')
                            }),
                            showFileList && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $915070fc553cba86$export$2e2bcd8739ae039), {
                                ...props
                            }),
                            numberOfFilesForRecovery && (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                                className: "uppy-Dashboard-serviceMsg",
                                children: [
                                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("svg", {
                                        className: "uppy-Dashboard-serviceMsg-icon",
                                        "aria-hidden": "true",
                                        focusable: "false",
                                        width: "21",
                                        height: "16",
                                        viewBox: "0 0 24 19",
                                        children: (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("g", {
                                            transform: "translate(0 -1)",
                                            fill: "none",
                                            fillRule: "evenodd",
                                            children: [
                                                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                                                    d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z",
                                                    fill: "#FFD300"
                                                }),
                                                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("path", {
                                                    fill: "#000",
                                                    d: "M11 6h2l-.3 8h-1.4z"
                                                }),
                                                (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("circle", {
                                                    fill: "#000",
                                                    cx: "12",
                                                    cy: "17",
                                                    r: "1"
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("strong", {
                                        className: "uppy-Dashboard-serviceMsg-title",
                                        children: props.i18n('sessionRestored')
                                    }),
                                    (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                                        className: "uppy-Dashboard-serviceMsg-text",
                                        children: renderRestoredText()
                                    })
                                ]
                            }),
                            showFileList ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $7a578b6cd2206257$export$2e2bcd8739ae039), {
                                id: props.id,
                                i18n: props.i18n,
                                uppy: props.uppy,
                                files: props.files,
                                resumableUploads: props.resumableUploads,
                                hideRetryButton: props.hideRetryButton,
                                hidePauseResumeButton: props.hidePauseResumeButton,
                                hideCancelButton: props.hideCancelButton,
                                showLinkToFileUploadResult: props.showLinkToFileUploadResult,
                                showRemoveButtonAfterComplete: props.showRemoveButtonAfterComplete,
                                metaFields: props.metaFields,
                                toggleFileCard: props.toggleFileCard,
                                handleRequestThumbnail: props.handleRequestThumbnail,
                                handleCancelThumbnail: props.handleCancelThumbnail,
                                recoveredState: props.recoveredState,
                                individualCancellation: props.individualCancellation,
                                openFileEditor: props.openFileEditor,
                                canEditFile: props.canEditFile,
                                toggleAddFilesPanel: props.toggleAddFilesPanel,
                                isSingleFile: isSingleFile,
                                itemsPerRow: itemsPerRow,
                                containerWidth: props.containerWidth,
                                containerHeight: props.containerHeight
                            }) : (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039), {
                                i18n: props.i18n,
                                i18nArray: props.i18nArray,
                                acquirers: props.acquirers,
                                handleInputChange: props.handleInputChange,
                                maxNumberOfFiles: props.maxNumberOfFiles,
                                allowedFileTypes: props.allowedFileTypes,
                                showNativePhotoCameraButton: props.showNativePhotoCameraButton,
                                showNativeVideoCameraButton: props.showNativeVideoCameraButton,
                                nativeCameraFacingMode: props.nativeCameraFacingMode,
                                showPanel: props.showPanel,
                                activePickerPanel: props.activePickerPanel,
                                disableLocalFiles: props.disableLocalFiles,
                                fileManagerSelectionType: props.fileManagerSelectionType,
                                note: props.note,
                                proudlyDisplayPoweredByUppy: props.proudlyDisplayPoweredByUppy
                            }),
                            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), {
                                children: props.showAddFilesPanel ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $175934b4bbc4fb46$export$2e2bcd8739ae039), {
                                    ...props,
                                    isSizeMD: isSizeMD
                                }, "AddFiles") : null
                            }),
                            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), {
                                children: props.fileCardFor ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $af43f3a66035ecee$export$2e2bcd8739ae039), {
                                    ...props
                                }, "FileCard") : null
                            }),
                            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), {
                                children: props.activePickerPanel ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $e3578ca53f5728a8$export$2e2bcd8739ae039), {
                                    ...props
                                }, "Picker") : null
                            }),
                            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), {
                                children: props.showFileEditor ? (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)((0, $d8360bbc75e6a373$export$2e2bcd8739ae039), {
                                    ...props
                                }, "Editor") : null
                            }),
                            (0, $1fd71c045d4a7be8$export$34b9dba7ce09269b)("div", {
                                className: "uppy-Dashboard-progressindicators",
                                children: props.progressindicators.map((target)=>{
                                    // TODO
                                    // Here we're telling typescript all `this.type = 'progressindicator'` plugins inherit from `UIPlugin`
                                    // This is factually true in Uppy right now, but maybe it doesn't have to be
                                    return props.uppy.getPlugin(target.id).render(props.state);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return dashboard;
}


var $c4158ae05dd76b13$export$2e2bcd8739ae039 = {
    strings: {
        // When `inline: false`, used as the screen reader label for the button that closes the modal.
        closeModal: 'Close Modal',
        // Used as the screen reader label for the plus (+) button that shows the “Add more files” screen
        addMoreFiles: 'Add more files',
        addingMoreFiles: 'Adding more files',
        // Used as the header for import panels, e.g., “Import from Google Drive”.
        importFrom: 'Import from %{name}',
        // When `inline: false`, used as the screen reader label for the dashboard modal.
        dashboardWindowTitle: 'Uppy Dashboard Window (Press escape to close)',
        // When `inline: true`, used as the screen reader label for the dashboard area.
        dashboardTitle: 'Uppy Dashboard',
        // Shown in the Informer when a link to a file was copied to the clipboard.
        copyLinkToClipboardSuccess: 'Link copied to clipboard.',
        // Used when a link cannot be copied automatically — the user has to select the text from the
        // input element below this string.
        copyLinkToClipboardFallback: 'Copy the URL below',
        // Used as the hover title and screen reader label for buttons that copy a file link.
        copyLink: 'Copy link',
        back: 'Back',
        // Used as the screen reader label for buttons that remove a file.
        removeFile: 'Remove file',
        // Used as the screen reader label for buttons that open the metadata editor panel for a file.
        editFile: 'Edit file',
        editImage: 'Edit image',
        // Shown in the panel header for the metadata editor. Rendered as “Editing image.png”.
        editing: 'Editing %{file}',
        // Shown on the main upload screen when an upload error occurs
        error: 'Error',
        // Used as the screen reader label for the button that saves metadata edits and returns to the
        // file list view.
        finishEditingFile: 'Finish editing file',
        saveChanges: 'Save changes',
        // Used as the label for the tab button that opens the system file selection dialog.
        myDevice: 'My Device',
        dropHint: 'Drop your files here',
        // Used as the hover text and screen reader label for file progress indicators when
        // they have been fully uploaded.
        uploadComplete: 'Upload complete',
        uploadPaused: 'Upload paused',
        // Used as the hover text and screen reader label for the buttons to resume paused uploads.
        resumeUpload: 'Resume upload',
        // Used as the hover text and screen reader label for the buttons to pause uploads.
        pauseUpload: 'Pause upload',
        // Used as the hover text and screen reader label for the buttons to retry failed uploads.
        retryUpload: 'Retry upload',
        // Used as the hover text and screen reader label for the buttons to cancel uploads.
        cancelUpload: 'Cancel upload',
        // Used in a title, how many files are currently selected
        xFilesSelected: {
            0: '%{smart_count} file selected',
            1: '%{smart_count} files selected'
        },
        uploadingXFiles: {
            0: 'Uploading %{smart_count} file',
            1: 'Uploading %{smart_count} files'
        },
        processingXFiles: {
            0: 'Processing %{smart_count} file',
            1: 'Processing %{smart_count} files'
        },
        // The "powered by Uppy" link at the bottom of the Dashboard.
        poweredBy: 'Powered by %{uppy}',
        addMore: 'Add more',
        editFileWithFilename: 'Edit file %{file}',
        save: 'Save',
        cancel: 'Cancel',
        dropPasteFiles: 'Drop files here or %{browseFiles}',
        dropPasteFolders: 'Drop files here or %{browseFolders}',
        dropPasteBoth: 'Drop files here, %{browseFiles} or %{browseFolders}',
        dropPasteImportFiles: 'Drop files here, %{browseFiles} or import from:',
        dropPasteImportFolders: 'Drop files here, %{browseFolders} or import from:',
        dropPasteImportBoth: 'Drop files here, %{browseFiles}, %{browseFolders} or import from:',
        importFiles: 'Import files from:',
        browseFiles: 'browse files',
        browseFolders: 'browse folders',
        recoveredXFiles: {
            0: 'We could not fully recover 1 file. Please re-select it and resume the upload.',
            1: 'We could not fully recover %{smart_count} files. Please re-select them and resume the upload.'
        },
        recoveredAllFiles: 'We restored all files. You can now resume the upload.',
        sessionRestored: 'Session restored',
        reSelect: 'Re-select',
        missingRequiredMetaFields: {
            0: 'Missing required meta field: %{fields}.',
            1: 'Missing required meta fields: %{fields}.'
        },
        // Used for native device camera buttons on mobile
        takePictureBtn: 'Take Picture',
        recordVideoBtn: 'Record Video'
    }
};


// @ts-ignore untyped
var $a6c8757fba02bc34$export$2e2bcd8739ae039 = [
    'a[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'area[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'input:not([disabled]):not([inert]):not([aria-hidden])',
    'select:not([disabled]):not([inert]):not([aria-hidden])',
    'textarea:not([disabled]):not([inert]):not([aria-hidden])',
    'button:not([disabled]):not([inert]):not([aria-hidden])',
    'iframe:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'object:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'embed:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[contenteditable]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[tabindex]:not([tabindex^="-"]):not([inert]):not([aria-hidden])'
];



/**
 * @returns {HTMLElement} - either dashboard element, or the overlay that's most on top
 */ function $0a4934e80baa1792$export$2e2bcd8739ae039(dashboardEl, activeOverlayType) {
    if (activeOverlayType) {
        const overlayEl = dashboardEl.querySelector(`[data-uppy-paneltype="${activeOverlayType}"]`);
        // if an overlay is already mounted
        if (overlayEl) return overlayEl;
    }
    return dashboardEl;
}


function $33dc1dd867a7b8b6$export$2e2bcd8739ae039() {
    let lastFocusWasOnSuperFocusableEl = false;
    const superFocus = (dashboardEl, activeOverlayType)=>{
        const overlayEl = (0, $0a4934e80baa1792$export$2e2bcd8739ae039)(dashboardEl, activeOverlayType);
        const isFocusInOverlay = overlayEl.contains(document.activeElement);
        // If focus is already in the topmost overlay, AND on last update we focused on the superfocusable
        // element - then leave focus up to the user.
        // [Practical check] without this line, typing in the search input in googledrive overlay won't work.
        if (isFocusInOverlay && lastFocusWasOnSuperFocusableEl) return;
        const superFocusableEl = overlayEl.querySelector('[data-uppy-super-focusable]');
        // If we are already in the topmost overlay, AND there are no super focusable elements yet, - leave focus up to the user.
        // [Practical check] without this line, if you are in an empty folder in google drive, and something's uploading in the
        // bg, - focus will be jumping to Done all the time.
        if (isFocusInOverlay && !superFocusableEl) return;
        if (superFocusableEl) {
            superFocusableEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = true;
        } else {
            const firstEl = overlayEl.querySelector((0, $a6c8757fba02bc34$export$2e2bcd8739ae039));
            firstEl?.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = false;
        }
    };
    // ___Why do we need to debounce?
    //    1. To deal with animations: overlay changes via animations, which results in the DOM updating AFTER plugin.update()
    //       already executed.
    //    [Practical check] without debounce, if we open the Url overlay, and click 'Done', Dashboard won't get focused again.
    //    [Practical check] if we delay 250ms instead of 260ms - IE11 won't get focused in same situation.
    //    2. Performance: there can be many state update()s in a second, and this function is called every time.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8284bc2b60dc4bc4$exports)))(superFocus, 260);
}


// @ts-ignore untyped



function $f5d602e6112dba3d$var$focusOnFirstNode(event, nodes) {
    const node = nodes[0];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
function $f5d602e6112dba3d$var$focusOnLastNode(event, nodes) {
    const node = nodes[nodes.length - 1];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
// ___Why not just use (focusedItemIndex === -1)?
//    Firefox thinks <ul> is focusable, but we don't have <ul>s in our FOCUSABLE_ELEMENTS. Which means that if we tab into
//    the <ul>, code will think that we are not in the active overlay, and we should focusOnFirstNode() of the currently
//    active overlay!
//    [Practical check] if we use (focusedItemIndex === -1), instagram provider in firefox will never get focus on its pics
//    in the <ul>.
function $f5d602e6112dba3d$var$isFocusInOverlay(activeOverlayEl) {
    return activeOverlayEl.contains(document.activeElement);
}
function $f5d602e6112dba3d$export$f41e0874aee57111(event, activeOverlayType, dashboardEl) {
    const activeOverlayEl = (0, $0a4934e80baa1792$export$2e2bcd8739ae039)(dashboardEl, activeOverlayType);
    const focusableNodes = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(activeOverlayEl.querySelectorAll((0, $a6c8757fba02bc34$export$2e2bcd8739ae039)));
    const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
    // If we pressed tab, and focus is not yet within the current overlay - focus on
    // the first element within the current overlay.
    // This is a safety measure (for when user returns from another tab e.g.), most
    // plugins will try to focus on some important element as it loads.
    if (!$f5d602e6112dba3d$var$isFocusInOverlay(activeOverlayEl)) $f5d602e6112dba3d$var$focusOnFirstNode(event, focusableNodes);
    else if (event.shiftKey && focusedItemIndex === 0) $f5d602e6112dba3d$var$focusOnLastNode(event, focusableNodes);
    else if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) $f5d602e6112dba3d$var$focusOnFirstNode(event, focusableNodes);
}
function $f5d602e6112dba3d$export$66fd63158b65050a(event, activeOverlayType, dashboardEl) {
    // ___When we're in the bare 'Drop files here, paste, browse or import from' screen
    if (activeOverlayType === null) ;
    else // Trap the focus inside this overlay!
    // User can close the overlay (click 'Done') if they want to travel away from Uppy.
    $f5d602e6112dba3d$export$f41e0874aee57111(event, activeOverlayType, dashboardEl);
}


const $b868dcf7a47332e3$var$TAB_KEY = 9;
const $b868dcf7a47332e3$var$ESC_KEY = 27;
function $b868dcf7a47332e3$var$createPromise() {
    const o = {};
    o.promise = new Promise((resolve, reject)=>{
        o.resolve = resolve;
        o.reject = reject;
    });
    return o;
}
const $b868dcf7a47332e3$var$defaultOptions = {
    target: 'body',
    metaFields: [],
    thumbnailWidth: 280,
    thumbnailType: 'image/jpeg',
    waitForThumbnailsBeforeUpload: false,
    defaultPickerIcon: $671181bcc8a0cf10$export$b9ab270927e310e4,
    showLinkToFileUploadResult: false,
    showProgressDetails: false,
    hideUploadButton: false,
    hideCancelButton: false,
    hideRetryButton: false,
    hidePauseResumeButton: false,
    hideProgressAfterFinish: false,
    note: null,
    singleFileFullScreen: true,
    disableStatusBar: false,
    disableInformer: false,
    disableThumbnailGenerator: false,
    fileManagerSelectionType: 'files',
    proudlyDisplayPoweredByUppy: true,
    showSelectedFiles: true,
    showRemoveButtonAfterComplete: false,
    showNativePhotoCameraButton: false,
    showNativeVideoCameraButton: false,
    theme: 'light',
    autoOpen: null,
    disabled: false,
    disableLocalFiles: false,
    nativeCameraFacingMode: '',
    onDragLeave: ()=>{},
    onDragOver: ()=>{},
    onDrop: ()=>{},
    plugins: [],
    // Dynamic default options, they have to be defined in the constructor (because
    // they require access to the `this` keyword), but we still want them to
    // appear in the default options so TS knows they'll be defined.
    doneButtonHandler: undefined,
    onRequestCloseModal: null,
    // defaultModalOptions
    inline: false,
    animateOpenClose: true,
    browserBackButtonClose: false,
    closeAfterFinish: false,
    closeModalOnClickOutside: false,
    disablePageScrollWhenModalOpen: true,
    trigger: null,
    // defaultInlineOptions
    width: 750,
    height: 550
};
class $b868dcf7a47332e3$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    static VERSION = (0, (/*@__PURE__*/$parcel$interopDefault($2ca689b6382edf6b$exports))).version;
    #disabledNodes;
    modalName = `uppy-Dashboard-${(0, $ee6f2436cceea22a$export$ac4959f4f1338dfc)()}`;
    superFocus = (0, $33dc1dd867a7b8b6$export$2e2bcd8739ae039)();
    ifFocusedOnUppyRecently = false;
    dashboardIsDisabled;
    savedScrollPosition;
    savedActiveElement;
    resizeObserver;
    darkModeMediaQuery;
    // Timeouts
    makeDashboardInsidesVisibleAnywayTimeout;
    constructor(uppy, opts){
        const autoOpen = opts?.autoOpen ?? null;
        super(uppy, {
            ...$b868dcf7a47332e3$var$defaultOptions,
            ...opts,
            autoOpen: autoOpen
        });
        this.id = this.opts.id || 'Dashboard';
        this.title = 'Dashboard';
        this.type = 'orchestrator';
        this.defaultLocale = (0, $c4158ae05dd76b13$export$2e2bcd8739ae039);
        // Dynamic default options:
        if (this.opts.doneButtonHandler === undefined) // `null` means "do not display a Done button", while `undefined` means
        // "I want the default behavior". For this reason, we need to differentiate `null` and `undefined`.
        this.opts.doneButtonHandler = ()=>{
            this.uppy.clear();
            this.requestCloseModal();
        };
        this.opts.onRequestCloseModal ??= ()=>this.closeModal();
        this.i18nInit();
    }
    removeTarget = (plugin)=>{
        const pluginState = this.getPluginState();
        // filter out the one we want to remove
        const newTargets = pluginState.targets.filter((target)=>target.id !== plugin.id);
        this.setPluginState({
            targets: newTargets
        });
    };
    addTarget = (plugin)=>{
        const callerPluginId = plugin.id || plugin.constructor.name;
        const callerPluginName = plugin.title || callerPluginId;
        const callerPluginType = plugin.type;
        if (callerPluginType !== 'acquirer' && callerPluginType !== 'progressindicator' && callerPluginType !== 'editor') {
            const msg = 'Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor';
            this.uppy.log(msg, 'error');
            return null;
        }
        const target = {
            id: callerPluginId,
            name: callerPluginName,
            type: callerPluginType
        };
        const state = this.getPluginState();
        const newTargets = state.targets.slice();
        newTargets.push(target);
        this.setPluginState({
            targets: newTargets
        });
        return this.el;
    };
    hideAllPanels = ()=>{
        const state = this.getPluginState();
        const update = {
            activePickerPanel: undefined,
            showAddFilesPanel: false,
            activeOverlayType: null,
            fileCardFor: null,
            showFileEditor: false
        };
        if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) // avoid doing a state update if nothing changed
        return;
        this.setPluginState(update);
        this.uppy.emit('dashboard:close-panel', state.activePickerPanel?.id);
    };
    showPanel = (id)=>{
        const { targets: targets } = this.getPluginState();
        const activePickerPanel = targets.find((target)=>{
            return target.type === 'acquirer' && target.id === id;
        });
        this.setPluginState({
            activePickerPanel: activePickerPanel,
            activeOverlayType: 'PickerPanel'
        });
        this.uppy.emit('dashboard:show-panel', id);
    };
    canEditFile = (file)=>{
        const { targets: targets } = this.getPluginState();
        const editors = this.#getEditors(targets);
        return editors.some((target)=>this.uppy.getPlugin(target.id).canEditFile(file));
    };
    openFileEditor = (file)=>{
        const { targets: targets } = this.getPluginState();
        const editors = this.#getEditors(targets);
        this.setPluginState({
            showFileEditor: true,
            fileCardFor: file.id || null,
            activeOverlayType: 'FileEditor'
        });
        editors.forEach((editor)=>{
            this.uppy.getPlugin(editor.id).selectFile(file);
        });
    };
    closeFileEditor = ()=>{
        const { metaFields: metaFields } = this.getPluginState();
        const isMetaEditorEnabled = metaFields && metaFields.length > 0;
        if (isMetaEditorEnabled) this.setPluginState({
            showFileEditor: false,
            activeOverlayType: 'FileCard'
        });
        else this.setPluginState({
            showFileEditor: false,
            fileCardFor: null,
            activeOverlayType: 'AddFiles'
        });
    };
    saveFileEditor = ()=>{
        const { targets: targets } = this.getPluginState();
        const editors = this.#getEditors(targets);
        editors.forEach((editor)=>{
            this.uppy.getPlugin(editor.id).save();
        });
        this.closeFileEditor();
    };
    openModal = ()=>{
        const { promise: promise, resolve: resolve } = $b868dcf7a47332e3$var$createPromise();
        // save scroll position
        this.savedScrollPosition = window.pageYOffset;
        // save active element, so we can restore focus when modal is closed
        this.savedActiveElement = document.activeElement;
        if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.add('uppy-Dashboard-isFixed');
        if (this.opts.animateOpenClose && this.getPluginState().isClosing) {
            const handler = ()=>{
                this.setPluginState({
                    isHidden: false
                });
                this.el.removeEventListener('animationend', handler, false);
                resolve();
            };
            this.el.addEventListener('animationend', handler, false);
        } else {
            this.setPluginState({
                isHidden: false
            });
            resolve();
        }
        if (this.opts.browserBackButtonClose) this.updateBrowserHistory();
        // handle ESC and TAB keys in modal dialog
        document.addEventListener('keydown', this.handleKeyDownInModal);
        this.uppy.emit('dashboard:modal-open');
        return promise;
    };
    closeModal = (opts)=>{
        // Whether the modal is being closed by the user (`true`) or by other means (e.g. browser back button)
        const manualClose = opts?.manualClose ?? true;
        const { isHidden: isHidden, isClosing: isClosing } = this.getPluginState();
        if (isHidden || isClosing) // short-circuit if animation is ongoing
        return undefined;
        const { promise: promise, resolve: resolve } = $b868dcf7a47332e3$var$createPromise();
        if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove('uppy-Dashboard-isFixed');
        if (this.opts.animateOpenClose) {
            this.setPluginState({
                isClosing: true
            });
            const handler = ()=>{
                this.setPluginState({
                    isHidden: true,
                    isClosing: false
                });
                this.superFocus.cancel();
                this.savedActiveElement.focus();
                this.el.removeEventListener('animationend', handler, false);
                resolve();
            };
            this.el.addEventListener('animationend', handler, false);
        } else {
            this.setPluginState({
                isHidden: true
            });
            this.superFocus.cancel();
            this.savedActiveElement.focus();
            resolve();
        }
        // handle ESC and TAB keys in modal dialog
        document.removeEventListener('keydown', this.handleKeyDownInModal);
        if (manualClose) {
            if (this.opts.browserBackButtonClose) // Make sure that the latest entry in the history state is our modal name
            {
                if (history.state?.[this.modalName]) // Go back in history to clear out the entry we created (ultimately closing the modal)
                history.back();
            }
        }
        this.uppy.emit('dashboard:modal-closed');
        return promise;
    };
    isModalOpen = ()=>{
        return !this.getPluginState().isHidden || false;
    };
    requestCloseModal = ()=>{
        if (this.opts.onRequestCloseModal) return this.opts.onRequestCloseModal();
        return this.closeModal();
    };
    setDarkModeCapability = (isDarkModeOn)=>{
        const { capabilities: capabilities } = this.uppy.getState();
        this.uppy.setState({
            capabilities: {
                ...capabilities,
                darkMode: isDarkModeOn
            }
        });
    };
    handleSystemDarkModeChange = (event)=>{
        const isDarkModeOnNow = event.matches;
        this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnNow ? 'on' : 'off'}`);
        this.setDarkModeCapability(isDarkModeOnNow);
    };
    toggleFileCard = (show, fileID)=>{
        const file = this.uppy.getFile(fileID);
        if (show) this.uppy.emit('dashboard:file-edit-start', file);
        else this.uppy.emit('dashboard:file-edit-complete', file);
        this.setPluginState({
            fileCardFor: show ? fileID : null,
            activeOverlayType: show ? 'FileCard' : null
        });
    };
    toggleAddFilesPanel = (show)=>{
        this.setPluginState({
            showAddFilesPanel: show,
            activeOverlayType: show ? 'AddFiles' : null
        });
    };
    addFiles = (files)=>{
        const descriptors = files.map((file)=>({
                source: this.id,
                name: file.name,
                type: file.type,
                data: file,
                meta: {
                    // path of the file relative to the ancestor directory the user selected.
                    // e.g. 'docs/Old Prague/airbnb.pdf'
                    relativePath: file.relativePath || file.webkitRelativePath || null
                }
            }));
        try {
            this.uppy.addFiles(descriptors);
        } catch (err) {
            this.uppy.log(err);
        }
    };
    // ___Why make insides of Dashboard invisible until first ResizeObserver event is emitted?
    //    ResizeOberserver doesn't emit the first resize event fast enough, users can see the jump from one .uppy-size-- to
    //    another (e.g. in Safari)
    // ___Why not apply visibility property to .uppy-Dashboard-inner?
    //    Because ideally, acc to specs, ResizeObserver should see invisible elements as of width 0. So even though applying
    //    invisibility to .uppy-Dashboard-inner works now, it may not work in the future.
    startListeningToResize = ()=>{
        // Watch for Dashboard container (`.uppy-Dashboard-inner`) resize
        // and update containerWidth/containerHeight in plugin state accordingly.
        // Emits first event on initialization.
        this.resizeObserver = new ResizeObserver((entries)=>{
            const uppyDashboardInnerEl = entries[0];
            const { width: width, height: height } = uppyDashboardInnerEl.contentRect;
            this.setPluginState({
                containerWidth: width,
                containerHeight: height,
                areInsidesReadyToBeVisible: true
            });
        });
        this.resizeObserver.observe(this.el.querySelector('.uppy-Dashboard-inner'));
        // If ResizeObserver fails to emit an event telling us what size to use - default to the mobile view
        this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(()=>{
            const pluginState = this.getPluginState();
            const isModalAndClosed = !this.opts.inline && pluginState.isHidden;
            if (// We might want to enable this in the future
            // if ResizeObserver hasn't yet fired,
            !pluginState.areInsidesReadyToBeVisible && // and it's not due to the modal being closed
            !isModalAndClosed) {
                this.uppy.log("[Dashboard] resize event didn\u2019t fire on time: defaulted to mobile layout", 'warning');
                this.setPluginState({
                    areInsidesReadyToBeVisible: true
                });
            }
        }, 1000);
    };
    stopListeningToResize = ()=>{
        this.resizeObserver.disconnect();
        clearTimeout(this.makeDashboardInsidesVisibleAnywayTimeout);
    };
    // Records whether we have been interacting with uppy right now,
    // which is then used to determine whether state updates should trigger a refocusing.
    recordIfFocusedOnUppyRecently = (event)=>{
        if (this.el.contains(event.target)) this.ifFocusedOnUppyRecently = true;
        else {
            this.ifFocusedOnUppyRecently = false;
            // ___Why run this.superFocus.cancel here when it already runs in superFocusOnEachUpdate?
            //    Because superFocus is debounced, when we move from Uppy to some other element on the page,
            //    previously run superFocus sometimes hits and moves focus back to Uppy.
            this.superFocus.cancel();
        }
    };
    disableInteractiveElements = (disable)=>{
        const NODES_TO_DISABLE = [
            'a[href]',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            'button:not([disabled])',
            '[role="button"]:not([disabled])'
        ];
        const nodesToDisable = this.#disabledNodes ?? (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(this.el.querySelectorAll(NODES_TO_DISABLE)).filter((node)=>!node.classList.contains('uppy-Dashboard-close'));
        for (const node of nodesToDisable)// Links can’t have `disabled` attr, so we use `aria-disabled` for a11y
        if (node.tagName === 'A') node.setAttribute('aria-disabled', disable);
        else node.disabled = disable;
        if (disable) this.#disabledNodes = nodesToDisable;
        else this.#disabledNodes = null;
        this.dashboardIsDisabled = disable;
    };
    updateBrowserHistory = ()=>{
        // Ensure history state does not already contain our modal name to avoid double-pushing
        if (!history.state?.[this.modalName]) // Push to history so that the page is not lost on browser back button press
        history.pushState({
            ...history.state,
            [this.modalName]: true
        }, '');
        // Listen for back button presses
        window.addEventListener('popstate', this.handlePopState, false);
    };
    handlePopState = (event)=>{
        // Close the modal if the history state no longer contains our modal name
        if (this.isModalOpen() && (!event.state || !event.state[this.modalName])) this.closeModal({
            manualClose: false
        });
        // When the browser back button is pressed and uppy is now the latest entry
        // in the history but the modal is closed, fix the history by removing the
        // uppy history entry.
        // This occurs when another entry is added into the history state while the
        // modal is open, and then the modal gets manually closed.
        // Solves PR #575 (https://github.com/transloadit/uppy/pull/575)
        if (!this.isModalOpen() && event.state?.[this.modalName]) history.back();
    };
    handleKeyDownInModal = (event)=>{
        // close modal on esc key press
        if (event.keyCode === $b868dcf7a47332e3$var$ESC_KEY) this.requestCloseModal();
        // trap focus on tab key press
        if (event.keyCode === $b868dcf7a47332e3$var$TAB_KEY) $f5d602e6112dba3d$export$f41e0874aee57111(event, this.getPluginState().activeOverlayType, this.el);
    };
    handleClickOutside = ()=>{
        if (this.opts.closeModalOnClickOutside) this.requestCloseModal();
    };
    handlePaste = (event)=>{
        // Let any acquirer plugin (Url/Webcam/etc.) handle pastes to the root
        this.uppy.iteratePlugins((plugin)=>{
            if (plugin.type === 'acquirer') plugin.handleRootPaste?.(event);
        });
        // Add all dropped files
        const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(event.clipboardData.files);
        if (files.length > 0) {
            this.uppy.log('[Dashboard] Files pasted');
            this.addFiles(files);
        }
    };
    handleInputChange = (event)=>{
        event.preventDefault();
        const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(event.currentTarget.files || []);
        if (files.length > 0) {
            this.uppy.log('[Dashboard] Files selected through input');
            this.addFiles(files);
        }
    };
    handleDragOver = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        // Check if some plugin can handle the datatransfer without files —
        // for instance, the Url plugin can import a url
        const canSomePluginHandleRootDrop = ()=>{
            let somePluginCanHandleRootDrop = true;
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.canHandleRootDrop?.(event)) somePluginCanHandleRootDrop = true;
            });
            return somePluginCanHandleRootDrop;
        };
        // Check if the "type" of the datatransfer object includes files
        const doesEventHaveFiles = ()=>{
            const { types: types } = event.dataTransfer;
            return types.some((type)=>type === 'Files');
        };
        // Deny drop, if no plugins can handle datatransfer, there are no files,
        // or when opts.disabled is set, or new uploads are not allowed
        const somePluginCanHandleRootDrop = canSomePluginHandleRootDrop();
        const hasFiles = doesEventHaveFiles();
        if (!somePluginCanHandleRootDrop && !hasFiles || this.opts.disabled || // opts.disableLocalFiles should only be taken into account if no plugins
        // can handle the datatransfer
        this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !this.uppy.getState().allowNewUpload) {
            event.dataTransfer.dropEffect = 'none';
            return;
        }
        // Add a small (+) icon on drop
        // (and prevent browsers from interpreting this as files being _moved_ into the
        // browser, https://github.com/transloadit/uppy/issues/1978).
        event.dataTransfer.dropEffect = 'copy';
        this.setPluginState({
            isDraggingOver: true
        });
        this.opts.onDragOver(event);
    };
    handleDragLeave = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        this.setPluginState({
            isDraggingOver: false
        });
        this.opts.onDragLeave(event);
    };
    handleDrop = async (event)=>{
        event.preventDefault();
        event.stopPropagation();
        this.setPluginState({
            isDraggingOver: false
        });
        // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root
        this.uppy.iteratePlugins((plugin)=>{
            if (plugin.type === 'acquirer') plugin.handleRootDrop?.(event);
        });
        // Add all dropped files
        let executedDropErrorOnce = false;
        const logDropError = (error)=>{
            this.uppy.log(error, 'error');
            // In practice all drop errors are most likely the same,
            // so let's just show one to avoid overwhelming the user
            if (!executedDropErrorOnce) {
                this.uppy.info(error.message, 'error');
                executedDropErrorOnce = true;
            }
        };
        this.uppy.log('[Dashboard] Processing dropped files');
        // Add all dropped files
        const files = await (0, $954bacbcaff60289$export$2e2bcd8739ae039)(event.dataTransfer, {
            logDropError: logDropError
        });
        if (files.length > 0) {
            this.uppy.log('[Dashboard] Files dropped');
            this.addFiles(files);
        }
        this.opts.onDrop(event);
    };
    handleRequestThumbnail = (file)=>{
        if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit('thumbnail:request', file);
    };
    /**
     * We cancel thumbnail requests when a file item component unmounts to avoid
     * clogging up the queue when the user scrolls past many elements.
     */ handleCancelThumbnail = (file)=>{
        if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit('thumbnail:cancel', file);
    };
    handleKeyDownInInline = (event)=>{
        // Trap focus on tab key press.
        if (event.keyCode === $b868dcf7a47332e3$var$TAB_KEY) $f5d602e6112dba3d$export$66fd63158b65050a(event, this.getPluginState().activeOverlayType, this.el);
    };
    // ___Why do we listen to the 'paste' event on a document instead of onPaste={props.handlePaste} prop,
    //    or this.el.addEventListener('paste')?
    //    Because (at least) Chrome doesn't handle paste if focus is on some button, e.g. 'My Device'.
    //    => Therefore, the best option is to listen to all 'paste' events, and only react to them when we are focused on our
    //       particular Uppy instance.
    // ___Why do we still need onPaste={props.handlePaste} for the DashboardUi?
    //    Because if we click on the 'Drop files here' caption e.g., `document.activeElement` will be 'body'. Which means our
    //    standard determination of whether we're pasting into our Uppy instance won't work.
    //    => Therefore, we need a traditional onPaste={props.handlePaste} handler too.
    handlePasteOnBody = (event)=>{
        const isFocusInOverlay = this.el.contains(document.activeElement);
        if (isFocusInOverlay) this.handlePaste(event);
    };
    handleComplete = ({ failed: failed })=>{
        if (this.opts.closeAfterFinish && !failed?.length) // All uploads are done
        this.requestCloseModal();
    };
    handleCancelRestore = ()=>{
        this.uppy.emit('restore-canceled');
    };
    #generateLargeThumbnailIfSingleFile = ()=>{
        if (this.opts.disableThumbnailGenerator) return;
        const LARGE_THUMBNAIL = 600;
        const files = this.uppy.getFiles();
        if (files.length === 1) {
            const thumbnailGenerator = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
            thumbnailGenerator?.setOptions({
                thumbnailWidth: LARGE_THUMBNAIL
            });
            const fileForThumbnail = {
                ...files[0],
                preview: undefined
            };
            thumbnailGenerator?.requestThumbnail(fileForThumbnail).then(()=>{
                thumbnailGenerator?.setOptions({
                    thumbnailWidth: this.opts.thumbnailWidth
                });
            });
        }
    };
    #openFileEditorWhenFilesAdded = (files)=>{
        const firstFile = files[0];
        const { metaFields: metaFields } = this.getPluginState();
        const isMetaEditorEnabled = metaFields && metaFields.length > 0;
        const isImageEditorEnabled = this.canEditFile(firstFile);
        if (isMetaEditorEnabled && this.opts.autoOpen === 'metaEditor') this.toggleFileCard(true, firstFile.id);
        else if (isImageEditorEnabled && this.opts.autoOpen === 'imageEditor') this.openFileEditor(firstFile);
    };
    initEvents = ()=>{
        // Modal open button
        if (this.opts.trigger && !this.opts.inline) {
            const showModalTrigger = (0, $3da4efa7f88c23a6$export$2e2bcd8739ae039)(this.opts.trigger);
            if (showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.addEventListener('click', this.openModal));
            else this.uppy.log('Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself', 'warning');
        }
        this.startListeningToResize();
        document.addEventListener('paste', this.handlePasteOnBody);
        this.uppy.on('plugin-added', this.#addSupportedPluginIfNoTarget);
        this.uppy.on('plugin-remove', this.removeTarget);
        this.uppy.on('file-added', this.hideAllPanels);
        this.uppy.on('dashboard:modal-closed', this.hideAllPanels);
        this.uppy.on('complete', this.handleComplete);
        this.uppy.on('files-added', this.#generateLargeThumbnailIfSingleFile);
        this.uppy.on('file-removed', this.#generateLargeThumbnailIfSingleFile);
        // ___Why fire on capture?
        //    Because this.ifFocusedOnUppyRecently needs to change before onUpdate() fires.
        document.addEventListener('focus', this.recordIfFocusedOnUppyRecently, true);
        document.addEventListener('click', this.recordIfFocusedOnUppyRecently, true);
        if (this.opts.inline) this.el.addEventListener('keydown', this.handleKeyDownInInline);
        if (this.opts.autoOpen) this.uppy.on('files-added', this.#openFileEditorWhenFilesAdded);
    };
    removeEvents = ()=>{
        const showModalTrigger = (0, $3da4efa7f88c23a6$export$2e2bcd8739ae039)(this.opts.trigger);
        if (!this.opts.inline && showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.removeEventListener('click', this.openModal));
        this.stopListeningToResize();
        document.removeEventListener('paste', this.handlePasteOnBody);
        window.removeEventListener('popstate', this.handlePopState, false);
        this.uppy.off('plugin-added', this.#addSupportedPluginIfNoTarget);
        this.uppy.off('plugin-remove', this.removeTarget);
        this.uppy.off('file-added', this.hideAllPanels);
        this.uppy.off('dashboard:modal-closed', this.hideAllPanels);
        this.uppy.off('complete', this.handleComplete);
        this.uppy.off('files-added', this.#generateLargeThumbnailIfSingleFile);
        this.uppy.off('file-removed', this.#generateLargeThumbnailIfSingleFile);
        document.removeEventListener('focus', this.recordIfFocusedOnUppyRecently);
        document.removeEventListener('click', this.recordIfFocusedOnUppyRecently);
        if (this.opts.inline) this.el.removeEventListener('keydown', this.handleKeyDownInInline);
        if (this.opts.autoOpen) this.uppy.off('files-added', this.#openFileEditorWhenFilesAdded);
    };
    superFocusOnEachUpdate = ()=>{
        const isFocusInUppy = this.el.contains(document.activeElement);
        // When focus is lost on the page (== focus is on body for most browsers, or focus is null for IE11)
        const isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
        const isInformerHidden = this.uppy.getState().info.length === 0;
        const isModal = !this.opts.inline;
        if (// If update is connected to showing the Informer - let the screen reader calmly read it.
        isInformerHidden && // If we are in a modal - always superfocus without concern for other elements
        // on the page (user is unlikely to want to interact with the rest of the page)
        (isModal || // If we are already inside of Uppy, or
        isFocusInUppy || // If we are not focused on anything BUT we have already, at least once, focused on uppy
        //   1. We focus when isFocusNowhere, because when the element we were focused
        //      on disappears (e.g. an overlay), - focus gets lost. If user is typing
        //      something somewhere else on the page, - focus won't be 'nowhere'.
        //   2. We only focus when focus is nowhere AND this.ifFocusedOnUppyRecently,
        //      to avoid focus jumps if we do something else on the page.
        //   [Practical check] Without '&& this.ifFocusedOnUppyRecently', in Safari, in inline mode,
        //                     when file is uploading, - navigate via tab to the checkbox,
        //                     try to press space multiple times. Focus will jump to Uppy.
        isFocusNowhere && this.ifFocusedOnUppyRecently)) this.superFocus(this.el, this.getPluginState().activeOverlayType);
        else this.superFocus.cancel();
    };
    afterUpdate = ()=>{
        if (this.opts.disabled && !this.dashboardIsDisabled) {
            this.disableInteractiveElements(true);
            return;
        }
        if (!this.opts.disabled && this.dashboardIsDisabled) this.disableInteractiveElements(false);
        this.superFocusOnEachUpdate();
    };
    saveFileCard = (meta, fileID)=>{
        this.uppy.setFileMeta(fileID, meta);
        this.toggleFileCard(false, fileID);
    };
    #attachRenderFunctionToTarget = (target)=>{
        const plugin = this.uppy.getPlugin(target.id);
        return {
            ...target,
            icon: plugin.icon || this.opts.defaultPickerIcon,
            render: plugin.render
        };
    };
    #isTargetSupported = (target)=>{
        const plugin = this.uppy.getPlugin(target.id);
        // If the plugin does not provide a `supported` check, assume the plugin works everywhere.
        if (typeof plugin.isSupported !== 'function') return true;
        return plugin.isSupported();
    };
    #getAcquirers = (targets)=>{
        return targets.filter((target)=>target.type === 'acquirer' && this.#isTargetSupported(target)).map(this.#attachRenderFunctionToTarget);
    };
    #getProgressIndicators = (targets)=>{
        return targets.filter((target)=>target.type === 'progressindicator').map(this.#attachRenderFunctionToTarget);
    };
    #getEditors = (targets)=>{
        return targets.filter((target)=>target.type === 'editor').map(this.#attachRenderFunctionToTarget);
    };
    render = (state)=>{
        const pluginState = this.getPluginState();
        const { files: files, capabilities: capabilities, allowNewUpload: allowNewUpload } = state;
        const { newFiles: newFiles, uploadStartedFiles: uploadStartedFiles, completeFiles: completeFiles, erroredFiles: erroredFiles, inProgressFiles: inProgressFiles, inProgressNotPausedFiles: inProgressNotPausedFiles, processingFiles: processingFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused } = this.uppy.getObjectOfFilesPerState();
        const acquirers = this.#getAcquirers(pluginState.targets);
        const progressindicators = this.#getProgressIndicators(pluginState.targets);
        const editors = this.#getEditors(pluginState.targets);
        let theme;
        if (this.opts.theme === 'auto') theme = capabilities.darkMode ? 'dark' : 'light';
        else theme = this.opts.theme;
        if ([
            'files',
            'folders',
            'both'
        ].indexOf(this.opts.fileManagerSelectionType) < 0) {
            this.opts.fileManagerSelectionType = 'files';
            console.warn(`Unsupported option for "fileManagerSelectionType". Using default of "${this.opts.fileManagerSelectionType}".`);
        }
        return (0, $8dc96b7f61bbef1d$export$2e2bcd8739ae039)({
            state: state,
            isHidden: pluginState.isHidden,
            files: files,
            newFiles: newFiles,
            uploadStartedFiles: uploadStartedFiles,
            completeFiles: completeFiles,
            erroredFiles: erroredFiles,
            inProgressFiles: inProgressFiles,
            inProgressNotPausedFiles: inProgressNotPausedFiles,
            processingFiles: processingFiles,
            isUploadStarted: isUploadStarted,
            isAllComplete: isAllComplete,
            isAllPaused: isAllPaused,
            totalFileCount: Object.keys(files).length,
            totalProgress: state.totalProgress,
            allowNewUpload: allowNewUpload,
            acquirers: acquirers,
            theme: theme,
            disabled: this.opts.disabled,
            disableLocalFiles: this.opts.disableLocalFiles,
            direction: this.opts.direction,
            activePickerPanel: pluginState.activePickerPanel,
            showFileEditor: pluginState.showFileEditor,
            saveFileEditor: this.saveFileEditor,
            closeFileEditor: this.closeFileEditor,
            disableInteractiveElements: this.disableInteractiveElements,
            animateOpenClose: this.opts.animateOpenClose,
            isClosing: pluginState.isClosing,
            progressindicators: progressindicators,
            editors: editors,
            autoProceed: this.uppy.opts.autoProceed,
            id: this.id,
            closeModal: this.requestCloseModal,
            handleClickOutside: this.handleClickOutside,
            handleInputChange: this.handleInputChange,
            handlePaste: this.handlePaste,
            inline: this.opts.inline,
            showPanel: this.showPanel,
            hideAllPanels: this.hideAllPanels,
            i18n: this.i18n,
            i18nArray: this.i18nArray,
            uppy: this.uppy,
            note: this.opts.note,
            recoveredState: state.recoveredState,
            metaFields: pluginState.metaFields,
            resumableUploads: capabilities.resumableUploads || false,
            individualCancellation: capabilities.individualCancellation,
            isMobileDevice: capabilities.isMobileDevice,
            fileCardFor: pluginState.fileCardFor,
            toggleFileCard: this.toggleFileCard,
            toggleAddFilesPanel: this.toggleAddFilesPanel,
            showAddFilesPanel: pluginState.showAddFilesPanel,
            saveFileCard: this.saveFileCard,
            openFileEditor: this.openFileEditor,
            canEditFile: this.canEditFile,
            width: this.opts.width,
            height: this.opts.height,
            showLinkToFileUploadResult: this.opts.showLinkToFileUploadResult,
            fileManagerSelectionType: this.opts.fileManagerSelectionType,
            proudlyDisplayPoweredByUppy: this.opts.proudlyDisplayPoweredByUppy,
            hideCancelButton: this.opts.hideCancelButton,
            hideRetryButton: this.opts.hideRetryButton,
            hidePauseResumeButton: this.opts.hidePauseResumeButton,
            showRemoveButtonAfterComplete: this.opts.showRemoveButtonAfterComplete,
            containerWidth: pluginState.containerWidth,
            containerHeight: pluginState.containerHeight,
            areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
            parentElement: this.el,
            allowedFileTypes: this.uppy.opts.restrictions.allowedFileTypes,
            maxNumberOfFiles: this.uppy.opts.restrictions.maxNumberOfFiles,
            requiredMetaFields: this.uppy.opts.restrictions.requiredMetaFields,
            showSelectedFiles: this.opts.showSelectedFiles,
            showNativePhotoCameraButton: this.opts.showNativePhotoCameraButton,
            showNativeVideoCameraButton: this.opts.showNativeVideoCameraButton,
            nativeCameraFacingMode: this.opts.nativeCameraFacingMode,
            singleFileFullScreen: this.opts.singleFileFullScreen,
            handleCancelRestore: this.handleCancelRestore,
            handleRequestThumbnail: this.handleRequestThumbnail,
            handleCancelThumbnail: this.handleCancelThumbnail,
            // drag props
            isDraggingOver: pluginState.isDraggingOver,
            handleDragOver: this.handleDragOver,
            handleDragLeave: this.handleDragLeave,
            handleDrop: this.handleDrop
        });
    };
    #addSpecifiedPluginsFromOptions = ()=>{
        const { plugins: plugins } = this.opts;
        plugins.forEach((pluginID)=>{
            const plugin = this.uppy.getPlugin(pluginID);
            if (plugin) plugin.mount(this, plugin);
            else this.uppy.log(`[Uppy] Dashboard could not find plugin '${pluginID}', make sure to uppy.use() the plugins you are specifying`, 'warning');
        });
    };
    #autoDiscoverPlugins = ()=>{
        this.uppy.iteratePlugins(this.#addSupportedPluginIfNoTarget);
    };
    #addSupportedPluginIfNoTarget = (plugin)=>{
        // Only these types belong on the Dashboard,
        // we wouldn’t want to try and mount Compressor or Tus, for example.
        const typesAllowed = [
            'acquirer',
            'editor'
        ];
        if (plugin && !plugin.opts?.target && typesAllowed.includes(plugin.type)) {
            const pluginAlreadyAdded = this.getPluginState().targets.some((installedPlugin)=>plugin.id === installedPlugin.id);
            if (!pluginAlreadyAdded) plugin.mount(this, plugin);
        }
    };
    #getStatusBarOpts() {
        const { hideUploadButton: hideUploadButton, hideRetryButton: hideRetryButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, showProgressDetails: showProgressDetails, hideProgressAfterFinish: hideProgressAfterFinish, locale: l, doneButtonHandler: doneButtonHandler } = this.opts;
        return {
            hideUploadButton: hideUploadButton,
            hideRetryButton: hideRetryButton,
            hidePauseResumeButton: hidePauseResumeButton,
            hideCancelButton: hideCancelButton,
            showProgressDetails: showProgressDetails,
            hideAfterFinish: hideProgressAfterFinish,
            locale: l,
            doneButtonHandler: doneButtonHandler
        };
    }
    #getThumbnailGeneratorOpts() {
        const { thumbnailWidth: thumbnailWidth, thumbnailHeight: thumbnailHeight, thumbnailType: thumbnailType, waitForThumbnailsBeforeUpload: waitForThumbnailsBeforeUpload } = this.opts;
        return {
            thumbnailWidth: thumbnailWidth,
            thumbnailHeight: thumbnailHeight,
            thumbnailType: thumbnailType,
            waitForThumbnailsBeforeUpload: waitForThumbnailsBeforeUpload,
            // If we don't block on thumbnails, we can lazily generate them
            lazy: !waitForThumbnailsBeforeUpload
        };
    }
    #getInformerOpts() {
        return {
        };
    }
    setOptions(opts) {
        super.setOptions(opts);
        this.uppy.getPlugin(this.#getStatusBarId())?.setOptions(this.#getStatusBarOpts());
        this.uppy.getPlugin(this.#getThumbnailGeneratorId())?.setOptions(this.#getThumbnailGeneratorOpts());
    }
    #getStatusBarId() {
        return `${this.id}:StatusBar`;
    }
    #getThumbnailGeneratorId() {
        return `${this.id}:ThumbnailGenerator`;
    }
    #getInformerId() {
        return `${this.id}:Informer`;
    }
    install = ()=>{
        // Set default state for Dashboard
        this.setPluginState({
            isHidden: true,
            fileCardFor: null,
            activeOverlayType: null,
            showAddFilesPanel: false,
            activePickerPanel: undefined,
            showFileEditor: false,
            metaFields: this.opts.metaFields,
            targets: [],
            // We'll make them visible once .containerWidth is determined
            areInsidesReadyToBeVisible: false,
            isDraggingOver: false
        });
        const { inline: inline, closeAfterFinish: closeAfterFinish } = this.opts;
        if (inline && closeAfterFinish) throw new Error('[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.');
        const { allowMultipleUploads: allowMultipleUploads, allowMultipleUploadBatches: allowMultipleUploadBatches } = this.uppy.opts;
        if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) this.uppy.log('[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true', 'warning');
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
        if (!this.opts.disableStatusBar) this.uppy.use((0, $f22a72e7b80fdb1a$export$2e2bcd8739ae039), {
            id: this.#getStatusBarId(),
            target: this,
            ...this.#getStatusBarOpts()
        });
        if (!this.opts.disableInformer) this.uppy.use((0, $2d1e3e0d76faae78$export$2e2bcd8739ae039), {
            id: this.#getInformerId(),
            target: this,
            ...this.#getInformerOpts()
        });
        if (!this.opts.disableThumbnailGenerator) this.uppy.use((0, $f92c4ad36d89e394$export$2e2bcd8739ae039), {
            id: this.#getThumbnailGeneratorId(),
            ...this.#getThumbnailGeneratorOpts()
        });
        // Dark Mode / theme
        this.darkModeMediaQuery = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
        const isDarkModeOnFromTheStart = this.darkModeMediaQuery ? this.darkModeMediaQuery.matches : false;
        this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnFromTheStart ? 'on' : 'off'}`);
        this.setDarkModeCapability(isDarkModeOnFromTheStart);
        if (this.opts.theme === 'auto') this.darkModeMediaQuery?.addListener(this.handleSystemDarkModeChange);
        this.#addSpecifiedPluginsFromOptions();
        this.#autoDiscoverPlugins();
        this.initEvents();
    };
    uninstall = ()=>{
        if (!this.opts.disableInformer) {
            const informer = this.uppy.getPlugin(`${this.id}:Informer`);
            // Checking if this plugin exists, in case it was removed by uppy-core
            // before the Dashboard was.
            if (informer) this.uppy.removePlugin(informer);
        }
        if (!this.opts.disableStatusBar) {
            const statusBar = this.uppy.getPlugin(`${this.id}:StatusBar`);
            if (statusBar) this.uppy.removePlugin(statusBar);
        }
        if (!this.opts.disableThumbnailGenerator) {
            const thumbnail = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
            if (thumbnail) this.uppy.removePlugin(thumbnail);
        }
        const { plugins: plugins } = this.opts;
        plugins.forEach((pluginID)=>{
            const plugin = this.uppy.getPlugin(pluginID);
            if (plugin) plugin.unmount();
        });
        if (this.opts.theme === 'auto') this.darkModeMediaQuery?.removeListener(this.handleSystemDarkModeChange);
        if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove('uppy-Dashboard-isFixed');
        this.unmount();
        this.removeEvents();
    };
}





/**
 * Create a wrapper around an event emitter with a `remove` method to remove
 * all events that were added using the wrapped emitter.
 */ class $c89f32c7d05a95a3$export$2e2bcd8739ae039 {
    #uppy;
    #events = [];
    constructor(uppy){
        this.#uppy = uppy;
    }
    on(event, fn) {
        this.#events.push([
            event,
            fn
        ]);
        return this.#uppy.on(event, fn);
    }
    remove() {
        for (const [event, fn] of this.#events.splice(0))this.#uppy.off(event, fn);
    }
    onFilePause(fileID, cb) {
        this.on('upload-pause', (file, isPaused)=>{
            if (fileID === file?.id) cb(isPaused);
        });
    }
    onFileRemove(fileID, cb) {
        this.on('file-removed', (file)=>{
            if (fileID === file.id) cb(file.id);
        });
    }
    onPause(fileID, cb) {
        this.on('upload-pause', (file, isPaused)=>{
            if (fileID === file?.id) // const isPaused = this.#uppy.pauseResume(fileID)
            cb(isPaused);
        });
    }
    onRetry(fileID, cb) {
        this.on('upload-retry', (file)=>{
            if (fileID === file?.id) cb();
        });
    }
    onRetryAll(fileID, cb) {
        this.on('retry-all', ()=>{
            if (!this.#uppy.getFile(fileID)) return;
            cb();
        });
    }
    onPauseAll(fileID, cb) {
        this.on('pause-all', ()=>{
            if (!this.#uppy.getFile(fileID)) return;
            cb();
        });
    }
    onCancelAll(fileID, eventHandler) {
        this.on('cancel-all', (...args)=>{
            if (!this.#uppy.getFile(fileID)) return;
            eventHandler(...args);
        });
    }
    onResumeAll(fileID, cb) {
        this.on('resume-all', ()=>{
            if (!this.#uppy.getFile(fileID)) return;
            cb();
        });
    }
}


class $0026c55df46f9934$var$NetworkError extends Error {
    cause;
    isNetworkError;
    request;
    constructor(error, xhr = null){
        super(`This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.`);
        this.cause = error;
        this.isNetworkError = true;
        this.request = xhr;
    }
}
var $0026c55df46f9934$export$2e2bcd8739ae039 = $0026c55df46f9934$var$NetworkError;


/**
 * Helper to abort upload requests if there has not been any progress for `timeout` ms.
 * Create an instance using `timer = new ProgressTimeout(10000, onTimeout)`
 * Call `timer.progress()` to signal that there has been progress of any kind.
 * Call `timer.done()` when the upload has completed.
 */ class $c8d4b79cf5a3269c$var$ProgressTimeout {
    #aliveTimer;
    #isDone = false;
    #onTimedOut;
    #timeout;
    constructor(timeout, timeoutHandler){
        this.#timeout = timeout;
        this.#onTimedOut = ()=>timeoutHandler(timeout);
    }
    progress() {
        // Some browsers fire another progress event when the upload is
        // cancelled, so we have to ignore progress after the timer was
        // told to stop.
        if (this.#isDone) return;
        if (this.#timeout > 0) {
            clearTimeout(this.#aliveTimer);
            this.#aliveTimer = setTimeout(this.#onTimedOut, this.#timeout);
        }
    }
    done() {
        if (!this.#isDone) {
            clearTimeout(this.#aliveTimer);
            this.#aliveTimer = undefined;
            this.#isDone = true;
        }
    }
}
var $c8d4b79cf5a3269c$export$2e2bcd8739ae039 = $c8d4b79cf5a3269c$var$ProgressTimeout;


const $e3981d1185f67d50$var$noop = ()=>{};
function $e3981d1185f67d50$export$47fdd40111eda34c(url, options = {}) {
    const { body: body = null, headers: headers = {}, method: method = 'GET', onBeforeRequest: onBeforeRequest = $e3981d1185f67d50$var$noop, onUploadProgress: onUploadProgress = $e3981d1185f67d50$var$noop, shouldRetry: shouldRetry = ()=>true, onAfterResponse: onAfterResponse = $e3981d1185f67d50$var$noop, onTimeout: onTimeout = $e3981d1185f67d50$var$noop, responseType: responseType, retries: retries = 3, signal: signal = null, timeout: timeout = 30000, withCredentials: withCredentials = false } = options;
    // 300 ms, 600 ms, 1200 ms, 2400 ms, 4800 ms
    const delay = (attempt)=>0.3 * 2 ** (attempt - 1) * 1000;
    const timer = new (0, $c8d4b79cf5a3269c$export$2e2bcd8739ae039)(timeout, onTimeout);
    function requestWithRetry(retryCount = 0) {
        // biome-ignore lint/suspicious/noAsyncPromiseExecutor: it's fine
        return new Promise(async (resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            const onError = (error)=>{
                if (shouldRetry(xhr) && retryCount < retries) setTimeout(()=>{
                    requestWithRetry(retryCount + 1).then(resolve, reject);
                }, delay(retryCount));
                else {
                    timer.done();
                    reject(error);
                }
            };
            xhr.open(method, url, true);
            xhr.withCredentials = withCredentials;
            if (responseType) xhr.responseType = responseType;
            signal?.addEventListener('abort', ()=>{
                xhr.abort();
                // Using DOMException for abort errors aligns with
                // the convention established by the Fetch API.
                reject(new DOMException('Aborted', 'AbortError'));
            });
            xhr.onload = async ()=>{
                try {
                    await onAfterResponse(xhr, retryCount);
                } catch (err) {
                    // This is important as we need to emit the xhr
                    // over the upload-error event.
                    err.request = xhr;
                    onError(err);
                    return;
                }
                if (xhr.status >= 200 && xhr.status < 300) {
                    timer.done();
                    resolve(xhr);
                } else if (shouldRetry(xhr) && retryCount < retries) setTimeout(()=>{
                    requestWithRetry(retryCount + 1).then(resolve, reject);
                }, delay(retryCount));
                else {
                    timer.done();
                    reject(new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(xhr.statusText, xhr));
                }
            };
            xhr.onerror = ()=>onError(new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(xhr.statusText, xhr));
            xhr.upload.onprogress = (event)=>{
                timer.progress();
                onUploadProgress(event);
            };
            if (headers) Object.keys(headers).forEach((key)=>{
                xhr.setRequestHeader(key, headers[key]);
            });
            await onBeforeRequest(xhr, retryCount);
            xhr.send(body);
        });
    }
    return requestWithRetry();
}


function $169d20dd56f976c7$export$3bd9b1601aad11ac(files) {
    const hasError = (file)=>'error' in file && !!file.error;
    return files.filter((file)=>!hasError(file));
}
function $169d20dd56f976c7$export$9e8ffa0bfbcfeed6(files) {
    return files.filter((file)=>!file.progress?.uploadStarted || !file.isRestored);
}


function $8e92129945053521$export$2e2bcd8739ae039(fields, meta) {
    if (fields === true) return Object.keys(meta);
    if (Array.isArray(fields)) return fields;
    return [];
}


function $404d4d8ff4ce3ae1$var$isNetworkError(xhr) {
    if (!xhr) return false;
    return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}
var $404d4d8ff4ce3ae1$export$2e2bcd8739ae039 = $404d4d8ff4ce3ae1$var$isNetworkError;



function $6cb886e1a5aec334$var$createCancelError(cause) {
    return new Error('Cancelled', {
        cause: cause
    });
}
function $6cb886e1a5aec334$var$abortOn(signal) {
    if (signal != null) {
        const abortPromise = ()=>this.abort(signal.reason);
        signal.addEventListener('abort', abortPromise, {
            once: true
        });
        const removeAbortListener = ()=>{
            signal.removeEventListener('abort', abortPromise);
        };
        this.then?.(removeAbortListener, removeAbortListener);
    }
    return this;
}
class $6cb886e1a5aec334$export$32306e81289653bc {
    #activeRequests = 0;
    #queuedHandlers = [];
    #paused = false;
    #pauseTimer;
    #downLimit = 1;
    #upperLimit;
    #rateLimitingTimer;
    limit;
    constructor(limit){
        if (typeof limit !== 'number' || limit === 0) this.limit = Infinity;
        else this.limit = limit;
    }
    #call(fn) {
        this.#activeRequests += 1;
        let done = false;
        let cancelActive;
        try {
            cancelActive = fn();
        } catch (err) {
            this.#activeRequests -= 1;
            throw err;
        }
        return {
            abort: (cause)=>{
                if (done) return;
                done = true;
                this.#activeRequests -= 1;
                cancelActive?.(cause);
                this.#queueNext();
            },
            done: ()=>{
                if (done) return;
                done = true;
                this.#activeRequests -= 1;
                this.#queueNext();
            }
        };
    }
    #queueNext() {
        // Do it soon but not immediately, this allows clearing out the entire queue synchronously
        // one by one without continuously _advancing_ it (and starting new tasks before immediately
        // aborting them)
        queueMicrotask(()=>this.#next());
    }
    #next() {
        if (this.#paused || this.#activeRequests >= this.limit) return;
        if (this.#queuedHandlers.length === 0) return;
        // Dispatch the next request, and update the abort/done handlers
        // so that cancelling it does the Right Thing (and doesn't just try
        // to dequeue an already-running request).
        const next = this.#queuedHandlers.shift();
        if (next == null) throw new Error('Invariant violation: next is null');
        const handler = this.#call(next.fn);
        next.abort = handler.abort;
        next.done = handler.done;
    }
    #queue(fn, options) {
        const handler = {
            fn: fn,
            priority: options?.priority || 0,
            abort: ()=>{
                this.#dequeue(handler);
            },
            done: ()=>{
                throw new Error('Cannot mark a queued request as done: this indicates a bug');
            }
        };
        const index = this.#queuedHandlers.findIndex((other)=>{
            return handler.priority > other.priority;
        });
        if (index === -1) this.#queuedHandlers.push(handler);
        else this.#queuedHandlers.splice(index, 0, handler);
        return handler;
    }
    #dequeue(handler) {
        const index = this.#queuedHandlers.indexOf(handler);
        if (index !== -1) this.#queuedHandlers.splice(index, 1);
    }
    run(fn, queueOptions) {
        if (!this.#paused && this.#activeRequests < this.limit) return this.#call(fn);
        return this.#queue(fn, queueOptions);
    }
    wrapSyncFunction(fn, queueOptions) {
        return (...args)=>{
            const queuedRequest = this.run(()=>{
                fn(...args);
                queueMicrotask(()=>queuedRequest.done());
                return ()=>{};
            }, queueOptions);
            return {
                abortOn: $6cb886e1a5aec334$var$abortOn,
                abort () {
                    queuedRequest.abort();
                }
            };
        };
    }
    wrapPromiseFunction(fn, queueOptions) {
        return (...args)=>{
            let queuedRequest;
            const outerPromise = new Promise((resolve, reject)=>{
                queuedRequest = this.run(()=>{
                    let cancelError;
                    let innerPromise;
                    try {
                        innerPromise = Promise.resolve(fn(...args));
                    } catch (err) {
                        innerPromise = Promise.reject(err);
                    }
                    innerPromise.then((result)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            resolve(result);
                        }
                    }, (err)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            reject(err);
                        }
                    });
                    return (cause)=>{
                        cancelError = $6cb886e1a5aec334$var$createCancelError(cause);
                    };
                }, queueOptions);
            });
            outerPromise.abort = (cause)=>{
                queuedRequest.abort(cause);
            };
            outerPromise.abortOn = $6cb886e1a5aec334$var$abortOn;
            return outerPromise;
        };
    }
    resume() {
        this.#paused = false;
        clearTimeout(this.#pauseTimer);
        for(let i = 0; i < this.limit; i++)this.#queueNext();
    }
    #resume = ()=>this.resume();
    /**
     * Freezes the queue for a while or indefinitely.
     *
     * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
     *                                    If omitted, the queue won't resume automatically.
     */ pause(duration = null) {
        this.#paused = true;
        clearTimeout(this.#pauseTimer);
        if (duration != null) this.#pauseTimer = setTimeout(this.#resume, duration);
    }
    /**
     * Pauses the queue for a duration, and lower the limit of concurrent requests
     * when the queue resumes. When the queue resumes, it tries to progressively
     * increase the limit in `this.#increaseLimit` until another call is made to
     * `this.rateLimit`.
     * Call this function when using the RateLimitedQueue for network requests and
     * the remote server responds with 429 HTTP code.
     *
     * @param {number} duration in milliseconds.
     */ rateLimit(duration) {
        clearTimeout(this.#rateLimitingTimer);
        this.pause(duration);
        if (this.limit > 1 && Number.isFinite(this.limit)) {
            this.#upperLimit = this.limit - 1;
            this.limit = this.#downLimit;
            this.#rateLimitingTimer = setTimeout(this.#increaseLimit, duration);
        }
    }
    #increaseLimit = ()=>{
        if (this.#paused) {
            this.#rateLimitingTimer = setTimeout(this.#increaseLimit, 0);
            return;
        }
        this.#downLimit = this.limit;
        this.limit = Math.ceil((this.#upperLimit + this.#downLimit) / 2);
        for(let i = this.#downLimit; i <= this.limit; i++)this.#queueNext();
        if (this.#upperLimit - this.#downLimit > 3) this.#rateLimitingTimer = setTimeout(this.#increaseLimit, 2000);
        else this.#downLimit = Math.floor(this.#downLimit / 2);
    };
    get isPaused() {
        return this.#paused;
    }
}
const $6cb886e1a5aec334$export$603eb9c93e04437 = Symbol('__queue');


var $a2a151d65cc71d43$exports = {};
$a2a151d65cc71d43$exports = JSON.parse("{\"name\":\"@uppy/xhr-upload\",\"description\":\"Plain and simple classic HTML multipart form uploads with Uppy, as well as uploads using the HTTP PUT method.\",\"version\":\"4.4.2\",\"license\":\"MIT\",\"main\":\"lib/index.js\",\"type\":\"module\",\"scripts\":{\"build\":\"tsc --build tsconfig.build.json\",\"typecheck\":\"tsc --build\",\"test\":\"vitest run --environment=jsdom --silent='passed-only'\"},\"keywords\":[\"file uploader\",\"xhr\",\"xhr upload\",\"XMLHttpRequest\",\"ajax\",\"fetch\",\"uppy\",\"uppy-plugin\"],\"homepage\":\"https://uppy.io\",\"bugs\":{\"url\":\"https://github.com/transloadit/uppy/issues\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/transloadit/uppy.git\"},\"files\":[\"src\",\"lib\",\"dist\",\"CHANGELOG.md\"],\"dependencies\":{\"@uppy/companion-client\":\"^4.5.2\",\"@uppy/utils\":\"^6.2.2\"},\"devDependencies\":{\"@uppy/core\":\"^4.5.2\",\"jsdom\":\"^26.1.0\",\"nock\":\"^13.1.0\",\"typescript\":\"^5.8.3\",\"vitest\":\"^3.2.4\"},\"peerDependencies\":{\"@uppy/core\":\"^4.5.2\"}}");


var $3b2facc875d4722d$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the Informer if an upload is being canceled because it stalled for too long.
        uploadStalled: 'Upload has not made any progress for %{seconds} seconds. You may want to retry it.'
    }
};


function $cf91058fd9d7f8ee$var$buildResponseError(xhr, err) {
    let error = err;
    // No error message
    if (!error) error = new Error('Upload error');
    // Got an error message string
    if (typeof error === 'string') error = new Error(error);
    // Got something else
    if (!(error instanceof Error)) error = Object.assign(new Error('Upload error'), {
        data: error
    });
    if ((0, $404d4d8ff4ce3ae1$export$2e2bcd8739ae039)(xhr)) {
        error = new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(error, xhr);
        return error;
    }
    // @ts-expect-error request can only be set on NetworkError
    // but we use NetworkError to distinguish between errors.
    error.request = xhr;
    return error;
}
/**
 * Set `data.type` in the blob to `file.meta.type`,
 * because we might have detected a more accurate file type in Uppy
 * https://stackoverflow.com/a/50875615
 */ function $cf91058fd9d7f8ee$var$setTypeInBlob(file) {
    const dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
    return dataWithUpdatedType;
}
const $cf91058fd9d7f8ee$var$defaultOptions = {
    formData: true,
    fieldName: 'file',
    method: 'post',
    allowedMetaFields: true,
    bundle: false,
    headers: {},
    timeout: 30000,
    limit: 5,
    withCredentials: false,
    responseType: ''
};
class $cf91058fd9d7f8ee$export$2e2bcd8739ae039 extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    static VERSION = (0, (/*@__PURE__*/$parcel$interopDefault($a2a151d65cc71d43$exports))).version;
    #getFetcher;
    requests;
    uploaderEvents;
    constructor(uppy, opts){
        super(uppy, {
            ...$cf91058fd9d7f8ee$var$defaultOptions,
            fieldName: opts.bundle ? 'files[]' : 'file',
            ...opts
        });
        this.type = 'uploader';
        this.id = this.opts.id || 'XHRUpload';
        this.defaultLocale = (0, $3b2facc875d4722d$export$2e2bcd8739ae039);
        this.i18nInit();
        // Simultaneous upload limiting is shared across all uploads with this plugin.
        if ((0, $6cb886e1a5aec334$export$603eb9c93e04437) in this.opts) // @ts-ignore untyped internal
        this.requests = this.opts[0, $6cb886e1a5aec334$export$603eb9c93e04437];
        else this.requests = new (0, $6cb886e1a5aec334$export$32306e81289653bc)(this.opts.limit);
        if (this.opts.bundle && !this.opts.formData) throw new Error('`opts.formData` must be true when `opts.bundle` is enabled.');
        if (this.opts.bundle && typeof this.opts.headers === 'function') throw new Error('`opts.headers` can not be a function when the `bundle: true` option is set.');
        if (opts?.allowedMetaFields === undefined && 'metaFields' in this.opts) throw new Error('The `metaFields` option has been renamed to `allowedMetaFields`.');
        this.uploaderEvents = Object.create(null);
        /**
         * xhr-upload wrapper for `fetcher` to handle user options
         * `validateStatus`, `getResponseError`, `getResponseData`
         * and to emit `upload-progress`, `upload-error`, and `upload-success` events.
         */ this.#getFetcher = (files)=>{
            return async (url, options)=>{
                try {
                    const res = await (0, $e3981d1185f67d50$export$47fdd40111eda34c)(url, {
                        ...options,
                        onBeforeRequest: (xhr, retryCount)=>this.opts.onBeforeRequest?.(xhr, retryCount, files),
                        shouldRetry: this.opts.shouldRetry,
                        onAfterResponse: this.opts.onAfterResponse,
                        onTimeout: (timeout)=>{
                            const seconds = Math.ceil(timeout / 1000);
                            const error = new Error(this.i18n('uploadStalled', {
                                seconds: seconds
                            }));
                            this.uppy.emit('upload-stalled', error, files);
                        },
                        onUploadProgress: (event)=>{
                            if (event.lengthComputable) for (const { id: id } of files){
                                const file = this.uppy.getFile(id);
                                this.uppy.emit('upload-progress', file, {
                                    uploadStarted: file.progress.uploadStarted ?? 0,
                                    bytesUploaded: event.loaded / event.total * file.size,
                                    bytesTotal: file.size
                                });
                            }
                        }
                    });
                    let body = await this.opts.getResponseData?.(res);
                    if (res.responseType === 'json') body ??= res.response;
                    else try {
                        body ??= JSON.parse(res.responseText);
                    } catch (cause) {
                        throw new Error('@uppy/xhr-upload expects a JSON response (with a `url` property). To parse non-JSON responses, use `getResponseData` to turn your response into JSON.', {
                            cause: cause
                        });
                    }
                    const uploadURL = typeof body?.url === 'string' ? body.url : undefined;
                    for (const { id: id } of files)this.uppy.emit('upload-success', this.uppy.getFile(id), {
                        status: res.status,
                        body: body,
                        uploadURL: uploadURL
                    });
                    return res;
                } catch (error) {
                    if (error.name === 'AbortError') return undefined;
                    const request = error.request;
                    for (const file of files)this.uppy.emit('upload-error', this.uppy.getFile(file.id), $cf91058fd9d7f8ee$var$buildResponseError(request, error), request);
                    throw error;
                }
            };
        };
    }
    getOptions(file) {
        const overrides = this.uppy.getState().xhrUpload;
        const { headers: headers } = this.opts;
        const opts = {
            ...this.opts,
            ...overrides || {},
            ...file.xhrUpload || {},
            headers: {}
        };
        // Support for `headers` as a function, only in the XHRUpload settings.
        // Options set by other plugins in Uppy state or on the files themselves are still merged in afterward.
        //
        // ```js
        // headers: (file) => ({ expires: file.meta.expires })
        // ```
        if (typeof headers === 'function') opts.headers = headers(file);
        else Object.assign(opts.headers, this.opts.headers);
        if (overrides) Object.assign(opts.headers, overrides.headers);
        if (file.xhrUpload) Object.assign(opts.headers, file.xhrUpload.headers);
        return opts;
    }
    addMetadata(formData, meta, opts) {
        const allowedMetaFields = (0, $8e92129945053521$export$2e2bcd8739ae039)(opts.allowedMetaFields, meta);
        allowedMetaFields.forEach((item)=>{
            const value = meta[item];
            if (Array.isArray(value)) // In this case we don't transform `item` to add brackets, it's up to
            // the user to add the brackets so it won't be overridden.
            value.forEach((subItem)=>formData.append(item, subItem));
            else formData.append(item, value);
        });
    }
    createFormDataUpload(file, opts) {
        const formPost = new FormData();
        this.addMetadata(formPost, file.meta, opts);
        const dataWithUpdatedType = $cf91058fd9d7f8ee$var$setTypeInBlob(file);
        if (file.name) formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
        else formPost.append(opts.fieldName, dataWithUpdatedType);
        return formPost;
    }
    createBundledUpload(files, opts) {
        const formPost = new FormData();
        const { meta: meta } = this.uppy.getState();
        this.addMetadata(formPost, meta, opts);
        files.forEach((file)=>{
            const options = this.getOptions(file);
            const dataWithUpdatedType = $cf91058fd9d7f8ee$var$setTypeInBlob(file);
            if (file.name) formPost.append(options.fieldName, dataWithUpdatedType, file.name);
            else formPost.append(options.fieldName, dataWithUpdatedType);
        });
        return formPost;
    }
    async #uploadLocalFile(file) {
        const events = new (0, $c89f32c7d05a95a3$export$2e2bcd8739ae039)(this.uppy);
        const controller = new AbortController();
        const uppyFetch = this.requests.wrapPromiseFunction(async ()=>{
            const opts = this.getOptions(file);
            const fetch = this.#getFetcher([
                file
            ]);
            const body = opts.formData ? this.createFormDataUpload(file, opts) : file.data;
            const endpoint = typeof opts.endpoint === 'string' ? opts.endpoint : await opts.endpoint(file);
            return fetch(endpoint, {
                ...opts,
                body: body,
                signal: controller.signal
            });
        });
        events.onFileRemove(file.id, ()=>controller.abort());
        events.onCancelAll(file.id, ()=>{
            controller.abort();
        });
        try {
            await uppyFetch().abortOn(controller.signal);
        } catch (error) {
            // TODO: create formal error with name 'AbortError' (this comes from RateLimitedQueue)
            if (error.message !== 'Cancelled') throw error;
        } finally{
            events.remove();
        }
    }
    async #uploadBundle(files) {
        const controller = new AbortController();
        const uppyFetch = this.requests.wrapPromiseFunction(async ()=>{
            const optsFromState = this.uppy.getState().xhrUpload ?? {};
            const fetch = this.#getFetcher(files);
            const body = this.createBundledUpload(files, {
                ...this.opts,
                ...optsFromState
            });
            const endpoint = typeof this.opts.endpoint === 'string' ? this.opts.endpoint : await this.opts.endpoint(files);
            return fetch(endpoint, {
                // headers can't be a function with bundle: true
                ...this.opts,
                body: body,
                signal: controller.signal
            });
        });
        function abort() {
            controller.abort();
        }
        // We only need to abort on cancel all because
        // individual cancellations are not possible with bundle: true
        this.uppy.once('cancel-all', abort);
        try {
            await uppyFetch().abortOn(controller.signal);
        } catch (error) {
            // TODO: create formal error with name 'AbortError' (this comes from RateLimitedQueue)
            if (error.message !== 'Cancelled') throw error;
        } finally{
            this.uppy.off('cancel-all', abort);
        }
    }
    #getCompanionClientArgs(file) {
        const opts = this.getOptions(file);
        const allowedMetaFields = (0, $8e92129945053521$export$2e2bcd8739ae039)(opts.allowedMetaFields, file.meta);
        return {
            ...file.remote?.body,
            protocol: 'multipart',
            endpoint: opts.endpoint,
            size: file.data.size,
            fieldname: opts.fieldName,
            metadata: Object.fromEntries(allowedMetaFields.map((name)=>[
                    name,
                    file.meta[name]
                ])),
            httpMethod: opts.method,
            useFormData: opts.formData,
            headers: opts.headers
        };
    }
    async #uploadFiles(files) {
        await Promise.allSettled(files.map((file)=>{
            if (file.isRemote) {
                const getQueue = ()=>this.requests;
                const controller = new AbortController();
                const removedHandler = (removedFile)=>{
                    if (removedFile.id === file.id) controller.abort();
                };
                this.uppy.on('file-removed', removedHandler);
                const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, this.#getCompanionClientArgs(file), {
                    signal: controller.signal,
                    getQueue: getQueue
                });
                this.requests.wrapSyncFunction(()=>{
                    this.uppy.off('file-removed', removedHandler);
                }, {
                    priority: -1
                })();
                return uploadPromise;
            }
            return this.#uploadLocalFile(file);
        }));
    }
    #handleUpload = async (fileIDs)=>{
        if (fileIDs.length === 0) {
            this.uppy.log('[XHRUpload] No files to upload!');
            return;
        }
        // No limit configured by the user, and no RateLimitedQueue passed in by a "parent" plugin
        // (basically just AwsS3) using the internal symbol
        // @ts-ignore untyped internal
        if (this.opts.limit === 0 && !this.opts[0, $6cb886e1a5aec334$export$603eb9c93e04437]) this.uppy.log('[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0', 'warning');
        this.uppy.log('[XHRUpload] Uploading...');
        const files = this.uppy.getFilesByIds(fileIDs);
        const filesFiltered = (0, $169d20dd56f976c7$export$3bd9b1601aad11ac)(files);
        const filesToEmit = (0, $169d20dd56f976c7$export$9e8ffa0bfbcfeed6)(filesFiltered);
        this.uppy.emit('upload-start', filesToEmit);
        if (this.opts.bundle) {
            // if bundle: true, we don’t support remote uploads
            const isSomeFileRemote = filesFiltered.some((file)=>file.isRemote);
            if (isSomeFileRemote) throw new Error("Can\u2019t upload remote files when the `bundle: true` option is set");
            if (typeof this.opts.headers === 'function') throw new TypeError('`headers` may not be a function when the `bundle: true` option is set');
            await this.#uploadBundle(filesFiltered);
        } else await this.#uploadFiles(filesFiltered);
    };
    install() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: false
                }
            });
        }
        this.uppy.addUploader(this.#handleUpload);
    }
    uninstall() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: true
                }
            });
        }
        this.uppy.removeUploader(this.#handleUpload);
    }
}






var $e04f4766b186d0a1$exports = {};
/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */ (function(global, factory) {
    $e04f4766b186d0a1$exports = factory();
})($e04f4766b186d0a1$exports, function() {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    var canvasToBlob = {
        exports: {}
    };
    /*
   * JavaScript Canvas to Blob
   * https://github.com/blueimp/JavaScript-Canvas-to-Blob
   *
   * Copyright 2012, Sebastian Tschan
   * https://blueimp.net
   *
   * Licensed under the MIT license:
   * https://opensource.org/licenses/MIT
   *
   * Based on stackoverflow user Stoive's code snippet:
   * http://stackoverflow.com/q/4998908
   */ (function(module1) {
        if (typeof window === 'undefined') return;
        (function(window1) {
            var CanvasPrototype = window1.HTMLCanvasElement && window1.HTMLCanvasElement.prototype;
            var hasBlobConstructor = window1.Blob && function() {
                try {
                    return Boolean(new Blob());
                } catch (e) {
                    return false;
                }
            }();
            var hasArrayBufferViewSupport = hasBlobConstructor && window1.Uint8Array && function() {
                try {
                    return new Blob([
                        new Uint8Array(100)
                    ]).size === 100;
                } catch (e) {
                    return false;
                }
            }();
            var BlobBuilder = window1.BlobBuilder || window1.WebKitBlobBuilder || window1.MozBlobBuilder || window1.MSBlobBuilder;
            var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;
            var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window1.atob && window1.ArrayBuffer && window1.Uint8Array && function(dataURI) {
                var matches, mediaType, isBase64, dataString, byteString, arrayBuffer, intArray, i, bb;
                // Parse the dataURI components as per RFC 2397
                matches = dataURI.match(dataURIPattern);
                if (!matches) throw new Error('invalid data URI');
                // Default to text/plain;charset=US-ASCII
                mediaType = matches[2] ? matches[1] : 'text/plain' + (matches[3] || ';charset=US-ASCII');
                isBase64 = !!matches[4];
                dataString = dataURI.slice(matches[0].length);
                if (isBase64) // Convert base64 to raw binary data held in a string:
                byteString = atob(dataString);
                else // Convert base64/URLEncoded data component to raw binary:
                byteString = decodeURIComponent(dataString);
                // Write the bytes of the string to an ArrayBuffer:
                arrayBuffer = new ArrayBuffer(byteString.length);
                intArray = new Uint8Array(arrayBuffer);
                for(i = 0; i < byteString.length; i += 1)intArray[i] = byteString.charCodeAt(i);
                // Write the ArrayBuffer (or ArrayBufferView) to a blob:
                if (hasBlobConstructor) return new Blob([
                    hasArrayBufferViewSupport ? intArray : arrayBuffer
                ], {
                    type: mediaType
                });
                bb = new BlobBuilder();
                bb.append(arrayBuffer);
                return bb.getBlob(mediaType);
            };
            if (window1.HTMLCanvasElement && !CanvasPrototype.toBlob) {
                if (CanvasPrototype.mozGetAsFile) CanvasPrototype.toBlob = function(callback, type, quality) {
                    var self = this;
                    setTimeout(function() {
                        if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) callback(dataURLtoBlob(self.toDataURL(type, quality)));
                        else callback(self.mozGetAsFile('blob', type));
                    });
                };
                else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
                    if (CanvasPrototype.msToBlob) CanvasPrototype.toBlob = function(callback, type, quality) {
                        var self = this;
                        setTimeout(function() {
                            if ((type && type !== 'image/png' || quality) && CanvasPrototype.toDataURL && dataURLtoBlob) callback(dataURLtoBlob(self.toDataURL(type, quality)));
                            else callback(self.msToBlob(type));
                        });
                    };
                    else CanvasPrototype.toBlob = function(callback, type, quality) {
                        var self = this;
                        setTimeout(function() {
                            callback(dataURLtoBlob(self.toDataURL(type, quality)));
                        });
                    };
                }
            }
            if (module1.exports) module1.exports = dataURLtoBlob;
            else window1.dataURLtoBlob = dataURLtoBlob;
        })(window);
    })(canvasToBlob);
    var toBlob = canvasToBlob.exports;
    var isBlob = function isBlob(value) {
        if (typeof Blob === 'undefined') return false;
        return value instanceof Blob || Object.prototype.toString.call(value) === '[object Blob]';
    };
    var DEFAULTS = {
        /**
     * Indicates if output the original image instead of the compressed one
     * when the size of the compressed image is greater than the original one's
     * @type {boolean}
     */ strict: true,
        /**
     * Indicates if read the image's Exif Orientation information,
     * and then rotate or flip the image automatically.
     * @type {boolean}
     */ checkOrientation: true,
        /**
     * Indicates if retain the image's Exif information after compressed.
     * @type {boolean}
    */ retainExif: false,
        /**
     * The max width of the output image.
     * @type {number}
     */ maxWidth: Infinity,
        /**
     * The max height of the output image.
     * @type {number}
     */ maxHeight: Infinity,
        /**
     * The min width of the output image.
     * @type {number}
     */ minWidth: 0,
        /**
     * The min height of the output image.
     * @type {number}
     */ minHeight: 0,
        /**
     * The width of the output image.
     * If not specified, the natural width of the source image will be used.
     * @type {number}
     */ width: undefined,
        /**
     * The height of the output image.
     * If not specified, the natural height of the source image will be used.
     * @type {number}
     */ height: undefined,
        /**
     * Sets how the size of the image should be resized to the container
     * specified by the `width` and `height` options.
     * @type {string}
     */ resize: 'none',
        /**
     * The quality of the output image.
     * It must be a number between `0` and `1`,
     * and only available for `image/jpeg` and `image/webp` images.
     * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
     * @type {number}
     */ quality: 0.8,
        /**
     * The mime type of the output image.
     * By default, the original mime type of the source image file will be used.
     * @type {string}
     */ mimeType: 'auto',
        /**
     * Files whose file type is included in this list,
     * and whose file size exceeds the `convertSize` value will be converted to JPEGs.
     * @type {string｜Array}
     */ convertTypes: [
            'image/png'
        ],
        /**
     * PNG files over this size (5 MB by default) will be converted to JPEGs.
     * To disable this, just set the value to `Infinity`.
     * @type {number}
     */ convertSize: 5000000,
        /**
     * The hook function to execute before draw the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.fillStyle = '#fff';
     * }
     */ beforeDraw: null,
        /**
     * The hook function to execute after drew the image into the canvas for compression.
     * @type {Function}
     * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
     * @param {HTMLCanvasElement} canvas - The canvas for compression.
     * @example
     * function (context, canvas) {
     *   context.filter = 'grayscale(100%)';
     * }
     */ drew: null,
        /**
     * The hook function to execute when success to compress the image.
     * @type {Function}
     * @param {File} file - The compressed image File object.
     * @example
     * function (file) {
     *   console.log(file);
     * }
     */ success: null,
        /**
     * The hook function to execute when fail to compress the image.
     * @type {Function}
     * @param {Error} err - An Error object.
     * @example
     * function (err) {
     *   console.log(err.message);
     * }
     */ error: null
    };
    var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var WINDOW = IS_BROWSER ? window : {};
    /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */ var isPositiveNumber = function isPositiveNumber(value) {
        return value > 0 && value < Infinity;
    };
    var slice = Array.prototype.slice;
    /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */ function toArray(value) {
        return Array.from ? Array.from(value) : slice.call(value);
    }
    var REGEXP_IMAGE_TYPE = /^image\/.+$/;
    /**
   * Check if the given value is a mime type of image.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given is a mime type of image, else `false`.
   */ function isImageType(value) {
        return REGEXP_IMAGE_TYPE.test(value);
    }
    /**
   * Convert image type to extension.
   * @param {string} value - The image type to convert.
   * @returns {boolean} Returns the image extension.
   */ function imageTypeToExtension(value) {
        var extension = isImageType(value) ? value.substr(6) : '';
        if (extension === 'jpeg') extension = 'jpg';
        return ".".concat(extension);
    }
    var fromCharCode = String.fromCharCode;
    /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */ function getStringFromCharCode(dataView, start, length) {
        var str = '';
        var i;
        length += start;
        for(i = start; i < length; i += 1)str += fromCharCode(dataView.getUint8(i));
        return str;
    }
    var btoa = WINDOW.btoa;
    /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */ function arrayBufferToDataURL(arrayBuffer, mimeType) {
        var chunks = [];
        var chunkSize = 8192;
        var uint8 = new Uint8Array(arrayBuffer);
        while(uint8.length > 0){
            // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
            // eslint-disable-next-line prefer-spread
            chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
            uint8 = uint8.subarray(chunkSize);
        }
        return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
    }
    /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */ function resetAndGetOrientation(arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        var orientation;
        // Ignores range error when the image does not have correct Exif information
        try {
            var littleEndian;
            var app1Start;
            var ifdStart;
            // Only handle JPEG image (start by 0xFFD8)
            if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
                var length = dataView.byteLength;
                var offset = 2;
                while(offset + 1 < length){
                    if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
                        app1Start = offset;
                        break;
                    }
                    offset += 1;
                }
            }
            if (app1Start) {
                var exifIDCode = app1Start + 4;
                var tiffOffset = app1Start + 10;
                if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
                    var endianness = dataView.getUint16(tiffOffset);
                    littleEndian = endianness === 0x4949;
                    if (littleEndian || endianness === 0x4D4D /* bigEndian */ ) {
                        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
                            if (firstIFDOffset >= 0x00000008) ifdStart = tiffOffset + firstIFDOffset;
                        }
                    }
                }
            }
            if (ifdStart) {
                var _length = dataView.getUint16(ifdStart, littleEndian);
                var _offset;
                var i;
                for(i = 0; i < _length; i += 1){
                    _offset = ifdStart + i * 12 + 2;
                    if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */ ) {
                        // 8 is the offset of the current tag's value
                        _offset += 8;
                        // Get the original orientation value
                        orientation = dataView.getUint16(_offset, littleEndian);
                        // Override the orientation with its default value
                        dataView.setUint16(_offset, 1, littleEndian);
                        break;
                    }
                }
            }
        } catch (e) {
            orientation = 1;
        }
        return orientation;
    }
    /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */ function parseOrientation(orientation) {
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;
        switch(orientation){
            // Flip horizontal
            case 2:
                scaleX = -1;
                break;
            // Rotate left 180°
            case 3:
                rotate = -180;
                break;
            // Flip vertical
            case 4:
                scaleY = -1;
                break;
            // Flip vertical and rotate right 90°
            case 5:
                rotate = 90;
                scaleY = -1;
                break;
            // Rotate right 90°
            case 6:
                rotate = 90;
                break;
            // Flip horizontal and rotate right 90°
            case 7:
                rotate = 90;
                scaleX = -1;
                break;
            // Rotate left 90°
            case 8:
                rotate = -90;
                break;
        }
        return {
            rotate: rotate,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
    /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */ function normalizeDecimalNumber(value) {
        var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
        return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
    }
    /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */ function getAdjustedSizes(_ref) {
        var aspectRatio = _ref.aspectRatio, height = _ref.height, width = _ref.width;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
        var isValidWidth = isPositiveNumber(width);
        var isValidHeight = isPositiveNumber(height);
        if (isValidWidth && isValidHeight) {
            var adjustedWidth = height * aspectRatio;
            if ((type === 'contain' || type === 'none') && adjustedWidth > width || type === 'cover' && adjustedWidth < width) height = width / aspectRatio;
            else width = height * aspectRatio;
        } else if (isValidWidth) height = width / aspectRatio;
        else if (isValidHeight) width = height * aspectRatio;
        return {
            width: width,
            height: height
        };
    }
    /**
   * Get Exif information from the given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {Array} The read Exif information.
   */ function getExif(arrayBuffer) {
        var array = toArray(new Uint8Array(arrayBuffer));
        var length = array.length;
        var segments = [];
        var start = 0;
        while(start + 3 < length){
            var value = array[start];
            var next = array[start + 1];
            // SOS (Start of Scan)
            if (value === 0xFF && next === 0xDA) break;
            // SOI (Start of Image)
            if (value === 0xFF && next === 0xD8) start += 2;
            else {
                var offset = array[start + 2] * 256 + array[start + 3];
                var end = start + offset + 2;
                var segment = array.slice(start, end);
                segments.push(segment);
                start = end;
            }
        }
        return segments.reduce(function(exifArray, current) {
            if (current[0] === 0xFF && current[1] === 0xE1) return exifArray.concat(current);
            return exifArray;
        }, []);
    }
    /**
   * Insert Exif information into the given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {Array} exifArray - The Exif information to insert.
   * @returns {ArrayBuffer} The transformed array buffer.
   */ function insertExif(arrayBuffer, exifArray) {
        var array = toArray(new Uint8Array(arrayBuffer));
        if (array[2] !== 0xFF || array[3] !== 0xE0) return arrayBuffer;
        var app0Length = array[4] * 256 + array[5];
        var newArrayBuffer = [
            0xFF,
            0xD8
        ].concat(exifArray, array.slice(4 + app0Length));
        return new Uint8Array(newArrayBuffer);
    }
    var ArrayBuffer$1 = WINDOW.ArrayBuffer, FileReader = WINDOW.FileReader;
    var URL = WINDOW.URL || WINDOW.webkitURL;
    var REGEXP_EXTENSION = /\.\w+$/;
    var AnotherCompressor = WINDOW.Compressor;
    /**
   * Creates a new image compressor.
   * @class
   */ var Compressor = /*#__PURE__*/ function() {
        /**
     * The constructor of Compressor.
     * @param {File|Blob} file - The target image file for compressing.
     * @param {Object} [options] - The options for compressing.
     */ function Compressor(file, options) {
            _classCallCheck(this, Compressor);
            this.file = file;
            this.exif = [];
            this.image = new Image();
            this.options = _objectSpread2(_objectSpread2({}, DEFAULTS), options);
            this.aborted = false;
            this.result = null;
            this.init();
        }
        _createClass(Compressor, [
            {
                key: "init",
                value: function init() {
                    var _this = this;
                    var file = this.file, options = this.options;
                    if (!isBlob(file)) {
                        this.fail(new Error('The first argument must be a File or Blob object.'));
                        return;
                    }
                    var mimeType = file.type;
                    if (!isImageType(mimeType)) {
                        this.fail(new Error('The first argument must be an image File or Blob object.'));
                        return;
                    }
                    if (!URL || !FileReader) {
                        this.fail(new Error('The current browser does not support image compression.'));
                        return;
                    }
                    if (!ArrayBuffer$1) {
                        options.checkOrientation = false;
                        options.retainExif = false;
                    }
                    var isJPEGImage = mimeType === 'image/jpeg';
                    var checkOrientation = isJPEGImage && options.checkOrientation;
                    var retainExif = isJPEGImage && options.retainExif;
                    if (URL && !checkOrientation && !retainExif) this.load({
                        url: URL.createObjectURL(file)
                    });
                    else {
                        var reader = new FileReader();
                        this.reader = reader;
                        reader.onload = function(_ref) {
                            var target = _ref.target;
                            var result = target.result;
                            var data = {};
                            var orientation = 1;
                            if (checkOrientation) {
                                // Reset the orientation value to its default value 1
                                // as some iOS browsers will render image with its orientation
                                orientation = resetAndGetOrientation(result);
                                if (orientation > 1) _extends(data, parseOrientation(orientation));
                            }
                            if (retainExif) _this.exif = getExif(result);
                            if (checkOrientation || retainExif) {
                                if (!URL || orientation > 1) data.url = arrayBufferToDataURL(result, mimeType);
                                else data.url = URL.createObjectURL(file);
                            } else data.url = result;
                            _this.load(data);
                        };
                        reader.onabort = function() {
                            _this.fail(new Error('Aborted to read the image with FileReader.'));
                        };
                        reader.onerror = function() {
                            _this.fail(new Error('Failed to read the image with FileReader.'));
                        };
                        reader.onloadend = function() {
                            _this.reader = null;
                        };
                        if (checkOrientation || retainExif) reader.readAsArrayBuffer(file);
                        else reader.readAsDataURL(file);
                    }
                }
            },
            {
                key: "load",
                value: function load(data) {
                    var _this2 = this;
                    var file = this.file, image = this.image;
                    image.onload = function() {
                        _this2.draw(_objectSpread2(_objectSpread2({}, data), {}, {
                            naturalWidth: image.naturalWidth,
                            naturalHeight: image.naturalHeight
                        }));
                    };
                    image.onabort = function() {
                        _this2.fail(new Error('Aborted to load the image.'));
                    };
                    image.onerror = function() {
                        _this2.fail(new Error('Failed to load the image.'));
                    };
                    // Match all browsers that use WebKit as the layout engine in iOS devices,
                    // such as Safari for iOS, Chrome for iOS, and in-app browsers.
                    if (WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent)) // Fix the `The operation is insecure` error (#57)
                    image.crossOrigin = 'anonymous';
                    image.alt = file.name;
                    image.src = data.url;
                }
            },
            {
                key: "draw",
                value: function draw(_ref2) {
                    var _this3 = this;
                    var naturalWidth = _ref2.naturalWidth, naturalHeight = _ref2.naturalHeight, _ref2$rotate = _ref2.rotate, rotate = _ref2$rotate === void 0 ? 0 : _ref2$rotate, _ref2$scaleX = _ref2.scaleX, scaleX = _ref2$scaleX === void 0 ? 1 : _ref2$scaleX, _ref2$scaleY = _ref2.scaleY, scaleY = _ref2$scaleY === void 0 ? 1 : _ref2$scaleY;
                    var file = this.file, image = this.image, options = this.options;
                    var canvas = document.createElement('canvas');
                    var context = canvas.getContext('2d');
                    var is90DegreesRotated = Math.abs(rotate) % 180 === 90;
                    var resizable = (options.resize === 'contain' || options.resize === 'cover') && isPositiveNumber(options.width) && isPositiveNumber(options.height);
                    var maxWidth = Math.max(options.maxWidth, 0) || Infinity;
                    var maxHeight = Math.max(options.maxHeight, 0) || Infinity;
                    var minWidth = Math.max(options.minWidth, 0) || 0;
                    var minHeight = Math.max(options.minHeight, 0) || 0;
                    var aspectRatio = naturalWidth / naturalHeight;
                    var width = options.width, height = options.height;
                    if (is90DegreesRotated) {
                        var _ref3 = [
                            maxHeight,
                            maxWidth
                        ];
                        maxWidth = _ref3[0];
                        maxHeight = _ref3[1];
                        var _ref4 = [
                            minHeight,
                            minWidth
                        ];
                        minWidth = _ref4[0];
                        minHeight = _ref4[1];
                        var _ref5 = [
                            height,
                            width
                        ];
                        width = _ref5[0];
                        height = _ref5[1];
                    }
                    if (resizable) aspectRatio = width / height;
                    var _getAdjustedSizes = getAdjustedSizes({
                        aspectRatio: aspectRatio,
                        width: maxWidth,
                        height: maxHeight
                    }, 'contain');
                    maxWidth = _getAdjustedSizes.width;
                    maxHeight = _getAdjustedSizes.height;
                    var _getAdjustedSizes2 = getAdjustedSizes({
                        aspectRatio: aspectRatio,
                        width: minWidth,
                        height: minHeight
                    }, 'cover');
                    minWidth = _getAdjustedSizes2.width;
                    minHeight = _getAdjustedSizes2.height;
                    if (resizable) {
                        var _getAdjustedSizes3 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: width,
                            height: height
                        }, options.resize);
                        width = _getAdjustedSizes3.width;
                        height = _getAdjustedSizes3.height;
                    } else {
                        var _getAdjustedSizes4 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: width,
                            height: height
                        });
                        var _getAdjustedSizes4$wi = _getAdjustedSizes4.width;
                        width = _getAdjustedSizes4$wi === void 0 ? naturalWidth : _getAdjustedSizes4$wi;
                        var _getAdjustedSizes4$he = _getAdjustedSizes4.height;
                        height = _getAdjustedSizes4$he === void 0 ? naturalHeight : _getAdjustedSizes4$he;
                    }
                    width = Math.floor(normalizeDecimalNumber(Math.min(Math.max(width, minWidth), maxWidth)));
                    height = Math.floor(normalizeDecimalNumber(Math.min(Math.max(height, minHeight), maxHeight)));
                    var destX = -width / 2;
                    var destY = -height / 2;
                    var destWidth = width;
                    var destHeight = height;
                    var params = [];
                    if (resizable) {
                        var srcX = 0;
                        var srcY = 0;
                        var srcWidth = naturalWidth;
                        var srcHeight = naturalHeight;
                        var _getAdjustedSizes5 = getAdjustedSizes({
                            aspectRatio: aspectRatio,
                            width: naturalWidth,
                            height: naturalHeight
                        }, {
                            contain: 'cover',
                            cover: 'contain'
                        }[options.resize]);
                        srcWidth = _getAdjustedSizes5.width;
                        srcHeight = _getAdjustedSizes5.height;
                        srcX = (naturalWidth - srcWidth) / 2;
                        srcY = (naturalHeight - srcHeight) / 2;
                        params.push(srcX, srcY, srcWidth, srcHeight);
                    }
                    params.push(destX, destY, destWidth, destHeight);
                    if (is90DegreesRotated) {
                        var _ref6 = [
                            height,
                            width
                        ];
                        width = _ref6[0];
                        height = _ref6[1];
                    }
                    canvas.width = width;
                    canvas.height = height;
                    if (!isImageType(options.mimeType)) options.mimeType = file.type;
                    var fillStyle = 'transparent';
                    // Converts PNG files over the `convertSize` to JPEGs.
                    if (file.size > options.convertSize && options.convertTypes.indexOf(options.mimeType) >= 0) options.mimeType = 'image/jpeg';
                    var isJPEGImage = options.mimeType === 'image/jpeg';
                    if (isJPEGImage) fillStyle = '#fff';
                    // Override the default fill color (#000, black)
                    context.fillStyle = fillStyle;
                    context.fillRect(0, 0, width, height);
                    if (options.beforeDraw) options.beforeDraw.call(this, context, canvas);
                    if (this.aborted) return;
                    context.save();
                    context.translate(width / 2, height / 2);
                    context.rotate(rotate * Math.PI / 180);
                    context.scale(scaleX, scaleY);
                    context.drawImage.apply(context, [
                        image
                    ].concat(params));
                    context.restore();
                    if (options.drew) options.drew.call(this, context, canvas);
                    if (this.aborted) return;
                    var callback = function callback(blob) {
                        if (!_this3.aborted) {
                            var done = function done(result) {
                                return _this3.done({
                                    naturalWidth: naturalWidth,
                                    naturalHeight: naturalHeight,
                                    result: result
                                });
                            };
                            if (blob && isJPEGImage && options.retainExif && _this3.exif && _this3.exif.length > 0) {
                                var next = function next(arrayBuffer) {
                                    return done(toBlob(arrayBufferToDataURL(insertExif(arrayBuffer, _this3.exif), options.mimeType)));
                                };
                                if (blob.arrayBuffer) blob.arrayBuffer().then(next).catch(function() {
                                    _this3.fail(new Error('Failed to read the compressed image with Blob.arrayBuffer().'));
                                });
                                else {
                                    var reader = new FileReader();
                                    _this3.reader = reader;
                                    reader.onload = function(_ref7) {
                                        var target = _ref7.target;
                                        next(target.result);
                                    };
                                    reader.onabort = function() {
                                        _this3.fail(new Error('Aborted to read the compressed image with FileReader.'));
                                    };
                                    reader.onerror = function() {
                                        _this3.fail(new Error('Failed to read the compressed image with FileReader.'));
                                    };
                                    reader.onloadend = function() {
                                        _this3.reader = null;
                                    };
                                    reader.readAsArrayBuffer(blob);
                                }
                            } else done(blob);
                        }
                    };
                    if (canvas.toBlob) canvas.toBlob(callback, options.mimeType, options.quality);
                    else callback(toBlob(canvas.toDataURL(options.mimeType, options.quality)));
                }
            },
            {
                key: "done",
                value: function done(_ref8) {
                    var naturalWidth = _ref8.naturalWidth, naturalHeight = _ref8.naturalHeight, result = _ref8.result;
                    var file = this.file, image = this.image, options = this.options;
                    if (URL && image.src.indexOf('blob:') === 0) URL.revokeObjectURL(image.src);
                    if (result) {
                        // Returns original file if the result is greater than it and without size related options
                        if (options.strict && !options.retainExif && result.size > file.size && options.mimeType === file.type && !(options.width > naturalWidth || options.height > naturalHeight || options.minWidth > naturalWidth || options.minHeight > naturalHeight || options.maxWidth < naturalWidth || options.maxHeight < naturalHeight)) result = file;
                        else {
                            var date = new Date();
                            result.lastModified = date.getTime();
                            result.lastModifiedDate = date;
                            result.name = file.name;
                            // Convert the extension to match its type
                            if (result.name && result.type !== file.type) result.name = result.name.replace(REGEXP_EXTENSION, imageTypeToExtension(result.type));
                        }
                    } else // Returns original file if the result is null in some cases.
                    result = file;
                    this.result = result;
                    if (options.success) options.success.call(this, result);
                }
            },
            {
                key: "fail",
                value: function fail(err) {
                    var options = this.options;
                    if (options.error) options.error.call(this, err);
                    else throw err;
                }
            },
            {
                key: "abort",
                value: function abort() {
                    if (!this.aborted) {
                        this.aborted = true;
                        if (this.reader) this.reader.abort();
                        else if (!this.image.complete) {
                            this.image.onload = null;
                            this.image.onabort();
                        } else this.fail(new Error('The compression process has been aborted.'));
                    }
                }
            }
        ], [
            {
                key: "noConflict",
                value: function noConflict() {
                    window.Compressor = AnotherCompressor;
                    return Compressor;
                }
            },
            {
                key: "setDefaults",
                value: function setDefaults(options) {
                    _extends(DEFAULTS, options);
                }
            }
        ]);
        return Compressor;
    }();
    return Compressor;
});


var $de0418694bba9f03$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the Status Bar
        compressingImages: 'Compressing images...',
        compressedX: 'Saved %{size} by compressing images'
    }
};


const $d847a4c5a8f23ad9$var$defaultOptions = {
    quality: 0.6,
    limit: 10
};
class $d847a4c5a8f23ad9$export$2e2bcd8739ae039 extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    #RateLimitedQueue;
    constructor(uppy, opts){
        super(uppy, {
            ...$d847a4c5a8f23ad9$var$defaultOptions,
            ...opts
        });
        this.id = this.opts.id || 'Compressor';
        this.type = 'modifier';
        this.defaultLocale = (0, $de0418694bba9f03$export$2e2bcd8739ae039);
        this.#RateLimitedQueue = new (0, $6cb886e1a5aec334$export$32306e81289653bc)(this.opts.limit);
        this.i18nInit();
        this.prepareUpload = this.prepareUpload.bind(this);
        this.compress = this.compress.bind(this);
    }
    compress(blob) {
        return new Promise((resolve, reject)=>{
            new (0, (/*@__PURE__*/$parcel$interopDefault($e04f4766b186d0a1$exports)))(blob, {
                ...this.opts,
                success: resolve,
                error: reject
            });
        });
    }
    async prepareUpload(fileIDs) {
        let totalCompressedSize = 0;
        const compressedFiles = [];
        const compressAndApplyResult = this.#RateLimitedQueue.wrapPromiseFunction(async (file)=>{
            try {
                const compressedBlob = await this.compress(file.data);
                const compressedSavingsSize = file.data.size - compressedBlob.size;
                this.uppy.log(`[Image Compressor] Image ${file.id} compressed by ${(0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(compressedSavingsSize)}`);
                totalCompressedSize += compressedSavingsSize;
                const { name: name, type: type, size: size } = compressedBlob;
                const compressedFileName = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(name);
                const metaFileName = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.meta.name);
                // Name (file.meta.name) might have been changed by user, so we update only the extension
                const newMetaName = `${metaFileName.name}.${compressedFileName.extension}`;
                this.uppy.setFileState(file.id, {
                    ...name && {
                        name: name
                    },
                    ...compressedFileName.extension && {
                        extension: compressedFileName.extension
                    },
                    ...type && {
                        type: type
                    },
                    ...size && {
                        size: size
                    },
                    data: compressedBlob,
                    meta: {
                        ...file.meta,
                        type: type,
                        name: newMetaName
                    }
                });
                compressedFiles.push(file);
            } catch (err) {
                this.uppy.log(`[Image Compressor] Failed to compress ${file.id}:`, 'warning');
                this.uppy.log(err, 'warning');
            }
        });
        const promises = fileIDs.map((fileID)=>{
            const file = this.uppy.getFile(fileID);
            this.uppy.emit('preprocess-progress', file, {
                mode: 'indeterminate',
                message: this.i18n('compressingImages')
            });
            if (file.isRemote) return Promise.resolve();
            // Some browsers (Firefox) add blobs with empty file type, when files are
            // added from a folder. Uppy auto-detects type from extension, but leaves the original blob intact.
            // However, Compressor.js failes when file has no type, so we set it here
            if (!file.data.type) file.data = file.data.slice(0, file.data.size, file.type);
            if (!file.type?.startsWith('image/')) return Promise.resolve();
            return compressAndApplyResult(file);
        });
        // Why emit `preprocess-complete` for all files at once, instead of
        // above when each is processed?
        // Because it leads to StatusBar showing a weird “upload 6 files” button,
        // while waiting for all the files to complete pre-processing.
        await Promise.all(promises);
        this.uppy.emit('compressor:complete', compressedFiles);
        // Only show informer if Compressor mananged to save at least a kilobyte
        if (totalCompressedSize > 1024) this.uppy.info(this.i18n('compressedX', {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalCompressedSize)
        }), 'info');
        for (const fileID of fileIDs){
            const file = this.uppy.getFile(fileID);
            this.uppy.emit('preprocess-complete', file);
        }
    }
    install() {
        this.uppy.addPreProcessor(this.prepareUpload);
    }
    uninstall() {
        this.uppy.removePreProcessor(this.prepareUpload);
    }
}



const $cb482a25fa64fd81$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $cb482a25fa64fd81$export$2e2bcd8739ae039 = {
    randomUUID: $cb482a25fa64fd81$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $a4faffbfed8ce8b6$var$getRandomValues;
const $a4faffbfed8ce8b6$var$rnds8 = new Uint8Array(16);
function $a4faffbfed8ce8b6$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$a4faffbfed8ce8b6$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $a4faffbfed8ce8b6$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$a4faffbfed8ce8b6$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $a4faffbfed8ce8b6$var$getRandomValues($a4faffbfed8ce8b6$var$rnds8);
}


var $f53d8abb4c91ec67$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $8e32bacb71dd477f$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $f53d8abb4c91ec67$export$2e2bcd8739ae039).test(uuid);
}
var $8e32bacb71dd477f$export$2e2bcd8739ae039 = $8e32bacb71dd477f$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $489cbfc69d38cb8e$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$489cbfc69d38cb8e$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $489cbfc69d38cb8e$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $489cbfc69d38cb8e$var$byteToHex[arr[offset + 0]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 1]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 2]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 3]] + '-' + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 4]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 5]] + '-' + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 6]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 7]] + '-' + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 8]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 9]] + '-' + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 10]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 11]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 12]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 13]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 14]] + $489cbfc69d38cb8e$var$byteToHex[arr[offset + 15]];
}
function $489cbfc69d38cb8e$var$stringify(arr, offset = 0) {
    const uuid = $489cbfc69d38cb8e$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $8e32bacb71dd477f$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $489cbfc69d38cb8e$export$2e2bcd8739ae039 = $489cbfc69d38cb8e$var$stringify;


function $d0666643e2ee88b4$var$v4(options, buf, offset) {
    if ((0, $cb482a25fa64fd81$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $cb482a25fa64fd81$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $a4faffbfed8ce8b6$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $489cbfc69d38cb8e$export$8fb373d660548968)(rnds);
}
var $d0666643e2ee88b4$export$2e2bcd8739ae039 = $d0666643e2ee88b4$var$v4;


const $4dcbb1f6ebd585d1$var$de_DE = {
    strings: {},
    pluralize (count) {
        if (count === 1) return 0;
        return 1;
    }
};
$4dcbb1f6ebd585d1$var$de_DE.strings = {
    addBulkFilesFailed: {
        '0': "Das Hinzuf\xfcgen einer Datei ist aufgrund eines internen Fehlers fehlgeschlagen",
        '1': "Das Hinzuf\xfcgen von %{smart_count} Dateien ist aufgrund eines internen Fehlers fehlgeschlagen"
    },
    addingMoreFiles: "Dateien hinzuf\xfcgen",
    addMore: "Mehr hinzuf\xfcgen",
    addMoreFiles: "Dateien hinzuf\xfcgen",
    allFilesFromFolderNamed: 'Alle Dateien vom Ordner %{name}',
    allowAccessDescription: 'Um Bilder oder Videos mit Ihrer Kamera aufzunehmen, erlauben Sie dieser Website bitte den Zugriff auf Ihre Kamera.',
    allowAccessTitle: 'Bitte erlauben Sie Zugriff auf Ihre Kamera',
    aspectRatioLandscape: 'Zuschneiden auf Querformat (16:9)',
    aspectRatioPortrait: 'Zuschneiden auf Hochformat (9:16)',
    aspectRatioSquare: 'Zuschneiden auf Quadrat',
    authenticateWith: 'Mit %{pluginName} verbinden',
    authenticateWithTitle: "Bitte authentifizieren Sie sich mit %{pluginName}, um Dateien auszuw\xe4hlen",
    back: "Zur\xfcck",
    backToSearch: "Zur\xfcck zur Suche",
    browse: 'durchsuchen',
    browseFiles: 'Dateien durchsuchen',
    browseFolders: 'Ordner durchsuchen',
    cancel: 'Abbrechen',
    cancelUpload: 'Hochladen abbrechen',
    chooseFiles: "Dateien ausw\xe4hlen",
    closeModal: "Fenster schlie\xdfen",
    companionError: 'Verbindung zu Companion fehlgeschlagen',
    companionUnauthorizeHint: "Um die Autorisierung f\xfcr Ihr %{provider} Konto aufzuheben, gehen Sie bitte zu %{url}",
    complete: 'Fertig',
    connectedToInternet: 'Mit dem Internet verbunden',
    copyLink: 'Link kopieren',
    copyLinkToClipboardFallback: 'Untenstehende URL kopieren',
    copyLinkToClipboardSuccess: 'Link in die Zwischenablage kopiert',
    creatingAssembly: 'Das Hochladen wird vorbereiten...',
    creatingAssemblyFailed: 'Transloadit: Assembly konnte nicht erstellt werden',
    dashboardTitle: 'Hochladen von Dateien',
    dashboardWindowTitle: "Hochladen von Dateien (ESC dr\xfccken zum Schlie\xdfen)",
    dataUploadedOfTotal: '%{complete} von %{total}',
    discardRecordedFile: 'Aufgenommene Datei verwerfen',
    done: 'Abgeschlossen',
    dropHereOr: 'Dateien hier ablegen oder %{browse}',
    dropHint: 'Dateien hier ablegen',
    dropPasteBoth: "Dateien hier ablegen/einf\xfcgen, %{browseFiles} oder %{browseFolders}",
    dropPasteFiles: "Dateien hier ablegen/einf\xfcgen oder %{browseFiles}",
    dropPasteFolders: "Dateien hier ablegen/einf\xfcgen oder %{browseFolders}",
    dropPasteImportBoth: "Dateien hier ablegen/einf\xfcgen, %{browse} oder von folgenden Quellen importieren:",
    dropPasteImportFiles: "Dateien hier ablegen/einf\xfcgen, %{browseFiles} oder von folgenden Quellen importieren:",
    dropPasteImportFolders: "Dateien hier ablegen/einf\xfcgen, %{browseFolders} oder von folgenden Quellen importieren:",
    editFile: 'Datei bearbeiten',
    editImage: 'Bild bearbeiten',
    editFileWithFilename: 'Datei %{file} bearbeiten',
    editing: '%{file} bearbeiten',
    emptyFolderAdded: "Keine Dateien hinzugef\xfcgt, da der Ordner leer war",
    encoding: 'Kodieren...',
    enterCorrectUrl: 'Falsche URL: Bitte stellen Sie sicher, dass Sie einen direkten Link zu einer Datei eingeben',
    enterTextToSearch: 'Text zum Suchen von Bildern eingeben',
    enterUrlToImport: 'URL zum Importieren einer Datei eingeben',
    exceedsSize: "Datei %{file} ist gr\xf6\xdfer als die maximal erlaubte Dateigr\xf6\xdfe von %{size}",
    failedToFetch: 'Companion konnte diese URL nicht verarbeiten - stellen Sie bitte sicher, dass sie korrekt ist',
    failedToUpload: 'Fehler beim Hochladen der Datei %{file}',
    filesUploadedOfTotal: {
        '0': '%{complete} von %{smart_count} Datei hochgeladen',
        '1': '%{complete} von %{smart_count} Dateien hochgeladen'
    },
    filter: 'Filter',
    finishEditingFile: 'Bearbeitung beenden',
    flipHorizontal: 'Horizontal spiegeln',
    folderAdded: {
        '0': "Eine Datei von %{folder} hinzugef\xfcgt",
        '1': "%{smart_count} Dateien von %{folder} hinzugef\xfcgt"
    },
    folderAlreadyAdded: 'Der Ordner "%{folder}" wurde bereits hinzugef\xfcgt',
    generatingThumbnails: 'Erstellen von Miniaturansichten...',
    import: 'Importieren',
    importFiles: 'Importiere Dateien von:',
    importFrom: 'Importieren von %{name}',
    inferiorSize: "Diese Datei ist kleiner als die minimal erlaubte Dateigr\xf6\xdfe von %{size}",
    loading: 'Laden...',
    logOut: 'Abmelden',
    micDisabled: 'Zugriff auf Mikrofon von Benutzer abgelehnt',
    missingRequiredMetaField: 'Fehlende erforderliche Meta-Felder',
    missingRequiredMetaFieldOnFile: 'Fehlende erforderliche Meta-Felder in %{fileName}',
    missingRequiredMetaFields: {
        '0': 'Fehlendes erforderliches Meta-Feld: %{fields}.',
        '1': 'Fehlende erforderliche Meta-Felder: %{fields}.'
    },
    myDevice: "Mein Ger\xe4t",
    noCameraDescription: "Bitte Kamera anschlie\xdfen, um Bilder oder Videos aufzunehmen",
    noCameraTitle: "Kamera nicht verf\xfcgbar",
    noDuplicates: "Datei '%{fileName}' existiert bereits und kann nicht erneut hinzugef\xfcgt werden",
    noFilesFound: 'Sie haben hier keine Dateien oder Ordner',
    noInternetConnection: 'Keine Internetverbindung',
    noMoreFilesAllowed: "W\xe4hrend der Upload l\xe4uft, k\xf6nnen keine weiteren Dateien hinzugef\xfcgt werden",
    openFolderNamed: "Ordner %{name} \xf6ffnen",
    pause: 'Pausieren',
    paused: 'Pausiert',
    pauseUpload: 'Hochladen pausieren',
    pluginNameBox: 'Box',
    pluginNameCamera: 'Kamera',
    pluginNameDropbox: 'Dropbox',
    pluginNameFacebook: 'Facebook',
    pluginNameGoogleDrive: 'Google Drive',
    pluginNameInstagram: 'Instagram',
    pluginNameOneDrive: 'OneDrive',
    pluginNameZoom: 'Zoom',
    poweredBy: 'Powered by %{uppy}',
    processingXFiles: {
        '0': 'Eine Datei verarbeiten',
        '1': '%{smart_count} Dateien verarbeiten'
    },
    recording: 'Aufnahme',
    recordingLength: 'Aufnahmedauer %{recording_length}',
    recordingStoppedMaxSize: "Die Aufnahme wurde gestoppt, weil die Dateigr\xf6\xdfe das Limit \xfcberschritten hat",
    recordVideoBtn: 'Video aufnehmen',
    recoveredAllFiles: "Wir haben alle Dateien wiederhergestellt. Sie k\xf6nnen mit dem Hochladen fortfahren.",
    recoveredXFiles: {
        '0': "Wir konnten eine Datei nicht vollst\xe4ndig wiederherstellen. Bitte w\xe4hlen Sie sie erneut aus und fahren Sie dann mit dem Hochladen fort.",
        '1': "Wir konnten %{smart_count} Dateien nicht vollst\xe4ndig wiederherstellen. Bitte w\xe4hlen Sie sie erneut aus und fahren Sie dann mit dem Hochladen fort."
    },
    removeFile: 'Datei entfernen',
    reSelect: "Erneut ausw\xe4hlen",
    resetFilter: "Filter zur\xfccksetzen",
    resume: 'Fortsetzen',
    resumeUpload: 'Hochladen fortsetzen',
    retry: 'Erneut versuchen',
    retryUpload: 'Hochladen erneut versuchen',
    revert: "R\xfcckg\xe4ngig machen",
    rotate: 'Drehen',
    save: 'Speichern',
    saveChanges: "\xc4nderungen speichern",
    searchImages: 'Suche nach Bildern',
    selectX: {
        '0': "W\xe4hlen Sie %{smart_count}",
        '1': "W\xe4hlen Sie %{smart_count}"
    },
    sessionRestored: '',
    smile: "Bitte l\xe4cheln!",
    startCapturing: 'Bildschirmaufnahme starten',
    startRecording: 'Videoaufnahme starten',
    stopCapturing: 'Bildschirmaufnahme stoppen',
    stopRecording: 'Videoaufnahme stoppen',
    streamActive: 'Stream aktiv',
    streamPassive: 'Stream passiv',
    submitRecordedFile: 'Aufgezeichnete Datei verwenden',
    takePicture: 'Ein Foto aufnehmen',
    takePictureBtn: 'Foto aufnehmen',
    timedOut: "Upload f\xfcr %{seconds} Sekunden stehen geblieben, breche ab.",
    upload: 'Hochladen',
    uploadComplete: 'Hochladen abgeschlossen',
    uploadFailed: 'Hochladen fehlgeschlagen',
    uploading: 'Wird hochgeladen',
    uploadingXFiles: {
        '0': 'Eine Datei wird hochgeladen',
        '1': '%{smart_count} Dateien werden hochgeladen'
    },
    uploadPaused: 'Hochladen pausiert',
    uploadXFiles: {
        '0': 'Eine Datei hochladen',
        '1': '%{smart_count} Dateien hochladen'
    },
    uploadXNewFiles: {
        '0': '+%{smart_count} Datei hochladen',
        '1': '+%{smart_count} Dateien hochladen'
    },
    xFilesSelected: {
        '0': "Eine Datei ausgew\xe4hlt",
        '1': "%{smart_count} Dateien ausgew\xe4hlt"
    },
    xMoreFilesAdded: {
        '0': "Eine weitere Datei hinzugef\xfcgt",
        '1': "%{smart_count} weitere Dateien hinzugef\xfcgt"
    },
    xTimeLeft: '%{time} verbleibend',
    youCanOnlyUploadFileTypes: "Sie k\xf6nnen nur folgende Dateitypen hochladen: %{types}",
    youCanOnlyUploadX: {
        '0': "Sie k\xf6nnen nur eine Datei hochladen",
        '1': "Sie k\xf6nnen nur %{smart_count} Dateien hochladen"
    },
    youHaveToAtLeastSelectX: {
        '0': "Sie m\xfcssen mindestens eine Datei ausw\xe4hlen",
        '1': "Sie m\xfcssen mindestens %{smart_count} Dateien ausw\xe4hlen"
    },
    zoomIn: "Vergr\xf6\xdfern",
    zoomOut: 'Verkleinern'
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== 'undefined') // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.de_DE = $4dcbb1f6ebd585d1$var$de_DE;
var $4dcbb1f6ebd585d1$export$2e2bcd8739ae039 = $4dcbb1f6ebd585d1$var$de_DE;


const $eb5fbf45bcb54698$var$fr_FR = {
    strings: {},
    pluralize (n) {
        if (n <= 1) return 0;
        return 1;
    }
};
$eb5fbf45bcb54698$var$fr_FR.strings = {
    addBulkFilesFailed: {
        '0': "L\u2019ajout de %{smart_count} fichier a \xe9chou\xe9",
        '1': "L\u2019ajout de %{smart_count} fichiers a \xe9chou\xe9"
    },
    addedNumFiles: "%{numFiles} fichier(s) ajout\xe9(s)",
    addingMoreFiles: 'Ajout de fichiers',
    addMore: "Ajouter d\u2019autres",
    addMoreFiles: "Ajouter d\u2019autres fichiers",
    allFilesFromFolderNamed: 'Tous les fichiers du dossier %{name}',
    allowAccessDescription: "Pour prendre des photos ou enregistrer une vid\xe9o, veuillez autoriser l\u2019acc\xe8s \xe0 votre cam\xe9ra pour ce site.",
    allowAccessTitle: "Veuillez autoriser l\u2019acc\xe8s \xe0 votre cam\xe9ra",
    authAborted: 'Authentification interrompue',
    authenticateWith: "Se connecter \xe0 %{pluginName}",
    authenticateWithTitle: "Veuillez vous authentifier avec %{pluginName} pour s\xe9lectionner les fichiers",
    back: 'Retour',
    browse: 'naviguer',
    browseFiles: 'naviguer',
    cancel: 'Annuler',
    cancelUpload: "Annuler le t\xe9l\xe9versement",
    chooseFiles: 'Choisir des fichiers',
    closeModal: "Fermer la fen\xeatre",
    companionError: "Connexion \xe0 Companion a \xe9chou\xe9",
    companionUnauthorizeHint: "Pour vous d\xe9connecter de votre compte %{provider}, veuillez aller \xe0 %{url}",
    complete: "Termin\xe9",
    compressedX: "%{size} \xe9conomis\xe9(s) par la compression",
    compressingImages: "Compression des images\u2026",
    connectedToInternet: "Connect\xe9 \xe0 Internet",
    copyLink: 'Copier le lien',
    copyLinkToClipboardFallback: 'Copier le lien ci-dessous',
    copyLinkToClipboardSuccess: "Lien copi\xe9",
    creatingAssembly: "Pr\xe9paration du t\xe9l\xe9versement\u2026",
    creatingAssemblyFailed: "Transloadit: Impossible de cr\xe9er Assembly",
    dashboardTitle: "T\xe9l\xe9verseur de fichiers",
    dashboardWindowTitle: "Fen\xeatre de t\xe9l\xe9versement de fichiers (Appuyez sur \xc9chap pour fermer)",
    dataUploadedOfTotal: '%{complete} sur %{total}',
    done: "Termin\xe9",
    dropHereOr: "D\xe9poser les fichiers ici ou %{browse}",
    dropHint: "D\xe9posez vos fichiers ici",
    dropPasteBoth: "D\xe9poser les fichiers ici, coller ou %{browse}",
    dropPasteFiles: "D\xe9poser les fichiers ici, coller ou %{browse}",
    dropPasteFolders: "D\xe9poser les fichiers ici, coller ou %{browse}",
    dropPasteImportBoth: "D\xe9poser les fichiers ici, coller, %{browse} ou importer de",
    dropPasteImportFiles: "D\xe9poser les fichiers ici, coller, %{browse} ou importer de",
    dropPasteImportFolders: "D\xe9poser les fichiers ici, coller, %{browse} ou importer de",
    editFile: 'Modifier le fichier',
    editImage: "Modifier l\u2019image",
    editFileWithFilename: 'Modifier le fichier %{file}',
    editing: 'Modification en cours de %{file}',
    emptyFolderAdded: "Aucun fichier n\u2019a \xe9t\xe9 ajout\xe9 depuis un dossier vide",
    encoding: "Traitement\u2026",
    enterCorrectUrl: 'Lien incorrect: Assurez-vous que vous entrez un lien direct vers le fichier',
    enterUrlToImport: 'Entrez le lien pour importer un fichier',
    exceedsSize: "Ce fichier d\xe9passe la taille maximale autoris\xe9e de %{size}",
    failedToFetch: "Companion a \xe9chou\xe9 \xe0 r\xe9cup\xe9rer ce lien, assurez-vous qu\u2019il est correct",
    failedToUpload: "Le t\xe9l\xe9versement de %{file} a \xe9chou\xe9",
    fileSource: 'Fichier source: %{name}',
    filesUploadedOfTotal: {
        '0': "%{complete} sur %{smart_count} fichier t\xe9l\xe9vers\xe9",
        '1': "%{complete} sur %{smart_count} fichiers t\xe9l\xe9vers\xe9s"
    },
    filter: 'Filtrer',
    finishEditingFile: "Terminer l\u2019\xe9dition du fichier",
    folderAdded: {
        '0': "%{smart_count} fichier ajout\xe9 de %{folder}",
        '1': "%{smart_count} fichiers ajout\xe9s de %{folder}"
    },
    generatingThumbnails: "G\xe9n\xe9ration des vignettes\u2026",
    import: 'Importer',
    importFrom: 'Importer de %{name}',
    loading: "Chargement\u2026",
    logOut: "D\xe9connexion",
    micDisabled: "Acc\xe8s au micro refus\xe9 par l\u2019utilisateur",
    myDevice: 'Mon Appareil',
    noDuplicates: 'Impossible d\u2019ajouter le fichier "%{fileName}", il existe d\xe9j\xe0',
    noFilesFound: "Vous n\u2019avez aucun fichier ou dossier ici",
    noInternetConnection: "Pas de connexion \xe0 Internet",
    noMoreFilesAllowed: "Impossible d\u2019ajouter de nouveaux fichiers: en cours de chargement ",
    openFolderNamed: 'Ouvrir %{name}',
    pause: 'Pause',
    pauseUpload: "Mettre en pause le t\xe9l\xe9versement",
    paused: 'En pause',
    poweredBy: "Propuls\xe9 par %{uppy}",
    processingXFiles: {
        '0': 'Traitement de %{smart_count} fichier',
        '1': 'Traitement de %{smart_count} fichiers'
    },
    recording: 'Enregistrement',
    recordingLength: "Dur\xe9e d\u2019enregistrement %{recording_length}",
    recordingStoppedMaxSize: "L\u2019enregistrement s\u2019est arr\xe9t\xe9 car la taille du fichier d\xe9passe la limite",
    removeFile: 'Effacer le fichier %{file}',
    resetFilter: "R\xe9initialiser filtre",
    resume: 'Reprendre',
    resumeUpload: "Reprendre le t\xe9l\xe9versement",
    retry: "R\xe9essayer",
    retryUpload: "R\xe9essayer le t\xe9l\xe9versement",
    save: 'Sauvegarder',
    saveChanges: 'Sauvegarder les modifications',
    selectFileNamed: "S\xe9lectionner le fichier %{name}",
    selectX: {
        '0': "S\xe9lectionner %{smart_count}",
        '1': "S\xe9lectionner %{smart_count}"
    },
    smile: 'Souriez !',
    startRecording: "Commencer l\u2019enregistrement vid\xe9o",
    stopRecording: "Arr\xeater l\u2019enregistrement vid\xe9o",
    streamActive: 'Stream actif',
    streamPassive: 'Stream passif',
    submitRecordedFile: "Envoyer la vid\xe9o enregistr\xe9e",
    takePicture: 'Prendre une photo',
    timedOut: "T\xe9l\xe9versement bloqu\xe9 durant %{seconds} secondes, annulation.",
    unselectFileNamed: "D\xe9s\xe9lectionner le fichier %{name}",
    upload: "T\xe9l\xe9verser",
    uploadComplete: "T\xe9l\xe9versement termin\xe9",
    uploadFailed: "Le t\xe9l\xe9versement a \xe9chou\xe9",
    uploadPaused: "T\xe9l\xe9versement mis en pause",
    uploadStalled: "T\xe9l\xe9versement bloqu\xe9 depuis %{seconds} secondes. Il est peut-\xeatre n\xe9cessaire de recommencer l\u2019op\xe9ration.",
    uploadXFiles: {
        '0': "T\xe9l\xe9verser %{smart_count} fichier",
        '1': "T\xe9l\xe9verser %{smart_count} fichiers"
    },
    uploadXNewFiles: {
        '0': "T\xe9l\xe9verser +%{smart_count} fichier",
        '1': "T\xe9l\xe9verser +%{smart_count} fichiers"
    },
    uploading: "T\xe9l\xe9versement en cours",
    uploadingXFiles: {
        '0': "T\xe9l\xe9versement de %{smart_count} fichier",
        '1': "T\xe9l\xe9versement de %{smart_count} fichiers"
    },
    xFilesSelected: {
        '0': "%{smart_count} fichier s\xe9lectionn\xe9",
        '1': "%{smart_count} fichiers s\xe9lectionn\xe9s"
    },
    xMoreFilesAdded: {
        '0': "%{smart_count} autre fichier ajout\xe9",
        '1': "%{smart_count} autres fichiers ajout\xe9s"
    },
    xTimeLeft: '%{time} restantes',
    youCanOnlyUploadFileTypes: "Vous pouvez seulement t\xe9l\xe9verser: %{types}",
    youCanOnlyUploadX: {
        '0': "Vous pouvez seulement t\xe9l\xe9verser %{smart_count} fichier",
        '1': "Vous pouvez seulement t\xe9l\xe9verser %{smart_count} fichiers"
    },
    youHaveToAtLeastSelectX: {
        '0': "Vous devez s\xe9lectionner au moins %{smart_count} fichier",
        '1': "Vous devez s\xe9lectionner au moins %{smart_count} fichiers"
    }
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== 'undefined') // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.fr_FR = $eb5fbf45bcb54698$var$fr_FR;
var $eb5fbf45bcb54698$export$2e2bcd8739ae039 = $eb5fbf45bcb54698$var$fr_FR;


const $17e4618551887cdb$var$it_IT = {
    strings: {},
    pluralize (n) {
        if (n === 1) return 0;
        return 1;
    }
};
$17e4618551887cdb$var$it_IT.strings = {
    addMoreFiles: "Aggiungi pi\xf9 file",
    addingMoreFiles: 'Sto aggiungendo altri file',
    allowAccessDescription: "Per acquisire foto o video con la tua fotocamera, abilitane l'accesso da questo sito.",
    allowAccessTitle: "Abilita l'accesso alla fotocamera",
    authenticateWith: 'Connetti a %{pluginName}',
    authenticateWithTitle: 'Autenticati con %{pluginName} per selezionare i file',
    back: 'Indietro',
    addMore: "Aggiungi pi\xf9",
    browse: 'sfoglia',
    browseFiles: 'sfoglia',
    cancel: 'Annulla',
    cancelUpload: 'Annulla upload',
    chooseFiles: 'Scegli i file',
    closeModal: 'Chiudi modale',
    companionError: 'Connessione con Companion fallita',
    complete: 'Completato',
    connectedToInternet: 'Connesso a internet',
    copyLink: 'Copia link',
    copyLinkToClipboardFallback: "Copia l'URL sottostante",
    copyLinkToClipboardSuccess: 'Link copiato',
    creatingAssembly: 'Upload in preparazione...',
    creatingAssemblyFailed: "Transloadit: Non ho potuto creare l'Assembly",
    dashboardTitle: 'File Uploader',
    dashboardWindowTitle: 'File Uploader (Premi Esc per chiudere)',
    dataUploadedOfTotal: '%{complete} di %{total}',
    done: 'Fatto',
    dropHereOr: 'Trascina i file qui o %{browse}',
    dropHint: 'Trascina i file qui',
    dropPasteBoth: 'Trascina i file qui, incolla o %{browse}',
    dropPasteFiles: 'Trascina i file qui, incolla o %{browse}',
    dropPasteFolders: 'Trascina i file qui, incolla o %{browse}',
    dropPasteImportBoth: 'Trascina i file qui, incolla, %{browse} o importa da',
    dropPasteImportFiles: 'Trascina i file qui, incolla, %{browse} o importa da',
    dropPasteImportFolders: 'Trascina i file qui, incolla, %{browse} o importa da',
    editFile: 'Modifica file',
    editImage: 'Modifica immagine',
    editing: 'Modifica %{file}',
    emptyFolderAdded: 'Nessun file aggiunto dalla cartella vuota',
    encoding: 'Encoding...',
    enterCorrectUrl: 'URL non corretta: assicurati che sia un link diretto ad un file',
    enterUrlToImport: "Immetti l'URL per importare un file",
    exceedsSize: 'Questo file supera la dimensione massima di %{size}',
    failedToFetch: 'Impossibile verificare questa URL, assicurati che sia corretta',
    failedToUpload: 'Upload del file %{file} non riuscito',
    fileSource: 'Sorgente file: %{name}',
    filesUploadedOfTotal: {
        '0': '%{complete} di %{smart_count} file caricato',
        '1': '%{complete} di %{smart_count} file caricati'
    },
    filter: 'Filter',
    finishEditingFile: 'Finish editing file',
    folderAdded: {
        '0': 'Aggiunto %{smart_count} file da %{folder}',
        '1': 'Aggiunti %{smart_count} file da %{folder}'
    },
    import: 'Importa',
    importFrom: 'Importa da %{name}',
    loading: 'Caricamento...',
    logOut: 'Logout',
    myDevice: 'Il mio computer',
    noFilesFound: 'Non hai file o cartelle qui',
    noInternetConnection: 'Nessuna connessione a internet',
    pause: 'Pausa',
    pauseUpload: 'Pausa upload',
    paused: 'In pausa',
    poweredBy: 'Powered by %{uppy}',
    processingXFiles: {
        '0': 'Sto processando %{smart_count} file',
        '1': 'Sto processando %{smart_count} file'
    },
    removeFile: 'Rimuovi il file',
    resetFilter: 'Ripristina filtro',
    resume: 'Riprendi',
    resumeUpload: "Riprendi l'upload",
    retry: 'Riprova',
    retryUpload: "Riprova l'upload",
    saveChanges: 'Salva le modifiche',
    selectX: {
        '0': 'Seleziona %{smart_count}',
        '1': 'Seleziona %{smart_count}'
    },
    smile: 'Sorridi!',
    startRecording: 'Inizia la registrazione del video',
    stopRecording: 'Interrompi la registrazione del video',
    takePicture: 'Scatta una foto',
    timedOut: 'Upload fermo da %{seconds} secondi, sto annullando.',
    upload: 'Upload',
    uploadComplete: 'Upload completato',
    uploadFailed: 'Upload non riuscito',
    uploadPaused: 'Upload in pausa',
    uploadXFiles: {
        '0': 'Upload di %{smart_count} file',
        '1': 'Upload di %{smart_count} file'
    },
    uploadXNewFiles: {
        '0': 'Upload +%{smart_count} file',
        '1': 'Upload +%{smart_count} file'
    },
    uploading: 'In caricamento',
    uploadingXFiles: {
        '0': 'Caricando %{smart_count} file',
        '1': 'Caricando %{smart_count} file'
    },
    xFilesSelected: {
        '0': '%{smart_count} file selezionato',
        '1': '%{smart_count} file selezionati'
    },
    xMoreFilesAdded: {
        '0': '%{smart_count} alto file aggiunto',
        '1': '%{smart_count} altri file aggiunti'
    },
    xTimeLeft: '%{time} rimasto',
    youCanOnlyUploadFileTypes: 'Puoi caricare solamente: %{types}',
    youCanOnlyUploadX: {
        '0': 'Puoi caricare %{smart_count} solo file',
        '1': 'Puoi caricare solo %{smart_count} file'
    },
    youHaveToAtLeastSelectX: {
        '0': 'Devi selezionare almeno %{smart_count} file',
        '1': 'Devi selezionare almeno %{smart_count} file'
    },
    selectFileNamed: 'Seleziona il file %{name}',
    unselectFileNamed: 'Deseleziona il file %{name}',
    openFolderNamed: 'Cartella aperta %{name}'
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== 'undefined') // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.it_IT = $17e4618551887cdb$var$it_IT;
var $17e4618551887cdb$export$2e2bcd8739ae039 = $17e4618551887cdb$var$it_IT;


const $e8c2aad43689e7e3$var$en_US = {
    strings: {},
    pluralize (count) {
        if (count === 1) return 0;
        return 1;
    }
};
$e8c2aad43689e7e3$var$en_US.strings = {
    addBulkFilesFailed: {
        '0': 'Failed to add %{smart_count} file due to an internal error',
        '1': 'Failed to add %{smart_count} files due to internal errors'
    },
    addedNumFiles: 'Added %{numFiles} file(s)',
    addingMoreFiles: 'Adding more files',
    additionalRestrictionsFailed: '%{count} additional restrictions were not fulfilled',
    addMore: 'Add more',
    addMoreFiles: 'Add more files',
    allFilesFromFolderNamed: 'All files from folder %{name}',
    allowAccessDescription: 'In order to take pictures or record video with your camera, please allow camera access for this site.',
    allowAccessTitle: 'Please allow access to your camera',
    allowAudioAccessDescription: 'In order to record audio, please allow microphone access for this site.',
    allowAudioAccessTitle: 'Please allow access to your microphone',
    aspectRatioLandscape: 'Crop landscape (16:9)',
    aspectRatioPortrait: 'Crop portrait (9:16)',
    aspectRatioSquare: 'Crop square',
    authAborted: 'Authentication aborted',
    authenticateWith: 'Connect to %{pluginName}',
    authenticateWithTitle: 'Please authenticate with %{pluginName} to select files',
    back: 'Back',
    browse: 'browse',
    browseFiles: 'browse files',
    browseFolders: 'browse folders',
    cancel: 'Cancel',
    cancelUpload: 'Cancel upload',
    chooseFiles: 'Choose files',
    closeModal: 'Close Modal',
    companionError: 'Connection with Companion failed',
    companionUnauthorizeHint: 'To unauthorize to your %{provider} account, please go to %{url}',
    complete: 'Complete',
    compressedX: 'Saved %{size} by compressing images',
    compressingImages: 'Compressing images...',
    connectedToInternet: 'Connected to the Internet',
    copyLink: 'Copy link',
    copyLinkToClipboardFallback: 'Copy the URL below',
    copyLinkToClipboardSuccess: 'Link copied to clipboard.',
    creatingAssembly: 'Preparing upload...',
    creatingAssemblyFailed: 'Transloadit: Could not create Assembly',
    dashboardTitle: 'Uppy Dashboard',
    dashboardWindowTitle: 'Uppy Dashboard Window (Press escape to close)',
    dataUploadedOfTotal: '%{complete} of %{total}',
    discardRecordedFile: 'Discard recorded file',
    done: 'Done',
    dropHereOr: 'Drop here or %{browse}',
    dropHint: 'Drop your files here',
    dropPasteBoth: 'Drop files here, %{browseFiles} or %{browseFolders}',
    dropPasteFiles: 'Drop files here or %{browseFiles}',
    dropPasteFolders: 'Drop files here or %{browseFolders}',
    dropPasteImportBoth: 'Drop files here, %{browseFiles}, %{browseFolders} or import from:',
    dropPasteImportFiles: 'Drop files here, %{browseFiles} or import from:',
    dropPasteImportFolders: 'Drop files here, %{browseFolders} or import from:',
    editFile: 'Edit file',
    editImage: 'Edit image',
    editFileWithFilename: 'Edit file %{file}',
    editing: 'Editing %{file}',
    emptyFolderAdded: 'No files were added from empty folder',
    encoding: 'Encoding...',
    enterCorrectUrl: 'Incorrect URL: Please make sure you are entering a direct link to a file',
    enterTextToSearch: 'Enter text to search for images',
    enterUrlToImport: 'Enter URL to import a file',
    error: 'Error',
    exceedsSize: '%{file} exceeds maximum allowed size of %{size}',
    failedToFetch: "Companion failed to fetch this URL, please make sure it\u2019s correct",
    failedToUpload: 'Failed to upload %{file}',
    filesUploadedOfTotal: {
        '0': '%{complete} of %{smart_count} file uploaded',
        '1': '%{complete} of %{smart_count} files uploaded'
    },
    filter: 'Filter',
    finishEditingFile: 'Finish editing file',
    flipHorizontal: 'Flip horizontal',
    folderAdded: {
        '0': 'Added %{smart_count} file from %{folder}',
        '1': 'Added %{smart_count} files from %{folder}'
    },
    folderAlreadyAdded: 'The folder "%{folder}" was already added',
    generatingThumbnails: 'Generating thumbnails...',
    import: 'Import',
    importFiles: 'Import files from:',
    importFrom: 'Import from %{name}',
    inferiorSize: 'This file is smaller than the allowed size of %{size}',
    loadedXFiles: 'Loaded %{numFiles} files',
    loading: 'Loading...',
    logOut: 'Log out',
    micDisabled: 'Microphone access denied by user',
    missingRequiredMetaField: 'Missing required meta fields',
    missingRequiredMetaFieldOnFile: 'Missing required meta fields in %{fileName}',
    missingRequiredMetaFields: {
        '0': 'Missing required meta field: %{fields}.',
        '1': 'Missing required meta fields: %{fields}.'
    },
    myDevice: 'My Device',
    noAudioDescription: 'In order to record audio, please connect a microphone or another audio input device',
    noAudioTitle: 'Microphone Not Available',
    noCameraDescription: 'In order to take pictures or record video, please connect a camera device',
    noCameraTitle: 'Camera Not Available',
    noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
    noFilesFound: 'You have no files or folders here',
    noInternetConnection: 'No Internet connection',
    noMoreFilesAllowed: 'Cannot add more files',
    noSearchResults: 'Unfortunately, there are no results for this search',
    openFolderNamed: 'Open folder %{name}',
    pause: 'Pause',
    paused: 'Paused',
    pauseUpload: 'Pause upload',
    pluginNameAudio: 'Audio',
    pluginNameBox: 'Box',
    pluginNameCamera: 'Camera',
    pluginNameDropbox: 'Dropbox',
    pluginNameFacebook: 'Facebook',
    pluginNameGoogleDrive: 'Google Drive',
    pluginNameInstagram: 'Instagram',
    pluginNameOneDrive: 'OneDrive',
    pluginNameZoom: 'Zoom',
    poweredBy: 'Powered by %{uppy}',
    processingXFiles: {
        '0': 'Processing %{smart_count} file',
        '1': 'Processing %{smart_count} files'
    },
    recording: 'Recording',
    recordingLength: 'Recording length %{recording_length}',
    recordingStoppedMaxSize: 'Recording stopped because the file size is about to exceed the limit',
    recordVideoBtn: 'Record Video',
    recoveredAllFiles: 'We restored all files. You can now resume the upload.',
    recoveredXFiles: {
        '0': 'We could not fully recover 1 file. Please re-select it and resume the upload.',
        '1': 'We could not fully recover %{smart_count} files. Please re-select them and resume the upload.'
    },
    removeFile: 'Remove file',
    reSelect: 'Re-select',
    resetFilter: 'Reset filter',
    resetSearch: 'Reset search',
    resume: 'Resume',
    resumeUpload: 'Resume upload',
    retry: 'Retry',
    retryUpload: 'Retry upload',
    revert: 'Revert',
    rotate: 'Rotate',
    save: 'Save',
    saveChanges: 'Save changes',
    search: 'Search',
    searchImages: 'Search for images',
    selectX: {
        '0': 'Select %{smart_count}',
        '1': 'Select %{smart_count}'
    },
    sessionRestored: 'Session restored',
    showErrorDetails: 'Show error details',
    signInWithGoogle: 'Sign in with Google',
    smile: 'Smile!',
    startAudioRecording: 'Begin audio recording',
    startCapturing: 'Begin screen capturing',
    startRecording: 'Begin video recording',
    stopAudioRecording: 'Stop audio recording',
    stopCapturing: 'Stop screen capturing',
    stopRecording: 'Stop video recording',
    streamActive: 'Stream active',
    streamPassive: 'Stream passive',
    submitRecordedFile: 'Submit recorded file',
    takePicture: 'Take a picture',
    takePictureBtn: 'Take Picture',
    timedOut: 'Upload stalled for %{seconds} seconds, aborting.',
    upload: 'Upload',
    uploadComplete: 'Upload complete',
    uploadFailed: 'Upload failed',
    uploading: 'Uploading',
    uploadingXFiles: {
        '0': 'Uploading %{smart_count} file',
        '1': 'Uploading %{smart_count} files'
    },
    uploadPaused: 'Upload paused',
    uploadStalled: 'Upload has not made any progress for %{seconds} seconds. You may want to retry it.',
    uploadXFiles: {
        '0': 'Upload %{smart_count} file',
        '1': 'Upload %{smart_count} files'
    },
    uploadXNewFiles: {
        '0': 'Upload +%{smart_count} file',
        '1': 'Upload +%{smart_count} files'
    },
    xFilesSelected: {
        '0': '%{smart_count} file selected',
        '1': '%{smart_count} files selected'
    },
    xMoreFilesAdded: {
        '0': '%{smart_count} more file added',
        '1': '%{smart_count} more files added'
    },
    xTimeLeft: '%{time} left',
    youCanOnlyUploadFileTypes: 'You can only upload: %{types}',
    youCanOnlyUploadX: {
        '0': 'You can only upload %{smart_count} file',
        '1': 'You can only upload %{smart_count} files'
    },
    youHaveToAtLeastSelectX: {
        '0': 'You have to select at least %{smart_count} file',
        '1': 'You have to select at least %{smart_count} files'
    },
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out'
};
// TODO: remove this in the next major?
// @ts-expect-error Uppy can be a global in legacy bundle
if (typeof Uppy !== 'undefined') // @ts-expect-error Uppy can be a global in legacy bundle
globalThis.Uppy.locales.en_US = $e8c2aad43689e7e3$var$en_US;
var $e8c2aad43689e7e3$export$2e2bcd8739ae039 = $e8c2aad43689e7e3$var$en_US;


class $2b8eccc7b4db22b8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.isWithinIFrame = false;
        this.api = this.getAttribute('data-tk-api') || undefined;
        this.moveAPI = this.getAttribute('data-tk-move-api') || undefined;
        this.usage = this.getAttribute('data-tk-usage') || undefined;
        this.filePath = this.getAttribute('data-tk-file-path') || undefined;
        this.disableCompressor = this.hasAttribute('data-tk-disable-compressor');
        this.outputMimeType = this.getAttribute('data-tk-output-mime-type') || 'image/webp';
        this.maxNumberOfFiles = Number(this.getAttribute('data-tk-max-number-of-files')) || null;
        this.maxFileSize = Number(this.getAttribute('data-tk-max-file-size')) || null;
        this.allowedFileTypes = (this.getAttribute('data-tk-allowed-file-types') || 'image/*').split(',');
        this.locale = Number(this.getAttribute('data-tk-locale')) || 1;
        this.disableUniqueFileNames = this.hasAttribute('data-tk-disable-unique-file-names');
        const getLanguage = {
            1: (0, $4dcbb1f6ebd585d1$export$2e2bcd8739ae039),
            2: (0, $eb5fbf45bcb54698$export$2e2bcd8739ae039),
            3: (0, $e8c2aad43689e7e3$export$2e2bcd8739ae039),
            4: (0, $17e4618551887cdb$export$2e2bcd8739ae039)
        };
        this.language = getLanguage[this.locale];
        this.filePrefix = this.getAttribute('data-tk-file-prefix') || undefined;
        this.isWithinIFrame = this.hasAttribute('data-tk-is-within-iframe');
    }
    connectedCallback() {
        if (!this.api || !this.moveAPI || !this.usage || !this.filePath) throw new Error('FileUploadArea: Attributes are missing!');
        this.init();
    }
    init() {
        const endpoint = `${this.api}${this.usage}`;
        this.uppy = new (0, $b16b91c7840d3bff$export$2e2bcd8739ae039)();
        this.uppy.setOptions({
            restrictions: {
                maxFileSize: this.maxFileSize,
                maxNumberOfFiles: this.maxNumberOfFiles,
                allowedFileTypes: this.allowedFileTypes
            },
            locale: this.language
        });
        this.uppy.use((0, $b868dcf7a47332e3$export$2e2bcd8739ae039), {
            target: this,
            inline: true,
            width: '100%'
        });
        this.uppy.use((0, $cf91058fd9d7f8ee$export$2e2bcd8739ae039), {
            endpoint: endpoint,
            allowedMetaFields: [],
            getResponseData: (xhr)=>this.getResponseData(xhr)
        });
        !this.disableCompressor && this.uppy.use((0, $d847a4c5a8f23ad9$export$2e2bcd8739ae039), {
            mimeType: this.outputMimeType
        });
        this.uppy.on('file-added', (file)=>{
            const modifiedFileName = this.getFileName(file);
            this.uppy?.setFileMeta(file.id, {
                name: modifiedFileName
            });
            this.uppy?.setFileState(file.id, {
                name: modifiedFileName
            });
        });
    }
    async getResponseData(xhr) {
        if (xhr.status === 200) {
            const response = await this.moveFile();
            const { path: path, success: success } = response.dataAsJson;
            if (!success) {
                const error = {
                    name: 'CANCEL',
                    message: 'FAILED!'
                };
                this.uppy?.emit('error', error);
                this.uppy?.emit('cancel-all');
                return {
                    url: ''
                };
            } else {
                if (this.isWithinIFrame) window.parent.postMessage({
                    mceAction: 'close',
                    content: path,
                    size: {
                        width: 0,
                        height: 0
                    }
                }, '*');
                return {
                    url: path
                };
            }
        }
        return {
            url: ''
        };
    }
    async moveFile() {
        const data = {
            usage: this.usage,
            path: this.filePath
        };
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: this.moveAPI,
                resolveHandler: (success)=>resolve(success),
                payload: data
            });
        });
    }
    getFileName(file) {
        if (this.disableUniqueFileNames && this.filePrefix) return `${this.filePrefix}-${file.name}`;
        if (!this.disableUniqueFileNames && this.filePrefix) return `${this.filePrefix}-${(0, $d0666643e2ee88b4$export$2e2bcd8739ae039)()}.${file.extension}`;
        if (!this.disableUniqueFileNames && !this.filePrefix) return `${(0, $d0666643e2ee88b4$export$2e2bcd8739ae039)()}.${file.extension}`;
        return file.name;
    }
}


class $562c28a8df1194c9$export$60b03b353ad03260 {
    constructor(initialState){
        this.listeners = [];
        this.state = initialState;
        this.isInitialized = new Promise((resolve)=>{
            this.resolveInitialize = resolve;
        });
    }
    async startInitialization() {
        await this.initialize();
        this.resolveInitialize();
    }
    subscribe(callback) {
        this.listeners.push(callback);
        return ()=>{
            this.listeners = this.listeners.filter((listener)=>listener !== callback);
        };
    }
    notifyListeners(action) {
        this.listeners.forEach((listener)=>listener({
                state: this.state,
                action: action
            }));
    }
    notify(action, state) {
        this.state = {
            ...this.state,
            ...state
        };
        console.log(`Action: ${action}`, state);
        this.notifyListeners(action);
    }
}


const $7818c326be87ea84$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $7818c326be87ea84$var$idbProxyableTypes;
let $7818c326be87ea84$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $7818c326be87ea84$var$getIdbProxyableTypes() {
    return $7818c326be87ea84$var$idbProxyableTypes || ($7818c326be87ea84$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $7818c326be87ea84$var$getCursorAdvanceMethods() {
    return $7818c326be87ea84$var$cursorAdvanceMethods || ($7818c326be87ea84$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $7818c326be87ea84$var$transactionDoneMap = new WeakMap();
const $7818c326be87ea84$var$transformCache = new WeakMap();
const $7818c326be87ea84$var$reverseTransformCache = new WeakMap();
function $7818c326be87ea84$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($7818c326be87ea84$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    // This mapping exists in reverseTransformCache but doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $7818c326be87ea84$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $7818c326be87ea84$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($7818c326be87ea84$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $7818c326be87ea84$var$transactionDoneMap.set(tx, done);
}
let $7818c326be87ea84$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $7818c326be87ea84$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $7818c326be87ea84$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $7818c326be87ea84$var$replaceTraps(callback) {
    $7818c326be87ea84$var$idbProxyTraps = callback($7818c326be87ea84$var$idbProxyTraps);
}
function $7818c326be87ea84$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($7818c326be87ea84$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($7818c326be87ea84$export$debb760848ca95a(this), args);
        return $7818c326be87ea84$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $7818c326be87ea84$export$4997ffc0176396a6(func.apply($7818c326be87ea84$export$debb760848ca95a(this), args));
    };
}
function $7818c326be87ea84$var$transformCachableValue(value) {
    if (typeof value === 'function') return $7818c326be87ea84$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $7818c326be87ea84$var$cacheDonePromiseForTransaction(value);
    if ($7818c326be87ea84$var$instanceOfAny(value, $7818c326be87ea84$var$getIdbProxyableTypes())) return new Proxy(value, $7818c326be87ea84$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $7818c326be87ea84$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $7818c326be87ea84$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($7818c326be87ea84$var$transformCache.has(value)) return $7818c326be87ea84$var$transformCache.get(value);
    const newValue = $7818c326be87ea84$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $7818c326be87ea84$var$transformCache.set(value, newValue);
        $7818c326be87ea84$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $7818c326be87ea84$export$debb760848ca95a = (value)=>$7818c326be87ea84$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $7818c326be87ea84$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $7818c326be87ea84$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade($7818c326be87ea84$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $7818c326be87ea84$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $7818c326be87ea84$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $7818c326be87ea84$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $7818c326be87ea84$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $7818c326be87ea84$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $7818c326be87ea84$var$cachedMethods = new Map();
function $7818c326be87ea84$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($7818c326be87ea84$var$cachedMethods.get(prop)) return $7818c326be87ea84$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $7818c326be87ea84$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $7818c326be87ea84$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $7818c326be87ea84$var$cachedMethods.set(prop, method);
    return method;
}
$7818c326be87ea84$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$7818c326be87ea84$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$7818c326be87ea84$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $7818c326be87ea84$var$advanceMethodProps = [
    'continue',
    'continuePrimaryKey',
    'advance'
];
const $7818c326be87ea84$var$methodMap = {};
const $7818c326be87ea84$var$advanceResults = new WeakMap();
const $7818c326be87ea84$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $7818c326be87ea84$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$7818c326be87ea84$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $7818c326be87ea84$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $7818c326be87ea84$var$methodMap[prop] = function(...args) {
            $7818c326be87ea84$var$advanceResults.set(this, $7818c326be87ea84$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $7818c326be87ea84$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $7818c326be87ea84$var$cursorIteratorTraps);
    $7818c326be87ea84$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $7818c326be87ea84$var$reverseTransformCache.set(proxiedCursor, $7818c326be87ea84$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($7818c326be87ea84$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $7818c326be87ea84$var$advanceResults.delete(proxiedCursor);
    }
}
function $7818c326be87ea84$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $7818c326be87ea84$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === 'iterate' && $7818c326be87ea84$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$7818c326be87ea84$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($7818c326be87ea84$var$isIteratorProp(target, prop)) return $7818c326be87ea84$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $7818c326be87ea84$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));


var $9f71fef3739216f1$export$61e2e3c065b02bd0 = /*#__PURE__*/ function(CompareActions) {
    CompareActions["SWITCH_CATEGORY"] = "switchCategory";
    CompareActions["REMOVE_CATEGORY"] = "removeCategory";
    CompareActions["ADD_MULTIPLE_ITEMS"] = "addMultipleItems";
    CompareActions["PATCH_ITEM"] = "patchItem";
    CompareActions["CLEAR_TABLE"] = "clearTable";
    CompareActions["CLEAR_ALL_TABLE"] = "clearAllTable";
    return CompareActions;
}({});
class $9f71fef3739216f1$export$2e2bcd8739ae039 extends (0, $562c28a8df1194c9$export$60b03b353ad03260) {
    constructor(){
        super({
            categories: [],
            articles: [],
            attributeList: [],
            currentCategoryId: 0
        });
    }
    async initialize() {
        this.database = await (0, $7818c326be87ea84$export$ca0ed41b1a2af7e)('CompareStore', 1, {
            upgrade (db) {
                db.createObjectStore('categories');
                db.createObjectStore('articles');
                db.createObjectStore('attributeList').createIndex('categoryId', 'categoryId', {
                    unique: false
                });
            }
        });
        const firstCategory = (await this.database.getAll('categories')).at(0);
        if (firstCategory) this.state.currentCategoryId = firstCategory.id;
        await this.saveAllStores();
    }
    getState() {
        return this.state;
    }
    async clearAll() {
        await this.database?.clear('categories');
        await this.database?.clear('articles');
        await this.database?.clear('attributeList');
        await this.syncState();
        this.notify("clearAllTable", this.state);
    }
    async clear(storeName) {
        await this.database?.clear(storeName);
        await this.syncState();
        this.notify("clearTable", this.state);
    }
    getCategoryById(categoryId) {
        const { categories: categories } = this.state;
        return categories.find((item)=>item.id === categoryId);
    }
    getArticleCountByCategoryId(categoryId) {
        const { categories: categories, articles: articles } = this.state;
        const category = categories.find((item)=>item.id === categoryId);
        const length = articles.filter((article)=>category?.articleIds.includes(article.id)).length;
        if (length === 0) return category?.articleIds.length;
        else return length;
    }
    async patchCategoryById(categoryId, category) {
        await this.database?.put('categories', category, categoryId);
        await this.syncState();
        this.notify("patchItem", this.state);
    }
    async removeCategoryById(categoryId) {
        await this.database?.delete('categories', categoryId);
        await this.syncState();
        this.notify("removeCategory", this.state);
    }
    async getEntriesByCategoryId(categoryId) {
        if (!this.database) return;
        const tx = this.database.transaction('attributeList', 'readonly');
        const index = tx.store.index('categoryId');
        const keyRange = IDBKeyRange.only(categoryId);
        const results = await index.getAll(keyRange);
        await tx.done;
        return results;
    }
    async addMultipleItems(storeName, items) {
        const transaction = this.database?.transaction(storeName, 'readwrite');
        const store = transaction?.objectStore(storeName);
        if (!this.hasAllItemsAnId(items)) return;
        await Promise.all([
            items.map(async (item)=>{
                await store?.put(item, item.id);
            })
        ]);
        await transaction?.done;
        await this.syncState();
        this.notify("addMultipleItems", this.state);
    }
    async modifyItem(storeName, id, modifiedState) {
        const item = await this.database?.get(storeName, id);
        const newItem = {
            ...item,
            ...modifiedState
        };
        await this.database?.put(storeName, newItem, id);
        await this.syncState();
        this.notify("patchItem", this.state);
    }
    switchCategory(categoryId) {
        this.state.currentCategoryId = categoryId;
        this.notify("switchCategory", this.state);
    }
    async syncState() {
        await this.saveAllStores();
    }
    async saveAllStores() {
        this.state = {
            categories: await this.database?.getAll('categories'),
            articles: await this.database?.getAll('articles'),
            attributeList: await this.database?.getAll('attributeList'),
            currentCategoryId: this.state.currentCategoryId
        };
    }
    hasAllItemsAnId(items) {
        const invalidItems = items.filter((item)=>!('id' in item) || item.id === undefined);
        return invalidItems.length === 0;
    }
}




class $7cfc9025399237fb$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.anchor = this.querySelector('a') || undefined;
        this.counter = this.anchor?.querySelector('[data-tk-counter-info') || undefined;
        this.emptyClassName = this.getDataAttribute('empty-class-name', 'tk-button__counter--empty');
    }
    async connectedCallback() {
        if (!this.anchor) throw new Error('Compare Info: Element is missing!');
        await (0, $f8125d35cd9a4f7a$export$be9343d232c38cbb)('compareStore');
        this.store = (0, $f8125d35cd9a4f7a$export$6ccbb43953eebf8)('compareStore');
        this.unsubscribe = this.store.subscribe(()=>this.render());
        this.render();
    }
    disconnectedCallback() {
        this.unsubscribe && this.unsubscribe();
    }
    render() {
        if (this.store && this.counter) {
            const { categories: categories } = this.store.getState();
            this.anchor?.setAttribute('data-count', String(categories.length));
            if (categories.length === 0 && this.counter) this.counter?.classList.add(this.emptyClassName);
            else {
                this.counter?.classList.remove(this.emptyClassName);
                this.counter.textContent = String(categories.length);
            }
        }
    }
}



class $9cc5e30d1bc8a0e8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.viewportElement = this.closest('[data-tk-viewport]') || undefined;
    }
    connectedCallback() {
        if (!this.viewportElement) throw new Error('Status Console: Missing Viewport Element!');
        this.resize();
        this.registerViewportListener();
    }
    registerViewportListener() {
        const onResize = this.resize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: this.viewportElement,
            action: onResize
        });
    }
    resize() {
        document.documentElement.style.setProperty('--offset-top', `${this.clientHeight}px`);
    }
}





class $68fa613ad09d90db$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.cursor = this.getAttribute('data-tk-cursor') || 'pointer';
    }
    connectedCallback() {
        this.style.cursor = this.cursor;
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.copy.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: onClick
        });
    }
    async copy() {
        try {
            await navigator.clipboard.writeText(this.textContent || '');
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$39227038979f1988).messageClipboard.text);
        } catch (error) {
            console.error('Error when copying to the clipboard:', error);
        }
    }
}




class $d3f5c18545e5cabd$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.queue = [], this.activeRequests = 0;
        this.maxConcurrentRequests = Number(this.getAttribute('data-tk-max-concurrent') || 3);
    }
    async addRequest(params) {
        return new Promise((resolve, reject)=>{
            const requestItem = {
                ...params,
                resolveHandler: (data)=>{
                    params.resolveHandler(data);
                    resolve();
                },
                rejectHandler: (error)=>{
                    params.rejectHandler?.(error);
                    reject(error);
                }
            };
            this.queue.push(requestItem);
            this.processQueue();
        });
    }
    async processQueue() {
        if (this.activeRequests >= this.maxConcurrentRequests || this.queue.length === 0) return;
        const request = this.queue.shift();
        this.activeRequests += 1;
        try {
            await (0, $1653b55d89a7adce$export$d5a8517da06db2d)(request);
        } finally{
            this.activeRequests -= 1;
            this.processQueue();
        }
    }
}





const $b314948e6a7c6950$var$isValidJSON = (value)=>{
    try {
        const json = JSON.parse(value);
        return {
            isValid: true,
            json: json
        };
    } catch  {
        return {
            isValid: false
        };
    }
};
var $b314948e6a7c6950$export$2e2bcd8739ae039 = $b314948e6a7c6950$var$isValidJSON;


const $3507ba4caf4aa34e$var$parseBooleanOrString = (value)=>{
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
};
var $3507ba4caf4aa34e$export$2e2bcd8739ae039 = $3507ba4caf4aa34e$var$parseBooleanOrString;


const $bf3fdf42d85858f4$var$toSnakeCase = (input)=>input.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
var $bf3fdf42d85858f4$export$2e2bcd8739ae039 = $bf3fdf42d85858f4$var$toSnakeCase;


class $0efda1b115753384$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.hasItems = false, this.attributeList = [];
        this.trackerElement = this.closest('[data-tk-tracker-wrapper]') || undefined;
        this.event = this.getAttribute('data-tk-event') || undefined;
        this.isAsync = this.hasAttribute('data-tk-is-async');
        this.asyncAttributesURL = this.getAttribute('data-tk-async-attributes-url') || undefined;
        this.trackerType = this.getAttribute('data-tk-tracker-type') || undefined;
        this.hasItems = this.hasAttribute('data-tk-has-items');
        this.itemsKey = this.getDataAttribute('has-items', 'items');
        this.location = window.location.href;
    }
    async connectedCallback() {
        if (!this.trackerElement) throw new Error('Tracker Element is missing!');
        if (!this.event) throw new Error('Event is not defined');
        if (this.isAsync) this.init();
        else this.pushListener({
            event: 'tk-tracker-ready',
            element: this.trackerElement,
            action: this.init.bind(this)
        });
    }
    async init() {
        this.attributeList = this.extractAttributesFrom(this);
        if (this.hasItems) this.collectItemAttributes();
        await this.getAsyncAttributes();
        this.pushTracker();
    }
    extractAttributesFrom(element) {
        return Object.keys(element.dataset).filter((key)=>!key.startsWith('tk')).map((key)=>this.createAttribute(key, element.dataset[key])).filter(Boolean);
    }
    createAttribute(key, value) {
        const result = (0, $b314948e6a7c6950$export$2e2bcd8739ae039)(value);
        return {
            key: key,
            value: result.isValid ? result.json : (0, $3507ba4caf4aa34e$export$2e2bcd8739ae039)(value)
        };
    }
    collectItemAttributes() {
        const items = Array.from(this.querySelectorAll('[data-tk-item]'));
        const itemAttributes = items.map((item)=>this.extractAttributesFrom(item)).map(this.mapToSnakeCase);
        this.attributeList.push({
            key: this.itemsKey,
            value: itemAttributes
        });
    }
    mapToSnakeCase(attributes) {
        return attributes.reduce((acc, attr)=>{
            const key = (0, $bf3fdf42d85858f4$export$2e2bcd8739ae039)(attr.key);
            // Wenn der Wert ein Array ist, konvertiere ihn in einen String (z.B. JSON.stringify)
            if (Array.isArray(attr.value)) acc[key] = JSON.stringify(attr.value);
            else acc[key] = attr.value;
            return acc;
        }, {});
    }
    async getAsyncAttributes() {
        if (!this.asyncAttributesURL) return;
        await (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncAttributesURL,
            resolveHandler: this.handleAsyncAttributes.bind(this)
        });
    }
    handleAsyncAttributes(response) {
        Object.entries(response.dataAsJson.attributes).forEach(([key, value])=>{
            this.attributeList.push({
                key: value,
                value: response.dataAsJson[key]
            });
        });
    }
    pushTracker() {
        const item = {
            event: this.event,
            location: this.location,
            ...this.attributeList.reduce((acc, attr)=>{
                const key = (0, $bf3fdf42d85858f4$export$2e2bcd8739ae039)(attr.key);
                acc[key] = attr.value;
                return acc;
            }, {})
        };
        this.trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                trackerType: this.trackerType,
                item: item
            }
        }));
    }
}



class $9d20cb2aef3a6ec2$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.dialog = this.querySelector('dialog') || undefined;
        this.button = this.querySelector('button') || undefined;
        this.selectedClassName = this.getAttribute('data-selected-class-name') || 'tk-button__account--selected';
        this.alignedRightClassName = this.getAttribute('data-aligned-right-class-name') || 'tk-button__account--right';
        this.onShowEvent = ()=>{};
        this.onCloseEvent = ()=>{};
    }
    disconnectedCallback() {
        this.removeEventListener('mouseenter', this.onShowEvent);
        this.dialog?.removeEventListener('mouseleave', this.onCloseEvent);
    }
    connectedCallback() {
        this.registerOpenListener();
    }
    registerOpenListener() {
        this.onShowEvent = this.show.bind(this);
        this.addEventListener('mouseenter', this.onShowEvent);
    }
    registerCloseListener() {
        this.onCloseEvent = this.close.bind(this);
        this.addEventListener('mouseleave', this.onCloseEvent);
        this.dialog?.addEventListener('mouseleave', this.onCloseEvent);
    }
    show() {
        if (!this.dialog || !this.button) return;
        this.dialog.show();
        this.button.classList.add(this.selectedClassName);
        const { left: left } = this.button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        if (window.outerWidth <= this.dialog.clientWidth + leftPosition) this.dialog.classList.add(this.alignedRightClassName);
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    close(event) {
        if (!this.dialog || !this.button) return;
        const dialogDimensions = this.dialog.getBoundingClientRect();
        const buttonDimensions = this.button.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: dialogDimensions
            },
            {
                rectangle: buttonDimensions,
                offset: {
                    bottom: dialogDimensions.top - buttonDimensions.bottom
                }
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.button.classList.remove(this.selectedClassName);
            this.dialog.close();
        }
    }
}



class $87c9f038bb9cd227$export$2e2bcd8739ae039 extends (0, $9d20cb2aef3a6ec2$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    registerOpenListener() {
        this.onShowEvent = this.show.bind(this);
        this.addEventListener('click', this.onShowEvent);
    }
    registerCloseListener() {
        this.onCloseEvent = this.close.bind(this);
        window.addEventListener('click', this.onCloseEvent);
    }
    show() {
        if (!this.dialog) return;
        this.dialog.show();
        this.classList.add(this.selectedClassName);
        const { left: left } = this.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        if (window.outerWidth <= this.dialog.clientWidth + leftPosition) this.dialog.classList.add(this.alignedRightClassName);
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    close(event) {
        if (!this.dialog) return;
        const dialogDimensions = this.dialog.getBoundingClientRect();
        const buttonDimensions = this.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: dialogDimensions
            },
            {
                rectangle: buttonDimensions,
                offset: {
                    bottom: dialogDimensions.top - buttonDimensions.bottom
                }
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.classList.remove(this.selectedClassName);
            this.dialog.close();
        }
    }
}







var $011e7dbf949e9361$var$MessageType = /*#__PURE__*/ function(MessageType) {
    MessageType[MessageType["tooShort"] = 1] = "tooShort";
    MessageType[MessageType["dangerousString"] = 2] = "dangerousString";
    MessageType[MessageType["disallowedCharacters"] = 3] = "disallowedCharacters";
    return MessageType;
}($011e7dbf949e9361$var$MessageType || {});
const $011e7dbf949e9361$var$ALLOWED_CHARACTERS = /[^a-zA-Z0-9 äÄãÃåÅáÁàÀâÂéÉèÈêÊëËöÖóÓòÒôÔõÕüÜúÚùÙûÛìÌíÍîÎïÏñÑøØçÇß',-_.]+/;
class $011e7dbf949e9361$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorSearch = '[data-tk-search]', this.selectorSearchBackButton = '[data-tk-search-back]', this.selectorSearchResetButton = '[data-tk-search-reset]', this.selectorSearchSubmitButton = '[data-tk-search-submit]', this.selectorSearchFilterElement = '[data-tk-search-filter]', this.selectorSearchResult = '[data-tk-search-result]', this.attributeSearchMinLength = '[data-tk-search-min-input-length]', this.directSearchInputObj = {}, this.timerID = 0, this.searchTermAsUrlParam = true, this.disallowedCharacters = '';
        this.directSearchForm = this.querySelector(this.selectorSearch) || undefined;
        this.directSearchBackButton = this.querySelector(this.selectorSearchBackButton) || undefined;
        this.directSearchResetButton = this.querySelector(this.selectorSearchResetButton) || undefined;
        this.directSearchSubmitButton = this.querySelector(this.selectorSearchSubmitButton) || undefined;
        this.directSearchFilterElement = this.querySelector(this.selectorSearchFilterElement) || undefined;
        this.directSearchResult = this.querySelector(this.selectorSearchResult) || undefined;
        this.directSearchMinLength = Number(this.getAttribute(this.attributeSearchMinLength)) || 3;
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-search--active';
        this.activeResultClassName = this.getAttribute('data-tk-active-result-class-name') || 'tk-search--has-data';
        this.tooShortClassName = this.getAttribute('data-tk-too-short-class-name') || 'tk-search__result--too-short';
        this.loadingClassName = this.getAttribute('data-tk-loading-class-name') || 'tk-search__result--loading';
        this.allowedCharactersRegex = RegExp(this.getAttribute('data-tk-allowed-characters') || $011e7dbf949e9361$var$ALLOWED_CHARACTERS);
        if (!this.directSearchForm) throw new Error('TK: Missing Direct-Search');
        this.directSearchInputElement = this.directSearchForm.querySelector('input') || undefined;
        if (!this.directSearchInputElement) throw new Error('TK: Missing Direct-Search-Input');
        if (!this.directSearchResult) throw new Error('TK: Missing Direct-Search Result Wrapper');
        $011e7dbf949e9361$export$2e2bcd8739ae039.replaceToActionUrl();
    }
    connectedCallback() {
        this.registerListener();
    }
    registerListener() {
        if (this.directSearchInputElement) {
            const keyUpEventHandler = this.getSuggest.bind(this);
            const setClassEventHandler = this.setActiveClass.bind(this);
            const submitEventHandler = this.submitSearch.bind(this);
            const focusOutEventHandler = this.focusOut.bind(this);
            this.pushListener({
                event: 'submit',
                element: this.directSearchForm,
                action: submitEventHandler
            });
            this.pushListener({
                event: 'input',
                element: this.directSearchInputElement,
                action: keyUpEventHandler
            });
            this.pushListener({
                event: 'focusin',
                element: this.directSearchInputElement,
                action: setClassEventHandler
            });
            this.pushListener({
                event: 'click',
                element: window,
                action: focusOutEventHandler
            });
        }
        if (this.directSearchBackButton) {
            const navigateBackEventHandler = this.navigateBack.bind(this);
            this.pushListener({
                event: 'click',
                element: this.directSearchBackButton,
                action: navigateBackEventHandler
            });
        }
        if (this.directSearchResetButton) {
            const resetEventHandler = this.resetSearch.bind(this);
            this.pushListener({
                event: 'click',
                element: this.directSearchResetButton,
                action: resetEventHandler
            });
        }
        if (this.directSearchFilterElement) {
            const selectboxEventHandler = this.getSuggest.bind(this);
            this.pushListener({
                event: 'change',
                element: this.directSearchFilterElement,
                action: selectboxEventHandler
            });
        }
    }
    setActiveClass() {
        this.classList.add(this.activeClassName);
    }
    submitSearch(event) {
        if (!this.directSearchForm) return;
        event.preventDefault();
        this.directSearchInputObj = this.validateSearchInput();
        this.modifyDOM();
        if (!this.directSearchInputObj.valid) {
            this.classList.add(this.activeResultClassName);
            if (this.directSearchInputObj.hasDangerousString) this.setErrorMessage(2);
            else if (this.directSearchInputObj.hasDisallowedChars) this.setErrorMessage(3);
            else this.setErrorMessage(1);
            return;
        }
        this.directSearchForm.submit();
    }
    focusOut(event) {
        if (event.pointerId === -1) return;
        const fieldElement = this.directSearchInputElement;
        const resultElement = this.directSearchResult;
        if (!fieldElement || !resultElement) return;
        const fieldElementRect = fieldElement.getBoundingClientRect();
        const resultRect = resultElement.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: fieldElementRect
            },
            {
                rectangle: resultRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.classList.remove(this.activeClassName);
            this.resetSearch();
        }
    }
    setProgressBar() {
        const progressBarTpl = `
        <div class="tk-progress tk-progress--infinite tk-progress--breakout">
            <div class="tk-progress__bar"></div>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML('beforeend', progressBarTpl);
    }
    setErrorMessage(msgType) {
        let message = '';
        switch(msgType){
            case 1:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageTooShort.text.replace('%1', String(this.directSearchMinLength));
                break;
            case 2:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageDangerousString.text;
                break;
            case 3:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageDisallowedCharacter.text.replace('%1', String(this.disallowedCharacters));
                break;
            default:
                break;
        }
        const msgTpl = `
        <div class="tk-message tk-message--info tk-message--breakout">
            <span class="tk-message__icon">
                <i class="tk-icon-info"></i>
            </span>
            <span class="tk-message__label">
                ${message}
            </span>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML('beforeend', msgTpl);
    }
    setMessageTooShort() {
        const msgTpl = `
        <div class="tk-message tk-message--info tk-message--breakout">
            <span class="tk-message__icon">
                <i class="tk-icon-info"></i>
            </span>
            <span class="tk-message__label">
                ${(0, $86b3c5b6d66bd808$export$f625b980042672da).messageTooShort.text.replace('%1', String(this.directSearchMinLength))}
            </span>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML('beforeend', msgTpl);
    }
    getSuggest() {
        if (!this.directSearchResult) return;
        this.directSearchInputObj = this.validateSearchInput();
        this.modifyDOM();
        if (!this.directSearchInputObj.valid) {
            this.classList.add(this.activeResultClassName);
            if (this.directSearchInputObj.hasDangerousString) this.setErrorMessage(2);
            else if (this.directSearchInputObj.hasDisallowedChars) this.setErrorMessage(3);
            else this.setErrorMessage(1);
            return;
        }
        this.resetResultList();
        this.timerID && clearTimeout(this.timerID);
        this.timerID = window.setTimeout(()=>{
            // append Progress-Bar
            this.setProgressBar();
            // Validate again to prevent submitting empty search in the case of rapid backspace deletions.
            this.directSearchInputObj = this.validateSearchInput();
            if (!this.directSearchInputObj.valid) {
                this.resetResultList();
                this.setErrorMessage(1);
                return;
            }
            const searchData = this.setDataForRequest();
            const data = Object.fromEntries(Object.entries(searchData));
            const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: this.getDirectSearchSuggestDataFromResult.bind(this),
                payload: data
            });
        }, 500);
    }
    setDataForRequest() {
        const retVal = {
            type: 'directsearchsuggest',
            inputValue: encodeURIComponent(this.directSearchInputObj.value),
            filterAttribute: this.directSearchFilterElement?.dataset.tkSearchFilterAttribute,
            filterValue: this.directSearchFilterElement?.value
        };
        if (!this.directSearchFilterElement) {
            delete retVal.filterAttribute;
            delete retVal.filterValue;
        }
        return retVal;
    }
    getDirectSearchSuggestDataFromResult(response) {
        if (!this.directSearchResult) return;
        this.classList.add(this.activeResultClassName);
        this.directSearchResult.innerHTML = response.dataAsJson.html;
    }
    modifyDOM() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        }, {
            element: this,
            className: this.activeResultClassName
        });
        if (this.directSearchInputObj.valid) $011e7dbf949e9361$export$2e2bcd8739ae039.addClassList(classListObj);
        else this.resetResultList();
    }
    static clearClassListObj() {
        const classListObj = [];
        return classListObj;
    }
    static addClassList(items) {
        items.forEach((item)=>{
            item.element?.classList.add(item.className);
        });
    }
    static removeClassList(items) {
        items.forEach((item)=>{
            item.element?.classList.remove(item.className);
        });
    }
    resetResultList() {
        this.directSearchResult?.replaceChildren();
    }
    navigateBack() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        });
        $011e7dbf949e9361$export$2e2bcd8739ae039.removeClassList(classListObj);
    }
    resetSearch() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        }, {
            element: this,
            className: this.activeResultClassName
        });
        this.resetResultList();
        $011e7dbf949e9361$export$2e2bcd8739ae039.removeClassList(classListObj);
        this.directSearchForm?.reset();
    }
    static replaceToActionUrl() {
        const actionUrl = localStorage.getItem('searchActionUrl') ? new URL(localStorage.getItem('searchActionUrl')) : undefined;
        if (actionUrl && actionUrl.pathname === window.location.pathname) window.history.replaceState(null, 'searchActionUrl', actionUrl);
        if (actionUrl) localStorage.removeItem('searchActionUrl');
    }
    validateSearchInput() {
        const value = this.directSearchInputElement?.value.trim() || '';
        const minLength = Number(this.getAttribute('data-tk-search-min-input-length') || 3);
        const hasDangerousString = value?.includes('<');
        const hasDisallowedChars = this.hasDisallowedCharacters(value);
        return {
            minimum: minLength,
            value: value,
            valid: value.length >= minLength && !hasDangerousString && !hasDisallowedChars,
            hasDangerousString: hasDangerousString,
            hasDisallowedChars: hasDisallowedChars
        };
    }
    hasDisallowedCharacters(value) {
        if (!value) {
            this.disallowedCharacters = '';
            return false;
        }
        const character = value.match(this.allowedCharactersRegex)?.at(0) ?? '';
        this.disallowedCharacters = character;
        return Boolean(character);
    }
}




var $1943502441640b9f$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType[MessageType["tooShort"] = 1] = "tooShort";
    MessageType[MessageType["dangerousString"] = 2] = "dangerousString";
    MessageType[MessageType["disallowedCharacters"] = 3] = "disallowedCharacters";
    return MessageType;
}({});
class $1943502441640b9f$export$2e2bcd8739ae039 extends (0, $011e7dbf949e9361$export$2e2bcd8739ae039) {
    static{
        this.MessageType = $1943502441640b9f$export$80edbf15fa61a4db;
    }
    constructor(){
        super();
        this.defaultSearchUrl = this.getAttribute('data-tk-default-search-url') || '';
        this.mobileBtn = document.querySelector('[data-tk-search-mobile-btn]');
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.mobileBtn) this.registerMobileListener();
    }
    getSuggest() {
        if (!this.defaultSearchUrl) throw new Error('Missing default search url');
        if (!this.directSearchResult) return;
        this.directSearchInputObj = this.validateSearchInput();
        this.modifyDOM();
        if (!this.directSearchInputObj.valid) {
            this.classList.add(this.activeResultClassName);
            if (this.directSearchInputObj.hasDangerousString) this.setErrorMessage(2);
            else if (this.directSearchInputObj.hasDisallowedChars) this.setErrorMessage(3);
            else this.setErrorMessage(1);
            return;
        }
        this.resetResultList();
        this.timerID && clearTimeout(this.timerID);
        this.timerID = window.setTimeout(()=>{
            // append Progress-Bar
            this.setProgressBar();
            const searchData = this.setDataForRequest();
            const data = Object.fromEntries(Object.entries(searchData));
            let searchTerm = data?.inputValue;
            const minLen = Number(this.attributeSearchMinLength) || 3;
            searchTerm = (searchTerm ?? '').split('%20').filter((part)=>part.length >= minLen).join('%20');
            const url = `${this.defaultSearchUrl}?query=${searchTerm}`;
            const getSuggestAction = this.onDirectSearchSuggest.bind(this);
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: getSuggestAction,
                payload: data
            });
        }, 500);
    }
    onDirectSearchSuggest(response) {
        if (!this.directSearchResult) return;
        this.classList.add(this.activeResultClassName);
        this.directSearchResult.innerHTML = response.dataAsHtml;
    }
    registerMobileListener() {
        const searchInput = this.directSearchForm?.querySelector('input');
        if (!searchInput) return;
        const action = ()=>{
            searchInput.focus();
            this.setActiveClass();
        };
        this.pushListener({
            event: 'click',
            element: this.mobileBtn,
            action: action
        });
    }
    focusOut(event) {
        if (event.pointerId === -1) return;
        const fieldElement = this.directSearchInputElement;
        const resultElement = this.directSearchResult;
        if (!fieldElement || !resultElement) return;
        const fieldElementRect = fieldElement.getBoundingClientRect();
        const resultRect = resultElement.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: fieldElementRect
            },
            {
                rectangle: resultRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles) && event.target != this.mobileBtn) {
            this.classList.remove(this.activeClassName);
            this.resetSearch();
        }
    }
}







class $8b05e2474621c644$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            'data-count'
        ];
    }
    constructor(){
        super(), this.isDataFetched = false;
        this.headerButton = this.querySelector('[data-tk-header-button]') || undefined;
        this.counter = this.headerButton?.querySelector('[data-tk-counter-info') || undefined;
        this.overlay = this.querySelector('[data-tk-minibasket-overlay]') || undefined;
        this.contentWrapper = this.querySelector('[data-tk-minibasket-content]') || undefined;
        this.countItemsRequestURL = this.getAttribute('data-tk-count-items-request-url') || undefined;
        this.getContentRequestURL = this.getAttribute('data-tk-get-content-request-url') || undefined;
        this.counterEmptyClassName = this.getAttribute('data-tk-counter-empty-class-name') || 'tk-button__counter--empty';
        this.offset = Number(this.getAttribute('data-tk-minibasket-offset')) || 4;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-minibasket--open';
        this.minDistanceToBorder = Number(this.getAttribute('data-tk-min-distance-to-border')) || 5;
        // Custom Events
        this.openedEventName = this.getAttribute('data-tk-event-opened-name') || 'tk-minibasket-opened';
        this.openedEvent = new CustomEvent(this.openedEventName);
        this.closedEventName = this.getAttribute('data-tk-event-closed-name') || 'tk-minibasket-closed';
        this.closedEvent = new CustomEvent(this.closedEventName);
        this.updateEventName = this.getAttribute('data-tk-event-update-name') || 'tk-minibasket-update';
        this.updateEvent = new CustomEvent(this.updateEventName);
    }
    connectedCallback() {
        if (!this.headerButton) throw new Error('Minibasket: Header Button is missing!');
        if (!this.countItemsRequestURL || !this.getContentRequestURL) throw new Error('Minibasket: Request URLs are missing!');
        this.registerInitializeListener();
        this.fetchQuantity();
    }
    attributeChangedCallback(name, _oldValue, newValue) {
        if (name === 'data-count') this.setCounter(Number(newValue));
    }
    registerInitializeListener() {
        const handleOpen = this.open.bind(this);
        this.pushListener({
            event: 'click',
            element: this.headerButton,
            action: handleOpen
        });
        const handleOpened = this.opened.bind(this);
        this.pushListener({
            event: this.openedEventName,
            element: this,
            action: handleOpened
        });
        const handleUpdate = this.update.bind(this);
        this.pushListener({
            event: this.updateEventName,
            element: this,
            action: handleUpdate
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
    }
    registerScrollListener() {
        const handleScroll = this.alignOverlayToButton.bind(this);
        this.pushListener({
            event: 'scroll',
            element: window,
            action: handleScroll
        });
    }
    open() {
        document.body.insertAdjacentElement('beforeend', this.overlay);
        this.overlay.classList.add(this.openClassName);
        this.alignOverlayToButton();
        !this.isDataFetched && this.fetchAll();
        this.dispatchEvent(this.openedEvent);
    }
    opened() {
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
            this.registerScrollListener();
        }, 0);
    }
    update() {
        this.fetchQuantity();
        this.fetchAll();
    }
    close(event) {
        if (!this.overlay) return;
        const headerButtonRect = this.headerButton.getBoundingClientRect();
        const overlayRect = this.overlay.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: headerButtonRect
            },
            {
                rectangle: overlayRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.overlay.classList.remove(this.openClassName);
            this.dispatchEvent(this.closedEvent);
            this.removeListener(window);
        }
    }
    fetchAll() {
        Promise.all([
            $8b05e2474621c644$export$2e2bcd8739ae039.fetchData(this.getContentRequestURL)
        ]).then((responses)=>{
            this.isDataFetched = true;
            this.placeContent(responses[0]);
        }).catch(()=>{
            this.isDataFetched = false;
        });
    }
    fetchQuantity() {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.countItemsRequestURL,
            resolveHandler: this.getQuantity.bind(this)
        });
    }
    static fetchData(url) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    getQuantity(response) {
        if (!response || !response.success) return;
        const { quantity: quantity } = response.dataAsJson;
        this.setCounter(quantity);
    }
    setCounter(quantity) {
        if (quantity === 0) this.counter?.classList.add(this.counterEmptyClassName);
        else {
            this.headerButton?.setAttribute('data-count', `${quantity || 0}`);
            this.counter?.classList.remove(this.counterEmptyClassName);
            if (this.counter) this.counter.textContent = `${quantity}`;
        }
    }
    placeContent(response) {
        if (!response || !response.success) return;
        if (!this.contentWrapper) return;
        const items = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.contentWrapper.innerHTML = '';
        this.contentWrapper.insertAdjacentHTML('beforeend', items.innerHTML);
    }
    alignOverlayToButton() {
        const { bottom: bottom, right: right } = this.headerButton.getBoundingClientRect();
        const { width: width } = this.overlay.getBoundingClientRect();
        const distanceToBorder = right - width;
        this.overlay.style.top = `${bottom + this.offset}px`;
        if (distanceToBorder >= this.minDistanceToBorder) this.overlay.style.left = `${right - width}px`;
        else {
            this.overlay.style.left = '50%';
            this.overlay.style.transform = 'translateX(-50%)';
        }
    }
}


class $ba0287e7c80bda20$export$2e2bcd8739ae039 extends (0, $8b05e2474621c644$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.amountRequestURL = this.getAttribute('data-tk-amount-request-url') || undefined;
        this.amountDisplay = this.querySelector('[data-tk-amount-info]') || undefined;
        this.amountEmptyClass = this.getAttribute('data-tk-amount-empty-class-name') || 'tk-button__amount--empty';
        this.priceVisible = this.getAttribute('data-tk-price-visible') !== '0';
    }
    connectedCallback() {
        super.connectedCallback();
        this.fetchAmount();
    }
    fetchAmount() {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.amountRequestURL,
            resolveHandler: this.setAmount.bind(this)
        });
    }
    setAmount(response) {
        if (!response || !response.success) return;
        const { amount: amount, currency: currency } = response.dataAsJson;
        if (parseInt(amount) === 0 || !this.priceVisible) this.amountDisplay?.classList.add(this.amountEmptyClass);
        else {
            this.headerButton?.setAttribute('data-amount', `${currency} ${amount || 0}`);
            this.amountDisplay?.classList.remove(this.amountEmptyClass);
            if (this.amountDisplay) this.amountDisplay.textContent = `${currency} ${amount}`;
        }
    }
    update() {
        this.fetchAmount();
        this.fetchQuantity();
        this.fetchAll();
    }
}





class $c7b0de4494db348b$export$2e2bcd8739ae039 extends (0, $ad2181492f474118$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    connectedCallback() {
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            stockPeriodType: this.stockPeriodType,
            artUnitType: this.artUnitType,
            element: this
        };
        if (this.articleList && (!this.isAsyncTile || this.loadingType === '2')) this.sendDataToArticleList(item);
        else this.handleStock(item);
    }
    handleStock(item) {
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsJSONString([
            item
        ]) : (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsEntrypoint([
            item
        ]);
        const data = {
            type: 'stock',
            arttype: 'single',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this)
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    refreshStock(item, responseItem) {
        const { html: html, nextReceipt: nextReceipt } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? atob(html) : html;
        const tooltip = this.querySelector('tk-tooltip');
        tooltip && tooltip.remove();
        this.insertAdjacentHTML('beforeend', htmlString);
        if (nextReceipt) {
            const nextReceiptString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(nextReceipt) ? atob(nextReceipt) : nextReceipt;
            this.insertAdjacentHTML('afterend', nextReceiptString);
        }
    }
}




class $1de4bc533e624441$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.requestURL = this.getAttribute('data-tk-url') || undefined;
        this.checkbox = this.querySelector('#price-control') || undefined;
    }
    connectedCallback() {
        if (!this.requestURL) throw new Error('DIWPriceControl: Missung URL');
        if (!this.checkbox) throw new Error('DIWPriceControl: Missung Switch');
        const action = this.togglePriceVisibility.bind(this);
        this.pushListener({
            event: 'change',
            element: this.checkbox,
            action: action
        });
    }
    togglePriceVisibility() {
        const payload = {
            'price-control': `${Number(this.checkbox.checked)}`
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.requestURL,
            resolveHandler: this.handlePriceChange.bind(this),
            payload: payload
        });
    }
    handlePriceChange(response) {
        const success = response.dataAsJson.success;
        if (!success) throw new Error('DIWPriceControl: Sessionvar could not be set');
        window.location.reload();
    }
}





const $7cf802f14f3a63bb$var$QUANTITY_ATTR = 'data-quantity';
class $7cf802f14f3a63bb$export$2e2bcd8739ae039 extends (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            $7cf802f14f3a63bb$var$QUANTITY_ATTR
        ];
    }
    constructor(){
        super();
        this.quantity = Number(this.getAttribute($7cf802f14f3a63bb$var$QUANTITY_ATTR)) || undefined;
        this.requestURL = this.getAttribute('data-tk-request-url') || undefined;
    }
    connectedCallback() {
        if (!this.requestURL) return;
        this.item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: this
        };
        this.loadingType === '2' ? this.registerHoverListener() : this.handlePrice();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === $7cf802f14f3a63bb$var$QUANTITY_ATTR) {
            const quantity = Number(newValue);
            this.quantity = quantity;
            this.handlePrice();
        }
    }
    handlePrice() {
        const data = {
            quantity: String(this.quantity || 1)
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.requestURL,
            resolveHandler: this.updatePrice.bind(this),
            payload: data
        });
    }
    updatePrice(response) {
        const priceElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        if (priceElement.querySelector('[data-tk-price-promotion]')) this.classList.add(this.isPromotionClassName);
        this.innerHTML = priceElement.innerHTML;
    }
}




class $6d1c1bebccef2c7f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.form = this.querySelector('form') || undefined;
        this.fieldsContainer = this.querySelector('[data-tk-fields-container]') || undefined;
        this.fieldCount = this.fieldsContainer?.childElementCount || 1;
        this.addFieldButton = this.form?.querySelector('[data-tk-add-field]') || undefined;
        this.deleteFieldButtons = Array.from(this.querySelectorAll('[data-tk-delete]')) || undefined;
        this.template = this.querySelector('[data-tk-field-template]') || undefined;
        this.type = this.getAttribute('data-tk-type') || 'editlinks';
        this.existingData = this.getAttribute('data-tk-existing-data') || undefined;
    }
    connectedCallback() {
        if (!this.form || this.type == 'editlinks' && !this.fieldsContainer) throw new Error('DIWLinks: form or fields container not found');
        this.pushListener({
            event: 'submit',
            element: this.form,
            action: this.handleSubmit.bind(this)
        });
        if (this.addFieldButton && this.template) this.pushListener({
            event: 'click',
            element: this.addFieldButton,
            action: this.addField.bind(this)
        });
        this.registerDeleteButtons(this.deleteFieldButtons);
    }
    registerDeleteButtons(btns) {
        btns.forEach((btn)=>{
            this.pushListener({
                event: 'click',
                element: btn,
                action: this.deleteField.bind(this)
            });
        });
    }
    addField(e) {
        e.preventDefault();
        this.fieldCount++;
        if (!this.template) throw new Error('DIWLinks: template not found');
        const clone = this.template.content.cloneNode(true);
        // Replace {{ID}} placeholders in all attributes
        Array.from(clone.querySelectorAll('*')).forEach((element)=>{
            Array.from(element.attributes).forEach((attr)=>{
                attr.value = attr.value.replace(/\{\{ID\}\}/g, String(this.fieldCount));
            });
        });
        this.fieldsContainer.appendChild(clone);
        this.registerDeleteButtons(Array.from(this.fieldsContainer.lastElementChild.querySelectorAll('[data-tk-delete]')));
    }
    deleteField(e) {
        const target = e.target;
        const fieldset = target.closest('[data-tk-fieldset]');
        fieldset && fieldset.remove();
    }
    handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(this.form);
        let items = [];
        // Group entries by field number to pair name with link
        const fieldMap = new Map();
        formData.forEach((value, key)=>{
            const [fieldType, fieldNum] = key.split('-').slice(-2);
            if (!fieldMap.has(fieldNum)) fieldMap.set(fieldNum, {});
            if (fieldType == 'link') value = value.toString().split(window.location.host)[1] || value;
            fieldMap.get(fieldNum)[fieldType] = String(value);
        });
        fieldMap.forEach((field)=>{
            if (field.name && field.link) items.push(field);
        });
        console.log(items);
        if (this.type === 'addpage' && this.existingData) {
            const existingJson = JSON.parse(this.existingData).items;
            items = existingJson.concat(items);
        }
        const payload = {
            data: JSON.stringify({
                items: items
            })
        };
        console.log(payload);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.form.action,
            resolveHandler: this.updateLinks.bind(this),
            payload: payload
        });
    }
    updateLinks() {
        window.location.reload();
    }
}




var $fe64c06a372e274b$export$bcd15065bd7fecf6 = /*#__PURE__*/ function(SortDirectionEnum) {
    SortDirectionEnum["ASC"] = "ASC";
    SortDirectionEnum["DESC"] = "DESC";
    return SortDirectionEnum;
}({});
const $fe64c06a372e274b$export$633da1651c3bd3f9 = (a, b, direction)=>direction.toUpperCase() === "DESC" ? b.localeCompare(a) : a.localeCompare(b);
const $fe64c06a372e274b$export$dcb32d3e7e407924 = (a, b, direction)=>{
    const numberA = Number(a);
    const numberB = Number(b);
    return direction.toUpperCase() === "DESC" ? numberB - numberA : numberA - numberB;
};
const $fe64c06a372e274b$export$c4c806e061935577 = (a, b, direction)=>{
    const dateFormattedA = a.split('.').reverse().join('-');
    const dateFormattedB = b.split('.').reverse().join('-');
    const dateA = Date.parse(dateFormattedA);
    const dateB = Date.parse(dateFormattedB);
    return direction.toUpperCase() === "DESC" ? dateB - dateA : dateA - dateB;
};
const $fe64c06a372e274b$export$15d252ed5f5f8636 = (a, b, direction)=>{
    const dateA = new Date();
    const dateB = new Date();
    const splittedA = a.split(':').map((item)=>Number(item));
    const splittedB = b.split(':').map((item)=>Number(item));
    dateA.setHours(splittedA.at(0) || 0, splittedA.at(1), splittedA.at(2));
    dateB.setHours(splittedB.at(0) || 0, splittedB.at(1), splittedB.at(2));
    const timeA = dateA.getTime();
    const timeB = dateB.getTime();
    return direction.toUpperCase() === "DESC" ? timeB - timeA : timeA - timeB;
};
const $fe64c06a372e274b$export$ed1371d464d87bcf = (a, b, direction)=>{
    const timeStampListA = a.split(' ');
    const timeStampListB = b.split(' ');
    const dateA = timeStampListA.at(0)?.split('.').reverse().join('-');
    const dateB = timeStampListB.at(0)?.split('.').reverse().join('-');
    const timeA = timeStampListA.at(1);
    const timeB = timeStampListB.at(1);
    const timestampA = Date.parse(`${dateA}T${timeA}`);
    const timestampB = Date.parse(`${dateB}T${timeB}`);
    return direction.toUpperCase() === "DESC" ? timestampB - timestampA : timestampA - timestampB;
};
const $fe64c06a372e274b$export$92f3520fe1ac7383 = (a, b, direction)=>{
    const booleanA = Boolean(a);
    const booleanB = Boolean(b);
    const numberA = Number(booleanA);
    const numberB = Number(booleanB);
    return direction === "DESC" ? numberB - numberA : numberA - numberB;
};



var $2595e2ca594d6789$var$DataMaster = /*#__PURE__*/ function(DataMaster) {
    DataMaster["CLIENT"] = "client";
    return DataMaster;
}($2595e2ca594d6789$var$DataMaster || {});
class $2595e2ca594d6789$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.gridTemplateColList = [], this.hasAccordionRows = false, this.isHorizontalScrollable = false;
        this.headElement = this.querySelector('[data-tk-table-head]') || undefined;
        if (!this.headElement) throw new Error('Table: Head is missing!');
        this.rowHeadElement = this.headElement.querySelector('[data-tk-table-row]') || undefined;
        this.headShadowClassName = this.getAttribute('data-tk-head-shadow-class-name') || 'tk-table__head-shadow';
        this.isStickyLeft = this.hasAttribute('data-tk-is-sticky-left');
        this.isStickyHead = this.hasAttribute('data-tk-is-sticky-head');
        this.gridTemplateMobile = this.getAttribute('data-tk-grid-template-mobile') || '1fr';
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-table--loaded';
        this.stickyLeftClassname = this.getAttribute('data-tk-sticky-left-class-name') || 'tk-table--sticky-left';
        this.rightShadowClassName = this.getAttribute('data-tk-right-shadow-class-name') || 'tk-table__right-shadow';
        this.stickyHeadClassName = this.getAttribute('data-tk-sticky-head-class-name') || 'tk-table--sticky-head';
        this.customCols = this.getAttribute('data-tk-col-width') || 'auto';
        this.observer = new ResizeObserver(this.handleResize.bind(this));
        this.desktopMinWidth = Number(this.getAttribute('data-tk-desktop-min-width')) || 992;
        this.rowLinkSelector = 'data-tk-table-row-link';
        this.table = this.querySelector('table') || undefined;
        this.ascSortClassName = this.getAttribute('data-tk-asc-sort-class-name') || 'tk-table--sort-asc';
        this.descSortClassName = this.getAttribute('data-tk-desc-sort-class-name') || 'tk-table--sort-desc';
        this.isSortTable = Boolean(this.table?.hasAttribute('data-tk-table-sort'));
        this.colAlignStart = this.hasAttribute('data-tk-col-align-start');
        this.colAlignStartClassName = this.getAttribute('data-tk-col-align-start-class-name') || 'tk-table__col--align-left';
        this.colItemAlignCenter = this.hasAttribute('data-tk-col-item-align-center');
        this.colItemAlignCenterClassName = this.getAttribute('data-tk-col-item-align-center-class-name') || 'tk-table__col--item-align-center';
        this.colItemAlignStart = this.hasAttribute('data-tk-col-item-align-start');
        this.colItemAlignStartClassName = this.getAttribute('data-tk-col-item-align-start-class-name') || 'tk-table__col--item-align-start';
        this.colItemAlignEnd = this.hasAttribute('data-tk-col-item-align-end');
        this.colItemAlignEndClassName = this.getAttribute('data-tk-col-item-align-end-class-name') || 'tk-table__col--item-align-end';
        this.tableSelector = '[data-tk-table-sort]';
        this.sortDirectionSelector = '[data-tk-sort-direction]';
        this.tkSortDirectionSelector = 'tkSortDirection';
        this.tkSortAttrSelector = 'tkSortAttr';
        this.tkSortDatatypeSelector = 'tkSortDatatype';
        this.dataMasterSelector = 'data-tk-datamaster';
        this.dataSortAttrSelector = 'data-tk-sort-attr';
        this.hasAccordionRows = this.hasAttribute('data-tk-accordion-rows');
        this.accordionRowHeadActiveClassName = this.getDataAttribute('accordion-row-head-active-class-name', 'tk-table__row--head-accordion-active');
        this.accordionRowBodyActiveClassName = this.getDataAttribute('accordion-row-body-active-class-name', 'tk-table__row--body-accordion-active');
        this.accordionLastElementClassName = this.getDataAttribute('accordion-last-element-class-name', 'tk-table--accordion-last-row');
    }
    connectedCallback() {
        this.classList.add(this.loadedClassName);
        window.viewport.clientWidth < this.desktopMinWidth ? this.setGridMobile() : this.setGrid();
        this.registerViewportListener();
        this.registerScrollListener();
        this.registerRowLinkListener();
        this.observer.observe(this);
        this.isStickyHead && this.setStickyHead();
        this.isSortTable && this.registerTableHeadListener();
        this.colAlignStart && this.setColAlignStart();
        this.colItemAlignCenter && this.setColItemAlign(this.colItemAlignCenterClassName);
        this.colItemAlignStart && this.setColItemAlign(this.colItemAlignStartClassName);
        this.colItemAlignEnd && this.setColItemAlign(this.colItemAlignEndClassName);
        this.hasAccordionRows && this.registerAccordionListener();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observer.unobserve(this);
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.desktopMinWidth) this.setGridMobile();
        else this.setGrid();
    }
    registerScrollListener() {
        const action = this.handleScrollBehavior.bind(this);
        this.pushListener({
            event: 'scroll',
            element: this,
            action: action
        });
    }
    registerTableHeadListener() {
        const handleSortTable = this.handleSortTable.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleSortTable
        });
    }
    registerRowLinkListener() {
        const handleRowLink = this.handleRowLink.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleRowLink
        });
    }
    registerAccordionListener() {
        const onClick = this.handleAccordion.bind(this);
        const rows = this.querySelectorAll('[data-tk-table-row-id]');
        rows.forEach((row)=>{
            this.pushListener({
                event: 'click',
                element: row,
                action: onClick
            });
        });
    }
    handleScrollBehavior(event) {
        this.toggleScrollHorizontalBehavior(event);
        if (this.isStickyLeft) this.toggleScrollLeftBehavior(event);
        if (this.isStickyHead) this.toggleScrollTopBehavior(event);
    }
    handleRowLink(event) {
        const target = event.target;
        if (target.closest('a')) return;
        if (target.closest('button')) return;
        const row = target.closest(`[${this.rowLinkSelector}]`);
        if (!row) return;
        const link = row.getAttribute(this.rowLinkSelector);
        if (!link) return;
        window.location.href = link;
    }
    handleSortTable(event) {
        if (!event) return;
        const target = event.target;
        const column = target.closest('th');
        column && column.hasAttribute('data-tk-sort-direction') && this.sortTable(column);
    }
    handleResize(entries) {
        entries.forEach(()=>{
            this.isHorizontalScrollable = this.scrollWidth > this.clientWidth;
            if (this.isHorizontalScrollable && !this.horizontalScrollShadowElement) this.setHorizontalScrollShadow();
            if (!this.horizontalScrollShadowElement) return;
            this.horizontalScrollShadowElement.hidden = !this.isHorizontalScrollable;
            this.boxShadowElement && (this.boxShadowElement.style.width = `${this.scrollWidth}px`);
        });
    }
    setGrid() {
        if (!this.rowHeadElement) return;
        const cols = this.rowHeadElement.childElementCount;
        this.gridTemplateColList = this.customCols?.split(/(?!, ),/g);
        this.style.gridTemplateColumns = this.customCols?.includes(',') ? this.gridTemplateColList?.join(' ') : `repeat(${cols}, ${this.customCols})`;
        if (this.headElement) this.headElement.classList.remove('tk-table__head--force-mobile');
        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.remove('tk-table__title--force-mobile');
        });
    }
    setGridMobile() {
        this.style.gridTemplateColumns = this.gridTemplateMobile;
        if (this.headElement) this.headElement.classList.add('tk-table__head--force-mobile');
        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.add('tk-table__title--force-mobile');
        });
    }
    toggleScrollLeftBehavior(event) {
        const element = event.target;
        this.classList.toggle(this.stickyLeftClassname, element.scrollLeft > 0);
    }
    toggleScrollHorizontalBehavior(event) {
        if (!this.horizontalScrollShadowElement) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = event.target;
        this.horizontalScrollShadowElement.hidden = scrollLeft >= scrollWidth - clientWidth;
        this.horizontalScrollShadowElement.style.right = `-${scrollLeft}px`;
    }
    toggleScrollTopBehavior(event) {
        if (!this.boxShadowElement) return;
        const element = event.target;
        this.boxShadowElement.hidden = element.scrollTop === 0;
        this.classList.toggle(this.stickyHeadClassName, element.scrollTop > 0);
        this.boxShadowElement.style.top = `${element.scrollTop}px`;
    }
    setStickyHead() {
        if (!this.headElement) return;
        this.boxShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.headShadowClassName}' hidden></div>`);
        if (!this.boxShadowElement) return;
        const column = this.rowHeadElement?.firstElementChild;
        const height = column?.getBoundingClientRect().height || 0;
        this.boxShadowElement.style.width = `${this.scrollWidth}px`;
        this.boxShadowElement.style.height = `${height}px`;
        this.headElement.insertAdjacentElement('afterbegin', this.boxShadowElement);
    }
    setHorizontalScrollShadow() {
        this.horizontalScrollShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.rightShadowClassName}'></div>`);
        if (!this.horizontalScrollShadowElement) return;
        this.insertAdjacentElement('beforeend', this.horizontalScrollShadowElement);
    }
    sortTable(column) {
        const dataMaster = this.table?.getAttribute(this.dataMasterSelector);
        if (dataMaster === "client") {
            this.setOrToggleSortDirection(column);
            this.clearHeadElementClassList(column);
            this.clientSortTable({
                element: column,
                type: column.dataset[this.tkSortDatatypeSelector],
                sortDirection: column.dataset[this.tkSortDirectionSelector],
                column: column.cellIndex
            });
            this.postAsynClientSortState(column);
        } else this.serverAsynTableSortRequest(column);
    }
    clientSortTable(headItem) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const rows = tableBody.querySelectorAll('[data-tk-table-row]');
        if (!rows) return;
        const rowList = Array.from(rows).map((element)=>{
            const value = Array.from(element.querySelectorAll('[data-tk-table-value]')).at(headItem.column)?.textContent || '';
            return {
                element: element,
                value: value
            };
        });
        const sortTypes = {
            A: (a, b)=>(0, $fe64c06a372e274b$export$633da1651c3bd3f9)(a, b, headItem.sortDirection),
            N: (a, b)=>(0, $fe64c06a372e274b$export$dcb32d3e7e407924)(a, b, headItem.sortDirection),
            D: (a, b)=>(0, $fe64c06a372e274b$export$c4c806e061935577)(a, b, headItem.sortDirection),
            H: (a, b)=>(0, $fe64c06a372e274b$export$15d252ed5f5f8636)(a, b, headItem.sortDirection),
            S: (a, b)=>(0, $fe64c06a372e274b$export$ed1371d464d87bcf)(a, b, headItem.sortDirection),
            B: (a, b)=>(0, $fe64c06a372e274b$export$92f3520fe1ac7383)(a, b, headItem.sortDirection)
        };
        const sortedList = rowList.sort((a, b)=>sortTypes[headItem.type](a.value, b.value));
        tableBody.innerHTML = '';
        sortedList.forEach((item)=>{
            tableBody.appendChild(item.element);
        });
        if (headItem.element.classList.contains(this.ascSortClassName) || headItem.element.classList.contains(this.descSortClassName)) headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.replace(this.ascSortClassName, this.descSortClassName) : headItem.element.classList.replace(this.descSortClassName, this.ascSortClassName);
        else headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.add(this.descSortClassName) : headItem.element.classList.add(this.ascSortClassName);
    }
    clearHeadElementClassList(column) {
        if (!this.rowHeadElement) return;
        const head = Array.from(this.rowHeadElement.children);
        const filteredHead = head.filter((item)=>item !== column);
        filteredHead.forEach((child)=>{
            const element = child;
            element.classList.remove(this.ascSortClassName);
            element.classList.remove(this.descSortClassName);
        });
    }
    setOrToggleSortDirection(thElement) {
        this.removeUnseletectedSortDir(thElement);
        // toggelt direction auf geklickten header spalte
        thElement.dataset[this.tkSortDirectionSelector] = thElement.dataset[this.tkSortDirectionSelector] === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC ? (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC : (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC;
    }
    serverAsynTableSortRequest(thElement) {
        this.setOrToggleSortDirection(thElement);
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.asyncTableSortHandler.bind(this),
            payload: options
        });
    }
    postAsynClientSortState(thElement) {
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: ()=>{},
            payload: options
        });
    }
    asyncTableSortHandler(response) {
        if (!response.success || !response.dataAsHtml) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.replaceAllResponseTable(html);
    }
    replaceAllResponseTable(element) {
        const oldTables = document.querySelectorAll(this.tableSelector);
        const newTables = element.querySelectorAll(this.tableSelector);
        oldTables.forEach((oldTable)=>{
            const correspondingNewTable = Array.from(newTables).find((newTable)=>oldTable.id === newTable.id);
            if (correspondingNewTable) oldTable?.parentNode?.replaceChild(correspondingNewTable, oldTable);
        });
    }
    getAsynPostOptions(thElement) {
        const table = thElement.closest(this.tableSelector);
        if (!table) return {};
        const client = table.getAttribute(this.dataMasterSelector);
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const sortDirection = thElement.dataset[this.tkSortDirectionSelector];
        const options = {
            type: 'tablesort',
            clientSort: String(!!client),
            tableid: table.id,
            sorting: `{"${sortAttribut}":"${sortDirection}"}`
        };
        return options;
    }
    removeUnseletectedSortDir(thElement) {
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const table = thElement.closest(this.tableSelector);
        if (!table) return;
        const headers = table.querySelectorAll(this.sortDirectionSelector);
        headers.forEach((header)=>{
            const headerSortAttr = header.dataset[this.tkSortAttrSelector];
            if (headerSortAttr === sortAttribut) return;
            header.dataset[this.tkSortDirectionSelector] = '';
        });
    }
    setColAlignStart() {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll('[data-tk-table-row] td');
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(this.colAlignStartClassName);
        });
    }
    setColItemAlign(className) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll('[data-tk-table-row] td');
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(className);
        });
    }
    handleAccordion(event) {
        const headElement = event.currentTarget;
        const id = headElement.getAttribute('data-tk-table-row-id');
        if (!id) return;
        const bodyElements = this.querySelectorAll(`[data-tk-table-accordion="${id}"]`);
        const isActive = headElement.classList.toggle(this.accordionRowHeadActiveClassName);
        bodyElements.forEach((element, index)=>{
            element.hidden = !isActive;
            element.classList.toggle(this.accordionRowBodyActiveClassName, isActive);
            if (index === bodyElements.length - 1) element.classList.add(this.accordionLastElementClassName);
        });
    }
}


/**
 * Enumeration of video sources that can be used in video editables.
 */ var $8da060ca62730502$export$f3a17123d80000c5 = /*#__PURE__*/ function(VideoSource) {
    VideoSource["YOUTUBE"] = "YOUTUBE";
    VideoSource["VIMEO"] = "VIMEO";
    VideoSource["DAILYMOTION"] = "DAILYMOTION";
    VideoSource["TIKTOK"] = "TIKTOK";
    VideoSource["FACEBOOK"] = "FACEBOOK";
    return VideoSource;
}({});


/**
 * Options for the `diffDOM` function.
 */ function $da8ead2273adf04f$export$f6a286c942d22c53(container, newHtmlString, options = {}) {
    const { preserveFocus: preserveFocus = false, wrapMultipleRoots: wrapMultipleRoots = false } = options;
    const template = document.createElement('template');
    template.innerHTML = newHtmlString.trim();
    const fragment = template.content;
    const active = preserveFocus ? document.activeElement : null;
    if (wrapMultipleRoots) {
        container.innerHTML = '';
        container.appendChild(fragment.cloneNode(true));
    } else {
        const newNode = fragment.firstElementChild;
        if (!newNode) return;
        if (container.firstElementChild) $da8ead2273adf04f$var$patch(container.firstElementChild, newNode);
        else container.appendChild(newNode.cloneNode(true));
    }
    if (preserveFocus && active && document.body.contains(active)) active.focus();
}
/**
 * Recursively patches an old DOM node to match a new one by updating only what is necessary.
 *
 * @param {Node} oldNode - The existing DOM node.
 * @param {Node} newNode - The new DOM node to match.
 */ function $da8ead2273adf04f$var$patch(oldNode, newNode) {
    if (oldNode.nodeType !== newNode.nodeType) {
        oldNode.replaceWith(newNode.cloneNode(true));
        return;
    }
    if (oldNode.nodeType === Node.TEXT_NODE) {
        if (oldNode.textContent !== newNode.textContent) oldNode.textContent = newNode.textContent;
        return;
    }
    const oldEl = oldNode;
    const newEl = newNode;
    if (oldEl.nodeName !== newEl.nodeName) {
        oldEl.replaceWith(newEl.cloneNode(true));
        return;
    }
    $da8ead2273adf04f$var$updateAttributes(oldEl, newEl);
    $da8ead2273adf04f$var$patchChildren(oldEl, newEl);
}
/**
 * Updates the attributes of an existing element to match those of a new element.
 *
 * @param {Element} oldEl - The element whose attributes will be updated.
 * @param {Element} newEl - The element whose attributes will be used as reference.
 */ function $da8ead2273adf04f$var$updateAttributes(oldEl, newEl) {
    const oldAttrs = oldEl.attributes;
    const newAttrs = newEl.attributes;
    // Remove attributes that no longer exist
    for(let i = oldAttrs.length - 1; i >= 0; i--){
        const attr = oldAttrs[i];
        if (!newEl.hasAttribute(attr.name)) oldEl.removeAttribute(attr.name);
    }
    // Add new attributes or update existing ones
    for(let i = 0; i < newAttrs.length; i++){
        const attr = newAttrs[i];
        if (oldEl.getAttribute(attr.name) !== attr.value) oldEl.setAttribute(attr.name, attr.value);
    }
    // Sync specific form element properties
    if (oldEl instanceof HTMLInputElement && newEl instanceof HTMLInputElement) {
        oldEl.checked = newEl.checked;
        oldEl.value = newEl.value;
    } else if (oldEl instanceof HTMLTextAreaElement && newEl instanceof HTMLTextAreaElement) oldEl.value = newEl.value;
    else if (oldEl instanceof HTMLSelectElement && newEl instanceof HTMLSelectElement) oldEl.value = newEl.value;
}
/**
 * Diffs and updates the child nodes of a given element.
 *
 * @param {Element} oldEl - The existing DOM element whose children will be patched.
 * @param {Element} newEl - The new DOM element to use as a reference for children.
 */ function $da8ead2273adf04f$var$patchChildren(oldEl, newEl) {
    const oldChildren = Array.from(oldEl.childNodes);
    const newChildren = Array.from(newEl.childNodes);
    const max = Math.max(oldChildren.length, newChildren.length);
    for(let i = 0; i < max; i++){
        const oldChild = oldChildren[i];
        const newChild = newChildren[i];
        if (!oldChild && newChild) oldEl.appendChild(newChild.cloneNode(true));
        else if (oldChild && !newChild) oldEl.removeChild(oldChild);
        else if (oldChild && newChild) $da8ead2273adf04f$var$patch(oldChild, newChild);
    }
}




function $f0816450e263ddf9$export$408a51f74a282ac(url) {
    try {
        const u = new URL(url);
        const host = u.hostname.replace('www.', '').toLowerCase();
        let source = null;
        let id = null;
        // 🟥 YouTube
        if (host.includes('youtube.com') || host.includes('youtu.be')) {
            source = (0, $8da060ca62730502$export$f3a17123d80000c5).YOUTUBE;
            if (u.searchParams.has('v')) id = u.searchParams.get('v');
            else if (u.pathname.startsWith('/embed/')) id = u.pathname.split('/embed/')[1];
            else if (u.pathname.startsWith('/shorts/')) id = u.pathname.split('/shorts/')[1];
            else id = u.pathname.slice(1);
        } else if (host.includes('vimeo.com')) {
            source = (0, $8da060ca62730502$export$f3a17123d80000c5).VIMEO;
            const parts = u.pathname.split('/');
            id = parts.pop() || parts.pop() || null; // handle trailing slash
        } else if (host.includes('dailymotion.com') || host.includes('dai.ly')) {
            source = (0, $8da060ca62730502$export$f3a17123d80000c5).DAILYMOTION;
            const match = u.pathname.match(/video\/([^_/?]+)/) || u.pathname.match(/^\/([^_/?]+)/);
            id = match ? match[1] : null;
        } else if (host.includes('tiktok.com')) {
            source = (0, $8da060ca62730502$export$f3a17123d80000c5).TIKTOK;
            const match = u.pathname.match(/\/video\/(\d+)/) || u.pathname.match(/\/v2\/(\d+)/);
            id = match ? match[1] : null;
        } else if (host.includes('facebook.com')) {
            source = (0, $8da060ca62730502$export$f3a17123d80000c5).FACEBOOK;
            if (u.searchParams.has('v')) id = u.searchParams.get('v');
            else {
                const match = u.pathname.match(/\/videos\/(\d+)/);
                id = match ? match[1] : null;
            }
        }
        return {
            source: source,
            id: id
        };
    } catch  {
        return {
            source: null,
            id: null
        };
    }
}
function $f0816450e263ddf9$export$5ecdddc5bf218cde(value) {
    const videoEmbedElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(value);
    const url = videoEmbedElement.getAttribute('data-url');
    const parsedVideo = url ? $f0816450e263ddf9$export$408a51f74a282ac(url) : {
        source: null,
        id: null
    };
    return {
        source: parsedVideo.source || (0, $8da060ca62730502$export$f3a17123d80000c5).YOUTUBE,
        sourceId: parsedVideo.id || '',
        thumbnail: videoEmbedElement.getAttribute('data-thumbnail-url') || '',
        title: videoEmbedElement.getAttribute('data-title') || '',
        description: videoEmbedElement.getAttribute('data-description') || '',
        autoplay: videoEmbedElement.hasAttribute('data-autoplay'),
        loop: videoEmbedElement.hasAttribute('data-loop'),
        muted: videoEmbedElement.hasAttribute('data-muted')
    };
}



class $b1129966fae90ad2$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.loaded = false;
    }
    connectedCallback() {
        this.render();
    }
    static get observedAttributes() {
        return [
            'data-url',
            'data-title',
            'data-description',
            'data-thumbnail-url',
            'data-autoplay',
            'data-loop',
            'data-muted'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-url' && oldValue !== newValue) this.url = newValue;
        if (name === 'data-title' && oldValue !== newValue) this.titleText = newValue;
        if (name === 'data-description' && oldValue !== newValue) this.description = newValue;
        if (name === 'data-thumbnail-url' && oldValue !== newValue) this.thumbnailURL = newValue;
        if (name === 'data-autoplay' && oldValue !== newValue) this.autoplay = newValue === '';
        if (name === 'data-loop' && oldValue !== newValue) this.loop = newValue === '';
        if (name === 'data-muted' && oldValue !== newValue) this.muted = newValue === '';
        if (oldValue !== newValue) this.render();
    }
    handleClick() {
        if (this.loaded || !this.url) return;
        const url = new URL(this.url);
        this.autoplay && url.searchParams.set('autoplay', '1');
        this.loop && url.searchParams.set('loop', '1');
        this.muted && url.searchParams.set('mute', '1');
        const iframeHTML = `<iframe
            src="${this.url}"
            title="${this.titleText || 'Video'}"
            frameborder="0"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            width="100%"
            height="100%"
        ></iframe>`;
        this.innerHTML = iframeHTML;
        this.loaded = true;
        (0, $da8ead2273adf04f$export$f6a286c942d22c53)(this, iframeHTML);
    }
    render() {
        if (this.loaded || !this.url) return;
        const { source: source, id: id } = (0, $f0816450e263ddf9$export$408a51f74a282ac)(this.url);
        if (!source || !id) return;
        let thumb = this.thumbnailURL;
        // Auto-Thumbnail für YouTube
        if (!thumb && source === (0, $8da060ca62730502$export$f3a17123d80000c5).YOUTUBE && id) thumb = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
        const html = `
            <div class="tk-video-embed__thumbnail" role="button" aria-label="Play video" data-thumbnail>
                <img src="${thumb ?? ''}" alt="${this.titleText ?? 'Video thumbnail'}">
                <div class="tk-video-embed__overlay">
                <div class="tk-video-embed__play-button">\u{25B6}</div>
                ${this.titleText ? `<h3 class="tk-video-embed__title">${this.titleText}</h3>` : ''}
                ${this.description ? `<p class="tk-video-embed__description">${this.description}</p>` : ''}
                </div>
            </div>`;
        (0, $da8ead2273adf04f$export$f6a286c942d22c53)(this, html, {
            wrapMultipleRoots: true
        });
        const thumbnailElement = this.querySelector('[data-thumbnail]');
        if (!thumbnailElement) return;
        const action = this.handleClick.bind(this);
        this.pushListener({
            event: 'click',
            element: thumbnailElement,
            action: action
        });
    }
}





const $dcecc7418fbd1ace$var$compareStore = new (0, $9f71fef3739216f1$export$2e2bcd8739ae039)();
(0, $f8125d35cd9a4f7a$export$7d8a5b498da695ac)({
    compareStore: $dcecc7418fbd1ace$var$compareStore
});
class $dcecc7418fbd1ace$export$2e2bcd8739ae039 extends (0, $e31d2de11bbf216d$export$2e2bcd8739ae039) {
    constructor(){
        super([
            {
                name: 'tk-manager',
                constructor: (0, $aa35ef9547ba682e$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-request-manager',
                constructor: (0, $d3f5c18545e5cabd$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-viewport',
                constructor: (0, $9ada6dd3e169a5cf$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tracker',
                constructor: (0, $588d148f2c9ac202$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-status-console',
                constructor: (0, $9cc5e30d1bc8a0e8$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-clipboard',
                constructor: (0, $68fa613ad09d90db$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-header',
                constructor: (0, $1352bbad447b1dc9$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-nav-sidebar',
                constructor: (0, $40898dd22403025f$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-basket-button',
                constructor: (0, $127c03b03da38c7a$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-carousel',
                constructor: (0, $b0d382fe358ed836$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-context-menu',
                constructor: (0, $d9484b764f1a944d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-flag',
                constructor: (0, $0d07f57cc5d15afe$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-product-tile',
                constructor: (0, $21ae20c5af7baedb$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-product-variants',
                constructor: (0, $21611c672b0d32ce$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tooltip',
                constructor: (0, $b4b8cee06c4cfcc8$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-dialog',
                constructor: (0, $5a26c1218729bf34$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-article-list',
                constructor: (0, $6406837936bc2cfc$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-static-content',
                constructor: (0, $edcef81612fbf4b7$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tabs-tab',
                constructor: (0, $237e800aa488702c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-favorite-button',
                constructor: (0, $2c226fea39ede692$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-favorite-info',
                constructor: (0, $38c77688df6cd108$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-element',
                constructor: (0, $9a3403e3213d867d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-validator',
                constructor: (0, $7217ff2f9b2d295c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tabs-accordion',
                constructor: (0, $59575c6d2ba9e740$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-compare-button',
                constructor: (0, $cc14b9b65c9c652e$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-selection',
                constructor: (0, $407d2fd9d876caa3$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-file-upload-area',
                constructor: (0, $2b8eccc7b4db22b8$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-compare-info',
                constructor: (0, $7cfc9025399237fb$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tracking',
                constructor: (0, $0efda1b115753384$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-button-dropdown',
                constructor: (0, $87c9f038bb9cd227$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-minibasket',
                constructor: (0, $ba0287e7c80bda20$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-stock',
                constructor: (0, $c7b0de4494db348b$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-price-control',
                constructor: (0, $1de4bc533e624441$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-price',
                constructor: (0, $7cf802f14f3a63bb$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-search',
                constructor: (0, $1943502441640b9f$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-links',
                constructor: (0, $6d1c1bebccef2c7f$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-table',
                constructor: (0, $2595e2ca594d6789$export$2e2bcd8739ae039)
            },
            {
                name: 'cms-video-embed',
                constructor: (0, $b1129966fae90ad2$export$2e2bcd8739ae039)
            }
        ]);
    }
}
new $dcecc7418fbd1ace$export$2e2bcd8739ae039();

})();
//# sourceMappingURL=general.js.map
